//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BIMDataValidatorClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processPrompt(body: AiPromptRequest | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/AiAssistant/processPrompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessPrompt(_response);
        });
    }

    protected processProcessPrompt(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
                result500 = resultData500 !== undefined ? resultData500 : null as any;
    
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginMicrosoft(body: AuthMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/loginMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginMicrosoft(_response);
        });
    }

    protected processLoginMicrosoft(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    loginLocal(body: AuthLocalRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/loginLocal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginLocal(_response);
        });
    }

    protected processLoginLocal(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupMicrosoft(body: SignupMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupResponse> {
        let url_ = this.baseUrl + "/Auth/signupMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupMicrosoft(_response);
        });
    }

    protected processSignupMicrosoft(response: AxiosResponse): Promise<SignupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupResponse.fromJS(resultData200);
            return Promise.resolve<SignupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hashOfPassword(body: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Auth/hashOfPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHashOfPassword(_response);
        });
    }

    protected processHashOfPassword(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getAppLogo( cancelToken?: CancelToken): Promise<GetAppLogoResponse> {
        let url_ = this.baseUrl + "/Auth/GetAppLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppLogo(_response);
        });
    }

    protected processGetAppLogo(response: AxiosResponse): Promise<GetAppLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetAppLogoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppLogoResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserInfo( cancelToken?: CancelToken): Promise<GetUserInfoResponse> {
        let url_ = this.baseUrl + "/Auth/GetUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<GetUserInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserInfoResponse.fromJS(resultData200);
            return Promise.resolve<GetUserInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenants(req: GetTenantsRequest, cancelToken?: CancelToken): Promise<GetTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/GetTenants";
        if (req === undefined || req === null)
            throw new globalThis.Error("The parameter 'req' must be defined.");
        url_ = url_.replace("{req}", encodeURIComponent("" + req));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<GetTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserTenants(userId: number, cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/GetUserTenants/{UserId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTenants(_response);
        });
    }

    protected processGetUserTenants(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    isAuthed( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Auth/IsAuthed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthed(_response);
        });
    }

    protected processIsAuthed(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    pwtoken(code: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Auth/pwtoken?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPwtoken(_response);
        });
    }

    protected processPwtoken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTools( cancelToken?: CancelToken): Promise<GetToolsResponse> {
        let url_ = this.baseUrl + "/Auth/GetTools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTools(_response);
        });
    }

    protected processGetTools(response: AxiosResponse): Promise<GetToolsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetToolsResponse.fromJS(resultData200);
            return Promise.resolve<GetToolsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetToolsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    query(body: BimKnowledgeRequest | undefined, cancelToken?: CancelToken): Promise<BimKnowledgeResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<BimKnowledgeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BimKnowledgeResponse.fromJS(resultData200);
            return Promise.resolve<BimKnowledgeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BimKnowledgeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    action(body: ExecuteActionRequest | undefined, cancelToken?: CancelToken): Promise<ExecuteActionResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAction(_response);
        });
    }

    protected processAction(response: AxiosResponse): Promise<ExecuteActionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExecuteActionResponse.fromJS(resultData200);
            return Promise.resolve<ExecuteActionResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExecuteActionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    semantic(body: SemanticSearchRequest | undefined, cancelToken?: CancelToken): Promise<SemanticSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/semantic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSemantic(_response);
        });
    }

    protected processSemantic(response: AxiosResponse): Promise<SemanticSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SemanticSearchResponse.fromJS(resultData200);
            return Promise.resolve<SemanticSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemanticSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    similar(body: FindSimilarRequest | undefined, cancelToken?: CancelToken): Promise<SemanticSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/similar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimilar(_response);
        });
    }

    protected processSimilar(response: AxiosResponse): Promise<SemanticSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SemanticSearchResponse.fromJS(resultData200);
            return Promise.resolve<SemanticSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemanticSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    flexible(body: FlexibleSearchApiRequest | undefined, cancelToken?: CancelToken): Promise<FlexibleSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/flexible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlexible(_response);
        });
    }

    protected processFlexible(response: AxiosResponse): Promise<FlexibleSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlexibleSearchResponse.fromJS(resultData200);
            return Promise.resolve<FlexibleSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlexibleSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    natural(body: NaturalLanguageSearchRequest | undefined, cancelToken?: CancelToken): Promise<NaturalLanguageSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/natural";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNatural(_response);
        });
    }

    protected processNatural(response: AxiosResponse): Promise<NaturalLanguageSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NaturalLanguageSearchResponse.fromJS(resultData200);
            return Promise.resolve<NaturalLanguageSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NaturalLanguageSearchResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    smart(body: NaturalLanguageSearchRequest | undefined, cancelToken?: CancelToken): Promise<SmartSearchResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/smart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSmart(_response);
        });
    }

    protected processSmart(response: AxiosResponse): Promise<SmartSearchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SmartSearchResponse.fromJS(resultData200);
            return Promise.resolve<SmartSearchResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SmartSearchResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param sessionId (optional) 
     * @param search (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    conversations(projectId: number | undefined, sessionId: string | undefined, search: string | undefined, page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ConversationLogPagedResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/conversations?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConversations(_response);
        });
    }

    protected processConversations(response: AxiosResponse): Promise<ConversationLogPagedResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversationLogPagedResponse.fromJS(resultData200);
            return Promise.resolve<ConversationLogPagedResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationLogPagedResponse>(null as any);
    }

    /**
     * @return Success
     */
    conversations2(id: number, cancelToken?: CancelToken): Promise<ConversationLogItem> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConversations2(_response);
        });
    }

    protected processConversations2(response: AxiosResponse): Promise<ConversationLogItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConversationLogItem.fromJS(resultData200);
            return Promise.resolve<ConversationLogItem>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConversationLogItem>(null as any);
    }

    /**
     * @param query (optional) 
     * @param top (optional) 
     * @return Success
     */
    debug(tenantId: number, query: string | undefined, top: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/search/debug/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (top === null)
            throw new globalThis.Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDebug(_response);
        });
    }

    protected processDebug(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    history(body: InsightHistoryRequest | undefined, cancelToken?: CancelToken): Promise<InsightHistoryResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHistory(_response);
        });
    }

    protected processHistory(response: AxiosResponse): Promise<InsightHistoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsightHistoryResponse.fromJS(resultData200);
            return Promise.resolve<InsightHistoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsightHistoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bookmark(insightId: string, body: BookmarkRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/insights/{insightId}/bookmark";
        if (insightId === undefined || insightId === null)
            throw new globalThis.Error("The parameter 'insightId' must be defined.");
        url_ = url_.replace("{insightId}", encodeURIComponent("" + insightId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBookmark(_response);
        });
    }

    protected processBookmark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param modelId (optional) 
     * @return Success
     */
    suggestions(projectId: number, modelId: number | undefined, cancelToken?: CancelToken): Promise<SuggestionsResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/suggestions/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (modelId === null)
            throw new globalThis.Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "modelId=" + encodeURIComponent("" + modelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuggestions(_response);
        });
    }

    protected processSuggestions(response: AxiosResponse): Promise<SuggestionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuggestionsResponse.fromJS(resultData200);
            return Promise.resolve<SuggestionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuggestionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sync(body: IndexSyncRequest | undefined, cancelToken?: CancelToken): Promise<IndexSyncStatus> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/index/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSync(_response);
        });
    }

    protected processSync(response: AxiosResponse): Promise<IndexSyncStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = IndexSyncStatus.fromJS(resultData202);
            return Promise.resolve<IndexSyncStatus>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndexSyncStatus>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    stats(tenantId: number | undefined, cancelToken?: CancelToken): Promise<IndexStats> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/index/stats?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStats(_response);
        });
    }

    protected processStats(response: AxiosResponse): Promise<IndexStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IndexStats.fromJS(resultData200);
            return Promise.resolve<IndexStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IndexStats>(null as any);
    }

    /**
     * @return Success
     */
    ensure( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/index/ensure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnsure(_response);
        });
    }

    protected processEnsure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    semanticAll(body: SemanticDebugRequest | undefined, cancelToken?: CancelToken): Promise<SemanticDebugResult[]> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/debug/semantic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSemanticAll(_response);
        });
    }

    protected processSemanticAll(response: AxiosResponse): Promise<SemanticDebugResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SemanticDebugResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SemanticDebugResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SemanticDebugResult[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    seed(body: SeedGenerationRequest | undefined, cancelToken?: CancelToken): Promise<SeedGenerationResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/debug/seed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeed(_response);
        });
    }

    protected processSeed(response: AxiosResponse): Promise<SeedGenerationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SeedGenerationResponse.fromJS(resultData200);
            return Promise.resolve<SeedGenerationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SeedGenerationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulk(body: BulkIndexRequest | undefined, cancelToken?: CancelToken): Promise<BulkIndexResponse> {
        let url_ = this.baseUrl + "/api/v1/BimKnowledge/index/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulk(_response);
        });
    }

    protected processBulk(response: AxiosResponse): Promise<BulkIndexResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = BulkIndexResponse.fromJS(resultData202);
            return Promise.resolve<BulkIndexResponse>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkIndexResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelDownloadLink(modelId: number, cancelToken?: CancelToken): Promise<GetModelResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-download-link/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelDownloadLink(_response);
        });
    }

    protected processGetModelDownloadLink(response: AxiosResponse): Promise<GetModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelResponse.fromJS(resultData200);
            return Promise.resolve<GetModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSasUrlForUploadFragments(body: GetSasUrlForUploadFragmentRequest | undefined, cancelToken?: CancelToken): Promise<GetSasUrlForUploadFragmentResponse> {
        let url_ = this.baseUrl + "/BimModels/get-sas-url-for-upload-fragments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForUploadFragments(_response);
        });
    }

    protected processGetSasUrlForUploadFragments(response: AxiosResponse): Promise<GetSasUrlForUploadFragmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForUploadFragmentResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForUploadFragmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForUploadFragmentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSasUrlForUploadIfc(body: GetSasUrlForUploadIfcRequest | undefined, cancelToken?: CancelToken): Promise<GetSasUrlForUploadIfcResponse> {
        let url_ = this.baseUrl + "/BimModels/get-sas-url-for-upload-ifc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForUploadIfc(_response);
        });
    }

    protected processGetSasUrlForUploadIfc(response: AxiosResponse): Promise<GetSasUrlForUploadIfcResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForUploadIfcResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForUploadIfcResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForUploadIfcResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSasUrlForDownloadIfc(modelId: number, cancelToken?: CancelToken): Promise<GetSasUrlForDownloadIfcResponse> {
        let url_ = this.baseUrl + "/BimModels/get-sas-url-for-download-ifc/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForDownloadIfc(_response);
        });
    }

    protected processGetSasUrlForDownloadIfc(response: AxiosResponse): Promise<GetSasUrlForDownloadIfcResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForDownloadIfcResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForDownloadIfcResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForDownloadIfcResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSasUrlForDownloadFragmets(modelId: number, cancelToken?: CancelToken): Promise<GetSasUrlForDownloadFragmentsResponse> {
        let url_ = this.baseUrl + "/BimModels/get-sas-url-for-download-fragmets/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForDownloadFragmets(_response);
        });
    }

    protected processGetSasUrlForDownloadFragmets(response: AxiosResponse): Promise<GetSasUrlForDownloadFragmentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForDownloadFragmentsResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForDownloadFragmentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForDownloadFragmentsResponse>(null as any);
    }

    /**
     * @return Success
     */
    completeIfcUpload(modelId: number, cancelToken?: CancelToken): Promise<CompleteIfcUploadResponse> {
        let url_ = this.baseUrl + "/BimModels/complete-ifc-upload/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteIfcUpload(_response);
        });
    }

    protected processCompleteIfcUpload(response: AxiosResponse): Promise<CompleteIfcUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteIfcUploadResponse.fromJS(resultData200);
            return Promise.resolve<CompleteIfcUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteIfcUploadResponse>(null as any);
    }

    /**
     * @return Success
     */
    completeFragmentsUpload(modelId: number, cancelToken?: CancelToken): Promise<CompleteFragmentsUploadResponse> {
        let url_ = this.baseUrl + "/BimModels/complete-fragments-upload/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteFragmentsUpload(_response);
        });
    }

    protected processCompleteFragmentsUpload(response: AxiosResponse): Promise<CompleteFragmentsUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteFragmentsUploadResponse.fromJS(resultData200);
            return Promise.resolve<CompleteFragmentsUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteFragmentsUploadResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getProjectModelsProperties(projectId: number | undefined, pageNumber: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<GetPropertiesForProjectResponse> {
        let url_ = this.baseUrl + "/BimModels/get-project-models-properties?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (pageNumber === null)
            throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectModelsProperties(_response);
        });
    }

    protected processGetProjectModelsProperties(response: AxiosResponse): Promise<GetPropertiesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelProperties(modelId: number, cancelToken?: CancelToken): Promise<GetPropertiesForModelResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-properties/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelProperties(_response);
        });
    }

    protected processGetModelProperties(response: AxiosResponse): Promise<GetPropertiesForModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForModelResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pushPropertiesForModel(body: PushPropertiesForModelRequest | undefined, cancelToken?: CancelToken): Promise<PushPropertiesForModelResponse> {
        let url_ = this.baseUrl + "/BimModels/push-properties-for-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushPropertiesForModel(_response);
        });
    }

    protected processPushPropertiesForModel(response: AxiosResponse): Promise<PushPropertiesForModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushPropertiesForModelResponse.fromJS(resultData200);
            return Promise.resolve<PushPropertiesForModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushPropertiesForModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pushModelTree(body: PushTreeDataToModelRequest | undefined, cancelToken?: CancelToken): Promise<PushTreeDataToModelResponse> {
        let url_ = this.baseUrl + "/BimModels/push-model-tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushModelTree(_response);
        });
    }

    protected processPushModelTree(response: AxiosResponse): Promise<PushTreeDataToModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushTreeDataToModelResponse.fromJS(resultData200);
            return Promise.resolve<PushTreeDataToModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushTreeDataToModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    finishModelProcessing(modelId: number, bulkUploadId: string, cancelToken?: CancelToken): Promise<FinishModelProcessingResponse> {
        let url_ = this.baseUrl + "/BimModels/finish-model-processing/{ModelId}/{BulkUploadId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        if (bulkUploadId === undefined || bulkUploadId === null)
            throw new globalThis.Error("The parameter 'bulkUploadId' must be defined.");
        url_ = url_.replace("{BulkUploadId}", encodeURIComponent("" + bulkUploadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishModelProcessing(_response);
        });
    }

    protected processFinishModelProcessing(response: AxiosResponse): Promise<FinishModelProcessingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FinishModelProcessingResponse.fromJS(resultData200);
            return Promise.resolve<FinishModelProcessingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FinishModelProcessingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTree(modelId: number, cancelToken?: CancelToken): Promise<GetTreeDataFromModelResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-tree/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTree(_response);
        });
    }

    protected processGetModelTree(response: AxiosResponse): Promise<GetTreeDataFromModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromModelResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromModelResponse>(null as any);
    }

    /**
     * @param modelName (optional) 
     * @param blockId (optional) 
     * @param filePart (optional) 
     * @return Success
     */
    uploadBlock(modelName: string | undefined, blockId: string | undefined, filePart: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadBlockResponse> {
        let url_ = this.baseUrl + "/BimModels/upload-block";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (modelName === null || modelName === undefined)
            throw new globalThis.Error("The parameter 'modelName' cannot be null.");
        else
            content_.append("ModelName", modelName.toString());
        if (blockId === null || blockId === undefined)
            throw new globalThis.Error("The parameter 'blockId' cannot be null.");
        else
            content_.append("BlockId", blockId.toString());
        if (filePart === null || filePart === undefined)
            throw new globalThis.Error("The parameter 'filePart' cannot be null.");
        else
            content_.append("FilePart", filePart.data, filePart.fileName ? filePart.fileName : "FilePart");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBlock(_response);
        });
    }

    protected processUploadBlock(response: AxiosResponse): Promise<UploadBlockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadBlockResponse.fromJS(resultData200);
            return Promise.resolve<UploadBlockResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadBlockResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    commitBlocks(body: CommitBlocksRequest | undefined, cancelToken?: CancelToken): Promise<CommitBlocksResponse> {
        let url_ = this.baseUrl + "/BimModels/commit-blocks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommitBlocks(_response);
        });
    }

    protected processCommitBlocks(response: AxiosResponse): Promise<CommitBlocksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommitBlocksResponse.fromJS(resultData200);
            return Promise.resolve<CommitBlocksResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommitBlocksResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTreesForProject(projectId: number, cancelToken?: CancelToken): Promise<GetTreeDataFromProjectResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-trees-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTreesForProject(_response);
        });
    }

    protected processGetModelTreesForProject(response: AxiosResponse): Promise<GetTreeDataFromProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelsForProject(projectId: number, cancelToken?: CancelToken): Promise<GetModelSasUrisFromProjectIdResponse> {
        let url_ = this.baseUrl + "/BimModels/get-models-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelsForProject(_response);
        });
    }

    protected processGetModelsForProject(response: AxiosResponse): Promise<GetModelSasUrisFromProjectIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelSasUrisFromProjectIdResponse.fromJS(resultData200);
            return Promise.resolve<GetModelSasUrisFromProjectIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelSasUrisFromProjectIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelsForProjectCabinet(projectId: number, cancelToken?: CancelToken): Promise<GetModelSasUrisFromProjectIdCabinetResponse> {
        let url_ = this.baseUrl + "/BimModels/get-models-for-project-cabinet/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelsForProjectCabinet(_response);
        });
    }

    protected processGetModelsForProjectCabinet(response: AxiosResponse): Promise<GetModelSasUrisFromProjectIdCabinetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelSasUrisFromProjectIdCabinetResponse.fromJS(resultData200);
            return Promise.resolve<GetModelSasUrisFromProjectIdCabinetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelSasUrisFromProjectIdCabinetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTreesForProjectCabinet(projectId: number, cancelToken?: CancelToken): Promise<GetTreeDataFromProjectCabinetResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-trees-for-project-cabinet/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTreesForProjectCabinet(_response);
        });
    }

    protected processGetModelTreesForProjectCabinet(response: AxiosResponse): Promise<GetTreeDataFromProjectCabinetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromProjectCabinetResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromProjectCabinetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromProjectCabinetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectModelsPropertiesCabinet(projectId: number, cancelToken?: CancelToken): Promise<GetPropertiesForProjectCabinetResponse> {
        let url_ = this.baseUrl + "/BimModels/get-project-models-properties-cabinet/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectModelsPropertiesCabinet(_response);
        });
    }

    protected processGetProjectModelsPropertiesCabinet(response: AxiosResponse): Promise<GetPropertiesForProjectCabinetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForProjectCabinetResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForProjectCabinetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForProjectCabinetResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteModelFromTree(modelId: number, cancelToken?: CancelToken): Promise<DeleteModelFromTreeResponse> {
        let url_ = this.baseUrl + "/BimModels/delete-model-from-tree/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModelFromTree(_response);
        });
    }

    protected processDeleteModelFromTree(response: AxiosResponse): Promise<DeleteModelFromTreeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteModelFromTreeResponse.fromJS(resultData200);
            return Promise.resolve<DeleteModelFromTreeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteModelFromTreeResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelIfc(modelId: number, cancelToken?: CancelToken): Promise<GetModelIfcResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-ifc/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelIfc(_response);
        });
    }

    protected processGetModelIfc(response: AxiosResponse): Promise<GetModelIfcResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelIfcResponse.fromJS(resultData200);
            return Promise.resolve<GetModelIfcResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelIfcResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelFrags(modelId: number, cancelToken?: CancelToken): Promise<GetModelFragsResponse> {
        let url_ = this.baseUrl + "/BimModels/get-model-frags/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelFrags(_response);
        });
    }

    protected processGetModelFrags(response: AxiosResponse): Promise<GetModelFragsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelFragsResponse.fromJS(resultData200);
            return Promise.resolve<GetModelFragsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelFragsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetRulesForPairer(pairerId: number, cancelToken?: CancelToken): Promise<GetBudgetRulesForPairerResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budget-rules-for-pairer/{PairerId}";
        if (pairerId === undefined || pairerId === null)
            throw new globalThis.Error("The parameter 'pairerId' must be defined.");
        url_ = url_.replace("{PairerId}", encodeURIComponent("" + pairerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetRulesForPairer(_response);
        });
    }

    protected processGetBudgetRulesForPairer(response: AxiosResponse): Promise<GetBudgetRulesForPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetRulesForPairerResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetRulesForPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetRulesForPairerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetRuleItemsForRule(ruleId: number, cancelToken?: CancelToken): Promise<GetBudgetRulesItemsForRuleResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budget-rule-items-for-rule/{RuleId}";
        if (ruleId === undefined || ruleId === null)
            throw new globalThis.Error("The parameter 'ruleId' must be defined.");
        url_ = url_.replace("{RuleId}", encodeURIComponent("" + ruleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetRuleItemsForRule(_response);
        });
    }

    protected processGetBudgetRuleItemsForRule(response: AxiosResponse): Promise<GetBudgetRulesItemsForRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetRulesItemsForRuleResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetRulesItemsForRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetRulesItemsForRuleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBudgetRuleForPairer(body: CreateBudgetRuleForPairerRequest | undefined, cancelToken?: CancelToken): Promise<CreateBudgetRuleForPairerResponse> {
        let url_ = this.baseUrl + "/Budgeting/create-budget-rule-for-pairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBudgetRuleForPairer(_response);
        });
    }

    protected processCreateBudgetRuleForPairer(response: AxiosResponse): Promise<CreateBudgetRuleForPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBudgetRuleForPairerResponse.fromJS(resultData200);
            return Promise.resolve<CreateBudgetRuleForPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBudgetRuleForPairerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetRuleById(budgetRuleId: number, cancelToken?: CancelToken): Promise<GetBudgetRuleByIdResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budget-rule-by-id/{BudgetRuleId}";
        if (budgetRuleId === undefined || budgetRuleId === null)
            throw new globalThis.Error("The parameter 'budgetRuleId' must be defined.");
        url_ = url_.replace("{BudgetRuleId}", encodeURIComponent("" + budgetRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetRuleById(_response);
        });
    }

    protected processGetBudgetRuleById(response: AxiosResponse): Promise<GetBudgetRuleByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetRuleByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetRuleByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetRuleByIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBudgetRule(body: UpdateBudgetRuleRequest | undefined, cancelToken?: CancelToken): Promise<UpdateBudgetRuleResponse> {
        let url_ = this.baseUrl + "/Budgeting/update-budget-rule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBudgetRule(_response);
        });
    }

    protected processUpdateBudgetRule(response: AxiosResponse): Promise<UpdateBudgetRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBudgetRuleResponse.fromJS(resultData200);
            return Promise.resolve<UpdateBudgetRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBudgetRuleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBudgetRuleItem(body: CreateBudgetRuleItemRequest | undefined, cancelToken?: CancelToken): Promise<CreateBudgetRuleItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/create-budget-rule-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBudgetRuleItem(_response);
        });
    }

    protected processCreateBudgetRuleItem(response: AxiosResponse): Promise<CreateBudgetRuleItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateBudgetRuleItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateBudgetRuleItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateBudgetRuleItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetRuleItemById(itemId: number, cancelToken?: CancelToken): Promise<GetBudgetRuleItemByIdResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budget-rule-item-by-id/{ItemId}";
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{ItemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetRuleItemById(_response);
        });
    }

    protected processGetBudgetRuleItemById(response: AxiosResponse): Promise<GetBudgetRuleItemByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetRuleItemByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetRuleItemByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetRuleItemByIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBudgetRuleItem(body: UpdateBudgetRuleItemRequest | undefined, cancelToken?: CancelToken): Promise<UpdateBudgetRuleItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/update-budget-rule-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBudgetRuleItem(_response);
        });
    }

    protected processUpdateBudgetRuleItem(response: AxiosResponse): Promise<UpdateBudgetRuleItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBudgetRuleItemResponse.fromJS(resultData200);
            return Promise.resolve<UpdateBudgetRuleItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBudgetRuleItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateBudgetAmounts(body: CalculateBudgetAmountsRequest | undefined, cancelToken?: CancelToken): Promise<CalculateBudgetAmountsResponse> {
        let url_ = this.baseUrl + "/Budgeting/calculate-budget-amounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateBudgetAmounts(_response);
        });
    }

    protected processCalculateBudgetAmounts(response: AxiosResponse): Promise<CalculateBudgetAmountsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateBudgetAmountsResponse.fromJS(resultData200);
            return Promise.resolve<CalculateBudgetAmountsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateBudgetAmountsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateBudgetAmountsDatabase(body: CalculateBudgetAmountsDatabaseRequest | undefined, cancelToken?: CancelToken): Promise<CalculateBudgetAmountsResponse> {
        let url_ = this.baseUrl + "/Budgeting/calculate-budget-amounts-database";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateBudgetAmountsDatabase(_response);
        });
    }

    protected processCalculateBudgetAmountsDatabase(response: AxiosResponse): Promise<CalculateBudgetAmountsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CalculateBudgetAmountsResponse.fromJS(resultData200);
            return Promise.resolve<CalculateBudgetAmountsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalculateBudgetAmountsResponse>(null as any);
    }

    /**
     * @param name (optional) 
     * @param file (optional) 
     * @return Success
     */
    importOtskp(name: string | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ImportOtskpResponse> {
        let url_ = this.baseUrl + "/Budgeting/import-otskp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportOtskp(_response);
        });
    }

    protected processImportOtskp(response: AxiosResponse): Promise<ImportOtskpResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportOtskpResponse.fromJS(resultData200);
            return Promise.resolve<ImportOtskpResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportOtskpResponse>(null as any);
    }

    /**
     * @param count (optional) 
     * @param offset (optional) 
     * @param pricingDatabaseId (optional) 
     * @return Success
     */
    getPricingDatabaseItems(count: number | undefined, offset: number | undefined, pricingDatabaseId: number | undefined, cancelToken?: CancelToken): Promise<PricingDatabaseItemDtoPaginableResult> {
        let url_ = this.baseUrl + "/Budgeting/get-pricing-database-items?";
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "Count=" + encodeURIComponent("" + count) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (pricingDatabaseId === null)
            throw new globalThis.Error("The parameter 'pricingDatabaseId' cannot be null.");
        else if (pricingDatabaseId !== undefined)
            url_ += "PricingDatabaseId=" + encodeURIComponent("" + pricingDatabaseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPricingDatabaseItems(_response);
        });
    }

    protected processGetPricingDatabaseItems(response: AxiosResponse): Promise<PricingDatabaseItemDtoPaginableResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PricingDatabaseItemDtoPaginableResult.fromJS(resultData200);
            return Promise.resolve<PricingDatabaseItemDtoPaginableResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PricingDatabaseItemDtoPaginableResult>(null as any);
    }

    /**
     * @return Success
     */
    getPricingDatabasesList( cancelToken?: CancelToken): Promise<GetPricingDatabaseListResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-pricing-databases-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPricingDatabasesList(_response);
        });
    }

    protected processGetPricingDatabasesList(response: AxiosResponse): Promise<GetPricingDatabaseListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPricingDatabaseListResponse.fromJS(resultData200);
            return Promise.resolve<GetPricingDatabaseListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPricingDatabaseListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePricingDatabase(body: RenamePricingDatabaseRequest | undefined, cancelToken?: CancelToken): Promise<RenamePricingDatabaseResponse> {
        let url_ = this.baseUrl + "/Budgeting/rename-pricing-database";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenamePricingDatabase(_response);
        });
    }

    protected processRenamePricingDatabase(response: AxiosResponse): Promise<RenamePricingDatabaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenamePricingDatabaseResponse.fromJS(resultData200);
            return Promise.resolve<RenamePricingDatabaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenamePricingDatabaseResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteBudgetrule(id: number, cancelToken?: CancelToken): Promise<DeleteBudgetRuleResponse> {
        let url_ = this.baseUrl + "/Budgeting/delete-budgetrule/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBudgetrule(_response);
        });
    }

    protected processDeleteBudgetrule(response: AxiosResponse): Promise<DeleteBudgetRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBudgetRuleResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBudgetRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBudgetRuleResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteBudgetRuleItem(id: number, cancelToken?: CancelToken): Promise<DeleteBudgetRuleItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/delete-budget-rule-item/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBudgetRuleItem(_response);
        });
    }

    protected processDeleteBudgetRuleItem(response: AxiosResponse): Promise<DeleteBudgetRuleItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBudgetRuleItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBudgetRuleItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBudgetRuleItemResponse>(null as any);
    }

    /**
     * @param standardId (optional) 
     * @param budgetingSessionId (optional) 
     * @return Success
     */
    propertiesForStandard(standardId: number | undefined, budgetingSessionId: number | undefined, cancelToken?: CancelToken): Promise<GetAllPropertiesForDataStandardResponse> {
        let url_ = this.baseUrl + "/Budgeting/properties-for-standard?";
        if (standardId === null)
            throw new globalThis.Error("The parameter 'standardId' cannot be null.");
        else if (standardId !== undefined)
            url_ += "StandardId=" + encodeURIComponent("" + standardId) + "&";
        if (budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' cannot be null.");
        else if (budgetingSessionId !== undefined)
            url_ += "BudgetingSessionId=" + encodeURIComponent("" + budgetingSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPropertiesForStandard(_response);
        });
    }

    protected processPropertiesForStandard(response: AxiosResponse): Promise<GetAllPropertiesForDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPropertiesForDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<GetAllPropertiesForDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPropertiesForDataStandardResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFormulaProperties(formulaId: number, cancelToken?: CancelToken): Promise<GetPropertiesForFormulaIdResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-formula-properties/{FormulaId}";
        if (formulaId === undefined || formulaId === null)
            throw new globalThis.Error("The parameter 'formulaId' must be defined.");
        url_ = url_.replace("{FormulaId}", encodeURIComponent("" + formulaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormulaProperties(_response);
        });
    }

    protected processGetFormulaProperties(response: AxiosResponse): Promise<GetPropertiesForFormulaIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForFormulaIdResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForFormulaIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForFormulaIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFormulaPropertiesAll( cancelToken?: CancelToken): Promise<GetAllPropertiesForFormulasResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-formula-properties-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormulaPropertiesAll(_response);
        });
    }

    protected processGetFormulaPropertiesAll(response: AxiosResponse): Promise<GetAllPropertiesForFormulasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPropertiesForFormulasResponse.fromJS(resultData200);
            return Promise.resolve<GetAllPropertiesForFormulasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPropertiesForFormulasResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addEditFormulaItem(body: AddEditFormulaItemRequest | undefined, cancelToken?: CancelToken): Promise<AddEditFormulaItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/add-edit-formula-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEditFormulaItem(_response);
        });
    }

    protected processAddEditFormulaItem(response: AxiosResponse): Promise<AddEditFormulaItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddEditFormulaItemResponse.fromJS(resultData200);
            return Promise.resolve<AddEditFormulaItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddEditFormulaItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFormulaItem(id: number, cancelToken?: CancelToken): Promise<GetFormulaItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-formula-item/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFormulaItem(_response);
        });
    }

    protected processGetFormulaItem(response: AxiosResponse): Promise<GetFormulaItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFormulaItemResponse.fromJS(resultData200);
            return Promise.resolve<GetFormulaItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFormulaItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteFormulaItem(id: number, cancelToken?: CancelToken): Promise<DeleteFormulaItemResponse> {
        let url_ = this.baseUrl + "/Budgeting/delete-formula-item/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFormulaItem(_response);
        });
    }

    protected processDeleteFormulaItem(response: AxiosResponse): Promise<DeleteFormulaItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteFormulaItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteFormulaItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteFormulaItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterElementsForBudgeting(body: FilterElementsForBudgetingRequest | undefined, cancelToken?: CancelToken): Promise<FilterElementsForBudgetingResponse> {
        let url_ = this.baseUrl + "/Budgeting/filter-elements-for-budgeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilterElementsForBudgeting(_response);
        });
    }

    protected processFilterElementsForBudgeting(response: AxiosResponse): Promise<FilterElementsForBudgetingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterElementsForBudgetingResponse.fromJS(resultData200);
            return Promise.resolve<FilterElementsForBudgetingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterElementsForBudgetingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetingSessions( cancelToken?: CancelToken): Promise<GetBudgetingSessionsResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budgeting-sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetingSessions(_response);
        });
    }

    protected processGetBudgetingSessions(response: AxiosResponse): Promise<GetBudgetingSessionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetingSessionsResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetingSessionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetingSessionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBudgetingSession(body: CreateOrUpdateBudgetingSessionRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateBudgetingSessionResponse> {
        let url_ = this.baseUrl + "/Budgeting/create-or-update-budgeting-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateBudgetingSession(_response);
        });
    }

    protected processCreateOrUpdateBudgetingSession(response: AxiosResponse): Promise<CreateOrUpdateBudgetingSessionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateBudgetingSessionResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateBudgetingSessionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateBudgetingSessionResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteBudgetingSession(sessionId: number, cancelToken?: CancelToken): Promise<DeleteBudgetingSessionResponse> {
        let url_ = this.baseUrl + "/Budgeting/delete-budgeting-session/{SessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{SessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBudgetingSession(_response);
        });
    }

    protected processDeleteBudgetingSession(response: AxiosResponse): Promise<DeleteBudgetingSessionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBudgetingSessionResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBudgetingSessionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBudgetingSessionResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetingSessionPairing(id: number, cancelToken?: CancelToken): Promise<GetBudgetingSessionPairingResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budgeting-session-pairing/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetingSessionPairing(_response);
        });
    }

    protected processGetBudgetingSessionPairing(response: AxiosResponse): Promise<GetBudgetingSessionPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetingSessionPairingResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetingSessionPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetingSessionPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBudgetingSessionPairing(body: SaveBudgetingSessionsPairingRequest | undefined, cancelToken?: CancelToken): Promise<SaveBudgetingSessionsPairingResponse> {
        let url_ = this.baseUrl + "/Budgeting/save-budgeting-session-pairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBudgetingSessionPairing(_response);
        });
    }

    protected processSaveBudgetingSessionPairing(response: AxiosResponse): Promise<SaveBudgetingSessionsPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveBudgetingSessionsPairingResponse.fromJS(resultData200);
            return Promise.resolve<SaveBudgetingSessionsPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveBudgetingSessionsPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fillBudgetCustomFieldWithValue(body: FillBudgetCustomFieldWithValueRequest | undefined, cancelToken?: CancelToken): Promise<FillBudgetCustomFieldWithValueResponse> {
        let url_ = this.baseUrl + "/Budgeting/fill-budget-custom-field-with-value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFillBudgetCustomFieldWithValue(_response);
        });
    }

    protected processFillBudgetCustomFieldWithValue(response: AxiosResponse): Promise<FillBudgetCustomFieldWithValueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FillBudgetCustomFieldWithValueResponse.fromJS(resultData200);
            return Promise.resolve<FillBudgetCustomFieldWithValueResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FillBudgetCustomFieldWithValueResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConstructionItemsFromBudget(body: CreateConstructionItemsFromBudgetRequest | undefined, cancelToken?: CancelToken): Promise<CreateConstructionItemsFromBudgetResponse> {
        let url_ = this.baseUrl + "/Budgeting/create-construction-items-from-budget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConstructionItemsFromBudget(_response);
        });
    }

    protected processCreateConstructionItemsFromBudget(response: AxiosResponse): Promise<CreateConstructionItemsFromBudgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConstructionItemsFromBudgetResponse.fromJS(resultData200);
            return Promise.resolve<CreateConstructionItemsFromBudgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConstructionItemsFromBudgetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getConstructionStructureOutputForSession(budgetingSessionId: number, cancelToken?: CancelToken): Promise<GetConstructionStructureOutputForSessionResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-construction-structure-output-for-session/{BudgetingSessionId}";
        if (budgetingSessionId === undefined || budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' must be defined.");
        url_ = url_.replace("{BudgetingSessionId}", encodeURIComponent("" + budgetingSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConstructionStructureOutputForSession(_response);
        });
    }

    protected processGetConstructionStructureOutputForSession(response: AxiosResponse): Promise<GetConstructionStructureOutputForSessionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConstructionStructureOutputForSessionResponse.fromJS(resultData200);
            return Promise.resolve<GetConstructionStructureOutputForSessionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConstructionStructureOutputForSessionResponse>(null as any);
    }

    /**
     * @param budgetingSessionId (optional) 
     * @return Success
     */
    filterElementsForBudgetingDatabase(budgetingSessionId: number | undefined, cancelToken?: CancelToken): Promise<FilterElementsForBudgetingResponse> {
        let url_ = this.baseUrl + "/Budgeting/filter-elements-for-budgeting-database?";
        if (budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' cannot be null.");
        else if (budgetingSessionId !== undefined)
            url_ += "BudgetingSessionId=" + encodeURIComponent("" + budgetingSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilterElementsForBudgetingDatabase(_response);
        });
    }

    protected processFilterElementsForBudgetingDatabase(response: AxiosResponse): Promise<FilterElementsForBudgetingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterElementsForBudgetingResponse.fromJS(resultData200);
            return Promise.resolve<FilterElementsForBudgetingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterElementsForBudgetingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetingSessionForTiles( cancelToken?: CancelToken): Promise<GetBudgetingSessionsTilesResponse> {
        let url_ = this.baseUrl + "/Budgeting/get-budgeting-session-for-tiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetingSessionForTiles(_response);
        });
    }

    protected processGetBudgetingSessionForTiles(response: AxiosResponse): Promise<GetBudgetingSessionsTilesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetingSessionsTilesResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetingSessionsTilesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetingSessionsTilesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterElementsForBudgetingPlugin(body: FilterElementsForBudgetingPluginRequest | undefined, cancelToken?: CancelToken): Promise<FilterElementsForBudgetingResponse> {
        let url_ = this.baseUrl + "/Budgeting/filter-elements-for-budgeting-plugin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilterElementsForBudgetingPlugin(_response);
        });
    }

    protected processFilterElementsForBudgetingPlugin(response: AxiosResponse): Promise<FilterElementsForBudgetingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterElementsForBudgetingResponse.fromJS(resultData200);
            return Promise.resolve<FilterElementsForBudgetingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterElementsForBudgetingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConstructionObject(body: CreateConstructionObjectRequest | undefined, cancelToken?: CancelToken): Promise<CreateConstructionObjectResponse> {
        let url_ = this.baseUrl + "/Construction/create-construction-object";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConstructionObject(_response);
        });
    }

    protected processCreateConstructionObject(response: AxiosResponse): Promise<CreateConstructionObjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConstructionObjectResponse.fromJS(resultData200);
            return Promise.resolve<CreateConstructionObjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConstructionObjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConstructionObject(body: UpdateConstructionObjectRequest | undefined, cancelToken?: CancelToken): Promise<UpdateConstructionObjectResponse> {
        let url_ = this.baseUrl + "/Construction/update-construction-object";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateConstructionObject(_response);
        });
    }

    protected processUpdateConstructionObject(response: AxiosResponse): Promise<UpdateConstructionObjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateConstructionObjectResponse.fromJS(resultData200);
            return Promise.resolve<UpdateConstructionObjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateConstructionObjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteConstructionObject(id: number, cancelToken?: CancelToken): Promise<DeleteConstructionObjectResponse> {
        let url_ = this.baseUrl + "/Construction/delete-construction-object/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConstructionObject(_response);
        });
    }

    protected processDeleteConstructionObject(response: AxiosResponse): Promise<DeleteConstructionObjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteConstructionObjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteConstructionObjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteConstructionObjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConstructionPart(body: CreateConstructionPartRequest | undefined, cancelToken?: CancelToken): Promise<CreateConstructionPartResponse> {
        let url_ = this.baseUrl + "/Construction/create-construction-part";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConstructionPart(_response);
        });
    }

    protected processCreateConstructionPart(response: AxiosResponse): Promise<CreateConstructionPartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConstructionPartResponse.fromJS(resultData200);
            return Promise.resolve<CreateConstructionPartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConstructionPartResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConstructionPart(body: UpdateConstructionPartRequest | undefined, cancelToken?: CancelToken): Promise<UpdateConstructionPartResponse> {
        let url_ = this.baseUrl + "/Construction/update-construction-part";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateConstructionPart(_response);
        });
    }

    protected processUpdateConstructionPart(response: AxiosResponse): Promise<UpdateConstructionPartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateConstructionPartResponse.fromJS(resultData200);
            return Promise.resolve<UpdateConstructionPartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateConstructionPartResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteConstructionPart(id: number, cancelToken?: CancelToken): Promise<DeleteConstructionPartResponse> {
        let url_ = this.baseUrl + "/Construction/delete-construction-part/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConstructionPart(_response);
        });
    }

    protected processDeleteConstructionPart(response: AxiosResponse): Promise<DeleteConstructionPartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteConstructionPartResponse.fromJS(resultData200);
            return Promise.resolve<DeleteConstructionPartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteConstructionPartResponse>(null as any);
    }

    /**
     * @return Success
     */
    exportXc4(budgetingSessionId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Construction/export-xc4/{BudgetingSessionId}";
        if (budgetingSessionId === undefined || budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' must be defined.");
        url_ = url_.replace("{BudgetingSessionId}", encodeURIComponent("" + budgetingSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportXc4(_response);
        });
    }

    protected processExportXc4(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param newName (optional) 
     * @param projectId (optional) 
     * @return Success
     */
    importXc4(file: FileParameter | undefined, newName: string | undefined, projectId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Construction/import-xc4";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (newName === null || newName === undefined)
            throw new globalThis.Error("The parameter 'newName' cannot be null.");
        else
            content_.append("NewName", newName.toString());
        if (projectId === null || projectId === undefined)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportXc4(_response);
        });
    }

    protected processImportXc4(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createConstructionItem(body: CreateConstructionItemRequest | undefined, cancelToken?: CancelToken): Promise<CreateConstructionItemResponse> {
        let url_ = this.baseUrl + "/Construction/create-construction-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConstructionItem(_response);
        });
    }

    protected processCreateConstructionItem(response: AxiosResponse): Promise<CreateConstructionItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateConstructionItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateConstructionItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateConstructionItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateConstructionItem(body: UpdateConstructionItemRequest | undefined, cancelToken?: CancelToken): Promise<UpdateConstructionItemResponse> {
        let url_ = this.baseUrl + "/Construction/update-construction-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateConstructionItem(_response);
        });
    }

    protected processUpdateConstructionItem(response: AxiosResponse): Promise<UpdateConstructionItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateConstructionItemResponse.fromJS(resultData200);
            return Promise.resolve<UpdateConstructionItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateConstructionItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteConstructionItem(id: number, cancelToken?: CancelToken): Promise<DeleteConstructionItemResponse> {
        let url_ = this.baseUrl + "/Construction/delete-construction-item/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConstructionItem(_response);
        });
    }

    protected processDeleteConstructionItem(response: AxiosResponse): Promise<DeleteConstructionItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteConstructionItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteConstructionItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteConstructionItemResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomImage(projectId: number, cancelToken?: CancelToken): Promise<DeleteCustomImageForProjectResponse> {
        let url_ = this.baseUrl + "/Construction/delete-custom-image/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomImage(_response);
        });
    }

    protected processDeleteCustomImage(response: AxiosResponse): Promise<DeleteCustomImageForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCustomImageForProjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCustomImageForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCustomImageForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteDocumentation(projectId: number, cancelToken?: CancelToken): Promise<DeleteDocumentationForProjectResponse> {
        let url_ = this.baseUrl + "/Construction/delete-documentation/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocumentation(_response);
        });
    }

    protected processDeleteDocumentation(response: AxiosResponse): Promise<DeleteDocumentationForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteDocumentationForProjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteDocumentationForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteDocumentationForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getConstructionObjectPrizes(budgetingSessionId: number, cancelToken?: CancelToken): Promise<GetConstructionObjectPrizesForProjectResponse> {
        let url_ = this.baseUrl + "/Construction/get-construction-object-prizes/{BudgetingSessionId}";
        if (budgetingSessionId === undefined || budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' must be defined.");
        url_ = url_.replace("{BudgetingSessionId}", encodeURIComponent("" + budgetingSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConstructionObjectPrizes(_response);
        });
    }

    protected processGetConstructionObjectPrizes(response: AxiosResponse): Promise<GetConstructionObjectPrizesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConstructionObjectPrizesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetConstructionObjectPrizesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConstructionObjectPrizesForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getConstructionPartPrizes(budgetingSessionId: number, cancelToken?: CancelToken): Promise<GetConstructionPartsPrizesForProjectResponse> {
        let url_ = this.baseUrl + "/Construction/get-construction-part-prizes/{BudgetingSessionId}";
        if (budgetingSessionId === undefined || budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' must be defined.");
        url_ = url_.replace("{BudgetingSessionId}", encodeURIComponent("" + budgetingSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConstructionPartPrizes(_response);
        });
    }

    protected processGetConstructionPartPrizes(response: AxiosResponse): Promise<GetConstructionPartsPrizesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetConstructionPartsPrizesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetConstructionPartsPrizesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConstructionPartsPrizesForProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectRequest | undefined, cancelToken?: CancelToken): Promise<CreateProjectResponse> {
        let url_ = this.baseUrl + "/Curve/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<CreateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProject(body: UpdateProjectRequest | undefined, cancelToken?: CancelToken): Promise<UpdateProjectResponse> {
        let url_ = this.baseUrl + "/Curve/UpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: AxiosResponse): Promise<UpdateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteProject(body: DeleteProjectRequest | undefined, cancelToken?: CancelToken): Promise<DeleteProjectResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<DeleteProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRoute(body: CreateRouteRequest | undefined, cancelToken?: CancelToken): Promise<CreateRouteResponse> {
        let url_ = this.baseUrl + "/Curve/CreateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRoute(_response);
        });
    }

    protected processCreateRoute(response: AxiosResponse): Promise<CreateRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRouteResponse.fromJS(resultData200);
            return Promise.resolve<CreateRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRoute(body: UpdateRouteRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRouteResponse> {
        let url_ = this.baseUrl + "/Curve/UpdateRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRoute(_response);
        });
    }

    protected processUpdateRoute(response: AxiosResponse): Promise<UpdateRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRouteResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRoute(body: DeleteRouteRequest | undefined, cancelToken?: CancelToken): Promise<DeleteRouteResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRoute(_response);
        });
    }

    protected processDeleteRoute(response: AxiosResponse): Promise<DeleteRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRouteResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRouteResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCurves(body: CreateOrUpdateCurvesRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateCurvesResponse> {
        let url_ = this.baseUrl + "/Curve/CreateOrUpdateCurves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateCurves(_response);
        });
    }

    protected processCreateOrUpdateCurves(response: AxiosResponse): Promise<CreateOrUpdateCurvesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateCurvesResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateCurvesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateCurvesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importMultiCurvesNew(body: ImportMultiCurvesNewRequest | undefined, cancelToken?: CancelToken): Promise<ImportMultiCurvesNewResponse> {
        let url_ = this.baseUrl + "/Curve/ImportMultiCurvesNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportMultiCurvesNew(_response);
        });
    }

    protected processImportMultiCurvesNew(response: AxiosResponse): Promise<ImportMultiCurvesNewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportMultiCurvesNewResponse.fromJS(resultData200);
            return Promise.resolve<ImportMultiCurvesNewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportMultiCurvesNewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteCurve(body: DeleteCurveRequest | undefined, cancelToken?: CancelToken): Promise<DeleteCurveResponse> {
        let url_ = this.baseUrl + "/Curve/DeleteCurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCurve(_response);
        });
    }

    protected processDeleteCurve(response: AxiosResponse): Promise<DeleteCurveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteCurveResponse.fromJS(resultData200);
            return Promise.resolve<DeleteCurveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteCurveResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsForCabinet( cancelToken?: CancelToken): Promise<GetProjectsForTenantAndCabinetResponse> {
        let url_ = this.baseUrl + "/Curve/GetProjectsForCabinet";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForCabinet(_response);
        });
    }

    protected processGetProjectsForCabinet(response: AxiosResponse): Promise<GetProjectsForTenantAndCabinetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsForTenantAndCabinetResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForTenantAndCabinetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForTenantAndCabinetResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectsForTenant( cancelToken?: CancelToken): Promise<GetProjectsForTenantResponse> {
        let url_ = this.baseUrl + "/Curve/GetProjectsForTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectsForTenant(_response);
        });
    }

    protected processGetProjectsForTenant(response: AxiosResponse): Promise<GetProjectsForTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsForTenantResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsForTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsForTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectById(id: number, cancelToken?: CancelToken): Promise<GetProjectByIdResponse> {
        let url_ = this.baseUrl + "/Curve/GetProjectById/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectById(_response);
        });
    }

    protected processGetProjectById(response: AxiosResponse): Promise<GetProjectByIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectByIdResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectByIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectByIdResponse>(null as any);
    }

    /**
     * @return Success
     */
    getCurvesForRoute(id: number, cancelToken?: CancelToken): Promise<GetCurvesForRouteResponse> {
        let url_ = this.baseUrl + "/Curve/GetCurvesForRoute/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurvesForRoute(_response);
        });
    }

    protected processGetCurvesForRoute(response: AxiosResponse): Promise<GetCurvesForRouteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurvesForRouteResponse.fromJS(resultData200);
            return Promise.resolve<GetCurvesForRouteResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurvesForRouteResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRoutesForProject(id: number, cancelToken?: CancelToken): Promise<GetRoutesForProjectResponse> {
        let url_ = this.baseUrl + "/Curve/GetRoutesForProject/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoutesForProject(_response);
        });
    }

    protected processGetRoutesForProject(response: AxiosResponse): Promise<GetRoutesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoutesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetRoutesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoutesForProjectResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadCustomImageForProject(projectId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadCustomImageForProjectResponse> {
        let url_ = this.baseUrl + "/Curve/UploadCustomImageForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId === null || projectId === undefined)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadCustomImageForProject(_response);
        });
    }

    protected processUploadCustomImageForProject(response: AxiosResponse): Promise<UploadCustomImageForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadCustomImageForProjectResponse.fromJS(resultData200);
            return Promise.resolve<UploadCustomImageForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadCustomImageForProjectResponse>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadDocumentationForProject(projectId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<UploadDocumentationForProjectResponse> {
        let url_ = this.baseUrl + "/Curve/UploadDocumentationForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId === null || projectId === undefined)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocumentationForProject(_response);
        });
    }

    protected processUploadDocumentationForProject(response: AxiosResponse): Promise<UploadDocumentationForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadDocumentationForProjectResponse.fromJS(resultData200);
            return Promise.resolve<UploadDocumentationForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadDocumentationForProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelDataForProjectHierarchy(projectId: number, cancelToken?: CancelToken): Promise<GetModelDataForProjectResponse> {
        let url_ = this.baseUrl + "/Data/get-model-data-for-project-hierarchy/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelDataForProjectHierarchy(_response);
        });
    }

    protected processGetModelDataForProjectHierarchy(response: AxiosResponse): Promise<GetModelDataForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelDataForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetModelDataForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelDataForProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importExcelHospital(body: ImportHospitalExcelRequest | undefined, cancelToken?: CancelToken): Promise<ImportHospitalExcelResponse> {
        let url_ = this.baseUrl + "/Data/import-excel-hospital";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcelHospital(_response);
        });
    }

    protected processImportExcelHospital(response: AxiosResponse): Promise<ImportHospitalExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportHospitalExcelResponse.fromJS(resultData200);
            return Promise.resolve<ImportHospitalExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportHospitalExcelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGroupsWithPairerNames(standardId: number, cancelToken?: CancelToken): Promise<GetGroupsWithPairerNamesResponse> {
        let url_ = this.baseUrl + "/Data/GetGroupsWithPairerNames/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new globalThis.Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupsWithPairerNames(_response);
        });
    }

    protected processGetGroupsWithPairerNames(response: AxiosResponse): Promise<GetGroupsWithPairerNamesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGroupsWithPairerNamesResponse.fromJS(resultData200);
            return Promise.resolve<GetGroupsWithPairerNamesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGroupsWithPairerNamesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyGroup(body: CopyGroupRequest | undefined, cancelToken?: CancelToken): Promise<CopyGroupResponse> {
        let url_ = this.baseUrl + "/Data/CopyGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyGroup(_response);
        });
    }

    protected processCopyGroup(response: AxiosResponse): Promise<CopyGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyGroupResponse.fromJS(resultData200);
            return Promise.resolve<CopyGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyGroupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDataStandardElementFilters(body: UpdateDataStandardElementFiltersRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardElementFiltersResponse> {
        let url_ = this.baseUrl + "/Data/UpdateDataStandardElementFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDataStandardElementFilters(_response);
        });
    }

    protected processUpdateDataStandardElementFilters(response: AxiosResponse): Promise<UpdateDataStandardElementFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardElementFiltersResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardElementFiltersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardElementFiltersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilterItemFields(body: GetFilterItemFieldsRequest | undefined, cancelToken?: CancelToken): Promise<GetFilterItemFieldsResponse> {
        let url_ = this.baseUrl + "/Data/GetFilterItemFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilterItemFields(_response);
        });
    }

    protected processGetFilterItemFields(response: AxiosResponse): Promise<GetFilterItemFieldsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilterItemFieldsResponse.fromJS(resultData200);
            return Promise.resolve<GetFilterItemFieldsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilterItemFieldsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteDataStandardElementFilters(body: DeleteDataStandardElementFiltersRequest | undefined, cancelToken?: CancelToken): Promise<DeleteDataStandardElementFiltersResponse> {
        let url_ = this.baseUrl + "/Data/DeleteDataStandardElementFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDataStandardElementFilters(_response);
        });
    }

    protected processDeleteDataStandardElementFilters(response: AxiosResponse): Promise<DeleteDataStandardElementFiltersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteDataStandardElementFiltersResponse.fromJS(resultData200);
            return Promise.resolve<DeleteDataStandardElementFiltersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteDataStandardElementFiltersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getStandards( cancelToken?: CancelToken): Promise<GetDataStandardsResponse> {
        let url_ = this.baseUrl + "/Data/GetStandards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandards(_response);
        });
    }

    protected processGetStandards(response: AxiosResponse): Promise<GetDataStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardsResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStandard(body: CreateDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<CreateDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/CreateStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStandard(_response);
        });
    }

    protected processCreateStandard(response: AxiosResponse): Promise<CreateDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<CreateDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyStandard(body: CopyDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<CopyDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/CopyStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyStandard(_response);
        });
    }

    protected processCopyStandard(response: AxiosResponse): Promise<CopyDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<CopyDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandard(body: UpdateDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardResponse> {
        let url_ = this.baseUrl + "/Data/UpdateStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStandard(_response);
        });
    }

    protected processUpdateStandard(response: AxiosResponse): Promise<UpdateDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteStandard(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteStandard/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStandard(_response);
        });
    }

    protected processDeleteStandard(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @return Success
     */
    getGroupsForStandard(standardId: number, cancelToken?: CancelToken): Promise<GetGroupsForStandardResponse> {
        let url_ = this.baseUrl + "/Data/GetGroupsForStandard/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new globalThis.Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupsForStandard(_response);
        });
    }

    protected processGetGroupsForStandard(response: AxiosResponse): Promise<GetGroupsForStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetGroupsForStandardResponse.fromJS(resultData200);
            return Promise.resolve<GetGroupsForStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetGroupsForStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGroupForStandard(body: CreateGroupForStandardRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateGroupForStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroupForStandard(_response);
        });
    }

    protected processCreateGroupForStandard(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGroupForStandard(body: UpdateGroupForStandardRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdateGroupForStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroupForStandard(_response);
        });
    }

    protected processUpdateGroupForStandard(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteGroupForStandard(groupId: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteGroupForStandard/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGroupForStandard(_response);
        });
    }

    protected processDeleteGroupForStandard(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateSingleFilter(body: FilterElementsRequest | undefined, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/ValidateSingleFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateSingleFilter(_response);
        });
    }

    protected processValidateSingleFilter(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPairer(body: CreatePairerRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreatePairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePairer(_response);
        });
    }

    protected processCreatePairer(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    deletePairer(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeletePairer/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePairer(_response);
        });
    }

    protected processDeletePairer(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deletePairers(body: DeletePairersRequest | undefined, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeletePairers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePairers(_response);
        });
    }

    protected processDeletePairers(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRule(body: CreateValidationsRuleRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRule(_response);
        });
    }

    protected processCreateRule(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPairerDetail(id: number, cancelToken?: CancelToken): Promise<GetPairerDetailResponse> {
        let url_ = this.baseUrl + "/Data/GetPairerDetail/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPairerDetail(_response);
        });
    }

    protected processGetPairerDetail(response: AxiosResponse): Promise<GetPairerDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPairerDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetPairerDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPairerDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModel(body: ValidateModelRequest | undefined, cancelToken?: CancelToken): Promise<ValidateModelResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModel(_response);
        });
    }

    protected processValidateModel(response: AxiosResponse): Promise<ValidateModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateModelResponse.fromJS(resultData200);
            return Promise.resolve<ValidateModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModelTreeResultLarge(body: ValidateModelAndReturnByPairersRequest | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModelTreeResultLarge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModelTreeResultLarge(_response);
        });
    }

    protected processValidateModelTreeResultLarge(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModelTreeResult(body: ValidateModelAndReturnByPairersRequest | undefined, cancelToken?: CancelToken): Promise<ValidateModelAndReturnByPairersResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModelTreeResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModelTreeResult(_response);
        });
    }

    protected processValidateModelTreeResult(response: AxiosResponse): Promise<ValidateModelAndReturnByPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateModelAndReturnByPairersResponse.fromJS(resultData200);
            return Promise.resolve<ValidateModelAndReturnByPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateModelAndReturnByPairersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateModelTreeResultDatabase(body: ValidateModelAndReturnByPairersDatabaseRequest | undefined, cancelToken?: CancelToken): Promise<ValidateModelAndReturnByPairersResponse> {
        let url_ = this.baseUrl + "/Data/ValidateModelTreeResultDatabase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateModelTreeResultDatabase(_response);
        });
    }

    protected processValidateModelTreeResultDatabase(response: AxiosResponse): Promise<ValidateModelAndReturnByPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateModelAndReturnByPairersResponse.fromJS(resultData200);
            return Promise.resolve<ValidateModelAndReturnByPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateModelAndReturnByPairersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPairersListForGroupId(groupId: number, cancelToken?: CancelToken): Promise<GetPairerListForGroupIdResponse> {
        let url_ = this.baseUrl + "/Data/GetPairersListForGroupId/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPairersListForGroupId(_response);
        });
    }

    protected processGetPairersListForGroupId(response: AxiosResponse): Promise<GetPairerListForGroupIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPairerListForGroupIdResponse.fromJS(resultData200);
            return Promise.resolve<GetPairerListForGroupIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPairerListForGroupIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteValidationsRule(body: DeleteValidationsRuleRequest | undefined, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteValidationsRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteValidationsRule(_response);
        });
    }

    protected processDeleteValidationsRule(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateValidationsRule(body: UpdateValidationsRuleRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdateValidationsRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateValidationsRule(_response);
        });
    }

    protected processUpdateValidationsRule(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyValidationRules(body: CopyValidationRulesRequest | undefined, cancelToken?: CancelToken): Promise<CopyValidationRulesResponse> {
        let url_ = this.baseUrl + "/Data/CopyValidationRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyValidationRules(_response);
        });
    }

    protected processCopyValidationRules(response: AxiosResponse): Promise<CopyValidationRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyValidationRulesResponse.fromJS(resultData200);
            return Promise.resolve<CopyValidationRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyValidationRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyPairers(body: CopyPairersRequest | undefined, cancelToken?: CancelToken): Promise<CopyPairersResponse> {
        let url_ = this.baseUrl + "/Data/CopyPairers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyPairers(_response);
        });
    }

    protected processCopyPairers(response: AxiosResponse): Promise<CopyPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyPairersResponse.fromJS(resultData200);
            return Promise.resolve<CopyPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyPairersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePairer(body: UpdatePairerRequest | undefined, cancelToken?: CancelToken): Promise<UpdateResponse> {
        let url_ = this.baseUrl + "/Data/UpdatePairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePairer(_response);
        });
    }

    protected processUpdatePairer(response: AxiosResponse): Promise<UpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMutliPairerByIds(body: GetMultiPairerByIdsRequest | undefined, cancelToken?: CancelToken): Promise<GetMultiPairerByIdsResponse> {
        let url_ = this.baseUrl + "/Data/GetMutliPairerByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMutliPairerByIds(_response);
        });
    }

    protected processGetMutliPairerByIds(response: AxiosResponse): Promise<GetMultiPairerByIdsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiPairerByIdsResponse.fromJS(resultData200);
            return Promise.resolve<GetMultiPairerByIdsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiPairerByIdsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMutliPairerByGroupId(groupId: number, cancelToken?: CancelToken): Promise<GetMultiPairerByGroupIdResponse> {
        let url_ = this.baseUrl + "/Data/GetMutliPairerByGroupId/{GroupId}";
        if (groupId === undefined || groupId === null)
            throw new globalThis.Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{GroupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMutliPairerByGroupId(_response);
        });
    }

    protected processGetMutliPairerByGroupId(response: AxiosResponse): Promise<GetMultiPairerByGroupIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMultiPairerByGroupIdResponse.fromJS(resultData200);
            return Promise.resolve<GetMultiPairerByGroupIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMultiPairerByGroupIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPairerOrGroup(body: CreateOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreatePairerOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePairerOrGroup(_response);
        });
    }

    protected processCreatePairerOrGroup(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRuleInPairerOrGroup(body: CreateValidationRuleInOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<CreateEntityResponse> {
        let url_ = this.baseUrl + "/Data/CreateRuleInPairerOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRuleInPairerOrGroup(_response);
        });
    }

    protected processCreateRuleInPairerOrGroup(response: AxiosResponse): Promise<CreateEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateEntityResponse.fromJS(resultData200);
            return Promise.resolve<CreateEntityResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateEntityResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteOrGroup(id: number, cancelToken?: CancelToken): Promise<EmptyResponse> {
        let url_ = this.baseUrl + "/Data/DeleteOrGroup/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrGroup(_response);
        });
    }

    protected processDeleteOrGroup(response: AxiosResponse): Promise<EmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmptyResponse.fromJS(resultData200);
            return Promise.resolve<EmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMultiPairer(body: SaveMultiPairerRequest | undefined, cancelToken?: CancelToken): Promise<SaveMultiPairerResponse> {
        let url_ = this.baseUrl + "/Data/SaveMultiPairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMultiPairer(_response);
        });
    }

    protected processSaveMultiPairer(response: AxiosResponse): Promise<SaveMultiPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMultiPairerResponse.fromJS(resultData200);
            return Promise.resolve<SaveMultiPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMultiPairerResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrGroup(body: UpdateOrGroupRequest | undefined, cancelToken?: CancelToken): Promise<UpdateOrGroupResponse> {
        let url_ = this.baseUrl + "/Data/UpdateOrGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrGroup(_response);
        });
    }

    protected processUpdateOrGroup(response: AxiosResponse): Promise<UpdateOrGroupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateOrGroupResponse.fromJS(resultData200);
            return Promise.resolve<UpdateOrGroupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateOrGroupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteOrGroupRuleSet(body: DeleteOrGroupRuleSetRequest | undefined, cancelToken?: CancelToken): Promise<DeleteOrGroupRuleSetResponse> {
        let url_ = this.baseUrl + "/Data/DeleteOrGroupRuleSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrGroupRuleSet(_response);
        });
    }

    protected processDeleteOrGroupRuleSet(response: AxiosResponse): Promise<DeleteOrGroupRuleSetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteOrGroupRuleSetResponse.fromJS(resultData200);
            return Promise.resolve<DeleteOrGroupRuleSetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteOrGroupRuleSetResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectData(body: UpdateProjectDataRequest | undefined, cancelToken?: CancelToken): Promise<UpdateProjectDataResponse> {
        let url_ = this.baseUrl + "/Data/UpdateProjectData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectData(_response);
        });
    }

    protected processUpdateProjectData(response: AxiosResponse): Promise<UpdateProjectDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectDataResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDataStandardForTreePairing(standardId: number, cancelToken?: CancelToken): Promise<GetDataStandardForTreePairingResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreePairing/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new globalThis.Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreePairing(_response);
        });
    }

    protected processGetDataStandardForTreePairing(response: AxiosResponse): Promise<GetDataStandardForTreePairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreePairingResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreePairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreePairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMicrostationPairingPairer(body: AddMicrostationPairingPairerRequest | undefined, cancelToken?: CancelToken): Promise<AddMicrostationPairingPairerResponse> {
        let url_ = this.baseUrl + "/Data/AddMicrostationPairingPairer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMicrostationPairingPairer(_response);
        });
    }

    protected processAddMicrostationPairingPairer(response: AxiosResponse): Promise<AddMicrostationPairingPairerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMicrostationPairingPairerResponse.fromJS(resultData200);
            return Promise.resolve<AddMicrostationPairingPairerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMicrostationPairingPairerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMicrostationPairingPairings(mStnPairingId: number, cancelToken?: CancelToken): Promise<GetMicrostationPairingPairingsResponse> {
        let url_ = this.baseUrl + "/Data/GetMicrostationPairingPairings/{MStnPairingId}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new globalThis.Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrostationPairingPairings(_response);
        });
    }

    protected processGetMicrostationPairingPairings(response: AxiosResponse): Promise<GetMicrostationPairingPairingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMicrostationPairingPairingsResponse.fromJS(resultData200);
            return Promise.resolve<GetMicrostationPairingPairingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMicrostationPairingPairingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMicrostationPairingPairers(body: GetMicrostationPairingPairersRequest | undefined, cancelToken?: CancelToken): Promise<GetMicrostationPairingPairersResponse> {
        let url_ = this.baseUrl + "/Data/GetMicrostationPairingPairers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrostationPairingPairers(_response);
        });
    }

    protected processGetMicrostationPairingPairers(response: AxiosResponse): Promise<GetMicrostationPairingPairersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMicrostationPairingPairersResponse.fromJS(resultData200);
            return Promise.resolve<GetMicrostationPairingPairersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMicrostationPairingPairersResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMicrostationPairings(body: DeleteMicrostationPairingsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteMicrostationPairingsResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMicrostationPairings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMicrostationPairings(_response);
        });
    }

    protected processDeleteMicrostationPairings(response: AxiosResponse): Promise<DeleteMicrostationPairingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMicrostationPairingsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMicrostationPairingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMicrostationPairingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataStandardForTreeValRule(body: GetDataStandardForTreeValRuleRequest | undefined, cancelToken?: CancelToken): Promise<GetDataStandardForTreeValRuleResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreeValRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreeValRule(_response);
        });
    }

    protected processGetDataStandardForTreeValRule(response: AxiosResponse): Promise<GetDataStandardForTreeValRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreeValRuleResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreeValRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreeValRuleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByLevels(body: GetMStnPairingsByLevelsRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByLevelsResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByLevels(_response);
        });
    }

    protected processGetMStnPairingsByLevels(response: AxiosResponse): Promise<GetMStnPairingsByLevelsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByLevelsResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByLevelsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByLevelsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByRelevance(body: GetMStnPairingsByRelevanceRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByRelevanceResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByRelevance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByRelevance(_response);
        });
    }

    protected processGetMStnPairingsByRelevance(response: AxiosResponse): Promise<GetMStnPairingsByRelevanceResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByRelevanceResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByRelevanceResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByRelevanceResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMStnPairingsLevelsName(mStnPairingId: number, cancelToken?: CancelToken): Promise<GetMStnPairingsLevelsNameResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsLevelsName/{MStnPairingId}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new globalThis.Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsLevelsName(_response);
        });
    }

    protected processGetMStnPairingsLevelsName(response: AxiosResponse): Promise<GetMStnPairingsLevelsNameResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsLevelsNameResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsLevelsNameResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsLevelsNameResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMicrostationPairing(projectId: number, cancelToken?: CancelToken): Promise<GetMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/GetMicrostationPairing/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMicrostationPairing(_response);
        });
    }

    protected processGetMicrostationPairing(response: AxiosResponse): Promise<GetMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<GetMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMicrostationPairing(body: CreateMicrostationPairingRequest | undefined, cancelToken?: CancelToken): Promise<CreateMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/CreateMicrostationPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMicrostationPairing(_response);
        });
    }

    protected processCreateMicrostationPairing(response: AxiosResponse): Promise<CreateMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<CreateMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateMicrostationPairingResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteMicrostationPairing(pairingId: number, cancelToken?: CancelToken): Promise<DeleteMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMicrostationPairing/{PairingId}";
        if (pairingId === undefined || pairingId === null)
            throw new globalThis.Error("The parameter 'pairingId' must be defined.");
        url_ = url_.replace("{PairingId}", encodeURIComponent("" + pairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMicrostationPairing(_response);
        });
    }

    protected processDeleteMicrostationPairing(response: AxiosResponse): Promise<DeleteMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnPairingsByRelevance2(body: GetMStnPairingsByRelevance2Request | undefined, cancelToken?: CancelToken): Promise<GetMStnPairingsByRelevance2Response> {
        let url_ = this.baseUrl + "/Data/GetMStnPairingsByRelevance2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnPairingsByRelevance2(_response);
        });
    }

    protected processGetMStnPairingsByRelevance2(response: AxiosResponse): Promise<GetMStnPairingsByRelevance2Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnPairingsByRelevance2Response.fromJS(resultData200);
            return Promise.resolve<GetMStnPairingsByRelevance2Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnPairingsByRelevance2Response>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMicrostationPairing(body: UpdateMicrostationPairingRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMicrostationPairingResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMicrostationPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMicrostationPairing(_response);
        });
    }

    protected processUpdateMicrostationPairing(response: AxiosResponse): Promise<UpdateMicrostationPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMicrostationPairingResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMicrostationPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMicrostationPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMicrostationAllAssign(body: AddMicrostationAllAssignRequest | undefined, cancelToken?: CancelToken): Promise<AddMicrostationAllAssignResponse> {
        let url_ = this.baseUrl + "/Data/AddMicrostationAllAssign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMicrostationAllAssign(_response);
        });
    }

    protected processAddMicrostationAllAssign(response: AxiosResponse): Promise<AddMicrostationAllAssignResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMicrostationAllAssignResponse.fromJS(resultData200);
            return Promise.resolve<AddMicrostationAllAssignResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMicrostationAllAssignResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMStnFeederItems(body: AddMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<AddMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/AddMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMStnFeederItems(_response);
        });
    }

    protected processAddMStnFeederItems(response: AxiosResponse): Promise<AddMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<AddMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederItems(body: UpdateMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederItems(_response);
        });
    }

    protected processUpdateMStnFeederItems(response: AxiosResponse): Promise<UpdateMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMStnFeederItems(body: DeleteMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<DeleteMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMStnFeederItems(_response);
        });
    }

    protected processDeleteMStnFeederItems(response: AxiosResponse): Promise<DeleteMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederItemsCount(body: GetMStnFeederItemsCountRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederItemsCountResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederItemsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederItemsCount(_response);
        });
    }

    protected processGetMStnFeederItemsCount(response: AxiosResponse): Promise<GetMStnFeederItemsCountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederItemsCountResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederItemsCountResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederItemsCountResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederItems(body: GetMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederItems(_response);
        });
    }

    protected processGetMStnFeederItems(response: AxiosResponse): Promise<GetMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederAllValRules(body: GetMStnFeederAllValRulesRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederAllValRulesResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederAllValRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederAllValRules(_response);
        });
    }

    protected processGetMStnFeederAllValRules(response: AxiosResponse): Promise<GetMStnFeederAllValRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederAllValRulesResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederAllValRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederAllValRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataStandardForTreeFeeder(body: GetDataStandardForTreeFeederRequest | undefined, cancelToken?: CancelToken): Promise<GetDataStandardForTreeFeederResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardForTreeFeeder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardForTreeFeeder(_response);
        });
    }

    protected processGetDataStandardForTreeFeeder(response: AxiosResponse): Promise<GetDataStandardForTreeFeederResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardForTreeFeederResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardForTreeFeederResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardForTreeFeederResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederFromDGN(body: UpdateMStnFeederFromDGNRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederFromDGNResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederFromDGN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederFromDGN(_response);
        });
    }

    protected processUpdateMStnFeederFromDGN(response: AxiosResponse): Promise<UpdateMStnFeederFromDGNResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederFromDGNResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederFromDGNResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederFromDGNResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederAutoValues(body: UpdateMStnFeederAutoValuesRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederAutoValuesResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederAutoValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederAutoValues(_response);
        });
    }

    protected processUpdateMStnFeederAutoValues(response: AxiosResponse): Promise<UpdateMStnFeederAutoValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederAutoValuesResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederAutoValuesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederAutoValuesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederAutoValuesToManual(body: UpdateMStnFeederAutoValuesToManualRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederAutoValuesToManualResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederAutoValuesToManual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederAutoValuesToManual(_response);
        });
    }

    protected processUpdateMStnFeederAutoValuesToManual(response: AxiosResponse): Promise<UpdateMStnFeederAutoValuesToManualResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederAutoValuesToManualResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederAutoValuesToManualResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederAutoValuesToManualResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederCurveName(body: UpdateMStnFeederCurveNameRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederCurveNameResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederCurveName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederCurveName(_response);
        });
    }

    protected processUpdateMStnFeederCurveName(response: AxiosResponse): Promise<UpdateMStnFeederCurveNameResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederCurveNameResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederCurveNameResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederCurveNameResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederStartStationing(body: UpdateMStnFeederStartStationingRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederStartStationingResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederStartStationing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederStartStationing(_response);
        });
    }

    protected processUpdateMStnFeederStartStationing(response: AxiosResponse): Promise<UpdateMStnFeederStartStationingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederStartStationingResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederStartStationingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederStartStationingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importMStnFeederValues(body: ImportMStnFeederValuesRequest | undefined, cancelToken?: CancelToken): Promise<ImportMStnFeederValuesResponse> {
        let url_ = this.baseUrl + "/Data/ImportMStnFeederValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportMStnFeederValues(_response);
        });
    }

    protected processImportMStnFeederValues(response: AxiosResponse): Promise<ImportMStnFeederValuesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportMStnFeederValuesResponse.fromJS(resultData200);
            return Promise.resolve<ImportMStnFeederValuesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportMStnFeederValuesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataStandardValRuleFields(body: GetDataStandardValRuleFieldsRequest | undefined, cancelToken?: CancelToken): Promise<GetDataStandardValRuleFieldsResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardValRuleFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardValRuleFields(_response);
        });
    }

    protected processGetDataStandardValRuleFields(response: AxiosResponse): Promise<GetDataStandardValRuleFieldsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardValRuleFieldsResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardValRuleFieldsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardValRuleFieldsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDataStandardDecimalPlaces(body: UpdateDataStandardDecimalPlacesRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardDecimalPlacesResponse> {
        let url_ = this.baseUrl + "/Data/UpdateDataStandardDecimalPlaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDataStandardDecimalPlaces(_response);
        });
    }

    protected processUpdateDataStandardDecimalPlaces(response: AxiosResponse): Promise<UpdateDataStandardDecimalPlacesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardDecimalPlacesResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardDecimalPlacesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardDecimalPlacesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandardRSD(body: ImportDataStandardRSDRequest | undefined, cancelToken?: CancelToken): Promise<ImportDataStandardRSDResponse> {
        let url_ = this.baseUrl + "/Data/ImportDataStandardRSD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandardRSD(_response);
        });
    }

    protected processImportDataStandardRSD(response: AxiosResponse): Promise<ImportDataStandardRSDResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportDataStandardRSDResponse.fromJS(resultData200);
            return Promise.resolve<ImportDataStandardRSDResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportDataStandardRSDResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnPairingFilteredPairerGroups(body: UpdateMStnPairingFilteredPairerGroupsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnPairingFilteredPairerGroupsResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnPairingFilteredPairerGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnPairingFilteredPairerGroups(_response);
        });
    }

    protected processUpdateMStnPairingFilteredPairerGroups(response: AxiosResponse): Promise<UpdateMStnPairingFilteredPairerGroupsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnPairingFilteredPairerGroupsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnPairingFilteredPairerGroupsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnPairingFilteredPairerGroupsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMStnFeederElementStationing(body: SaveMStnFeederElementStationingRequest | undefined, cancelToken?: CancelToken): Promise<SaveMStnFeederElementStationingResponse> {
        let url_ = this.baseUrl + "/Data/SaveMStnFeederElementStationing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMStnFeederElementStationing(_response);
        });
    }

    protected processSaveMStnFeederElementStationing(response: AxiosResponse): Promise<SaveMStnFeederElementStationingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMStnFeederElementStationingResponse.fromJS(resultData200);
            return Promise.resolve<SaveMStnFeederElementStationingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMStnFeederElementStationingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMStnFeederElementStationing(body: DeleteMStnFeederElementStationingRequest | undefined, cancelToken?: CancelToken): Promise<DeleteMStnFeederElementStationingResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMStnFeederElementStationing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMStnFeederElementStationing(_response);
        });
    }

    protected processDeleteMStnFeederElementStationing(response: AxiosResponse): Promise<DeleteMStnFeederElementStationingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMStnFeederElementStationingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMStnFeederElementStationingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMStnFeederElementStationingResponse>(null as any);
    }

    /**
     * @return Success
     */
    getMStnFeederElementsStationing(mStnPairingId: number, cancelToken?: CancelToken): Promise<GetMStnFeederElementsStationingResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederElementsStationing/{MStnPairingId}";
        if (mStnPairingId === undefined || mStnPairingId === null)
            throw new globalThis.Error("The parameter 'mStnPairingId' must be defined.");
        url_ = url_.replace("{MStnPairingId}", encodeURIComponent("" + mStnPairingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederElementsStationing(_response);
        });
    }

    protected processGetMStnFeederElementsStationing(response: AxiosResponse): Promise<GetMStnFeederElementsStationingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederElementsStationingResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederElementsStationingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederElementsStationingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederIsMultipleRoutes(body: UpdateMStnFeederIsMultipleRoutesRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederIsMultipleRoutesResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederIsMultipleRoutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederIsMultipleRoutes(_response);
        });
    }

    protected processUpdateMStnFeederIsMultipleRoutes(response: AxiosResponse): Promise<UpdateMStnFeederIsMultipleRoutesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederIsMultipleRoutesResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederIsMultipleRoutesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederIsMultipleRoutesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addMStnFeederCurve(body: AddMStnFeederCurveRequest | undefined, cancelToken?: CancelToken): Promise<AddMStnFeederCurveResponse> {
        let url_ = this.baseUrl + "/Data/AddMStnFeederCurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMStnFeederCurve(_response);
        });
    }

    protected processAddMStnFeederCurve(response: AxiosResponse): Promise<AddMStnFeederCurveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMStnFeederCurveResponse.fromJS(resultData200);
            return Promise.resolve<AddMStnFeederCurveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMStnFeederCurveResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMStnFeederCurve(body: UpdateMStnFeederCurveRequest | undefined, cancelToken?: CancelToken): Promise<UpdateMStnFeederCurveResponse> {
        let url_ = this.baseUrl + "/Data/UpdateMStnFeederCurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMStnFeederCurve(_response);
        });
    }

    protected processUpdateMStnFeederCurve(response: AxiosResponse): Promise<UpdateMStnFeederCurveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateMStnFeederCurveResponse.fromJS(resultData200);
            return Promise.resolve<UpdateMStnFeederCurveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateMStnFeederCurveResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMStnFeederCurve(body: DeleteMStnFeederCurveRequest | undefined, cancelToken?: CancelToken): Promise<DeleteMStnFeederCurveResponse> {
        let url_ = this.baseUrl + "/Data/DeleteMStnFeederCurve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMStnFeederCurve(_response);
        });
    }

    protected processDeleteMStnFeederCurve(response: AxiosResponse): Promise<DeleteMStnFeederCurveResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMStnFeederCurveResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMStnFeederCurveResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMStnFeederCurveResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederCurves(body: GetMStnFeederCurvesRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederCurvesResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederCurves";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederCurves(_response);
        });
    }

    protected processGetMStnFeederCurves(response: AxiosResponse): Promise<GetMStnFeederCurvesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederCurvesResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederCurvesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederCurvesResponse>(null as any);
    }

    /**
     * @return Success
     */
    isStandardDefault(id: number, cancelToken?: CancelToken): Promise<GetStandardIsDefaultResponse> {
        let url_ = this.baseUrl + "/Data/is-standard-default/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsStandardDefault(_response);
        });
    }

    protected processIsStandardDefault(response: AxiosResponse): Promise<GetStandardIsDefaultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStandardIsDefaultResponse.fromJS(resultData200);
            return Promise.resolve<GetStandardIsDefaultResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStandardIsDefaultResponse>(null as any);
    }

    /**
     * @return Success
     */
    isStandardEmpty(id: number, cancelToken?: CancelToken): Promise<GetStandardIsEmptyResponse> {
        let url_ = this.baseUrl + "/Data/is-standard-empty/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsStandardEmpty(_response);
        });
    }

    protected processIsStandardEmpty(response: AxiosResponse): Promise<GetStandardIsEmptyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStandardIsEmptyResponse.fromJS(resultData200);
            return Promise.resolve<GetStandardIsEmptyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStandardIsEmptyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importPairing(body: ImportPairingRequest | undefined, cancelToken?: CancelToken): Promise<ImportPairingResponse> {
        let url_ = this.baseUrl + "/Data/ImportPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportPairing(_response);
        });
    }

    protected processImportPairing(response: AxiosResponse): Promise<ImportPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportPairingResponse.fromJS(resultData200);
            return Promise.resolve<ImportPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyPairing(body: CopyPairingRequest | undefined, cancelToken?: CancelToken): Promise<CopyPairingResponse> {
        let url_ = this.baseUrl + "/Data/CopyPairing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyPairing(_response);
        });
    }

    protected processCopyPairing(response: AxiosResponse): Promise<CopyPairingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CopyPairingResponse.fromJS(resultData200);
            return Promise.resolve<CopyPairingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CopyPairingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMStnFeederItems(body: SaveMStnFeederItemsRequest | undefined, cancelToken?: CancelToken): Promise<SaveMStnFeederItemsResponse> {
        let url_ = this.baseUrl + "/Data/SaveMStnFeederItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMStnFeederItems(_response);
        });
    }

    protected processSaveMStnFeederItems(response: AxiosResponse): Promise<SaveMStnFeederItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMStnFeederItemsResponse.fromJS(resultData200);
            return Promise.resolve<SaveMStnFeederItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMStnFeederItemsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDataStandardBCHPValRules(standardId: number, cancelToken?: CancelToken): Promise<GetDataStandardBCHPValRulesResponse> {
        let url_ = this.baseUrl + "/Data/GetDataStandardBCHPValRules/{StandardId}";
        if (standardId === undefined || standardId === null)
            throw new globalThis.Error("The parameter 'standardId' must be defined.");
        url_ = url_.replace("{StandardId}", encodeURIComponent("" + standardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataStandardBCHPValRules(_response);
        });
    }

    protected processGetDataStandardBCHPValRules(response: AxiosResponse): Promise<GetDataStandardBCHPValRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataStandardBCHPValRulesResponse.fromJS(resultData200);
            return Promise.resolve<GetDataStandardBCHPValRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataStandardBCHPValRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDataStandardValRules(body: UpdateDataStandardValRulesRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardValRulesResponse> {
        let url_ = this.baseUrl + "/Data/UpdateDataStandardValRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDataStandardValRules(_response);
        });
    }

    protected processUpdateDataStandardValRules(response: AxiosResponse): Promise<UpdateDataStandardValRulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardValRulesResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardValRulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardValRulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveMStnFeederFormulas(body: SaveMStnFeederFormulasRequest | undefined, cancelToken?: CancelToken): Promise<SaveMStnFeederFormulasResponse> {
        let url_ = this.baseUrl + "/Data/SaveMStnFeederFormulas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMStnFeederFormulas(_response);
        });
    }

    protected processSaveMStnFeederFormulas(response: AxiosResponse): Promise<SaveMStnFeederFormulasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveMStnFeederFormulasResponse.fromJS(resultData200);
            return Promise.resolve<SaveMStnFeederFormulasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveMStnFeederFormulasResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMStnFeederFormulaItems(body: GetMStnFeederFormulaItemsRequest | undefined, cancelToken?: CancelToken): Promise<GetMStnFeederFormulaItemsResponse> {
        let url_ = this.baseUrl + "/Data/GetMStnFeederFormulaItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMStnFeederFormulaItems(_response);
        });
    }

    protected processGetMStnFeederFormulaItems(response: AxiosResponse): Promise<GetMStnFeederFormulaItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMStnFeederFormulaItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetMStnFeederFormulaItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMStnFeederFormulaItemsResponse>(null as any);
    }

    /**
     * @param standardId (optional) 
     * @param budgetingSessionId (optional) 
     * @return Success
     */
    getAllPairersForStandard(standardId: number | undefined, budgetingSessionId: number | undefined, cancelToken?: CancelToken): Promise<GetAllPairersForStandardResponse> {
        let url_ = this.baseUrl + "/Data/GetAllPairersForStandard?";
        if (standardId === null)
            throw new globalThis.Error("The parameter 'standardId' cannot be null.");
        else if (standardId !== undefined)
            url_ += "StandardId=" + encodeURIComponent("" + standardId) + "&";
        if (budgetingSessionId === null)
            throw new globalThis.Error("The parameter 'budgetingSessionId' cannot be null.");
        else if (budgetingSessionId !== undefined)
            url_ += "BudgetingSessionId=" + encodeURIComponent("" + budgetingSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPairersForStandard(_response);
        });
    }

    protected processGetAllPairersForStandard(response: AxiosResponse): Promise<GetAllPairersForStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllPairersForStandardResponse.fromJS(resultData200);
            return Promise.resolve<GetAllPairersForStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPairersForStandardResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSharedDataStandard( cancelToken?: CancelToken): Promise<GetSharedDataStandardsResponse> {
        let url_ = this.baseUrl + "/DataStandardsShare/GetSharedDataStandard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedDataStandard(_response);
        });
    }

    protected processGetSharedDataStandard(response: AxiosResponse): Promise<GetSharedDataStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSharedDataStandardsResponse.fromJS(resultData200);
            return Promise.resolve<GetSharedDataStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSharedDataStandardsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShareDataStandards(body: UpdateShareDataStandardsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateShareDataStandardsResponse> {
        let url_ = this.baseUrl + "/DataStandardsShare/UpdateShareDataStandards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShareDataStandards(_response);
        });
    }

    protected processUpdateShareDataStandards(response: AxiosResponse): Promise<UpdateShareDataStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateShareDataStandardsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateShareDataStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateShareDataStandardsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getAllDataStandardsSharing( cancelToken?: CancelToken): Promise<GetAllDataStandardsSharingResponse> {
        let url_ = this.baseUrl + "/DataStandardsShare/GetAllDataStandardsSharing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDataStandardsSharing(_response);
        });
    }

    protected processGetAllDataStandardsSharing(response: AxiosResponse): Promise<GetAllDataStandardsSharingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllDataStandardsSharingResponse.fromJS(resultData200);
            return Promise.resolve<GetAllDataStandardsSharingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllDataStandardsSharingResponse>(null as any);
    }

    /**
     * @param excel (optional) 
     * @param xmls (optional) 
     * @return Success
     */
    getInitData(excel: FileParameter | undefined, xmls: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<GetInitDataResponse> {
        let url_ = this.baseUrl + "/ETCS/GetInitData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (excel === null || excel === undefined)
            throw new globalThis.Error("The parameter 'excel' cannot be null.");
        else
            content_.append("Excel", excel.data, excel.fileName ? excel.fileName : "Excel");
        if (xmls === null || xmls === undefined)
            throw new globalThis.Error("The parameter 'xmls' cannot be null.");
        else
            xmls.forEach(item_ => content_.append("Xmls", item_.data, item_.fileName ? item_.fileName : "Xmls") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitData(_response);
        });
    }

    protected processGetInitData(response: AxiosResponse): Promise<GetInitDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInitDataResponse.fromJS(resultData200);
            return Promise.resolve<GetInitDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInitDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDownloadLinkFromCorsServer(url: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/FileHelper/GetDownloadLinkFromCorsServer/{url}";
        if (url === undefined || url === null)
            throw new globalThis.Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadLinkFromCorsServer(_response);
        });
    }

    protected processGetDownloadLinkFromCorsServer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    formulaList( cancelToken?: CancelToken): Promise<GetFormulasResponse> {
        let url_ = this.baseUrl + "/Formula/formula-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFormulaList(_response);
        });
    }

    protected processFormulaList(response: AxiosResponse): Promise<GetFormulasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFormulasResponse.fromJS(resultData200);
            return Promise.resolve<GetFormulasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFormulasResponse>(null as any);
    }

    /**
     * @return Success
     */
    formula(id: number, cancelToken?: CancelToken): Promise<GetFormulaResponse> {
        let url_ = this.baseUrl + "/Formula/formula/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFormula(_response);
        });
    }

    protected processFormula(response: AxiosResponse): Promise<GetFormulaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFormulaResponse.fromJS(resultData200);
            return Promise.resolve<GetFormulaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFormulaResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveFormula(body: SaveFormulaRequest | undefined, cancelToken?: CancelToken): Promise<SaveFormulaResponse> {
        let url_ = this.baseUrl + "/Formula/save-formula";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveFormula(_response);
        });
    }

    protected processSaveFormula(response: AxiosResponse): Promise<SaveFormulaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveFormulaResponse.fromJS(resultData200);
            return Promise.resolve<SaveFormulaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveFormulaResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteFormula(id: number, cancelToken?: CancelToken): Promise<DeleteFormulaResponse> {
        let url_ = this.baseUrl + "/Formula/delete-formula/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFormula(_response);
        });
    }

    protected processDeleteFormula(response: AxiosResponse): Promise<DeleteFormulaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteFormulaResponse.fromJS(resultData200);
            return Promise.resolve<DeleteFormulaResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteFormulaResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandard(body: ImportDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<ImportDataStandardResponse> {
        let url_ = this.baseUrl + "/Import/ImportDataStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandard(_response);
        });
    }

    protected processImportDataStandard(response: AxiosResponse): Promise<ImportDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<ImportDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDataStandardFromExcel(body: UpdateDataStandardFromExcelRequest | undefined, cancelToken?: CancelToken): Promise<UpdateDataStandardFromExcelResponse> {
        let url_ = this.baseUrl + "/Import/UpdateDataStandardFromExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDataStandardFromExcel(_response);
        });
    }

    protected processUpdateDataStandardFromExcel(response: AxiosResponse): Promise<UpdateDataStandardFromExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataStandardFromExcelResponse.fromJS(resultData200);
            return Promise.resolve<UpdateDataStandardFromExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataStandardFromExcelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportIDSFromStandard(body: IdsExportRequest | undefined, cancelToken?: CancelToken): Promise<ExportResult> {
        let url_ = this.baseUrl + "/Import/ExportIDSFromStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportIDSFromStandard(_response);
        });
    }

    protected processExportIDSFromStandard(response: AxiosResponse): Promise<ExportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportResult.fromJS(resultData200);
            return Promise.resolve<ExportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportResult>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param chunk (optional) 
     * @param chunkNumber (optional) 
     * @param totalChunks (optional) 
     * @param key (optional) 
     * @param standardId (optional) 
     * @return Success
     */
    uploadIdsImportFile(fileName: string | undefined, chunk: FileParameter | undefined, chunkNumber: number | undefined, totalChunks: number | undefined, key: string | undefined, standardId: number | undefined, cancelToken?: CancelToken): Promise<UploadIdsImportFileResponse> {
        let url_ = this.baseUrl + "/Import/UploadIdsImportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName === null || fileName === undefined)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("FileName", fileName.toString());
        if (chunk === null || chunk === undefined)
            throw new globalThis.Error("The parameter 'chunk' cannot be null.");
        else
            content_.append("Chunk", chunk.data, chunk.fileName ? chunk.fileName : "Chunk");
        if (chunkNumber === null || chunkNumber === undefined)
            throw new globalThis.Error("The parameter 'chunkNumber' cannot be null.");
        else
            content_.append("ChunkNumber", chunkNumber.toString());
        if (totalChunks === null || totalChunks === undefined)
            throw new globalThis.Error("The parameter 'totalChunks' cannot be null.");
        else
            content_.append("TotalChunks", totalChunks.toString());
        if (key === null || key === undefined)
            throw new globalThis.Error("The parameter 'key' cannot be null.");
        else
            content_.append("Key", key.toString());
        if (standardId === null || standardId === undefined)
            throw new globalThis.Error("The parameter 'standardId' cannot be null.");
        else
            content_.append("StandardId", standardId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadIdsImportFile(_response);
        });
    }

    protected processUploadIdsImportFile(response: AxiosResponse): Promise<UploadIdsImportFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadIdsImportFileResponse.fromJS(resultData200);
            return Promise.resolve<UploadIdsImportFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadIdsImportFileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getImportDSSettings(isFlatExcelSettings: boolean, cancelToken?: CancelToken): Promise<GetImportDSSettingsResponse> {
        let url_ = this.baseUrl + "/Import/GetImportDSSettings/{IsFlatExcelSettings}";
        if (isFlatExcelSettings === undefined || isFlatExcelSettings === null)
            throw new globalThis.Error("The parameter 'isFlatExcelSettings' must be defined.");
        url_ = url_.replace("{IsFlatExcelSettings}", encodeURIComponent("" + isFlatExcelSettings));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportDSSettings(_response);
        });
    }

    protected processGetImportDSSettings(response: AxiosResponse): Promise<GetImportDSSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetImportDSSettingsResponse.fromJS(resultData200);
            return Promise.resolve<GetImportDSSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetImportDSSettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createImportDSSetting(body: CreateImportDSSettingRequest | undefined, cancelToken?: CancelToken): Promise<CreateImportDSSettingResponse> {
        let url_ = this.baseUrl + "/Import/CreateImportDSSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateImportDSSetting(_response);
        });
    }

    protected processCreateImportDSSetting(response: AxiosResponse): Promise<CreateImportDSSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateImportDSSettingResponse.fromJS(resultData200);
            return Promise.resolve<CreateImportDSSettingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateImportDSSettingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateImportDSSetting(body: UpdateImportDSSettingRequest | undefined, cancelToken?: CancelToken): Promise<UpdateImportDSSettingResponse> {
        let url_ = this.baseUrl + "/Import/UpdateImportDSSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateImportDSSetting(_response);
        });
    }

    protected processUpdateImportDSSetting(response: AxiosResponse): Promise<UpdateImportDSSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateImportDSSettingResponse.fromJS(resultData200);
            return Promise.resolve<UpdateImportDSSettingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateImportDSSettingResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteImportDSSetting(importDSSettingId: number, cancelToken?: CancelToken): Promise<DeleteImportDSSettingResponse> {
        let url_ = this.baseUrl + "/Import/DeleteImportDSSetting/{ImportDSSettingId}";
        if (importDSSettingId === undefined || importDSSettingId === null)
            throw new globalThis.Error("The parameter 'importDSSettingId' must be defined.");
        url_ = url_.replace("{ImportDSSettingId}", encodeURIComponent("" + importDSSettingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImportDSSetting(_response);
        });
    }

    protected processDeleteImportDSSetting(response: AxiosResponse): Promise<DeleteImportDSSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteImportDSSettingResponse.fromJS(resultData200);
            return Promise.resolve<DeleteImportDSSettingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteImportDSSettingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkDataStandard(body: CheckDataStandardRequest | undefined, cancelToken?: CancelToken): Promise<CheckDataStandardResponse> {
        let url_ = this.baseUrl + "/Import/CheckDataStandard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDataStandard(_response);
        });
    }

    protected processCheckDataStandard(response: AxiosResponse): Promise<CheckDataStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckDataStandardResponse.fromJS(resultData200);
            return Promise.resolve<CheckDataStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckDataStandardResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandardFlatExcel(body: ImportDataStandardFlatExcelRequest | undefined, cancelToken?: CancelToken): Promise<ImportDataStandardFlatExcelResponse> {
        let url_ = this.baseUrl + "/Import/ImportDataStandardFlatExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandardFlatExcel(_response);
        });
    }

    protected processImportDataStandardFlatExcel(response: AxiosResponse): Promise<ImportDataStandardFlatExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportDataStandardFlatExcelResponse.fromJS(resultData200);
            return Promise.resolve<ImportDataStandardFlatExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportDataStandardFlatExcelResponse>(null as any);
    }

    /**
     * @return Success
     */
    sendEmail( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Mail/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    measuringUnits( cancelToken?: CancelToken): Promise<GetMeasuringUnitsListResponse> {
        let url_ = this.baseUrl + "/MeasuringUnits/measuring-units";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMeasuringUnits(_response);
        });
    }

    protected processMeasuringUnits(response: AxiosResponse): Promise<GetMeasuringUnitsListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMeasuringUnitsListResponse.fromJS(resultData200);
            return Promise.resolve<GetMeasuringUnitsListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMeasuringUnitsListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateMeasuringUnit(body: CreateOrUpdateMeasuringUnitRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateMeasuringUnitResponse> {
        let url_ = this.baseUrl + "/MeasuringUnits/create-or-update-measuring-unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateMeasuringUnit(_response);
        });
    }

    protected processCreateOrUpdateMeasuringUnit(response: AxiosResponse): Promise<CreateOrUpdateMeasuringUnitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateMeasuringUnitResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateMeasuringUnitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateMeasuringUnitResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteMeasuringUnit(id: number, cancelToken?: CancelToken): Promise<DeleteMeasuringUnitResponse> {
        let url_ = this.baseUrl + "/MeasuringUnits/delete-measuring-unit/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMeasuringUnit(_response);
        });
    }

    protected processDeleteMeasuringUnit(response: AxiosResponse): Promise<DeleteMeasuringUnitResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteMeasuringUnitResponse.fromJS(resultData200);
            return Promise.resolve<DeleteMeasuringUnitResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteMeasuringUnitResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRolePermissions( cancelToken?: CancelToken): Promise<GetRolePermissionsResponse> {
        let url_ = this.baseUrl + "/Permission/get-role-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePermissions(_response);
        });
    }

    protected processGetRolePermissions(response: AxiosResponse): Promise<GetRolePermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRolePermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetRolePermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRolePermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    generateUploadSasPricingDatabaseStructure( cancelToken?: CancelToken): Promise<StartUploadDatabaseStructureResponse> {
        let url_ = this.baseUrl + "/PricingDatabaseStructure/generate-upload-sas-pricing-database-structure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateUploadSasPricingDatabaseStructure(_response);
        });
    }

    protected processGenerateUploadSasPricingDatabaseStructure(response: AxiosResponse): Promise<StartUploadDatabaseStructureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartUploadDatabaseStructureResponse.fromJS(resultData200);
            return Promise.resolve<StartUploadDatabaseStructureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartUploadDatabaseStructureResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    commitUploadPricingDatabaseStructure(body: CommitUploadRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PricingDatabaseStructure/commit-upload-pricing-database-structure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCommitUploadPricingDatabaseStructure(_response);
        });
    }

    protected processCommitUploadPricingDatabaseStructure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param blockId (optional) 
     * @param blobId (optional) 
     * @param filePart (optional) 
     * @return Success
     */
    uploadBlockPricingDatabaseStructure(blockId: string | undefined, blobId: string | undefined, filePart: FileParameter | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PricingDatabaseStructure/upload-block-pricing-database-structure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (blockId === null || blockId === undefined)
            throw new globalThis.Error("The parameter 'blockId' cannot be null.");
        else
            content_.append("BlockId", blockId.toString());
        if (blobId === null || blobId === undefined)
            throw new globalThis.Error("The parameter 'blobId' cannot be null.");
        else
            content_.append("BlobId", blobId.toString());
        if (filePart === null || filePart === undefined)
            throw new globalThis.Error("The parameter 'filePart' cannot be null.");
        else
            content_.append("FilePart", filePart.data, filePart.fileName ? filePart.fileName : "FilePart");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBlockPricingDatabaseStructure(_response);
        });
    }

    protected processUploadBlockPricingDatabaseStructure(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param blobId (optional) 
     * @param pricingDatabaseId (optional) 
     * @return Success
     */
    importOtskpStructure(blobId: string | undefined, pricingDatabaseId: number | undefined, cancelToken?: CancelToken): Promise<ImportPricingDatabaseStructureResponse> {
        let url_ = this.baseUrl + "/PricingDatabaseStructure/import-otskp-structure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (blobId === null || blobId === undefined)
            throw new globalThis.Error("The parameter 'blobId' cannot be null.");
        else
            content_.append("BlobId", blobId.toString());
        if (pricingDatabaseId === null || pricingDatabaseId === undefined)
            throw new globalThis.Error("The parameter 'pricingDatabaseId' cannot be null.");
        else
            content_.append("PricingDatabaseId", pricingDatabaseId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportOtskpStructure(_response);
        });
    }

    protected processImportOtskpStructure(response: AxiosResponse): Promise<ImportPricingDatabaseStructureResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportPricingDatabaseStructureResponse.fromJS(resultData200);
            return Promise.resolve<ImportPricingDatabaseStructureResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportPricingDatabaseStructureResponse>(null as any);
    }

    /**
     * @return Success
     */
    pricingDatabaseTreeStructure(pricingDatabaseId: number, cancelToken?: CancelToken): Promise<GetPricingDatabaseStructureTreeResponse> {
        let url_ = this.baseUrl + "/PricingDatabaseStructure/pricing-database-tree-structure/{PricingDatabaseId}";
        if (pricingDatabaseId === undefined || pricingDatabaseId === null)
            throw new globalThis.Error("The parameter 'pricingDatabaseId' must be defined.");
        url_ = url_.replace("{PricingDatabaseId}", encodeURIComponent("" + pricingDatabaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPricingDatabaseTreeStructure(_response);
        });
    }

    protected processPricingDatabaseTreeStructure(response: AxiosResponse): Promise<GetPricingDatabaseStructureTreeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPricingDatabaseStructureTreeResponse.fromJS(resultData200);
            return Promise.resolve<GetPricingDatabaseStructureTreeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPricingDatabaseStructureTreeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectorList(body: GetSelectorListRequest | undefined, cancelToken?: CancelToken): Promise<GetSelectorListResponse> {
        let url_ = this.baseUrl + "/Selector/GetSelectorList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectorList(_response);
        });
    }

    protected processGetSelectorList(response: AxiosResponse): Promise<GetSelectorListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSelectorListResponse.fromJS(resultData200);
            return Promise.resolve<GetSelectorListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSelectorListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectorItems(body: GetSelectorItemsRequest | undefined, cancelToken?: CancelToken): Promise<GetSelectorItemsResponse> {
        let url_ = this.baseUrl + "/Selector/GetSelectorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectorItems(_response);
        });
    }

    protected processGetSelectorItems(response: AxiosResponse): Promise<GetSelectorItemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSelectorItemsResponse.fromJS(resultData200);
            return Promise.resolve<GetSelectorItemsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSelectorItemsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSelectorItem(body: CreateOrUpdateSelectorItemRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateSelectorItemResponse> {
        let url_ = this.baseUrl + "/Selector/CreateOrUpdateSelectorItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSelectorItem(_response);
        });
    }

    protected processCreateOrUpdateSelectorItem(response: AxiosResponse): Promise<CreateOrUpdateSelectorItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateSelectorItemResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateSelectorItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateSelectorItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSelector(body: CreateOrUpdateSelectorRequest | undefined, cancelToken?: CancelToken): Promise<CreateOrUpdateSelectorResponse> {
        let url_ = this.baseUrl + "/Selector/CreateOrUpdateSelector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateSelector(_response);
        });
    }

    protected processCreateOrUpdateSelector(response: AxiosResponse): Promise<CreateOrUpdateSelectorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrUpdateSelectorResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrUpdateSelectorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrUpdateSelectorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSelector(body: DeleteSelectorRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSelectorResponse> {
        let url_ = this.baseUrl + "/Selector/DeleteSelector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSelector(_response);
        });
    }

    protected processDeleteSelector(response: AxiosResponse): Promise<DeleteSelectorResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSelectorResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSelectorResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSelectorResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSelectorItem(body: DeleteSelectorItemRequest | undefined, cancelToken?: CancelToken): Promise<DeleteSelectorItemResponse> {
        let url_ = this.baseUrl + "/Selector/DeleteSelectorItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSelectorItem(_response);
        });
    }

    protected processDeleteSelectorItem(response: AxiosResponse): Promise<DeleteSelectorItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteSelectorItemResponse.fromJS(resultData200);
            return Promise.resolve<DeleteSelectorItemResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteSelectorItemResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectorHierarchy(body: GetSelectorHierarchyRequest | undefined, cancelToken?: CancelToken): Promise<GetSelectorHierarchyResponse> {
        let url_ = this.baseUrl + "/Selector/GetSelectorHierarchy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectorHierarchy(_response);
        });
    }

    protected processGetSelectorHierarchy(response: AxiosResponse): Promise<GetSelectorHierarchyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSelectorHierarchyResponse.fromJS(resultData200);
            return Promise.resolve<GetSelectorHierarchyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSelectorHierarchyResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importExcelEnums(body: ImportEnumsFromExcelRequest | undefined, cancelToken?: CancelToken): Promise<ImportEnumsFromExcelResponse> {
        let url_ = this.baseUrl + "/Selector/import-excel-enums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcelEnums(_response);
        });
    }

    protected processImportExcelEnums(response: AxiosResponse): Promise<ImportEnumsFromExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportEnumsFromExcelResponse.fromJS(resultData200);
            return Promise.resolve<ImportEnumsFromExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportEnumsFromExcelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getEnumCategories( cancelToken?: CancelToken): Promise<GetEnumCategoriesResponse> {
        let url_ = this.baseUrl + "/Selector/get-enum-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnumCategories(_response);
        });
    }

    protected processGetEnumCategories(response: AxiosResponse): Promise<GetEnumCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEnumCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<GetEnumCategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEnumCategoriesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEnumCategory(body: UpdateEnumCategoryRequest | undefined, cancelToken?: CancelToken): Promise<UpdateEnumCategoryResponse> {
        let url_ = this.baseUrl + "/Selector/UpdateEnumCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEnumCategory(_response);
        });
    }

    protected processUpdateEnumCategory(response: AxiosResponse): Promise<UpdateEnumCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateEnumCategoryResponse.fromJS(resultData200);
            return Promise.resolve<UpdateEnumCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateEnumCategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteEnumCategory(body: DeleteEnumCategoryRequest | undefined, cancelToken?: CancelToken): Promise<DeleteEnumCategoryResponse> {
        let url_ = this.baseUrl + "/Selector/DeleteEnumCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEnumCategory(_response);
        });
    }

    protected processDeleteEnumCategory(response: AxiosResponse): Promise<DeleteEnumCategoryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteEnumCategoryResponse.fromJS(resultData200);
            return Promise.resolve<DeleteEnumCategoryResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteEnumCategoryResponse>(null as any);
    }

    /**
     * @return Success
     */
    metadata( cancelToken?: CancelToken): Promise<SchemaMetadataResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMetadata(_response);
        });
    }

    protected processMetadata(response: AxiosResponse): Promise<SchemaMetadataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchemaMetadataResponse.fromJS(resultData200);
            return Promise.resolve<SchemaMetadataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchemaMetadataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate(body: SqlGenerateRequest | undefined, cancelToken?: CancelToken): Promise<SqlGenerateResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: AxiosResponse): Promise<SqlGenerateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SqlGenerateResponse.fromJS(resultData200);
            return Promise.resolve<SqlGenerateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SqlGenerateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    chat(body: SqlChatRequest | undefined, cancelToken?: CancelToken): Promise<SqlChatResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChat(_response);
        });
    }

    protected processChat(response: AxiosResponse): Promise<SqlChatResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SqlChatResponse.fromJS(resultData200);
            return Promise.resolve<SqlChatResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SqlChatResponse>(null as any);
    }

    /**
     * @return Success
     */
    session(sessionId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSession(_response);
        });
    }

    protected processSession(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validate(body: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    preview(body: SqlPreviewRequest | undefined, cancelToken?: CancelToken): Promise<SqlPreviewResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<SqlPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SqlPreviewResponse.fromJS(resultData200);
            return Promise.resolve<SqlPreviewResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SqlPreviewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queriesPOST(body: SaveQueryRequest | undefined, cancelToken?: CancelToken): Promise<SavedQueryDto> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/queries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueriesPOST(_response);
        });
    }

    protected processQueriesPOST(response: AxiosResponse): Promise<SavedQueryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = SavedQueryDto.fromJS(resultData201);
            return Promise.resolve<SavedQueryDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavedQueryDto>(null as any);
    }

    /**
     * @param includeShared (optional) 
     * @return Success
     */
    queriesAll(includeShared: boolean | undefined, cancelToken?: CancelToken): Promise<SavedQueryDto[]> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/queries?";
        if (includeShared === null)
            throw new globalThis.Error("The parameter 'includeShared' cannot be null.");
        else if (includeShared !== undefined)
            url_ += "includeShared=" + encodeURIComponent("" + includeShared) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueriesAll(_response);
        });
    }

    protected processQueriesAll(response: AxiosResponse): Promise<SavedQueryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SavedQueryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SavedQueryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavedQueryDto[]>(null as any);
    }

    /**
     * @return Success
     */
    queriesGET(id: number, cancelToken?: CancelToken): Promise<SavedQueryDto> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/queries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueriesGET(_response);
        });
    }

    protected processQueriesGET(response: AxiosResponse): Promise<SavedQueryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SavedQueryDto.fromJS(resultData200);
            return Promise.resolve<SavedQueryDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavedQueryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    queriesPUT(id: number, body: UpdateQueryRequest | undefined, cancelToken?: CancelToken): Promise<SavedQueryDto> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/queries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueriesPUT(_response);
        });
    }

    protected processQueriesPUT(response: AxiosResponse): Promise<SavedQueryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SavedQueryDto.fromJS(resultData200);
            return Promise.resolve<SavedQueryDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavedQueryDto>(null as any);
    }

    /**
     * @return Success
     */
    queriesDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/queries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueriesDELETE(_response);
        });
    }

    protected processQueriesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    schema(body: BimModelSchemaRequest | undefined, cancelToken?: CancelToken): Promise<BimModelSchemaResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/bim/schema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchema(_response);
        });
    }

    protected processSchema(response: AxiosResponse): Promise<BimModelSchemaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BimModelSchemaResponse.fromJS(resultData200);
            return Promise.resolve<BimModelSchemaResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BimModelSchemaResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate2(body: BimPropertyQueryRequest | undefined, cancelToken?: CancelToken): Promise<BimPropertyQueryResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/bim/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerate2(_response);
        });
    }

    protected processGenerate2(response: AxiosResponse): Promise<BimPropertyQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BimPropertyQueryResponse.fromJS(resultData200);
            return Promise.resolve<BimPropertyQueryResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BimPropertyQueryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    preview2(body: BimPropertyPreviewRequest | undefined, cancelToken?: CancelToken): Promise<SqlPreviewResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/bim/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview2(_response);
        });
    }

    protected processPreview2(response: AxiosResponse): Promise<SqlPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SqlPreviewResponse.fromJS(resultData200);
            return Promise.resolve<SqlPreviewResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SqlPreviewResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clientFilter(body: ClientFilterRequest | undefined, cancelToken?: CancelToken): Promise<ClientFilterResponse> {
        let url_ = this.baseUrl + "/api/v1/SqlAssistant/client-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClientFilter(_response);
        });
    }

    protected processClientFilter(response: AxiosResponse): Promise<ClientFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientFilterResponse.fromJS(resultData200);
            return Promise.resolve<ClientFilterResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientFilterResponse>(null as any);
    }

    /**
     * @param xml (optional) 
     * @return Success
     */
    idsValidate(xml: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Test/IdsValidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (xml === null || xml === undefined)
            throw new globalThis.Error("The parameter 'xml' cannot be null.");
        else
            content_.append("Xml", xml.data, xml.fileName ? xml.fileName : "Xml");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIdsValidate(_response);
        });
    }

    protected processIdsValidate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    saveDSSFromThreeFiles( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/SaveDSSFromThreeFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDSSFromThreeFiles(_response);
        });
    }

    protected processSaveDSSFromThreeFiles(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getGuid( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/GetGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGuid(_response);
        });
    }

    protected processGetGuid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getEmptyGridFilterModel( cancelToken?: CancelToken): Promise<GridFilterModel> {
        let url_ = this.baseUrl + "/Test/GetEmptyGridFilterModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmptyGridFilterModel(_response);
        });
    }

    protected processGetEmptyGridFilterModel(response: AxiosResponse): Promise<GridFilterModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GridFilterModel.fromJS(resultData200);
            return Promise.resolve<GridFilterModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridFilterModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importDataStandardLocally(body: ImportDataStandardLocallyRequest | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Test/ImportDataStandardLocally";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDataStandardLocally(_response);
        });
    }

    protected processImportDataStandardLocally(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDataFromModelTestEndpoint(body: GetDataFromModelRequest | undefined, cancelToken?: CancelToken): Promise<ValidationResponse> {
        let url_ = this.baseUrl + "/Test/GetDataFromModelTestEndpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataFromModelTestEndpoint(_response);
        });
    }

    protected processGetDataFromModelTestEndpoint(response: AxiosResponse): Promise<ValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidationResponse.fromJS(resultData200);
            return Promise.resolve<ValidationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidationResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltTreeData(body: ValidateTiltTreeDataRequest | undefined, cancelToken?: CancelToken): Promise<ValidateTiltTreeDataResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltTreeData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltTreeData(_response);
        });
    }

    protected processValidateTiltTreeData(response: AxiosResponse): Promise<ValidateTiltTreeDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateTiltTreeDataResponse.fromJS(resultData200);
            return Promise.resolve<ValidateTiltTreeDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateTiltTreeDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltPlugin(body: ValidationDesignSlopePluginRequest | undefined, cancelToken?: CancelToken): Promise<TiltValidationPluginResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltPlugin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltPlugin(_response);
        });
    }

    protected processValidateTiltPlugin(response: AxiosResponse): Promise<TiltValidationPluginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationPluginResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationPluginResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationPluginResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateTiltVideo(body: TestVideoValidationSlopeRequest | undefined, cancelToken?: CancelToken): Promise<TiltValidationResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidateTiltVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateTiltVideo(_response);
        });
    }

    protected processValidateTiltVideo(response: AxiosResponse): Promise<TiltValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationResponse>(null as any);
    }

    /**
     * @return Success
     */
    validationVersion(versionId: number, cancelToken?: CancelToken): Promise<TiltValidationVersionResponse> {
        let url_ = this.baseUrl + "/TiltValidation/ValidationVersion/{VersionId}";
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{VersionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidationVersion(_response);
        });
    }

    protected processValidationVersion(response: AxiosResponse): Promise<TiltValidationVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TiltValidationVersionResponse.fromJS(resultData200);
            return Promise.resolve<TiltValidationVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TiltValidationVersionResponse>(null as any);
    }

    /**
     * @param updateId (optional) 
     * @param password (optional) 
     * @return Success
     */
    getNewVersion(updateId: number | undefined, password: string | undefined, cancelToken?: CancelToken): Promise<GetNewVersionResponse> {
        let url_ = this.baseUrl + "/Updater/getNewVersion?";
        if (updateId === null)
            throw new globalThis.Error("The parameter 'updateId' cannot be null.");
        else if (updateId !== undefined)
            url_ += "UpdateId=" + encodeURIComponent("" + updateId) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewVersion(_response);
        });
    }

    protected processGetNewVersion(response: AxiosResponse): Promise<GetNewVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNewVersionResponse.fromJS(resultData200);
            return Promise.resolve<GetNewVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNewVersionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveBlobToUpdate(body: SaveBlobToUpdateRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Updater/saveBlobToUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBlobToUpdate(_response);
        });
    }

    protected processSaveBlobToUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUploaderUri(body: CreateNewUpdateRequest | undefined, cancelToken?: CancelToken): Promise<GetUploaderUriResponse> {
        let url_ = this.baseUrl + "/Updater/GetUploaderUri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUploaderUri(_response);
        });
    }

    protected processGetUploaderUri(response: AxiosResponse): Promise<GetUploaderUriResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUploaderUriResponse.fromJS(resultData200);
            return Promise.resolve<GetUploaderUriResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUploaderUriResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param password (optional) 
     * @return Success
     */
    getUploaderUriToUpdater(file: FileParameter | undefined, password: string | undefined, cancelToken?: CancelToken): Promise<GetUploaderUriResponse> {
        let url_ = this.baseUrl + "/Updater/GetUploaderUriToUpdater";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (password === null || password === undefined)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUploaderUriToUpdater(_response);
        });
    }

    protected processGetUploaderUriToUpdater(response: AxiosResponse): Promise<GetUploaderUriResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUploaderUriResponse.fromJS(resultData200);
            return Promise.resolve<GetUploaderUriResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUploaderUriResponse>(null as any);
    }

    /**
     * @param product (optional) 
     * @param pluginToProduct (optional) 
     * @return Success
     */
    updateInfo(product: string | undefined, pluginToProduct: string | undefined, cancelToken?: CancelToken): Promise<UpdateInfoResponse> {
        let url_ = this.baseUrl + "/Updater/updateInfo?";
        if (product === null)
            throw new globalThis.Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (pluginToProduct === null)
            throw new globalThis.Error("The parameter 'pluginToProduct' cannot be null.");
        else if (pluginToProduct !== undefined)
            url_ += "PluginToProduct=" + encodeURIComponent("" + pluginToProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<UpdateInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoResponse>(null as any);
    }

    /**
     * @param product (optional) 
     * @param pluginToProduct (optional) 
     * @return Success
     */
    getUpdateInfo(product: SGProductType | undefined, pluginToProduct: BentleyProductType | undefined, cancelToken?: CancelToken): Promise<UpdateInfoResponse> {
        let url_ = this.baseUrl + "/Updater/GetUpdateInfo?";
        if (product === null)
            throw new globalThis.Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (pluginToProduct === null)
            throw new globalThis.Error("The parameter 'pluginToProduct' cannot be null.");
        else if (pluginToProduct !== undefined)
            url_ += "PluginToProduct=" + encodeURIComponent("" + pluginToProduct) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpdateInfo(_response);
        });
    }

    protected processGetUpdateInfo(response: AxiosResponse): Promise<UpdateInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoResponse.fromJS(resultData200);
            return Promise.resolve<UpdateInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoResponse>(null as any);
    }

    /**
     * @return Success
     */
    healthCheck(password: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Updater/healthCheck/{Password}";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{Password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantRequest | undefined, cancelToken?: CancelToken): Promise<CreateTenantResponse> {
        let url_ = this.baseUrl + "/User/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<CreateTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantResponse.fromJS(resultData200);
            return Promise.resolve<CreateTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserToTenant(body: AddUserToTenantRequest | undefined, cancelToken?: CancelToken): Promise<AddUserToTenantResponse> {
        let url_ = this.baseUrl + "/User/AddUserToTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToTenant(_response);
        });
    }

    protected processAddUserToTenant(response: AxiosResponse): Promise<AddUserToTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUserToTenantResponse.fromJS(resultData200);
            return Promise.resolve<AddUserToTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUserToTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsAdmin( cancelToken?: CancelToken): Promise<GetTenantsAdminResponse> {
        let url_ = this.baseUrl + "/User/GetTenantsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsAdmin(_response);
        });
    }

    protected processGetTenantsAdmin(response: AxiosResponse): Promise<GetTenantsAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsUser( cancelToken?: CancelToken): Promise<GetTenantsUserResponse> {
        let url_ = this.baseUrl + "/User/GetTenantsUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsUser(_response);
        });
    }

    protected processGetTenantsUser(response: AxiosResponse): Promise<GetTenantsUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserTenant(body: ChangeUserTenantRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserTenantResponse> {
        let url_ = this.baseUrl + "/User/ChangeUserTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserTenant(_response);
        });
    }

    protected processChangeUserTenant(response: AxiosResponse): Promise<ChangeUserTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserTenantResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUserData(body: SaveUserDataRequest | undefined, cancelToken?: CancelToken): Promise<SaveUserDataResponse> {
        let url_ = this.baseUrl + "/User/SaveUserData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserData(_response);
        });
    }

    protected processSaveUserData(response: AxiosResponse): Promise<SaveUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveUserDataResponse.fromJS(resultData200);
            return Promise.resolve<SaveUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordUser(body: ResetPasswordUserRequest | undefined, cancelToken?: CancelToken): Promise<ResetPasswordUserResponse> {
        let url_ = this.baseUrl + "/User/ResetPasswordUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordUser(_response);
        });
    }

    protected processResetPasswordUser(response: AxiosResponse): Promise<ResetPasswordUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordUserResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangeUserPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserPasswordResponse> {
        let url_ = this.baseUrl + "/User/ChangeUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: AxiosResponse): Promise<ChangeUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersTenant(tenantId: number, cancelToken?: CancelToken): Promise<GetUsersTenantResponse> {
        let url_ = this.baseUrl + "/User/GetUsersTenant/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersTenant(_response);
        });
    }

    protected processGetUsersTenant(response: AxiosResponse): Promise<GetUsersTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersTenantResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteTenant(tenantId: number, cancelToken?: CancelToken): Promise<DeleteTenantResponse> {
        let url_ = this.baseUrl + "/User/DeleteTenant/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: AxiosResponse): Promise<DeleteTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTenantResponse.fromJS(resultData200);
            return Promise.resolve<DeleteTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameTenant(body: RenameTenantRequest | undefined, cancelToken?: CancelToken): Promise<RenameTenantResponse> {
        let url_ = this.baseUrl + "/User/RenameTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameTenant(_response);
        });
    }

    protected processRenameTenant(response: AxiosResponse): Promise<RenameTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameTenantResponse.fromJS(resultData200);
            return Promise.resolve<RenameTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserFromTenant(body: RemoveUserFromTenantRequest | undefined, cancelToken?: CancelToken): Promise<RemoveUserFromTenantResponse> {
        let url_ = this.baseUrl + "/User/RemoveUserFromTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserFromTenant(_response);
        });
    }

    protected processRemoveUserFromTenant(response: AxiosResponse): Promise<RemoveUserFromTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveUserFromTenantResponse.fromJS(resultData200);
            return Promise.resolve<RemoveUserFromTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveUserFromTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserSendSignupMail(body: CreateUserSendSignupMailRequest | undefined, cancelToken?: CancelToken): Promise<CreateUserSendSignupMailResponse> {
        let url_ = this.baseUrl + "/User/CreateUserSendSignupMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserSendSignupMail(_response);
        });
    }

    protected processCreateUserSendSignupMail(response: AxiosResponse): Promise<CreateUserSendSignupMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserSendSignupMailResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserSendSignupMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserSendSignupMailResponse>(null as any);
    }

    /**
     * @return Success
     */
    gateUrl( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/UserAnonymous/gate-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGateUrl(_response);
        });
    }

    protected processGateUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenantAndUser(body: CreateTenantAndUserRequest | undefined, cancelToken?: CancelToken): Promise<CreateTenantAndUserResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/CreateTenantAndUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenantAndUser(_response);
        });
    }

    protected processCreateTenantAndUser(response: AxiosResponse): Promise<CreateTenantAndUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantAndUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateTenantAndUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantAndUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLead(body: CreateLeadRequest | undefined, cancelToken?: CancelToken): Promise<CreateLeadResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/CreateLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLead(_response);
        });
    }

    protected processCreateLead(response: AxiosResponse): Promise<CreateLeadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateLeadResponse.fromJS(resultData200);
            return Promise.resolve<CreateLeadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateLeadResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getSignupUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetSignupUserDataResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/GetSignupUserData?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignupUserData(_response);
        });
    }

    protected processGetSignupUserData(response: AxiosResponse): Promise<GetSignupUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignupUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetSignupUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignupUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupUserMicrosoft(body: SignupUserMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupUserMicrosoftResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/SignupUserMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupUserMicrosoft(_response);
        });
    }

    protected processSignupUserMicrosoft(response: AxiosResponse): Promise<SignupUserMicrosoftResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupUserMicrosoftResponse.fromJS(resultData200);
            return Promise.resolve<SignupUserMicrosoftResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupUserMicrosoftResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param newPass (optional) 
     * @param signupToken (optional) 
     * @return Success
     */
    setUserPassword(id: number | undefined, newPass: string | undefined, signupToken: string | undefined, cancelToken?: CancelToken): Promise<SetUserPasswordResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/SetUserPassword?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (newPass === null)
            throw new globalThis.Error("The parameter 'newPass' cannot be null.");
        else if (newPass !== undefined)
            url_ += "NewPass=" + encodeURIComponent("" + newPass) + "&";
        if (signupToken === null)
            throw new globalThis.Error("The parameter 'signupToken' cannot be null.");
        else if (signupToken !== undefined)
            url_ += "SignupToken=" + encodeURIComponent("" + signupToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserPassword(_response);
        });
    }

    protected processSetUserPassword(response: AxiosResponse): Promise<SetUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<SetUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetUserPasswordResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getResetPasswordUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetResetPasswordUserDataResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/GetResetPasswordUserData?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResetPasswordUserData(_response);
        });
    }

    protected processGetResetPasswordUserData(response: AxiosResponse): Promise<GetResetPasswordUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetResetPasswordUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetResetPasswordUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetResetPasswordUserDataResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    resetUserPasswordSendMail(email: string | undefined, cancelToken?: CancelToken): Promise<ResetUserPasswordSendMailResponse> {
        let url_ = this.baseUrl + "/UserAnonymous/ResetUserPasswordSendMail?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetUserPasswordSendMail(_response);
        });
    }

    protected processResetUserPasswordSendMail(response: AxiosResponse): Promise<ResetUserPasswordSendMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetUserPasswordSendMailResponse.fromJS(resultData200);
            return Promise.resolve<ResetUserPasswordSendMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetUserPasswordSendMailResponse>(null as any);
    }
}

export class AddEditFormulaItemRequest implements IAddEditFormulaItemRequest {
    id?: number | undefined;
    formulaId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IAddEditFormulaItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formulaId = _data["formulaId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AddEditFormulaItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddEditFormulaItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formulaId"] = this.formulaId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IAddEditFormulaItemRequest {
    id?: number | undefined;
    formulaId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class AddEditFormulaItemResponse implements IAddEditFormulaItemResponse {
    ok?: boolean;
    id?: number | undefined;
    error?: string | undefined;

    constructor(data?: IAddEditFormulaItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): AddEditFormulaItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddEditFormulaItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["error"] = this.error;
        return data;
    }
}

export interface IAddEditFormulaItemResponse {
    ok?: boolean;
    id?: number | undefined;
    error?: string | undefined;
}

export class AddMicrostationAllAssignRequest implements IAddMicrostationAllAssignRequest {
    mStnPairingId?: number;
    pairingsAssign?: MStnPairingAssignDTO[] | undefined;

    constructor(data?: IAddMicrostationAllAssignRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["pairingsAssign"])) {
                this.pairingsAssign = [] as any;
                for (let item of _data["pairingsAssign"])
                    this.pairingsAssign!.push(MStnPairingAssignDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddMicrostationAllAssignRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationAllAssignRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.pairingsAssign)) {
            data["pairingsAssign"] = [];
            for (let item of this.pairingsAssign)
                data["pairingsAssign"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddMicrostationAllAssignRequest {
    mStnPairingId?: number;
    pairingsAssign?: MStnPairingAssignDTO[] | undefined;
}

export class AddMicrostationAllAssignResponse implements IAddMicrostationAllAssignResponse {
    ok?: boolean;

    constructor(data?: IAddMicrostationAllAssignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMicrostationAllAssignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationAllAssignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMicrostationAllAssignResponse {
    ok?: boolean;
}

export class AddMicrostationPairingPairerRequest implements IAddMicrostationPairingPairerRequest {
    mStnPairingId?: number;
    pairerId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IAddMicrostationPairingPairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.pairerId = _data["pairerId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddMicrostationPairingPairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationPairingPairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["pairerId"] = this.pairerId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddMicrostationPairingPairerRequest {
    mStnPairingId?: number;
    pairerId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class AddMicrostationPairingPairerResponse implements IAddMicrostationPairingPairerResponse {
    ok?: boolean;

    constructor(data?: IAddMicrostationPairingPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMicrostationPairingPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMicrostationPairingPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMicrostationPairingPairerResponse {
    ok?: boolean;
}

export class AddMStnFeederCurveRequest implements IAddMStnFeederCurveRequest {
    projectId?: number | undefined;
    mStnPairingId?: number | undefined;
    elementId?: string | undefined;
    modelName?: string | undefined;
    modelFile?: string | undefined;
    name?: string | undefined;
    startStationing?: number | undefined;

    constructor(data?: IAddMStnFeederCurveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.mStnPairingId = _data["mStnPairingId"];
            this.elementId = _data["elementId"];
            this.modelName = _data["modelName"];
            this.modelFile = _data["modelFile"];
            this.name = _data["name"];
            this.startStationing = _data["startStationing"];
        }
    }

    static fromJS(data: any): AddMStnFeederCurveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederCurveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["mStnPairingId"] = this.mStnPairingId;
        data["elementId"] = this.elementId;
        data["modelName"] = this.modelName;
        data["modelFile"] = this.modelFile;
        data["name"] = this.name;
        data["startStationing"] = this.startStationing;
        return data;
    }
}

export interface IAddMStnFeederCurveRequest {
    projectId?: number | undefined;
    mStnPairingId?: number | undefined;
    elementId?: string | undefined;
    modelName?: string | undefined;
    modelFile?: string | undefined;
    name?: string | undefined;
    startStationing?: number | undefined;
}

export class AddMStnFeederCurveResponse implements IAddMStnFeederCurveResponse {
    ok?: boolean;

    constructor(data?: IAddMStnFeederCurveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddMStnFeederCurveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederCurveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddMStnFeederCurveResponse {
    ok?: boolean;
}

export class AddMStnFeederElementStationingDTO implements IAddMStnFeederElementStationingDTO {
    mStnPairingId?: number;
    pairerId?: number;
    elementId?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;

    constructor(data?: IAddMStnFeederElementStationingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.pairerId = _data["pairerId"];
            this.elementId = _data["elementId"];
            this.alignmentName2 = _data["alignmentName2"];
            this.alignmentName3 = _data["alignmentName3"];
        }
    }

    static fromJS(data: any): AddMStnFeederElementStationingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederElementStationingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["pairerId"] = this.pairerId;
        data["elementId"] = this.elementId;
        data["alignmentName2"] = this.alignmentName2;
        data["alignmentName3"] = this.alignmentName3;
        return data;
    }
}

export interface IAddMStnFeederElementStationingDTO {
    mStnPairingId?: number;
    pairerId?: number;
    elementId?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;
}

export class AddMStnFeederItemDTO implements IAddMStnFeederItemDTO {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    childElementIds?: string[] | undefined;

    constructor(data?: IAddMStnFeederItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.level = _data["level"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            if (Array.isArray(_data["validationRuleIds"])) {
                this.validationRuleIds = [] as any;
                for (let item of _data["validationRuleIds"])
                    this.validationRuleIds!.push(item);
            }
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.dateValueType = _data["dateValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
            if (Array.isArray(_data["childElementIds"])) {
                this.childElementIds = [] as any;
                for (let item of _data["childElementIds"])
                    this.childElementIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddMStnFeederItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["level"] = this.level;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        if (Array.isArray(this.validationRuleIds)) {
            data["validationRuleIds"] = [];
            for (let item of this.validationRuleIds)
                data["validationRuleIds"].push(item);
        }
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["dateValueType"] = this.dateValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        if (Array.isArray(this.childElementIds)) {
            data["childElementIds"] = [];
            for (let item of this.childElementIds)
                data["childElementIds"].push(item);
        }
        return data;
    }
}

export interface IAddMStnFeederItemDTO {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    childElementIds?: string[] | undefined;
}

export class AddMStnFeederItemsRequest implements IAddMStnFeederItemsRequest {
    isImportExcel?: boolean;
    isFeatureDefinitions?: boolean;
    items?: AddMStnFeederItemDTO[] | undefined;

    constructor(data?: IAddMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isImportExcel = _data["isImportExcel"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddMStnFeederItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isImportExcel"] = this.isImportExcel;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddMStnFeederItemsRequest {
    isImportExcel?: boolean;
    isFeatureDefinitions?: boolean;
    items?: AddMStnFeederItemDTO[] | undefined;
}

export class AddMStnFeederItemsResponse implements IAddMStnFeederItemsResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedItemsDTO[] | undefined;
    removedItems?: number[] | undefined;

    constructor(data?: IAddMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["addedItems"])) {
                this.addedItems = [] as any;
                for (let item of _data["addedItems"])
                    this.addedItems!.push(MStnFeederAddedItemsDTO.fromJS(item));
            }
            if (Array.isArray(_data["removedItems"])) {
                this.removedItems = [] as any;
                for (let item of _data["removedItems"])
                    this.removedItems!.push(item);
            }
        }
    }

    static fromJS(data: any): AddMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.addedItems)) {
            data["addedItems"] = [];
            for (let item of this.addedItems)
                data["addedItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.removedItems)) {
            data["removedItems"] = [];
            for (let item of this.removedItems)
                data["removedItems"].push(item);
        }
        return data;
    }
}

export interface IAddMStnFeederItemsResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedItemsDTO[] | undefined;
    removedItems?: number[] | undefined;
}

export class AddUserToTenantRequest implements IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;
    sendMail?: boolean;

    constructor(data?: IAddUserToTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
            this.sendMail = _data["sendMail"];
        }
    }

    static fromJS(data: any): AddUserToTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        data["sendMail"] = this.sendMail;
        return data;
    }
}

export interface IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;
    sendMail?: boolean;
}

export class AddUserToTenantResponse implements IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;

    constructor(data?: IAddUserToTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.alreadyAdded = _data["alreadyAdded"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AddUserToTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["alreadyAdded"] = this.alreadyAdded;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;
}

export class AggregationPropertyRequest implements IAggregationPropertyRequest {
    propertySet?: string | undefined;
    propertyName?: string | undefined;

    constructor(data?: IAggregationPropertyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySet = _data["propertySet"];
            this.propertyName = _data["propertyName"];
        }
    }

    static fromJS(data: any): AggregationPropertyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AggregationPropertyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySet"] = this.propertySet;
        data["propertyName"] = this.propertyName;
        return data;
    }
}

export interface IAggregationPropertyRequest {
    propertySet?: string | undefined;
    propertyName?: string | undefined;
}

export class AggregationRequest implements IAggregationRequest {
    type?: string | undefined;
    propertyName?: string | undefined;
    propertySet?: string | undefined;
    properties?: AggregationPropertyRequest[] | undefined;
    groupByProperty?: string | undefined;
    groupByPropertySet?: string | undefined;

    constructor(data?: IAggregationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.propertyName = _data["propertyName"];
            this.propertySet = _data["propertySet"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(AggregationPropertyRequest.fromJS(item));
            }
            this.groupByProperty = _data["groupByProperty"];
            this.groupByPropertySet = _data["groupByPropertySet"];
        }
    }

    static fromJS(data: any): AggregationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AggregationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["propertyName"] = this.propertyName;
        data["propertySet"] = this.propertySet;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["groupByProperty"] = this.groupByProperty;
        data["groupByPropertySet"] = this.groupByPropertySet;
        return data;
    }
}

export interface IAggregationRequest {
    type?: string | undefined;
    propertyName?: string | undefined;
    propertySet?: string | undefined;
    properties?: AggregationPropertyRequest[] | undefined;
    groupByProperty?: string | undefined;
    groupByPropertySet?: string | undefined;
}

export class AggregationResponse implements IAggregationResponse {
    type?: string | undefined;
    result?: number | undefined;
    unit?: string | undefined;
    propertyResults?: { [key: string]: PropertyAggregationResultResponse; } | undefined;
    groupedResults?: { [key: string]: number; } | undefined;
    matchedElementCount?: number;
    description?: string | undefined;

    constructor(data?: IAggregationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.result = _data["result"];
            this.unit = _data["unit"];
            if (_data["propertyResults"]) {
                this.propertyResults = {} as any;
                for (let key in _data["propertyResults"]) {
                    if (_data["propertyResults"].hasOwnProperty(key))
                        (this.propertyResults as any)![key] = _data["propertyResults"][key] ? PropertyAggregationResultResponse.fromJS(_data["propertyResults"][key]) : new PropertyAggregationResultResponse();
                }
            }
            if (_data["groupedResults"]) {
                this.groupedResults = {} as any;
                for (let key in _data["groupedResults"]) {
                    if (_data["groupedResults"].hasOwnProperty(key))
                        (this.groupedResults as any)![key] = _data["groupedResults"][key];
                }
            }
            this.matchedElementCount = _data["matchedElementCount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AggregationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AggregationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["result"] = this.result;
        data["unit"] = this.unit;
        if (this.propertyResults) {
            data["propertyResults"] = {};
            for (let key in this.propertyResults) {
                if (this.propertyResults.hasOwnProperty(key))
                    (data["propertyResults"] as any)[key] = this.propertyResults[key] ? this.propertyResults[key].toJSON() : undefined as any;
            }
        }
        if (this.groupedResults) {
            data["groupedResults"] = {};
            for (let key in this.groupedResults) {
                if (this.groupedResults.hasOwnProperty(key))
                    (data["groupedResults"] as any)[key] = (this.groupedResults as any)[key];
            }
        }
        data["matchedElementCount"] = this.matchedElementCount;
        data["description"] = this.description;
        return data;
    }
}

export interface IAggregationResponse {
    type?: string | undefined;
    result?: number | undefined;
    unit?: string | undefined;
    propertyResults?: { [key: string]: PropertyAggregationResultResponse; } | undefined;
    groupedResults?: { [key: string]: number; } | undefined;
    matchedElementCount?: number;
    description?: string | undefined;
}

export class AiPromptRequest implements IAiPromptRequest {
    prompt?: string | undefined;
    context?: string | undefined;
    conversationId?: string | undefined;

    constructor(data?: IAiPromptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.context = _data["context"];
            this.conversationId = _data["conversationId"];
        }
    }

    static fromJS(data: any): AiPromptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AiPromptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["context"] = this.context;
        data["conversationId"] = this.conversationId;
        return data;
    }
}

export interface IAiPromptRequest {
    prompt?: string | undefined;
    context?: string | undefined;
    conversationId?: string | undefined;
}

export class AISuggestion implements IAISuggestion {
    query?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    predictedIntent?: UserIntent;

    constructor(data?: IAISuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.predictedIntent = _data["predictedIntent"];
        }
    }

    static fromJS(data: any): AISuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new AISuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["predictedIntent"] = this.predictedIntent;
        return data;
    }
}

export interface IAISuggestion {
    query?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    predictedIntent?: UserIntent;
}

export class AnalysisStatistics implements IAnalysisStatistics {
    totalElementsAnalyzed?: number;
    matchingElements?: number;
    filterCriteria?: string | undefined;
    aggregationType?: string | undefined;
    executionTime?: TimeSpan;

    constructor(data?: IAnalysisStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalElementsAnalyzed = _data["totalElementsAnalyzed"];
            this.matchingElements = _data["matchingElements"];
            this.filterCriteria = _data["filterCriteria"];
            this.aggregationType = _data["aggregationType"];
            this.executionTime = _data["executionTime"] ? TimeSpan.fromJS(_data["executionTime"]) : undefined as any;
        }
    }

    static fromJS(data: any): AnalysisStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalElementsAnalyzed"] = this.totalElementsAnalyzed;
        data["matchingElements"] = this.matchingElements;
        data["filterCriteria"] = this.filterCriteria;
        data["aggregationType"] = this.aggregationType;
        data["executionTime"] = this.executionTime ? this.executionTime.toJSON() : undefined as any;
        return data;
    }
}

export interface IAnalysisStatistics {
    totalElementsAnalyzed?: number;
    matchingElements?: number;
    filterCriteria?: string | undefined;
    aggregationType?: string | undefined;
    executionTime?: TimeSpan;
}

export class AuthLocalRequest implements IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthLocalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthLocalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLocalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthMicrosoftRequest implements IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthResponse implements IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDTO.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.resetPassword = _data["resetPassword"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        data["resetPassword"] = this.resetPassword;
        return data;
    }
}

export interface IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;
}

export class BaseLineDTO implements IBaseLineDTO {
    name?: string | undefined;
    data?: CorridorBaseLineDataDTO[] | undefined;

    constructor(data?: IBaseLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CorridorBaseLineDataDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BaseLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBaseLineDTO {
    name?: string | undefined;
    data?: CorridorBaseLineDataDTO[] | undefined;
}

export enum BentleyProductType {
    Microstation = "Microstation",
    Openroads = "Openroads",
    Openrail = "Openrail",
    Opensite = "Opensite",
}

export class BCHPPairerValRulesDTO implements IBCHPPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    validationRules?: BCHPValidationRuleDTO[] | undefined;

    constructor(data?: IBCHPPairerValRulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerGroupId = _data["pairerGroupId"];
            this.pairerName = _data["pairerName"];
            this.pairerGroupName = _data["pairerGroupName"];
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(BCHPValidationRuleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BCHPPairerValRulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BCHPPairerValRulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerGroupId"] = this.pairerGroupId;
        data["pairerName"] = this.pairerName;
        data["pairerGroupName"] = this.pairerGroupName;
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBCHPPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    validationRules?: BCHPValidationRuleDTO[] | undefined;
}

export class BCHPValidationRuleDTO implements IBCHPValidationRuleDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: IBCHPValidationRuleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.namePrefix = _data["namePrefix"];
            this.attributeName = _data["attributeName"];
            this.attributeNumber = _data["attributeNumber"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): BCHPValidationRuleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BCHPValidationRuleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["namePrefix"] = this.namePrefix;
        data["attributeName"] = this.attributeName;
        data["attributeNumber"] = this.attributeNumber;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IBCHPValidationRuleDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    dataType?: DataTypeValidation;
}

export class BimClassificationContext implements IBimClassificationContext {
    dataStandardId?: number;
    dataStandardName?: string | undefined;
    groups?: BimClassificationGroup[] | undefined;

    constructor(data?: IBimClassificationContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.dataStandardName = _data["dataStandardName"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(BimClassificationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BimClassificationContext {
        data = typeof data === 'object' ? data : {};
        let result = new BimClassificationContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["dataStandardName"] = this.dataStandardName;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBimClassificationContext {
    dataStandardId?: number;
    dataStandardName?: string | undefined;
    groups?: BimClassificationGroup[] | undefined;
}

export class BimClassificationGroup implements IBimClassificationGroup {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    classifications?: BimClassificationItem[] | undefined;

    constructor(data?: IBimClassificationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(BimClassificationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BimClassificationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BimClassificationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBimClassificationGroup {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    classifications?: BimClassificationItem[] | undefined;
}

export class BimClassificationItem implements IBimClassificationItem {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;

    constructor(data?: IBimClassificationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): BimClassificationItem {
        data = typeof data === 'object' ? data : {};
        let result = new BimClassificationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IBimClassificationItem {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
}

export class BimElementDto implements IBimElementDto {
    expressId?: string | undefined;
    ifcId?: string | undefined;
    propertySets?: BimPropertySetDto[] | undefined;

    constructor(data?: IBimElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcId = _data["ifcId"];
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(BimPropertySetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BimElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new BimElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcId"] = this.ifcId;
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBimElementDto {
    expressId?: string | undefined;
    ifcId?: string | undefined;
    propertySets?: BimPropertySetDto[] | undefined;
}

export class BimElementSummary implements IBimElementSummary {
    expressId?: number;
    ifcGuid?: string | undefined;
    name?: string | undefined;
    ifcType?: string | undefined;
    classifications?: string[] | undefined;
    keyProperties?: { [key: string]: string; } | undefined;

    constructor(data?: IBimElementSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcGuid = _data["ifcGuid"];
            this.name = _data["name"];
            this.ifcType = _data["ifcType"];
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(item);
            }
            if (_data["keyProperties"]) {
                this.keyProperties = {} as any;
                for (let key in _data["keyProperties"]) {
                    if (_data["keyProperties"].hasOwnProperty(key))
                        (this.keyProperties as any)![key] = _data["keyProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): BimElementSummary {
        data = typeof data === 'object' ? data : {};
        let result = new BimElementSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcGuid"] = this.ifcGuid;
        data["name"] = this.name;
        data["ifcType"] = this.ifcType;
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item);
        }
        if (this.keyProperties) {
            data["keyProperties"] = {};
            for (let key in this.keyProperties) {
                if (this.keyProperties.hasOwnProperty(key))
                    (data["keyProperties"] as any)[key] = (this.keyProperties as any)[key];
            }
        }
        return data;
    }
}

export interface IBimElementSummary {
    expressId?: number;
    ifcGuid?: string | undefined;
    name?: string | undefined;
    ifcType?: string | undefined;
    classifications?: string[] | undefined;
    keyProperties?: { [key: string]: string; } | undefined;
}

export class BimInsight implements IBimInsight {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    severity?: InsightSeverity;
    category?: InsightCategory;
    metrics?: InsightMetric[] | undefined;
    actions?: InsightAction[] | undefined;
    relatedElementIds?: number[] | undefined;
    explanation?: InsightExplanation;
    generatedAt?: Date;
    confidence?: number;

    constructor(data?: IBimInsight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.severity = _data["severity"];
            this.category = _data["category"];
            if (Array.isArray(_data["metrics"])) {
                this.metrics = [] as any;
                for (let item of _data["metrics"])
                    this.metrics!.push(InsightMetric.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(InsightAction.fromJS(item));
            }
            if (Array.isArray(_data["relatedElementIds"])) {
                this.relatedElementIds = [] as any;
                for (let item of _data["relatedElementIds"])
                    this.relatedElementIds!.push(item);
            }
            this.explanation = _data["explanation"] ? InsightExplanation.fromJS(_data["explanation"]) : undefined as any;
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : undefined as any;
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): BimInsight {
        data = typeof data === 'object' ? data : {};
        let result = new BimInsight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["severity"] = this.severity;
        data["category"] = this.category;
        if (Array.isArray(this.metrics)) {
            data["metrics"] = [];
            for (let item of this.metrics)
                data["metrics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatedElementIds)) {
            data["relatedElementIds"] = [];
            for (let item of this.relatedElementIds)
                data["relatedElementIds"].push(item);
        }
        data["explanation"] = this.explanation ? this.explanation.toJSON() : undefined as any;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : undefined as any;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IBimInsight {
    id?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    severity?: InsightSeverity;
    category?: InsightCategory;
    metrics?: InsightMetric[] | undefined;
    actions?: InsightAction[] | undefined;
    relatedElementIds?: number[] | undefined;
    explanation?: InsightExplanation;
    generatedAt?: Date;
    confidence?: number;
}

export class BimKnowledgeRequest implements IBimKnowledgeRequest {
    question?: string | undefined;
    projectId?: number;
    modelIds?: number[] | undefined;
    dataStandardId?: number | undefined;
    sessionId?: string | undefined;
    previousInsightId?: string | undefined;
    preferredFormat?: QueryOutputFormat;
    includeExplanation?: boolean;
    maxInsights?: number;

    constructor(data?: IBimKnowledgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.dataStandardId = _data["dataStandardId"];
            this.sessionId = _data["sessionId"];
            this.previousInsightId = _data["previousInsightId"];
            this.preferredFormat = _data["preferredFormat"];
            this.includeExplanation = _data["includeExplanation"];
            this.maxInsights = _data["maxInsights"];
        }
    }

    static fromJS(data: any): BimKnowledgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BimKnowledgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["dataStandardId"] = this.dataStandardId;
        data["sessionId"] = this.sessionId;
        data["previousInsightId"] = this.previousInsightId;
        data["preferredFormat"] = this.preferredFormat;
        data["includeExplanation"] = this.includeExplanation;
        data["maxInsights"] = this.maxInsights;
        return data;
    }
}

export interface IBimKnowledgeRequest {
    question?: string | undefined;
    projectId?: number;
    modelIds?: number[] | undefined;
    dataStandardId?: number | undefined;
    sessionId?: string | undefined;
    previousInsightId?: string | undefined;
    preferredFormat?: QueryOutputFormat;
    includeExplanation?: boolean;
    maxInsights?: number;
}

export class BimKnowledgeResponse implements IBimKnowledgeResponse {
    insights?: BimInsight[] | undefined;
    tableData?: PropertyTableData;
    summary?: string | undefined;
    nextActions?: InsightAction[] | undefined;
    suggestedQuestions?: string[] | undefined;
    executedPlan?: QueryPlan;
    sessionId?: string | undefined;
    tokenUsage?: TokenUsageInfo;
    stats?: ExecutionStats;

    constructor(data?: IBimKnowledgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insights"])) {
                this.insights = [] as any;
                for (let item of _data["insights"])
                    this.insights!.push(BimInsight.fromJS(item));
            }
            this.tableData = _data["tableData"] ? PropertyTableData.fromJS(_data["tableData"]) : undefined as any;
            this.summary = _data["summary"];
            if (Array.isArray(_data["nextActions"])) {
                this.nextActions = [] as any;
                for (let item of _data["nextActions"])
                    this.nextActions!.push(InsightAction.fromJS(item));
            }
            if (Array.isArray(_data["suggestedQuestions"])) {
                this.suggestedQuestions = [] as any;
                for (let item of _data["suggestedQuestions"])
                    this.suggestedQuestions!.push(item);
            }
            this.executedPlan = _data["executedPlan"] ? QueryPlan.fromJS(_data["executedPlan"]) : undefined as any;
            this.sessionId = _data["sessionId"];
            this.tokenUsage = _data["tokenUsage"] ? TokenUsageInfo.fromJS(_data["tokenUsage"]) : undefined as any;
            this.stats = _data["stats"] ? ExecutionStats.fromJS(_data["stats"]) : undefined as any;
        }
    }

    static fromJS(data: any): BimKnowledgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BimKnowledgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insights)) {
            data["insights"] = [];
            for (let item of this.insights)
                data["insights"].push(item ? item.toJSON() : undefined as any);
        }
        data["tableData"] = this.tableData ? this.tableData.toJSON() : undefined as any;
        data["summary"] = this.summary;
        if (Array.isArray(this.nextActions)) {
            data["nextActions"] = [];
            for (let item of this.nextActions)
                data["nextActions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.suggestedQuestions)) {
            data["suggestedQuestions"] = [];
            for (let item of this.suggestedQuestions)
                data["suggestedQuestions"].push(item);
        }
        data["executedPlan"] = this.executedPlan ? this.executedPlan.toJSON() : undefined as any;
        data["sessionId"] = this.sessionId;
        data["tokenUsage"] = this.tokenUsage ? this.tokenUsage.toJSON() : undefined as any;
        data["stats"] = this.stats ? this.stats.toJSON() : undefined as any;
        return data;
    }
}

export interface IBimKnowledgeResponse {
    insights?: BimInsight[] | undefined;
    tableData?: PropertyTableData;
    summary?: string | undefined;
    nextActions?: InsightAction[] | undefined;
    suggestedQuestions?: string[] | undefined;
    executedPlan?: QueryPlan;
    sessionId?: string | undefined;
    tokenUsage?: TokenUsageInfo;
    stats?: ExecutionStats;
}

export class BimModelDto implements IBimModelDto {
    modelId?: string | undefined;
    elements?: BimElementDto[] | undefined;

    constructor(data?: IBimModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(BimElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BimModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new BimModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBimModelDto {
    modelId?: string | undefined;
    elements?: BimElementDto[] | undefined;
}

export class BimModelInfo implements IBimModelInfo {
    id?: number;
    name?: string | undefined;
    createDate?: Date;
    propertyCount?: number;
    uniqueElementCount?: number;

    constructor(data?: IBimModelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.propertyCount = _data["propertyCount"];
            this.uniqueElementCount = _data["uniqueElementCount"];
        }
    }

    static fromJS(data: any): BimModelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BimModelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["propertyCount"] = this.propertyCount;
        data["uniqueElementCount"] = this.uniqueElementCount;
        return data;
    }
}

export interface IBimModelInfo {
    id?: number;
    name?: string | undefined;
    createDate?: Date;
    propertyCount?: number;
    uniqueElementCount?: number;
}

export class BimModelPropertyDto implements IBimModelPropertyDto {
    name?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;

    constructor(data?: IBimModelPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): BimModelPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BimModelPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IBimModelPropertyDto {
    name?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;
}

export class BimModelSchemaRequest implements IBimModelSchemaRequest {
    projectId?: number;
    bimModelId?: number | undefined;
    dataStandardId?: number | undefined;
    includeValueSamples?: boolean;
    maxSampleValues?: number;

    constructor(data?: IBimModelSchemaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.bimModelId = _data["bimModelId"];
            this.dataStandardId = _data["dataStandardId"];
            this.includeValueSamples = _data["includeValueSamples"];
            this.maxSampleValues = _data["maxSampleValues"];
        }
    }

    static fromJS(data: any): BimModelSchemaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BimModelSchemaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["bimModelId"] = this.bimModelId;
        data["dataStandardId"] = this.dataStandardId;
        data["includeValueSamples"] = this.includeValueSamples;
        data["maxSampleValues"] = this.maxSampleValues;
        return data;
    }
}

export interface IBimModelSchemaRequest {
    projectId?: number;
    bimModelId?: number | undefined;
    dataStandardId?: number | undefined;
    includeValueSamples?: boolean;
    maxSampleValues?: number;
}

export class BimModelSchemaResponse implements IBimModelSchemaResponse {
    project?: BimProjectInfo;
    models?: BimModelInfo[] | undefined;
    propertySets?: BimPropertySetInfo[] | undefined;
    classificationContext?: BimClassificationContext;
    totalPropertyCount?: number;
    largeDataWarning?: string | undefined;
    suggestedApproach?: QueryApproach;

    constructor(data?: IBimModelSchemaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? BimProjectInfo.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(BimModelInfo.fromJS(item));
            }
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(BimPropertySetInfo.fromJS(item));
            }
            this.classificationContext = _data["classificationContext"] ? BimClassificationContext.fromJS(_data["classificationContext"]) : undefined as any;
            this.totalPropertyCount = _data["totalPropertyCount"];
            this.largeDataWarning = _data["largeDataWarning"];
            this.suggestedApproach = _data["suggestedApproach"];
        }
    }

    static fromJS(data: any): BimModelSchemaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BimModelSchemaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item ? item.toJSON() : undefined as any);
        }
        data["classificationContext"] = this.classificationContext ? this.classificationContext.toJSON() : undefined as any;
        data["totalPropertyCount"] = this.totalPropertyCount;
        data["largeDataWarning"] = this.largeDataWarning;
        data["suggestedApproach"] = this.suggestedApproach;
        return data;
    }
}

export interface IBimModelSchemaResponse {
    project?: BimProjectInfo;
    models?: BimModelInfo[] | undefined;
    propertySets?: BimPropertySetInfo[] | undefined;
    classificationContext?: BimClassificationContext;
    totalPropertyCount?: number;
    largeDataWarning?: string | undefined;
    suggestedApproach?: QueryApproach;
}

export class BimProjectInfo implements IBimProjectInfo {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    modelCount?: number;

    constructor(data?: IBimProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.modelCount = _data["modelCount"];
        }
    }

    static fromJS(data: any): BimProjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BimProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["modelCount"] = this.modelCount;
        return data;
    }
}

export interface IBimProjectInfo {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    modelCount?: number;
}

export class BimPropertyInfo implements IBimPropertyInfo {
    name?: string | undefined;
    inferredDataType?: string | undefined;
    sampleValues?: string[] | undefined;
    occurrenceCount?: number;
    hasUnit?: boolean;
    commonUnit?: string | undefined;

    constructor(data?: IBimPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.inferredDataType = _data["inferredDataType"];
            if (Array.isArray(_data["sampleValues"])) {
                this.sampleValues = [] as any;
                for (let item of _data["sampleValues"])
                    this.sampleValues!.push(item);
            }
            this.occurrenceCount = _data["occurrenceCount"];
            this.hasUnit = _data["hasUnit"];
            this.commonUnit = _data["commonUnit"];
        }
    }

    static fromJS(data: any): BimPropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["inferredDataType"] = this.inferredDataType;
        if (Array.isArray(this.sampleValues)) {
            data["sampleValues"] = [];
            for (let item of this.sampleValues)
                data["sampleValues"].push(item);
        }
        data["occurrenceCount"] = this.occurrenceCount;
        data["hasUnit"] = this.hasUnit;
        data["commonUnit"] = this.commonUnit;
        return data;
    }
}

export interface IBimPropertyInfo {
    name?: string | undefined;
    inferredDataType?: string | undefined;
    sampleValues?: string[] | undefined;
    occurrenceCount?: number;
    hasUnit?: boolean;
    commonUnit?: string | undefined;
}

export class BimPropertyPreviewRequest implements IBimPropertyPreviewRequest {
    sqlQuery?: string | undefined;
    projectId?: number;
    bimModelId?: number | undefined;
    maxRows?: number;

    constructor(data?: IBimPropertyPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sqlQuery = _data["sqlQuery"];
            this.projectId = _data["projectId"];
            this.bimModelId = _data["bimModelId"];
            this.maxRows = _data["maxRows"];
        }
    }

    static fromJS(data: any): BimPropertyPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertyPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery;
        data["projectId"] = this.projectId;
        data["bimModelId"] = this.bimModelId;
        data["maxRows"] = this.maxRows;
        return data;
    }
}

export interface IBimPropertyPreviewRequest {
    sqlQuery?: string | undefined;
    projectId?: number;
    bimModelId?: number | undefined;
    maxRows?: number;
}

export class BimPropertyQueryRequest implements IBimPropertyQueryRequest {
    question?: string | undefined;
    projectId?: number;
    bimModelId?: number | undefined;
    dataStandardId?: number | undefined;
    sessionId?: string | undefined;
    schemaContext?: BimModelSchemaResponse;

    constructor(data?: IBimPropertyQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.projectId = _data["projectId"];
            this.bimModelId = _data["bimModelId"];
            this.dataStandardId = _data["dataStandardId"];
            this.sessionId = _data["sessionId"];
            this.schemaContext = _data["schemaContext"] ? BimModelSchemaResponse.fromJS(_data["schemaContext"]) : undefined as any;
        }
    }

    static fromJS(data: any): BimPropertyQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertyQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["projectId"] = this.projectId;
        data["bimModelId"] = this.bimModelId;
        data["dataStandardId"] = this.dataStandardId;
        data["sessionId"] = this.sessionId;
        data["schemaContext"] = this.schemaContext ? this.schemaContext.toJSON() : undefined as any;
        return data;
    }
}

export interface IBimPropertyQueryRequest {
    question?: string | undefined;
    projectId?: number;
    bimModelId?: number | undefined;
    dataStandardId?: number | undefined;
    sessionId?: string | undefined;
    schemaContext?: BimModelSchemaResponse;
}

export class BimPropertyQueryResponse implements IBimPropertyQueryResponse {
    sqlQuery?: string | undefined;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    estimatedRowCount?: number | undefined;
    performanceWarning?: string | undefined;
    usage?: TokenUsage;

    constructor(data?: IBimPropertyQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sqlQuery = _data["sqlQuery"];
            this.explanation = _data["explanation"];
            this.sessionId = _data["sessionId"];
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.estimatedRowCount = _data["estimatedRowCount"];
            this.performanceWarning = _data["performanceWarning"];
            this.usage = _data["usage"] ? TokenUsage.fromJS(_data["usage"]) : undefined as any;
        }
    }

    static fromJS(data: any): BimPropertyQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertyQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery;
        data["explanation"] = this.explanation;
        data["sessionId"] = this.sessionId;
        data["isValid"] = this.isValid;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["estimatedRowCount"] = this.estimatedRowCount;
        data["performanceWarning"] = this.performanceWarning;
        data["usage"] = this.usage ? this.usage.toJSON() : undefined as any;
        return data;
    }
}

export interface IBimPropertyQueryResponse {
    sqlQuery?: string | undefined;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    estimatedRowCount?: number | undefined;
    performanceWarning?: string | undefined;
    usage?: TokenUsage;
}

export class BimPropertySetDto implements IBimPropertySetDto {
    name?: string | undefined;
    properties?: BimModelPropertyDto[] | undefined;

    constructor(data?: IBimPropertySetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(BimModelPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BimPropertySetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertySetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBimPropertySetDto {
    name?: string | undefined;
    properties?: BimModelPropertyDto[] | undefined;
}

export class BimPropertySetInfo implements IBimPropertySetInfo {
    propertySetName?: string | undefined;
    properties?: BimPropertyInfo[] | undefined;
    occurrenceCount?: number;

    constructor(data?: IBimPropertySetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySetName = _data["propertySetName"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(BimPropertyInfo.fromJS(item));
            }
            this.occurrenceCount = _data["occurrenceCount"];
        }
    }

    static fromJS(data: any): BimPropertySetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BimPropertySetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySetName"] = this.propertySetName;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["occurrenceCount"] = this.occurrenceCount;
        return data;
    }
}

export interface IBimPropertySetInfo {
    propertySetName?: string | undefined;
    properties?: BimPropertyInfo[] | undefined;
    occurrenceCount?: number;
}

export class BookmarkRequest implements IBookmarkRequest {
    isBookmarked?: boolean;
    notes?: string | undefined;

    constructor(data?: IBookmarkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBookmarked = _data["isBookmarked"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): BookmarkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BookmarkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBookmarked"] = this.isBookmarked;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IBookmarkRequest {
    isBookmarked?: boolean;
    notes?: string | undefined;
}

export class BudgetCalculationResult implements IBudgetCalculationResult {
    pairerId?: number;
    itemSign?: string | undefined;
    itemName?: string | undefined;
    itemString?: string | undefined;
    itemId?: string | undefined;
    modelId?: string | undefined;
    measuringUnitId?: number | undefined;
    amount?: number;
    unitPrice?: number | undefined;
    measuringUnit?: string | undefined;
    formulaString?: string | undefined;
    pricingDatabase?: string | undefined;
    specification?: string | undefined;
    customFields?: CustomBudgetFieldDto[] | undefined;

    constructor(data?: IBudgetCalculationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.itemSign = _data["itemSign"];
            this.itemName = _data["itemName"];
            this.itemString = _data["itemString"];
            this.itemId = _data["itemId"];
            this.modelId = _data["modelId"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            this.measuringUnit = _data["measuringUnit"];
            this.formulaString = _data["formulaString"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.specification = _data["specification"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomBudgetFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetCalculationResult {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetCalculationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["itemSign"] = this.itemSign;
        data["itemName"] = this.itemName;
        data["itemString"] = this.itemString;
        data["itemId"] = this.itemId;
        data["modelId"] = this.modelId;
        data["measuringUnitId"] = this.measuringUnitId;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["measuringUnit"] = this.measuringUnit;
        data["formulaString"] = this.formulaString;
        data["pricingDatabase"] = this.pricingDatabase;
        data["specification"] = this.specification;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetCalculationResult {
    pairerId?: number;
    itemSign?: string | undefined;
    itemName?: string | undefined;
    itemString?: string | undefined;
    itemId?: string | undefined;
    modelId?: string | undefined;
    measuringUnitId?: number | undefined;
    amount?: number;
    unitPrice?: number | undefined;
    measuringUnit?: string | undefined;
    formulaString?: string | undefined;
    pricingDatabase?: string | undefined;
    specification?: string | undefined;
    customFields?: CustomBudgetFieldDto[] | undefined;
}

export class BudgetingSessionDto implements IBudgetingSessionDto {
    id?: number;
    name?: string | undefined;
    projectId?: number | undefined;
    dataStandardId?: number | undefined;

    constructor(data?: IBudgetingSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.dataStandardId = _data["dataStandardId"];
        }
    }

    static fromJS(data: any): BudgetingSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["dataStandardId"] = this.dataStandardId;
        return data;
    }
}

export interface IBudgetingSessionDto {
    id?: number;
    name?: string | undefined;
    projectId?: number | undefined;
    dataStandardId?: number | undefined;
}

export class BudgetingSessionForTilesDto implements IBudgetingSessionForTilesDto {
    id?: number;
    name?: string | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;
    dataStandardId?: number | undefined;
    dataStandardName?: string | undefined;

    constructor(data?: IBudgetingSessionForTilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.dataStandardId = _data["dataStandardId"];
            this.dataStandardName = _data["dataStandardName"];
        }
    }

    static fromJS(data: any): BudgetingSessionForTilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingSessionForTilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["dataStandardId"] = this.dataStandardId;
        data["dataStandardName"] = this.dataStandardName;
        return data;
    }
}

export interface IBudgetingSessionForTilesDto {
    id?: number;
    name?: string | undefined;
    projectId?: number | undefined;
    projectName?: string | undefined;
    dataStandardId?: number | undefined;
    dataStandardName?: string | undefined;
}

export class BudgetingSessionPairingDto implements IBudgetingSessionPairingDto {
    id?: number;
    elementId?: string | undefined;
    modelId?: string | undefined;
    pairerId?: number;
    budgetRuleId?: number;

    constructor(data?: IBudgetingSessionPairingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementId = _data["elementId"];
            this.modelId = _data["modelId"];
            this.pairerId = _data["pairerId"];
            this.budgetRuleId = _data["budgetRuleId"];
        }
    }

    static fromJS(data: any): BudgetingSessionPairingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetingSessionPairingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementId"] = this.elementId;
        data["modelId"] = this.modelId;
        data["pairerId"] = this.pairerId;
        data["budgetRuleId"] = this.budgetRuleId;
        return data;
    }
}

export interface IBudgetingSessionPairingDto {
    id?: number;
    elementId?: string | undefined;
    modelId?: string | undefined;
    pairerId?: number;
    budgetRuleId?: number;
}

export class BudgetItemMatch implements IBudgetItemMatch {
    budgetItemId?: number;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    measuringUnit?: string | undefined;
    formulaId?: number | undefined;

    constructor(data?: IBudgetItemMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetItemId = _data["budgetItemId"];
            this.budgetItemSign = _data["budgetItemSign"];
            this.budgetItemName = _data["budgetItemName"];
            this.budgetItemDescription = _data["budgetItemDescription"];
            this.budgetItemSpecification = _data["budgetItemSpecification"];
            this.unitPrice = _data["unitPrice"];
            this.measuringUnit = _data["measuringUnit"];
            this.formulaId = _data["formulaId"];
        }
    }

    static fromJS(data: any): BudgetItemMatch {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetItemMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetItemId"] = this.budgetItemId;
        data["budgetItemSign"] = this.budgetItemSign;
        data["budgetItemName"] = this.budgetItemName;
        data["budgetItemDescription"] = this.budgetItemDescription;
        data["budgetItemSpecification"] = this.budgetItemSpecification;
        data["unitPrice"] = this.unitPrice;
        data["measuringUnit"] = this.measuringUnit;
        data["formulaId"] = this.formulaId;
        return data;
    }
}

export interface IBudgetItemMatch {
    budgetItemId?: number;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    measuringUnit?: string | undefined;
    formulaId?: number | undefined;
}

export class BudgetResultDto implements IBudgetResultDto {
    results?: BudgetCalculationResult[] | undefined;
    summedResults?: BudgetCalculationResult[] | undefined;

    constructor(data?: IBudgetResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BudgetCalculationResult.fromJS(item));
            }
            if (Array.isArray(_data["summedResults"])) {
                this.summedResults = [] as any;
                for (let item of _data["summedResults"])
                    this.summedResults!.push(BudgetCalculationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.summedResults)) {
            data["summedResults"] = [];
            for (let item of this.summedResults)
                data["summedResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetResultDto {
    results?: BudgetCalculationResult[] | undefined;
    summedResults?: BudgetCalculationResult[] | undefined;
}

export class BudgetRuleDto implements IBudgetRuleDto {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    budgetRuleItems?: BudgetRuleItemDto[] | undefined;

    constructor(data?: IBudgetRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.category = _data["category"];
            if (Array.isArray(_data["budgetRuleItems"])) {
                this.budgetRuleItems = [] as any;
                for (let item of _data["budgetRuleItems"])
                    this.budgetRuleItems!.push(BudgetRuleItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["category"] = this.category;
        if (Array.isArray(this.budgetRuleItems)) {
            data["budgetRuleItems"] = [];
            for (let item of this.budgetRuleItems)
                data["budgetRuleItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetRuleDto {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    budgetRuleItems?: BudgetRuleItemDto[] | undefined;
}

export class BudgetRuleItemDto implements IBudgetRuleItemDto {
    id?: number;
    pairerBudgetRuleId?: number;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnit?: string | undefined;
    formulaId?: number | undefined;
    formulaName?: string | undefined;
    formulaNumeric?: boolean | undefined;
    formulaString?: string | undefined;

    constructor(data?: IBudgetRuleItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pairerBudgetRuleId = _data["pairerBudgetRuleId"];
            this.budgetItemSign = _data["budgetItemSign"];
            this.budgetItemName = _data["budgetItemName"];
            this.budgetItemDescription = _data["budgetItemDescription"];
            this.budgetItemSpecification = _data["budgetItemSpecification"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.measuringUnit = _data["measuringUnit"];
            this.formulaId = _data["formulaId"];
            this.formulaName = _data["formulaName"];
            this.formulaNumeric = _data["formulaNumeric"];
            this.formulaString = _data["formulaString"];
        }
    }

    static fromJS(data: any): BudgetRuleItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRuleItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pairerBudgetRuleId"] = this.pairerBudgetRuleId;
        data["budgetItemSign"] = this.budgetItemSign;
        data["budgetItemName"] = this.budgetItemName;
        data["budgetItemDescription"] = this.budgetItemDescription;
        data["budgetItemSpecification"] = this.budgetItemSpecification;
        data["measuringUnitId"] = this.measuringUnitId;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["measuringUnit"] = this.measuringUnit;
        data["formulaId"] = this.formulaId;
        data["formulaName"] = this.formulaName;
        data["formulaNumeric"] = this.formulaNumeric;
        data["formulaString"] = this.formulaString;
        return data;
    }
}

export interface IBudgetRuleItemDto {
    id?: number;
    pairerBudgetRuleId?: number;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnit?: string | undefined;
    formulaId?: number | undefined;
    formulaName?: string | undefined;
    formulaNumeric?: boolean | undefined;
    formulaString?: string | undefined;
}

export class BudgetRuleMatch implements IBudgetRuleMatch {
    budgetRuleId?: number;
    budgetRuleName?: string | undefined;
    category?: string | undefined;
    budgetItems?: BudgetItemMatch[] | undefined;
    isSelected?: boolean;

    constructor(data?: IBudgetRuleMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetRuleId = _data["budgetRuleId"];
            this.budgetRuleName = _data["budgetRuleName"];
            this.category = _data["category"];
            if (Array.isArray(_data["budgetItems"])) {
                this.budgetItems = [] as any;
                for (let item of _data["budgetItems"])
                    this.budgetItems!.push(BudgetItemMatch.fromJS(item));
            }
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): BudgetRuleMatch {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRuleMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetRuleId"] = this.budgetRuleId;
        data["budgetRuleName"] = this.budgetRuleName;
        data["category"] = this.category;
        if (Array.isArray(this.budgetItems)) {
            data["budgetItems"] = [];
            for (let item of this.budgetItems)
                data["budgetItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IBudgetRuleMatch {
    budgetRuleId?: number;
    budgetRuleName?: string | undefined;
    category?: string | undefined;
    budgetItems?: BudgetItemMatch[] | undefined;
    isSelected?: boolean;
}

export class BulkIndexRequest implements IBulkIndexRequest {
    fullReindex?: boolean;
    batchSize?: number;

    constructor(data?: IBulkIndexRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullReindex = _data["fullReindex"];
            this.batchSize = _data["batchSize"];
        }
    }

    static fromJS(data: any): BulkIndexRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BulkIndexRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullReindex"] = this.fullReindex;
        data["batchSize"] = this.batchSize;
        return data;
    }
}

export interface IBulkIndexRequest {
    fullReindex?: boolean;
    batchSize?: number;
}

export class BulkIndexResponse implements IBulkIndexResponse {
    jobId?: string | undefined;
    totalModelsInDatabase?: number;
    alreadyIndexedModels?: number;
    modelsToIndex?: number;
    fullReindex?: boolean;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IBulkIndexResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.totalModelsInDatabase = _data["totalModelsInDatabase"];
            this.alreadyIndexedModels = _data["alreadyIndexedModels"];
            this.modelsToIndex = _data["modelsToIndex"];
            this.fullReindex = _data["fullReindex"];
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BulkIndexResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BulkIndexResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["totalModelsInDatabase"] = this.totalModelsInDatabase;
        data["alreadyIndexedModels"] = this.alreadyIndexedModels;
        data["modelsToIndex"] = this.modelsToIndex;
        data["fullReindex"] = this.fullReindex;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IBulkIndexResponse {
    jobId?: string | undefined;
    totalModelsInDatabase?: number;
    alreadyIndexedModels?: number;
    modelsToIndex?: number;
    fullReindex?: boolean;
    status?: string | undefined;
    message?: string | undefined;
}

export class CalculateBudgetAmountsDatabaseRequest implements ICalculateBudgetAmountsDatabaseRequest {
    budgetingSessionId?: number;

    constructor(data?: ICalculateBudgetAmountsDatabaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetingSessionId = _data["budgetingSessionId"];
        }
    }

    static fromJS(data: any): CalculateBudgetAmountsDatabaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBudgetAmountsDatabaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetingSessionId"] = this.budgetingSessionId;
        return data;
    }
}

export interface ICalculateBudgetAmountsDatabaseRequest {
    budgetingSessionId?: number;
}

export class CalculateBudgetAmountsRequest implements ICalculateBudgetAmountsRequest {
    budgetingSessionId?: number;
    modelData?: string | undefined;

    constructor(data?: ICalculateBudgetAmountsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetingSessionId = _data["budgetingSessionId"];
            this.modelData = _data["modelData"];
        }
    }

    static fromJS(data: any): CalculateBudgetAmountsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBudgetAmountsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetingSessionId"] = this.budgetingSessionId;
        data["modelData"] = this.modelData;
        return data;
    }
}

export interface ICalculateBudgetAmountsRequest {
    budgetingSessionId?: number;
    modelData?: string | undefined;
}

export class CalculateBudgetAmountsResponse implements ICalculateBudgetAmountsResponse {
    data?: BudgetResultDto;

    constructor(data?: ICalculateBudgetAmountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BudgetResultDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculateBudgetAmountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateBudgetAmountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalculateBudgetAmountsResponse {
    data?: BudgetResultDto;
}

export class ClientClassificationContext implements IClientClassificationContext {
    dataStandardName?: string | undefined;
    groups?: ClientClassificationGroup[] | undefined;

    constructor(data?: IClientClassificationContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardName = _data["dataStandardName"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ClientClassificationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientClassificationContext {
        data = typeof data === 'object' ? data : {};
        let result = new ClientClassificationContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardName"] = this.dataStandardName;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientClassificationContext {
    dataStandardName?: string | undefined;
    groups?: ClientClassificationGroup[] | undefined;
}

export class ClientClassificationGroup implements IClientClassificationGroup {
    name?: string | undefined;
    nameGroup?: string | undefined;
    items?: ClientClassificationItem[] | undefined;

    constructor(data?: IClientClassificationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientClassificationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientClassificationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ClientClassificationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientClassificationGroup {
    name?: string | undefined;
    nameGroup?: string | undefined;
    items?: ClientClassificationItem[] | undefined;
}

export class ClientClassificationItem implements IClientClassificationItem {
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    keywords?: string[] | undefined;

    constructor(data?: IClientClassificationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientClassificationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClientClassificationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["filter"] = this.filter;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        return data;
    }
}

export interface IClientClassificationItem {
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    keywords?: string[] | undefined;
}

export class ClientDataSchema implements IClientDataSchema {
    propertyNames?: string[] | undefined;
    propertySetNames?: string[] | undefined;
    sampleValues?: { [key: string]: string[]; } | undefined;
    totalRows?: number;
    uniqueElements?: number;

    constructor(data?: IClientDataSchema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propertyNames"])) {
                this.propertyNames = [] as any;
                for (let item of _data["propertyNames"])
                    this.propertyNames!.push(item);
            }
            if (Array.isArray(_data["propertySetNames"])) {
                this.propertySetNames = [] as any;
                for (let item of _data["propertySetNames"])
                    this.propertySetNames!.push(item);
            }
            if (_data["sampleValues"]) {
                this.sampleValues = {} as any;
                for (let key in _data["sampleValues"]) {
                    if (_data["sampleValues"].hasOwnProperty(key))
                        (this.sampleValues as any)![key] = _data["sampleValues"][key] !== undefined ? _data["sampleValues"][key] : [];
                }
            }
            this.totalRows = _data["totalRows"];
            this.uniqueElements = _data["uniqueElements"];
        }
    }

    static fromJS(data: any): ClientDataSchema {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDataSchema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propertyNames)) {
            data["propertyNames"] = [];
            for (let item of this.propertyNames)
                data["propertyNames"].push(item);
        }
        if (Array.isArray(this.propertySetNames)) {
            data["propertySetNames"] = [];
            for (let item of this.propertySetNames)
                data["propertySetNames"].push(item);
        }
        if (this.sampleValues) {
            data["sampleValues"] = {};
            for (let key in this.sampleValues) {
                if (this.sampleValues.hasOwnProperty(key))
                    (data["sampleValues"] as any)[key] = (this.sampleValues as any)[key];
            }
        }
        data["totalRows"] = this.totalRows;
        data["uniqueElements"] = this.uniqueElements;
        return data;
    }
}

export interface IClientDataSchema {
    propertyNames?: string[] | undefined;
    propertySetNames?: string[] | undefined;
    sampleValues?: { [key: string]: string[]; } | undefined;
    totalRows?: number;
    uniqueElements?: number;
}

export class ClientFilterRequest implements IClientFilterRequest {
    question?: string | undefined;
    schema?: ClientDataSchema;
    classificationContext?: ClientClassificationContext;
    sessionId?: string | undefined;

    constructor(data?: IClientFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.schema = _data["schema"] ? ClientDataSchema.fromJS(_data["schema"]) : undefined as any;
            this.classificationContext = _data["classificationContext"] ? ClientClassificationContext.fromJS(_data["classificationContext"]) : undefined as any;
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): ClientFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClientFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["schema"] = this.schema ? this.schema.toJSON() : undefined as any;
        data["classificationContext"] = this.classificationContext ? this.classificationContext.toJSON() : undefined as any;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IClientFilterRequest {
    question?: string | undefined;
    schema?: ClientDataSchema;
    classificationContext?: ClientClassificationContext;
    sessionId?: string | undefined;
}

export class ClientFilterResponse implements IClientFilterResponse {
    filterModel?: ClientGridFilterModel;
    rawFilterExpression?: string | undefined;
    filterType?: FilterType;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    usage?: TokenUsage;

    constructor(data?: IClientFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterModel = _data["filterModel"] ? ClientGridFilterModel.fromJS(_data["filterModel"]) : undefined as any;
            this.rawFilterExpression = _data["rawFilterExpression"];
            this.filterType = _data["filterType"];
            this.explanation = _data["explanation"];
            this.sessionId = _data["sessionId"];
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.usage = _data["usage"] ? TokenUsage.fromJS(_data["usage"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterModel"] = this.filterModel ? this.filterModel.toJSON() : undefined as any;
        data["rawFilterExpression"] = this.rawFilterExpression;
        data["filterType"] = this.filterType;
        data["explanation"] = this.explanation;
        data["sessionId"] = this.sessionId;
        data["isValid"] = this.isValid;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["usage"] = this.usage ? this.usage.toJSON() : undefined as any;
        return data;
    }
}

export interface IClientFilterResponse {
    filterModel?: ClientGridFilterModel;
    rawFilterExpression?: string | undefined;
    filterType?: FilterType;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    usage?: TokenUsage;
}

export class ClientGridFilterItem implements IClientGridFilterItem {
    field?: string | undefined;
    operator?: string | undefined;
    value?: any | undefined;
    id?: string | undefined;

    constructor(data?: IClientGridFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClientGridFilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGridFilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IClientGridFilterItem {
    field?: string | undefined;
    operator?: string | undefined;
    value?: any | undefined;
    id?: string | undefined;
}

export class ClientGridFilterModel implements IClientGridFilterModel {
    items?: ClientGridFilterItem[] | undefined;
    logicOperator?: string | undefined;
    quickFilterValues?: string[] | undefined;

    constructor(data?: IClientGridFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClientGridFilterItem.fromJS(item));
            }
            this.logicOperator = _data["logicOperator"];
            if (Array.isArray(_data["quickFilterValues"])) {
                this.quickFilterValues = [] as any;
                for (let item of _data["quickFilterValues"])
                    this.quickFilterValues!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientGridFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientGridFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["logicOperator"] = this.logicOperator;
        if (Array.isArray(this.quickFilterValues)) {
            data["quickFilterValues"] = [];
            for (let item of this.quickFilterValues)
                data["quickFilterValues"].push(item);
        }
        return data;
    }
}

export interface IClientGridFilterModel {
    items?: ClientGridFilterItem[] | undefined;
    logicOperator?: string | undefined;
    quickFilterValues?: string[] | undefined;
}

export enum CollectionState {
    Unchanged = "Unchanged",
    Added = "Added",
    Modified = "Modified",
    Deleted = "Deleted",
}

export class ColumnInfo implements IColumnInfo {
    columnName?: string | undefined;
    propertyName?: string | undefined;
    dataType?: string | undefined;
    isNullable?: boolean;
    isPrimaryKey?: boolean;
    isForeignKey?: boolean;

    constructor(data?: IColumnInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.propertyName = _data["propertyName"];
            this.dataType = _data["dataType"];
            this.isNullable = _data["isNullable"];
            this.isPrimaryKey = _data["isPrimaryKey"];
            this.isForeignKey = _data["isForeignKey"];
        }
    }

    static fromJS(data: any): ColumnInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["propertyName"] = this.propertyName;
        data["dataType"] = this.dataType;
        data["isNullable"] = this.isNullable;
        data["isPrimaryKey"] = this.isPrimaryKey;
        data["isForeignKey"] = this.isForeignKey;
        return data;
    }
}

export interface IColumnInfo {
    columnName?: string | undefined;
    propertyName?: string | undefined;
    dataType?: string | undefined;
    isNullable?: boolean;
    isPrimaryKey?: boolean;
    isForeignKey?: boolean;
}

export class CommitBlocksRequest implements ICommitBlocksRequest {
    modelName?: string | undefined;
    modelId?: number;
    blockIds?: string[] | undefined;
    bulkUploadId?: string | undefined;

    constructor(data?: ICommitBlocksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelName = _data["modelName"];
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["blockIds"])) {
                this.blockIds = [] as any;
                for (let item of _data["blockIds"])
                    this.blockIds!.push(item);
            }
            this.bulkUploadId = _data["bulkUploadId"];
        }
    }

    static fromJS(data: any): CommitBlocksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommitBlocksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelName"] = this.modelName;
        data["modelId"] = this.modelId;
        if (Array.isArray(this.blockIds)) {
            data["blockIds"] = [];
            for (let item of this.blockIds)
                data["blockIds"].push(item);
        }
        data["bulkUploadId"] = this.bulkUploadId;
        return data;
    }
}

export interface ICommitBlocksRequest {
    modelName?: string | undefined;
    modelId?: number;
    blockIds?: string[] | undefined;
    bulkUploadId?: string | undefined;
}

export class CommitBlocksResponse implements ICommitBlocksResponse {
    modelSasUri?: string | undefined;

    constructor(data?: ICommitBlocksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelSasUri = _data["modelSasUri"];
        }
    }

    static fromJS(data: any): CommitBlocksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommitBlocksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelSasUri"] = this.modelSasUri;
        return data;
    }
}

export interface ICommitBlocksResponse {
    modelSasUri?: string | undefined;
}

export class CommitUploadRequest implements ICommitUploadRequest {
    blobId?: string | undefined;
    blockIds?: string[] | undefined;
    pricingDatabaseId?: number;

    constructor(data?: ICommitUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobId = _data["blobId"];
            if (Array.isArray(_data["blockIds"])) {
                this.blockIds = [] as any;
                for (let item of _data["blockIds"])
                    this.blockIds!.push(item);
            }
            this.pricingDatabaseId = _data["pricingDatabaseId"];
        }
    }

    static fromJS(data: any): CommitUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommitUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobId"] = this.blobId;
        if (Array.isArray(this.blockIds)) {
            data["blockIds"] = [];
            for (let item of this.blockIds)
                data["blockIds"].push(item);
        }
        data["pricingDatabaseId"] = this.pricingDatabaseId;
        return data;
    }
}

export interface ICommitUploadRequest {
    blobId?: string | undefined;
    blockIds?: string[] | undefined;
    pricingDatabaseId?: number;
}

export class CompareParams implements ICompareParams {
    sourceModelId?: number;
    targetModelId?: number;
    comparisonType?: string | undefined;

    constructor(data?: ICompareParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceModelId = _data["sourceModelId"];
            this.targetModelId = _data["targetModelId"];
            this.comparisonType = _data["comparisonType"];
        }
    }

    static fromJS(data: any): CompareParams {
        data = typeof data === 'object' ? data : {};
        let result = new CompareParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceModelId"] = this.sourceModelId;
        data["targetModelId"] = this.targetModelId;
        data["comparisonType"] = this.comparisonType;
        return data;
    }
}

export interface ICompareParams {
    sourceModelId?: number;
    targetModelId?: number;
    comparisonType?: string | undefined;
}

export class ComparisonDiff implements IComparisonDiff {
    expressId?: number;
    changeType?: string | undefined;
    elementType?: string | undefined;
    propertyChanges?: { [key: string]: PropertyDiff; } | undefined;

    constructor(data?: IComparisonDiff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.changeType = _data["changeType"];
            this.elementType = _data["elementType"];
            if (_data["propertyChanges"]) {
                this.propertyChanges = {} as any;
                for (let key in _data["propertyChanges"]) {
                    if (_data["propertyChanges"].hasOwnProperty(key))
                        (this.propertyChanges as any)![key] = _data["propertyChanges"][key] ? PropertyDiff.fromJS(_data["propertyChanges"][key]) : new PropertyDiff();
                }
            }
        }
    }

    static fromJS(data: any): ComparisonDiff {
        data = typeof data === 'object' ? data : {};
        let result = new ComparisonDiff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["changeType"] = this.changeType;
        data["elementType"] = this.elementType;
        if (this.propertyChanges) {
            data["propertyChanges"] = {};
            for (let key in this.propertyChanges) {
                if (this.propertyChanges.hasOwnProperty(key))
                    (data["propertyChanges"] as any)[key] = this.propertyChanges[key] ? this.propertyChanges[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IComparisonDiff {
    expressId?: number;
    changeType?: string | undefined;
    elementType?: string | undefined;
    propertyChanges?: { [key: string]: PropertyDiff; } | undefined;
}

export class ComparisonResult implements IComparisonResult {
    sourceModelId?: number;
    targetModelId?: number;
    sourceModelName?: string | undefined;
    targetModelName?: string | undefined;
    summary?: ComparisonSummary;
    differences?: ComparisonDiff[] | undefined;

    constructor(data?: IComparisonResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceModelId = _data["sourceModelId"];
            this.targetModelId = _data["targetModelId"];
            this.sourceModelName = _data["sourceModelName"];
            this.targetModelName = _data["targetModelName"];
            this.summary = _data["summary"] ? ComparisonSummary.fromJS(_data["summary"]) : undefined as any;
            if (Array.isArray(_data["differences"])) {
                this.differences = [] as any;
                for (let item of _data["differences"])
                    this.differences!.push(ComparisonDiff.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComparisonResult {
        data = typeof data === 'object' ? data : {};
        let result = new ComparisonResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceModelId"] = this.sourceModelId;
        data["targetModelId"] = this.targetModelId;
        data["sourceModelName"] = this.sourceModelName;
        data["targetModelName"] = this.targetModelName;
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComparisonResult {
    sourceModelId?: number;
    targetModelId?: number;
    sourceModelName?: string | undefined;
    targetModelName?: string | undefined;
    summary?: ComparisonSummary;
    differences?: ComparisonDiff[] | undefined;
}

export class ComparisonSummary implements IComparisonSummary {
    addedElements?: number;
    removedElements?: number;
    modifiedElements?: number;
    unchangedElements?: number;
    quantityDiffs?: { [key: string]: number; } | undefined;

    constructor(data?: IComparisonSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addedElements = _data["addedElements"];
            this.removedElements = _data["removedElements"];
            this.modifiedElements = _data["modifiedElements"];
            this.unchangedElements = _data["unchangedElements"];
            if (_data["quantityDiffs"]) {
                this.quantityDiffs = {} as any;
                for (let key in _data["quantityDiffs"]) {
                    if (_data["quantityDiffs"].hasOwnProperty(key))
                        (this.quantityDiffs as any)![key] = _data["quantityDiffs"][key];
                }
            }
        }
    }

    static fromJS(data: any): ComparisonSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ComparisonSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addedElements"] = this.addedElements;
        data["removedElements"] = this.removedElements;
        data["modifiedElements"] = this.modifiedElements;
        data["unchangedElements"] = this.unchangedElements;
        if (this.quantityDiffs) {
            data["quantityDiffs"] = {};
            for (let key in this.quantityDiffs) {
                if (this.quantityDiffs.hasOwnProperty(key))
                    (data["quantityDiffs"] as any)[key] = (this.quantityDiffs as any)[key];
            }
        }
        return data;
    }
}

export interface IComparisonSummary {
    addedElements?: number;
    removedElements?: number;
    modifiedElements?: number;
    unchangedElements?: number;
    quantityDiffs?: { [key: string]: number; } | undefined;
}

export class CompleteFragmentsUploadResponse implements ICompleteFragmentsUploadResponse {
    completedTime?: Date;

    constructor(data?: ICompleteFragmentsUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedTime = _data["completedTime"] ? new Date(_data["completedTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CompleteFragmentsUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteFragmentsUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICompleteFragmentsUploadResponse {
    completedTime?: Date;
}

export class CompleteIfcUploadResponse implements ICompleteIfcUploadResponse {
    completedTime?: Date;

    constructor(data?: ICompleteIfcUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedTime = _data["completedTime"] ? new Date(_data["completedTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CompleteIfcUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteIfcUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICompleteIfcUploadResponse {
    completedTime?: Date;
}

export class ComputeParams implements IComputeParams {
    operation?: string | undefined;
    targetField?: string | undefined;
    targetFields?: string[] | undefined;
    groupByField?: string | undefined;

    constructor(data?: IComputeParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operation = _data["operation"];
            this.targetField = _data["targetField"];
            if (Array.isArray(_data["targetFields"])) {
                this.targetFields = [] as any;
                for (let item of _data["targetFields"])
                    this.targetFields!.push(item);
            }
            this.groupByField = _data["groupByField"];
        }
    }

    static fromJS(data: any): ComputeParams {
        data = typeof data === 'object' ? data : {};
        let result = new ComputeParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation;
        data["targetField"] = this.targetField;
        if (Array.isArray(this.targetFields)) {
            data["targetFields"] = [];
            for (let item of this.targetFields)
                data["targetFields"].push(item);
        }
        data["groupByField"] = this.groupByField;
        return data;
    }
}

export interface IComputeParams {
    operation?: string | undefined;
    targetField?: string | undefined;
    targetFields?: string[] | undefined;
    groupByField?: string | undefined;
}

export class ConstructionItemDto implements IConstructionItemDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    unitPrice?: number | undefined;
    quantity?: number | undefined;
    totalPrice?: number | undefined;
    measuringUnit?: MeasuringUnitDto;
    elements?: ConstructionItemElementDto[] | undefined;

    constructor(data?: IConstructionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sign = _data["sign"];
            this.description = _data["description"];
            this.specification = _data["specification"];
            this.billOfQuantities = _data["billOfQuantities"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.totalPrice = _data["totalPrice"];
            this.measuringUnit = _data["measuringUnit"] ? MeasuringUnitDto.fromJS(_data["measuringUnit"]) : undefined as any;
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ConstructionItemElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstructionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sign"] = this.sign;
        data["description"] = this.description;
        data["specification"] = this.specification;
        data["billOfQuantities"] = this.billOfQuantities;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["totalPrice"] = this.totalPrice;
        data["measuringUnit"] = this.measuringUnit ? this.measuringUnit.toJSON() : undefined as any;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConstructionItemDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    unitPrice?: number | undefined;
    quantity?: number | undefined;
    totalPrice?: number | undefined;
    measuringUnit?: MeasuringUnitDto;
    elements?: ConstructionItemElementDto[] | undefined;
}

export class ConstructionItemElementDto implements IConstructionItemElementDto {
    modelId?: string | undefined;
    elementId?: string | undefined;

    constructor(data?: IConstructionItemElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.elementId = _data["elementId"];
        }
    }

    static fromJS(data: any): ConstructionItemElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionItemElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["elementId"] = this.elementId;
        return data;
    }
}

export interface IConstructionItemElementDto {
    modelId?: string | undefined;
    elementId?: string | undefined;
}

export class ConstructionObjectDto implements IConstructionObjectDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    parts?: ConstructionPartDto[] | undefined;

    constructor(data?: IConstructionObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sign = _data["sign"];
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(ConstructionPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstructionObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sign"] = this.sign;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConstructionObjectDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    parts?: ConstructionPartDto[] | undefined;
}

export class ConstructionObjectPrizeDto implements IConstructionObjectPrizeDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    totalPrice?: number;

    constructor(data?: IConstructionObjectPrizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): ConstructionObjectPrizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionObjectPrizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IConstructionObjectPrizeDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    totalPrice?: number;
}

export class ConstructionPartDto implements IConstructionPartDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    items?: ConstructionItemDto[] | undefined;

    constructor(data?: IConstructionPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sign = _data["sign"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConstructionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstructionPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sign"] = this.sign;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConstructionPartDto {
    id?: number;
    name?: string | undefined;
    sign?: string | undefined;
    items?: ConstructionItemDto[] | undefined;
}

export class ConstructionPartsPrizeDto implements IConstructionPartsPrizeDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    totalPrice?: number;

    constructor(data?: IConstructionPartsPrizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): ConstructionPartsPrizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructionPartsPrizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IConstructionPartsPrizeDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    totalPrice?: number;
}

export class ContextElement implements IContextElement {
    expressId?: number;
    ifcType?: string | undefined;
    name?: string | undefined;
    properties?: { [key: string]: PropertyValue; } | undefined;

    constructor(data?: IContextElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcType = _data["ifcType"];
            this.name = _data["name"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key] ? PropertyValue.fromJS(_data["properties"][key]) : new PropertyValue();
                }
            }
        }
    }

    static fromJS(data: any): ContextElement {
        data = typeof data === 'object' ? data : {};
        let result = new ContextElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcType"] = this.ifcType;
        data["name"] = this.name;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = this.properties[key] ? this.properties[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IContextElement {
    expressId?: number;
    ifcType?: string | undefined;
    name?: string | undefined;
    properties?: { [key: string]: PropertyValue; } | undefined;
}

export class ConversationLogItem implements IConversationLogItem {
    id?: number;
    sessionId?: string | undefined;
    question?: string | undefined;
    answerJson?: string | undefined;
    answerText?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    modelIds?: string | undefined;
    totalCount?: number | undefined;
    processingTimeMs?: number | undefined;
    creatorId?: number | undefined;
    createdAt?: Date;

    constructor(data?: IConversationLogItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionId = _data["sessionId"];
            this.question = _data["question"];
            this.answerJson = _data["answerJson"];
            this.answerText = _data["answerText"];
            this.category = _data["category"];
            this.projectId = _data["projectId"];
            this.modelIds = _data["modelIds"];
            this.totalCount = _data["totalCount"];
            this.processingTimeMs = _data["processingTimeMs"];
            this.creatorId = _data["creatorId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConversationLogItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationLogItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionId"] = this.sessionId;
        data["question"] = this.question;
        data["answerJson"] = this.answerJson;
        data["answerText"] = this.answerText;
        data["category"] = this.category;
        data["projectId"] = this.projectId;
        data["modelIds"] = this.modelIds;
        data["totalCount"] = this.totalCount;
        data["processingTimeMs"] = this.processingTimeMs;
        data["creatorId"] = this.creatorId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IConversationLogItem {
    id?: number;
    sessionId?: string | undefined;
    question?: string | undefined;
    answerJson?: string | undefined;
    answerText?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    modelIds?: string | undefined;
    totalCount?: number | undefined;
    processingTimeMs?: number | undefined;
    creatorId?: number | undefined;
    createdAt?: Date;
}

export class ConversationLogPagedResponse implements IConversationLogPagedResponse {
    items?: ConversationLogItem[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;

    constructor(data?: IConversationLogPagedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConversationLogItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
        }
    }

    static fromJS(data: any): ConversationLogPagedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationLogPagedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        return data;
    }
}

export interface IConversationLogPagedResponse {
    items?: ConversationLogItem[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
}

export class CopyDataStandardRequest implements ICopyDataStandardRequest {
    name?: string | undefined;
    standardId?: number;
    tenantId?: number;
    isDefaultStandard?: boolean;

    constructor(data?: ICopyDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.standardId = _data["standardId"];
            this.tenantId = _data["tenantId"];
            this.isDefaultStandard = _data["isDefaultStandard"];
        }
    }

    static fromJS(data: any): CopyDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["standardId"] = this.standardId;
        data["tenantId"] = this.tenantId;
        data["isDefaultStandard"] = this.isDefaultStandard;
        return data;
    }
}

export interface ICopyDataStandardRequest {
    name?: string | undefined;
    standardId?: number;
    tenantId?: number;
    isDefaultStandard?: boolean;
}

export class CopyDataStandardResponse implements ICopyDataStandardResponse {
    id?: number;

    constructor(data?: ICopyDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CopyDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICopyDataStandardResponse {
    id?: number;
}

export class CopyGroupRequest implements ICopyGroupRequest {
    standardId?: number;
    groupId?: number;

    constructor(data?: ICopyGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CopyGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICopyGroupRequest {
    standardId?: number;
    groupId?: number;
}

export class CopyGroupResponse implements ICopyGroupResponse {

    constructor(data?: ICopyGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyGroupResponse {
}

export class CopyPairersRequest implements ICopyPairersRequest {
    pairersIds?: number[] | undefined;
    groupId?: number;

    constructor(data?: ICopyPairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairersIds"])) {
                this.pairersIds = [] as any;
                for (let item of _data["pairersIds"])
                    this.pairersIds!.push(item);
            }
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CopyPairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairersIds)) {
            data["pairersIds"] = [];
            for (let item of this.pairersIds)
                data["pairersIds"].push(item);
        }
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICopyPairersRequest {
    pairersIds?: number[] | undefined;
    groupId?: number;
}

export class CopyPairersResponse implements ICopyPairersResponse {

    constructor(data?: ICopyPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyPairersResponse {
}

export class CopyPairingRequest implements ICopyPairingRequest {
    sourceMStnPairingId?: number;
    targetProjectId?: number;
    targetDataStandardId?: number;
    targetName?: string | undefined;
    targetLevels?: LevelMStnDTO[] | undefined;

    constructor(data?: ICopyPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceMStnPairingId = _data["sourceMStnPairingId"];
            this.targetProjectId = _data["targetProjectId"];
            this.targetDataStandardId = _data["targetDataStandardId"];
            this.targetName = _data["targetName"];
            if (Array.isArray(_data["targetLevels"])) {
                this.targetLevels = [] as any;
                for (let item of _data["targetLevels"])
                    this.targetLevels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CopyPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceMStnPairingId"] = this.sourceMStnPairingId;
        data["targetProjectId"] = this.targetProjectId;
        data["targetDataStandardId"] = this.targetDataStandardId;
        data["targetName"] = this.targetName;
        if (Array.isArray(this.targetLevels)) {
            data["targetLevels"] = [];
            for (let item of this.targetLevels)
                data["targetLevels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICopyPairingRequest {
    sourceMStnPairingId?: number;
    targetProjectId?: number;
    targetDataStandardId?: number;
    targetName?: string | undefined;
    targetLevels?: LevelMStnDTO[] | undefined;
}

export class CopyPairingResponse implements ICopyPairingResponse {
    ok?: boolean;
    pairingId?: number;

    constructor(data?: ICopyPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.pairingId = _data["pairingId"];
        }
    }

    static fromJS(data: any): CopyPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["pairingId"] = this.pairingId;
        return data;
    }
}

export interface ICopyPairingResponse {
    ok?: boolean;
    pairingId?: number;
}

export class CopyValidationRulesRequest implements ICopyValidationRulesRequest {
    destinationPairersIds?: number[] | undefined;
    pairerCopyValidationId?: number;

    constructor(data?: ICopyValidationRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["destinationPairersIds"])) {
                this.destinationPairersIds = [] as any;
                for (let item of _data["destinationPairersIds"])
                    this.destinationPairersIds!.push(item);
            }
            this.pairerCopyValidationId = _data["pairerCopyValidationId"];
        }
    }

    static fromJS(data: any): CopyValidationRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyValidationRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.destinationPairersIds)) {
            data["destinationPairersIds"] = [];
            for (let item of this.destinationPairersIds)
                data["destinationPairersIds"].push(item);
        }
        data["pairerCopyValidationId"] = this.pairerCopyValidationId;
        return data;
    }
}

export interface ICopyValidationRulesRequest {
    destinationPairersIds?: number[] | undefined;
    pairerCopyValidationId?: number;
}

export class CopyValidationRulesResponse implements ICopyValidationRulesResponse {

    constructor(data?: ICopyValidationRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CopyValidationRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CopyValidationRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICopyValidationRulesResponse {
}

export class CorridorBaseLineDataDTO implements ICorridorBaseLineDataDTO {
    datum?: Date;
    isActual?: boolean;
    id?: number;
    autor?: string | undefined;

    constructor(data?: ICorridorBaseLineDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datum = _data["datum"] ? new Date(_data["datum"].toString()) : undefined as any;
            this.isActual = _data["isActual"];
            this.id = _data["id"];
            this.autor = _data["autor"];
        }
    }

    static fromJS(data: any): CorridorBaseLineDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CorridorBaseLineDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datum"] = this.datum ? this.datum.toISOString() : undefined as any;
        data["isActual"] = this.isActual;
        data["id"] = this.id;
        data["autor"] = this.autor;
        return data;
    }
}

export interface ICorridorBaseLineDataDTO {
    datum?: Date;
    isActual?: boolean;
    id?: number;
    autor?: string | undefined;
}

export class CorridorDTO implements ICorridorDTO {
    name?: string | undefined;
    baseLines?: BaseLineDTO[] | undefined;

    constructor(data?: ICorridorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["baseLines"])) {
                this.baseLines = [] as any;
                for (let item of _data["baseLines"])
                    this.baseLines!.push(BaseLineDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CorridorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CorridorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.baseLines)) {
            data["baseLines"] = [];
            for (let item of this.baseLines)
                data["baseLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICorridorDTO {
    name?: string | undefined;
    baseLines?: BaseLineDTO[] | undefined;
}

export class CreateBudgetRuleForPairerRequest implements ICreateBudgetRuleForPairerRequest {
    pairerId?: number;
    name?: string | undefined;
    category?: string | undefined;
    items?: CreateBudgetRuleItemRequest[] | undefined;

    constructor(data?: ICreateBudgetRuleForPairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.name = _data["name"];
            this.category = _data["category"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CreateBudgetRuleItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBudgetRuleForPairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetRuleForPairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["name"] = this.name;
        data["category"] = this.category;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateBudgetRuleForPairerRequest {
    pairerId?: number;
    name?: string | undefined;
    category?: string | undefined;
    items?: CreateBudgetRuleItemRequest[] | undefined;
}

export class CreateBudgetRuleForPairerResponse implements ICreateBudgetRuleForPairerResponse {
    ok?: boolean;
    budgetRuleId?: number | undefined;
    error?: string | undefined;
    items?: BudgetRuleItemDto[] | undefined;

    constructor(data?: ICreateBudgetRuleForPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.budgetRuleId = _data["budgetRuleId"];
            this.error = _data["error"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetRuleItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBudgetRuleForPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetRuleForPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["budgetRuleId"] = this.budgetRuleId;
        data["error"] = this.error;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateBudgetRuleForPairerResponse {
    ok?: boolean;
    budgetRuleId?: number | undefined;
    error?: string | undefined;
    items?: BudgetRuleItemDto[] | undefined;
}

export class CreateBudgetRuleItemRequest implements ICreateBudgetRuleItemRequest {
    budgetRuleId?: number | undefined;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;

    constructor(data?: ICreateBudgetRuleItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetRuleId = _data["budgetRuleId"];
            this.formulaId = _data["formulaId"];
            this.budgetItemSign = _data["budgetItemSign"];
            this.budgetItemName = _data["budgetItemName"];
            this.budgetItemDescription = _data["budgetItemDescription"];
            this.budgetItemSpecification = _data["budgetItemSpecification"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.measuringUnit = _data["measuringUnit"];
        }
    }

    static fromJS(data: any): CreateBudgetRuleItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetRuleItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetRuleId"] = this.budgetRuleId;
        data["formulaId"] = this.formulaId;
        data["budgetItemSign"] = this.budgetItemSign;
        data["budgetItemName"] = this.budgetItemName;
        data["budgetItemDescription"] = this.budgetItemDescription;
        data["budgetItemSpecification"] = this.budgetItemSpecification;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["measuringUnitId"] = this.measuringUnitId;
        data["measuringUnit"] = this.measuringUnit;
        return data;
    }
}

export interface ICreateBudgetRuleItemRequest {
    budgetRuleId?: number | undefined;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;
}

export class CreateBudgetRuleItemResponse implements ICreateBudgetRuleItemResponse {
    ok?: boolean;
    itemId?: number | undefined;
    error?: string | undefined;

    constructor(data?: ICreateBudgetRuleItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.itemId = _data["itemId"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateBudgetRuleItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetRuleItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["itemId"] = this.itemId;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateBudgetRuleItemResponse {
    ok?: boolean;
    itemId?: number | undefined;
    error?: string | undefined;
}

export class CreateConstructionItemRequest implements ICreateConstructionItemRequest {
    constructionPartId?: number;
    sign?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: ICreateConstructionItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constructionPartId = _data["constructionPartId"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.specification = _data["specification"];
            this.billOfQuantities = _data["billOfQuantities"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CreateConstructionItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constructionPartId"] = this.constructionPartId;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["description"] = this.description;
        data["specification"] = this.specification;
        data["billOfQuantities"] = this.billOfQuantities;
        data["measuringUnitId"] = this.measuringUnitId;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ICreateConstructionItemRequest {
    constructionPartId?: number;
    sign?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    quantity?: number | undefined;
}

export class CreateConstructionItemResponse implements ICreateConstructionItemResponse {
    id?: number;

    constructor(data?: ICreateConstructionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateConstructionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateConstructionItemResponse {
    id?: number;
}

export class CreateConstructionItemsFromBudgetRequest implements ICreateConstructionItemsFromBudgetRequest {
    removePreviousObjects?: boolean;
    budgetingSessionId?: number;
    objectSign?: string | undefined;
    objectName?: string | undefined;
    modelData?: string | undefined;

    constructor(data?: ICreateConstructionItemsFromBudgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.removePreviousObjects = _data["removePreviousObjects"];
            this.budgetingSessionId = _data["budgetingSessionId"];
            this.objectSign = _data["objectSign"];
            this.objectName = _data["objectName"];
            this.modelData = _data["modelData"];
        }
    }

    static fromJS(data: any): CreateConstructionItemsFromBudgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionItemsFromBudgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["removePreviousObjects"] = this.removePreviousObjects;
        data["budgetingSessionId"] = this.budgetingSessionId;
        data["objectSign"] = this.objectSign;
        data["objectName"] = this.objectName;
        data["modelData"] = this.modelData;
        return data;
    }
}

export interface ICreateConstructionItemsFromBudgetRequest {
    removePreviousObjects?: boolean;
    budgetingSessionId?: number;
    objectSign?: string | undefined;
    objectName?: string | undefined;
    modelData?: string | undefined;
}

export class CreateConstructionItemsFromBudgetResponse implements ICreateConstructionItemsFromBudgetResponse {
    createdItemIds?: number[] | undefined;

    constructor(data?: ICreateConstructionItemsFromBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["createdItemIds"])) {
                this.createdItemIds = [] as any;
                for (let item of _data["createdItemIds"])
                    this.createdItemIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateConstructionItemsFromBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionItemsFromBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.createdItemIds)) {
            data["createdItemIds"] = [];
            for (let item of this.createdItemIds)
                data["createdItemIds"].push(item);
        }
        return data;
    }
}

export interface ICreateConstructionItemsFromBudgetResponse {
    createdItemIds?: number[] | undefined;
}

export class CreateConstructionObjectRequest implements ICreateConstructionObjectRequest {
    budgetingSessionId?: number;
    sign?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICreateConstructionObjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetingSessionId = _data["budgetingSessionId"];
            this.sign = _data["sign"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateConstructionObjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionObjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetingSessionId"] = this.budgetingSessionId;
        data["sign"] = this.sign;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateConstructionObjectRequest {
    budgetingSessionId?: number;
    sign?: string | undefined;
    name?: string | undefined;
}

export class CreateConstructionObjectResponse implements ICreateConstructionObjectResponse {
    id?: number;

    constructor(data?: ICreateConstructionObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateConstructionObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateConstructionObjectResponse {
    id?: number;
}

export class CreateConstructionPartRequest implements ICreateConstructionPartRequest {
    constructionObjectId?: number;
    sign?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICreateConstructionPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constructionObjectId = _data["constructionObjectId"];
            this.sign = _data["sign"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateConstructionPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constructionObjectId"] = this.constructionObjectId;
        data["sign"] = this.sign;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateConstructionPartRequest {
    constructionObjectId?: number;
    sign?: string | undefined;
    name?: string | undefined;
}

export class CreateConstructionPartResponse implements ICreateConstructionPartResponse {
    id?: number;

    constructor(data?: ICreateConstructionPartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateConstructionPartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConstructionPartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateConstructionPartResponse {
    id?: number;
}

export class CreateDataStandardRequest implements ICreateDataStandardRequest {
    name?: string | undefined;
    classifierName?: string | undefined;
    stage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    isDefaultStandard?: boolean;

    constructor(data?: ICreateDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.stage = _data["stage"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.ds_ds = _data["ds_ds"];
            this.isDefaultStandard = _data["isDefaultStandard"];
        }
    }

    static fromJS(data: any): CreateDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["stage"] = this.stage;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["ds_ds"] = this.ds_ds;
        data["isDefaultStandard"] = this.isDefaultStandard;
        return data;
    }
}

export interface ICreateDataStandardRequest {
    name?: string | undefined;
    classifierName?: string | undefined;
    stage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    isDefaultStandard?: boolean;
}

export class CreateDataStandardResponse implements ICreateDataStandardResponse {
    id?: number;
    ok?: boolean;
    timestamp?: Date;

    constructor(data?: ICreateDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ok = _data["ok"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ok"] = this.ok;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateDataStandardResponse {
    id?: number;
    ok?: boolean;
    timestamp?: Date;
}

export class CreateEntityResponse implements ICreateEntityResponse {
    id?: number;
    rowVersion?: string | undefined;

    constructor(data?: ICreateEntityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): CreateEntityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface ICreateEntityResponse {
    id?: number;
    rowVersion?: string | undefined;
}

export class CreateGroupForStandardRequest implements ICreateGroupForStandardRequest {
    standardId?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    color?: string | undefined;
    updateColorAll?: boolean;

    constructor(data?: ICreateGroupForStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            this.color = _data["color"];
            this.updateColorAll = _data["updateColorAll"];
        }
    }

    static fromJS(data: any): CreateGroupForStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupForStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        data["color"] = this.color;
        data["updateColorAll"] = this.updateColorAll;
        return data;
    }
}

export interface ICreateGroupForStandardRequest {
    standardId?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    color?: string | undefined;
    updateColorAll?: boolean;
}

export class CreateImportDSSettingRequest implements ICreateImportDSSettingRequest {
    importDSSetting?: ImportDSSettingDTO;

    constructor(data?: ICreateImportDSSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importDSSetting = _data["importDSSetting"] ? ImportDSSettingDTO.fromJS(_data["importDSSetting"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateImportDSSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImportDSSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importDSSetting"] = this.importDSSetting ? this.importDSSetting.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateImportDSSettingRequest {
    importDSSetting?: ImportDSSettingDTO;
}

export class CreateImportDSSettingResponse implements ICreateImportDSSettingResponse {
    ok?: boolean;
    id?: number | undefined;

    constructor(data?: ICreateImportDSSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateImportDSSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImportDSSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateImportDSSettingResponse {
    ok?: boolean;
    id?: number | undefined;
}

export class CreateLeadRequest implements ICreateLeadRequest {
    email?: string | undefined;
    company?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICreateLeadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.company = _data["company"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CreateLeadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["company"] = this.company;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICreateLeadRequest {
    email?: string | undefined;
    company?: string | undefined;
    phoneNumber?: string | undefined;
}

export class CreateLeadResponse implements ICreateLeadResponse {
    ok?: boolean;

    constructor(data?: ICreateLeadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateLeadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLeadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateLeadResponse {
    ok?: boolean;
}

export class CreateMicrostationPairingRequest implements ICreateMicrostationPairingRequest {
    dataStandardId?: number;
    projectId?: number;
    name?: string | undefined;

    constructor(data?: ICreateMicrostationPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMicrostationPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMicrostationPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMicrostationPairingRequest {
    dataStandardId?: number;
    projectId?: number;
    name?: string | undefined;
}

export class CreateMicrostationPairingResponse implements ICreateMicrostationPairingResponse {
    id?: number;
    rowVersion?: Date;

    constructor(data?: ICreateMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateMicrostationPairingResponse {
    id?: number;
    rowVersion?: Date;
}

export class CreateNewUpdateRequest implements ICreateNewUpdateRequest {
    version?: string | undefined;
    minimumUpdateVersion?: string | undefined;
    product?: SGProductType;
    productPlugin?: BentleyProductType;
    password?: string | undefined;

    constructor(data?: ICreateNewUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.minimumUpdateVersion = _data["minimumUpdateVersion"];
            this.product = _data["product"];
            this.productPlugin = _data["productPlugin"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateNewUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["minimumUpdateVersion"] = this.minimumUpdateVersion;
        data["product"] = this.product;
        data["productPlugin"] = this.productPlugin;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateNewUpdateRequest {
    version?: string | undefined;
    minimumUpdateVersion?: string | undefined;
    product?: SGProductType;
    productPlugin?: BentleyProductType;
    password?: string | undefined;
}

export class CreateOrGroupRequest implements ICreateOrGroupRequest {
    pairerId?: number;
    name?: string | undefined;

    constructor(data?: ICreateOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateOrGroupRequest {
    pairerId?: number;
    name?: string | undefined;
}

export class CreateOrUpdateBudgetingSessionRequest implements ICreateOrUpdateBudgetingSessionRequest {
    name?: string | undefined;
    id?: number | undefined;
    projectId?: number;
    dataStandardId?: number;

    constructor(data?: ICreateOrUpdateBudgetingSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.dataStandardId = _data["dataStandardId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateBudgetingSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBudgetingSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["dataStandardId"] = this.dataStandardId;
        return data;
    }
}

export interface ICreateOrUpdateBudgetingSessionRequest {
    name?: string | undefined;
    id?: number | undefined;
    projectId?: number;
    dataStandardId?: number;
}

export class CreateOrUpdateBudgetingSessionResponse implements ICreateOrUpdateBudgetingSessionResponse {
    sessionId?: number;
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: ICreateOrUpdateBudgetingSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateOrUpdateBudgetingSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBudgetingSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateOrUpdateBudgetingSessionResponse {
    sessionId?: number;
    ok?: boolean;
    error?: string | undefined;
}

export class CreateOrUpdateCurvesRequest implements ICreateOrUpdateCurvesRequest {
    routeId?: number;
    curves?: CurveDTO[] | undefined;
    deleted?: number[] | undefined;
    replace?: boolean | undefined;

    constructor(data?: ICreateOrUpdateCurvesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
            if (Array.isArray(_data["deleted"])) {
                this.deleted = [] as any;
                for (let item of _data["deleted"])
                    this.deleted!.push(item);
            }
            this.replace = _data["replace"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCurvesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCurvesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleted)) {
            data["deleted"] = [];
            for (let item of this.deleted)
                data["deleted"].push(item);
        }
        data["replace"] = this.replace;
        return data;
    }
}

export interface ICreateOrUpdateCurvesRequest {
    routeId?: number;
    curves?: CurveDTO[] | undefined;
    deleted?: number[] | undefined;
    replace?: boolean | undefined;
}

export class CreateOrUpdateCurvesResponse implements ICreateOrUpdateCurvesResponse {
    ok?: boolean;

    constructor(data?: ICreateOrUpdateCurvesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCurvesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCurvesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateOrUpdateCurvesResponse {
    ok?: boolean;
}

export class CreateOrUpdateMeasuringUnitRequest implements ICreateOrUpdateMeasuringUnitRequest {
    id?: number | undefined;
    sign?: string | undefined;
    name?: string | undefined;
    rowVersion?: Date | undefined;

    constructor(data?: ICreateOrUpdateMeasuringUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateOrUpdateMeasuringUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMeasuringUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateOrUpdateMeasuringUnitRequest {
    id?: number | undefined;
    sign?: string | undefined;
    name?: string | undefined;
    rowVersion?: Date | undefined;
}

export class CreateOrUpdateMeasuringUnitResponse implements ICreateOrUpdateMeasuringUnitResponse {
    ok?: boolean;
    id?: number | undefined;
    rowVersion?: Date | undefined;
    error?: string | undefined;

    constructor(data?: ICreateOrUpdateMeasuringUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMeasuringUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMeasuringUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateOrUpdateMeasuringUnitResponse {
    ok?: boolean;
    id?: number | undefined;
    rowVersion?: Date | undefined;
    error?: string | undefined;
}

export class CreateOrUpdateSelectorItemRequest implements ICreateOrUpdateSelectorItemRequest {
    id?: number;
    validationRuleConditionId?: number;
    newValue?: string | undefined;
    note?: string | undefined;
    type?: DataTypeValidation;

    constructor(data?: ICreateOrUpdateSelectorItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationRuleConditionId = _data["validationRuleConditionId"];
            this.newValue = _data["newValue"];
            this.note = _data["note"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationRuleConditionId"] = this.validationRuleConditionId;
        data["newValue"] = this.newValue;
        data["note"] = this.note;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateOrUpdateSelectorItemRequest {
    id?: number;
    validationRuleConditionId?: number;
    newValue?: string | undefined;
    note?: string | undefined;
    type?: DataTypeValidation;
}

export class CreateOrUpdateSelectorItemResponse implements ICreateOrUpdateSelectorItemResponse {
    ok?: boolean;
    id?: number | undefined;

    constructor(data?: ICreateOrUpdateSelectorItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateSelectorItemResponse {
    ok?: boolean;
    id?: number | undefined;
}

export class CreateOrUpdateSelectorRequest implements ICreateOrUpdateSelectorRequest {
    id?: number;
    newValue?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: ICreateOrUpdateSelectorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newValue = _data["newValue"];
            this.category = _data["category"];
            this.projectId = _data["projectId"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newValue"] = this.newValue;
        data["category"] = this.category;
        data["projectId"] = this.projectId;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ICreateOrUpdateSelectorRequest {
    id?: number;
    newValue?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    dataType?: DataTypeValidation;
}

export class CreateOrUpdateSelectorResponse implements ICreateOrUpdateSelectorResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: ICreateOrUpdateSelectorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSelectorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSelectorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateSelectorResponse {
    ok?: boolean;
    id?: number;
}

export class CreatePairerRequest implements ICreatePairerRequest {
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;

    constructor(data?: ICreatePairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CreatePairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ICreatePairerRequest {
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    name?: string | undefined;
    type?: ProjectType;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.showInBimCabinet = _data["showInBimCabinet"];
            this.customImageUri = _data["customImageUri"];
            this.drawer = _data["drawer"];
            this.investor = _data["investor"];
            this.stage = _data["stage"];
            this.drawingSoftware = _data["drawingSoftware"];
            this.cde = _data["cde"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["showInBimCabinet"] = this.showInBimCabinet;
        data["customImageUri"] = this.customImageUri;
        data["drawer"] = this.drawer;
        data["investor"] = this.investor;
        data["stage"] = this.stage;
        data["drawingSoftware"] = this.drawingSoftware;
        data["cde"] = this.cde;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateProjectRequest {
    name?: string | undefined;
    type?: ProjectType;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    description?: string | undefined;
}

export class CreateProjectResponse implements ICreateProjectResponse {
    projectId?: number;

    constructor(data?: ICreateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateProjectResponse {
    projectId?: number;
}

export class CreateRouteRequest implements ICreateRouteRequest {
    projectId?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: ICreateRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): CreateRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface ICreateRouteRequest {
    projectId?: number;
    name?: string | undefined;
    state?: number;
}

export class CreateRouteResponse implements ICreateRouteResponse {
    routeId?: number;

    constructor(data?: ICreateRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
        }
    }

    static fromJS(data: any): CreateRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        return data;
    }
}

export interface ICreateRouteResponse {
    routeId?: number;
}

export enum CreateTenantAndUserErrorType {
    USER_EXISTS = "USER_EXISTS",
    TENANT_EXISTS = "TENANT_EXISTS",
}

export class CreateTenantAndUserRequest implements ICreateTenantAndUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICreateTenantAndUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.company = _data["company"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateTenantAndUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantAndUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["company"] = this.company;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateTenantAndUserRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    company?: string | undefined;
    password?: string | undefined;
}

export class CreateTenantAndUserResponse implements ICreateTenantAndUserResponse {
    ok?: boolean;
    error?: CreateTenantAndUserErrorType;

    constructor(data?: ICreateTenantAndUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateTenantAndUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantAndUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateTenantAndUserResponse {
    ok?: boolean;
    error?: CreateTenantAndUserErrorType;
}

export class CreateTenantRequest implements ICreateTenantRequest {
    name?: string | undefined;
    rsdApiKey?: string | undefined;

    constructor(data?: ICreateTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
        }
    }

    static fromJS(data: any): CreateTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        return data;
    }
}

export interface ICreateTenantRequest {
    name?: string | undefined;
    rsdApiKey?: string | undefined;
}

export class CreateTenantResponse implements ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number | undefined;

    constructor(data?: ICreateTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number | undefined;
}

export class CreateUserRequest implements ICreateUserRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateUserRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    tenantId?: number | undefined;
}

export class CreateUserResponse implements ICreateUserResponse {
    ok?: boolean;
    password?: string | undefined;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateUserResponse {
    ok?: boolean;
    password?: string | undefined;
}

export class CreateUserSendSignupMailRequest implements ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;

    constructor(data?: ICreateUserSendSignupMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;
}

export class CreateUserSendSignupMailResponse implements ICreateUserSendSignupMailResponse {
    ok?: boolean;

    constructor(data?: ICreateUserSendSignupMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ICreateUserSendSignupMailResponse {
    ok?: boolean;
}

export class CreateValidationRuleInOrGroupRequest implements ICreateValidationRuleInOrGroupRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    groupId?: number;
    groupIndex?: number;
    attributeNumber?: number | undefined;
    attributeName?: string | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;

    constructor(data?: ICreateValidationRuleInOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.examplesOfValues = _data["examplesOfValues"];
            this.propertyIFC = _data["propertyIFC"];
            this.definedTypeIFC = _data["definedTypeIFC"];
            this.classIFC = _data["classIFC"];
            this.predefinedTypeIFC = _data["predefinedTypeIFC"];
            this.attributeIFC = _data["attributeIFC"];
            this.nullable = _data["nullable"];
            this.isCCI = _data["isCCI"];
            this.isDsStandard = _data["isDsStandard"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.dataType = _data["dataType"];
            this.condition = _data["condition"];
            this.groupId = _data["groupId"];
            this.groupIndex = _data["groupIndex"];
            this.attributeNumber = _data["attributeNumber"];
            this.attributeName = _data["attributeName"];
            this.validateDecimalPlaces = _data["validateDecimalPlaces"];
            this.description = _data["description"];
            this.dur = _data["dur"];
            this.dsp = _data["dsp"];
            this.pdps = _data["pdps"];
            this.rds = _data["rds"];
            this.dsps = _data["dsps"];
            this.dusp = _data["dusp"];
            this.drs = _data["drs"];
            this.dps = _data["dps"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : undefined as any;
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateValidationRuleInOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateValidationRuleInOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["examplesOfValues"] = this.examplesOfValues;
        data["propertyIFC"] = this.propertyIFC;
        data["definedTypeIFC"] = this.definedTypeIFC;
        data["classIFC"] = this.classIFC;
        data["predefinedTypeIFC"] = this.predefinedTypeIFC;
        data["attributeIFC"] = this.attributeIFC;
        data["nullable"] = this.nullable;
        data["isCCI"] = this.isCCI;
        data["isDsStandard"] = this.isDsStandard;
        data["decimalPlaces"] = this.decimalPlaces;
        data["dataType"] = this.dataType;
        data["condition"] = this.condition;
        data["groupId"] = this.groupId;
        data["groupIndex"] = this.groupIndex;
        data["attributeNumber"] = this.attributeNumber;
        data["attributeName"] = this.attributeName;
        data["validateDecimalPlaces"] = this.validateDecimalPlaces;
        data["description"] = this.description;
        data["dur"] = this.dur;
        data["dsp"] = this.dsp;
        data["pdps"] = this.pdps;
        data["rds"] = this.rds;
        data["dsps"] = this.dsps;
        data["dusp"] = this.dusp;
        data["drs"] = this.drs;
        data["dps"] = this.dps;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : undefined as any;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateValidationRuleInOrGroupRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    groupId?: number;
    groupIndex?: number;
    attributeNumber?: number | undefined;
    attributeName?: string | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
}

export class CreateValidationsRuleRequest implements ICreateValidationsRuleRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    pairerIds?: number[] | undefined;

    constructor(data?: ICreateValidationsRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.examplesOfValues = _data["examplesOfValues"];
            this.propertyIFC = _data["propertyIFC"];
            this.definedTypeIFC = _data["definedTypeIFC"];
            this.classIFC = _data["classIFC"];
            this.predefinedTypeIFC = _data["predefinedTypeIFC"];
            this.attributeIFC = _data["attributeIFC"];
            this.nullable = _data["nullable"];
            this.isCCI = _data["isCCI"];
            this.isDsStandard = _data["isDsStandard"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.dataType = _data["dataType"];
            this.condition = _data["condition"];
            this.attributeName = _data["attributeName"];
            this.attributeNumber = _data["attributeNumber"];
            this.validateDecimalPlaces = _data["validateDecimalPlaces"];
            this.description = _data["description"];
            this.dur = _data["dur"];
            this.dsp = _data["dsp"];
            this.pdps = _data["pdps"];
            this.rds = _data["rds"];
            this.dsps = _data["dsps"];
            this.dusp = _data["dusp"];
            this.drs = _data["drs"];
            this.dps = _data["dps"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : undefined as any;
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
            if (Array.isArray(_data["pairerIds"])) {
                this.pairerIds = [] as any;
                for (let item of _data["pairerIds"])
                    this.pairerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateValidationsRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateValidationsRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["examplesOfValues"] = this.examplesOfValues;
        data["propertyIFC"] = this.propertyIFC;
        data["definedTypeIFC"] = this.definedTypeIFC;
        data["classIFC"] = this.classIFC;
        data["predefinedTypeIFC"] = this.predefinedTypeIFC;
        data["attributeIFC"] = this.attributeIFC;
        data["nullable"] = this.nullable;
        data["isCCI"] = this.isCCI;
        data["isDsStandard"] = this.isDsStandard;
        data["decimalPlaces"] = this.decimalPlaces;
        data["dataType"] = this.dataType;
        data["condition"] = this.condition;
        data["attributeName"] = this.attributeName;
        data["attributeNumber"] = this.attributeNumber;
        data["validateDecimalPlaces"] = this.validateDecimalPlaces;
        data["description"] = this.description;
        data["dur"] = this.dur;
        data["dsp"] = this.dsp;
        data["pdps"] = this.pdps;
        data["rds"] = this.rds;
        data["dsps"] = this.dsps;
        data["dusp"] = this.dusp;
        data["drs"] = this.drs;
        data["dps"] = this.dps;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : undefined as any;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pairerIds)) {
            data["pairerIds"] = [];
            for (let item of this.pairerIds)
                data["pairerIds"].push(item);
        }
        return data;
    }
}

export interface ICreateValidationsRuleRequest {
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    dataType?: DataTypeValidation;
    condition?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    pairerIds?: number[] | undefined;
}

export class CurveDTO implements ICurveDTO {
    id?: number;
    r?: number | undefined;
    dstav?: number | undefined;
    d?: number | undefined;
    v?: number | undefined;
    v130?: number | undefined;
    v150?: number | undefined;
    vk?: number | undefined;
    vnakl?: number | undefined;
    lk1?: number | undefined;
    lk2?: number | undefined;
    inflexWithPrevious?: boolean;
    inflexWithNext?: boolean;
    hasMezilehla?: boolean;
    lkm?: number | undefined;

    constructor(data?: ICurveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.r = _data["r"];
            this.dstav = _data["dstav"];
            this.d = _data["d"];
            this.v = _data["v"];
            this.v130 = _data["v130"];
            this.v150 = _data["v150"];
            this.vk = _data["vk"];
            this.vnakl = _data["vnakl"];
            this.lk1 = _data["lk1"];
            this.lk2 = _data["lk2"];
            this.inflexWithPrevious = _data["inflexWithPrevious"];
            this.inflexWithNext = _data["inflexWithNext"];
            this.hasMezilehla = _data["hasMezilehla"];
            this.lkm = _data["lkm"];
        }
    }

    static fromJS(data: any): CurveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CurveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["r"] = this.r;
        data["dstav"] = this.dstav;
        data["d"] = this.d;
        data["v"] = this.v;
        data["v130"] = this.v130;
        data["v150"] = this.v150;
        data["vk"] = this.vk;
        data["vnakl"] = this.vnakl;
        data["lk1"] = this.lk1;
        data["lk2"] = this.lk2;
        data["inflexWithPrevious"] = this.inflexWithPrevious;
        data["inflexWithNext"] = this.inflexWithNext;
        data["hasMezilehla"] = this.hasMezilehla;
        data["lkm"] = this.lkm;
        return data;
    }
}

export interface ICurveDTO {
    id?: number;
    r?: number | undefined;
    dstav?: number | undefined;
    d?: number | undefined;
    v?: number | undefined;
    v130?: number | undefined;
    v150?: number | undefined;
    vk?: number | undefined;
    vnakl?: number | undefined;
    lk1?: number | undefined;
    lk2?: number | undefined;
    inflexWithPrevious?: boolean;
    inflexWithNext?: boolean;
    hasMezilehla?: boolean;
    lkm?: number | undefined;
}

export class CustomBudgetFieldDto implements ICustomBudgetFieldDto {
    name?: string | undefined;
    value?: string | undefined;
    isFilled?: boolean;

    constructor(data?: ICustomBudgetFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.isFilled = _data["isFilled"];
        }
    }

    static fromJS(data: any): CustomBudgetFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomBudgetFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["isFilled"] = this.isFilled;
        return data;
    }
}

export interface ICustomBudgetFieldDto {
    name?: string | undefined;
    value?: string | undefined;
    isFilled?: boolean;
}

export class DataInsightResponse implements IDataInsightResponse {
    findings?: string[] | undefined;
    statistics?: InsightStatistics;
    distribution?: { [key: string]: number; } | undefined;
    anomalies?: string[] | undefined;

    constructor(data?: IDataInsightResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["findings"])) {
                this.findings = [] as any;
                for (let item of _data["findings"])
                    this.findings!.push(item);
            }
            this.statistics = _data["statistics"] ? InsightStatistics.fromJS(_data["statistics"]) : undefined as any;
            if (_data["distribution"]) {
                this.distribution = {} as any;
                for (let key in _data["distribution"]) {
                    if (_data["distribution"].hasOwnProperty(key))
                        (this.distribution as any)![key] = _data["distribution"][key];
                }
            }
            if (Array.isArray(_data["anomalies"])) {
                this.anomalies = [] as any;
                for (let item of _data["anomalies"])
                    this.anomalies!.push(item);
            }
        }
    }

    static fromJS(data: any): DataInsightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataInsightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.findings)) {
            data["findings"] = [];
            for (let item of this.findings)
                data["findings"].push(item);
        }
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        if (this.distribution) {
            data["distribution"] = {};
            for (let key in this.distribution) {
                if (this.distribution.hasOwnProperty(key))
                    (data["distribution"] as any)[key] = (this.distribution as any)[key];
            }
        }
        if (Array.isArray(this.anomalies)) {
            data["anomalies"] = [];
            for (let item of this.anomalies)
                data["anomalies"].push(item);
        }
        return data;
    }
}

export interface IDataInsightResponse {
    findings?: string[] | undefined;
    statistics?: InsightStatistics;
    distribution?: { [key: string]: number; } | undefined;
    anomalies?: string[] | undefined;
}

export class DataPropertyDto implements IDataPropertyDto {
    propSetName?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numberOfDigits?: number | undefined;
    unit?: string | undefined;

    constructor(data?: IDataPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propSetName = _data["propSetName"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.numberOfDigits = _data["numberOfDigits"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): DataPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propSetName"] = this.propSetName;
        data["name"] = this.name;
        data["value"] = this.value;
        data["numberOfDigits"] = this.numberOfDigits;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IDataPropertyDto {
    propSetName?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numberOfDigits?: number | undefined;
    unit?: string | undefined;
}

export class DataStandardDTO implements IDataStandardDTO {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    rowVersion?: string | undefined;
    documentationStage?: DocumentationStage;
    isDefaultStandard?: boolean;
    isShared?: boolean;
    sharedWithTenants?: string[] | undefined;
    sharingTenant?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt?: Date | undefined;
    isMine?: boolean;

    constructor(data?: IDataStandardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.ds_ds = _data["ds_ds"];
            this.rowVersion = _data["rowVersion"];
            this.documentationStage = _data["documentationStage"];
            this.isDefaultStandard = _data["isDefaultStandard"];
            this.isShared = _data["isShared"];
            if (Array.isArray(_data["sharedWithTenants"])) {
                this.sharedWithTenants = [] as any;
                for (let item of _data["sharedWithTenants"])
                    this.sharedWithTenants!.push(item);
            }
            this.sharingTenant = _data["sharingTenant"];
            this.creatorId = _data["creatorId"];
            this.creatorName = _data["creatorName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isMine = _data["isMine"];
        }
    }

    static fromJS(data: any): DataStandardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataStandardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["ds_ds"] = this.ds_ds;
        data["rowVersion"] = this.rowVersion;
        data["documentationStage"] = this.documentationStage;
        data["isDefaultStandard"] = this.isDefaultStandard;
        data["isShared"] = this.isShared;
        if (Array.isArray(this.sharedWithTenants)) {
            data["sharedWithTenants"] = [];
            for (let item of this.sharedWithTenants)
                data["sharedWithTenants"].push(item);
        }
        data["sharingTenant"] = this.sharingTenant;
        data["creatorId"] = this.creatorId;
        data["creatorName"] = this.creatorName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isMine"] = this.isMine;
        return data;
    }
}

export interface IDataStandardDTO {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    rowVersion?: string | undefined;
    documentationStage?: DocumentationStage;
    isDefaultStandard?: boolean;
    isShared?: boolean;
    sharedWithTenants?: string[] | undefined;
    sharingTenant?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt?: Date | undefined;
    isMine?: boolean;
}

export class DataStandardsFullTreeDTO implements IDataStandardsFullTreeDTO {
    id?: number;
    name?: string | undefined;
    isDataStandardSZ?: boolean;
    pairersGroup?: PairerGroupFullTreeDTO[] | undefined;

    constructor(data?: IDataStandardsFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            if (Array.isArray(_data["pairersGroup"])) {
                this.pairersGroup = [] as any;
                for (let item of _data["pairersGroup"])
                    this.pairersGroup!.push(PairerGroupFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataStandardsFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataStandardsFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        if (Array.isArray(this.pairersGroup)) {
            data["pairersGroup"] = [];
            for (let item of this.pairersGroup)
                data["pairersGroup"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataStandardsFullTreeDTO {
    id?: number;
    name?: string | undefined;
    isDataStandardSZ?: boolean;
    pairersGroup?: PairerGroupFullTreeDTO[] | undefined;
}

export enum DataTypeValidation {
    None = "None",
    String = "String",
    Integer = "Integer",
    Decimal = "Decimal",
    Date = "Date",
    DateTime = "DateTime",
    Boolean = "Boolean",
    Guid = "Guid",
}

export class DeleteBudgetingSessionResponse implements IDeleteBudgetingSessionResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IDeleteBudgetingSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteBudgetingSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBudgetingSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteBudgetingSessionResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class DeleteBudgetRuleItemResponse implements IDeleteBudgetRuleItemResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IDeleteBudgetRuleItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteBudgetRuleItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBudgetRuleItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteBudgetRuleItemResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class DeleteBudgetRuleResponse implements IDeleteBudgetRuleResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IDeleteBudgetRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteBudgetRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBudgetRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteBudgetRuleResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class DeleteConstructionItemResponse implements IDeleteConstructionItemResponse {
    ok?: boolean;

    constructor(data?: IDeleteConstructionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteConstructionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteConstructionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteConstructionItemResponse {
    ok?: boolean;
}

export class DeleteConstructionObjectResponse implements IDeleteConstructionObjectResponse {
    ok?: boolean;

    constructor(data?: IDeleteConstructionObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteConstructionObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteConstructionObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteConstructionObjectResponse {
    ok?: boolean;
}

export class DeleteConstructionPartResponse implements IDeleteConstructionPartResponse {
    ok?: boolean;

    constructor(data?: IDeleteConstructionPartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteConstructionPartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteConstructionPartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteConstructionPartResponse {
    ok?: boolean;
}

export class DeleteCurveRequest implements IDeleteCurveRequest {
    id?: number;

    constructor(data?: IDeleteCurveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCurveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCurveRequest {
    id?: number;
}

export class DeleteCurveResponse implements IDeleteCurveResponse {
    ok?: boolean;

    constructor(data?: IDeleteCurveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteCurveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCurveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteCurveResponse {
    ok?: boolean;
}

export class DeleteCustomImageForProjectResponse implements IDeleteCustomImageForProjectResponse {
    success?: boolean;

    constructor(data?: IDeleteCustomImageForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteCustomImageForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomImageForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteCustomImageForProjectResponse {
    success?: boolean;
}

export class DeleteDataStandardElementFiltersRequest implements IDeleteDataStandardElementFiltersRequest {
    pairerIds?: number[] | undefined;
    fields?: string[] | undefined;

    constructor(data?: IDeleteDataStandardElementFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairerIds"])) {
                this.pairerIds = [] as any;
                for (let item of _data["pairerIds"])
                    this.pairerIds!.push(item);
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteDataStandardElementFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDataStandardElementFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairerIds)) {
            data["pairerIds"] = [];
            for (let item of this.pairerIds)
                data["pairerIds"].push(item);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        return data;
    }
}

export interface IDeleteDataStandardElementFiltersRequest {
    pairerIds?: number[] | undefined;
    fields?: string[] | undefined;
}

export class DeleteDataStandardElementFiltersResponse implements IDeleteDataStandardElementFiltersResponse {
    ok?: boolean;

    constructor(data?: IDeleteDataStandardElementFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteDataStandardElementFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDataStandardElementFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteDataStandardElementFiltersResponse {
    ok?: boolean;
}

export class DeleteDocumentationForProjectResponse implements IDeleteDocumentationForProjectResponse {
    success?: boolean;

    constructor(data?: IDeleteDocumentationForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteDocumentationForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteDocumentationForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteDocumentationForProjectResponse {
    success?: boolean;
}

export class DeleteEnumCategoryRequest implements IDeleteEnumCategoryRequest {
    categoryName?: string | undefined;

    constructor(data?: IDeleteEnumCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): DeleteEnumCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEnumCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IDeleteEnumCategoryRequest {
    categoryName?: string | undefined;
}

export class DeleteEnumCategoryResponse implements IDeleteEnumCategoryResponse {
    ok?: boolean;

    constructor(data?: IDeleteEnumCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteEnumCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEnumCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteEnumCategoryResponse {
    ok?: boolean;
}

export class DeleteFormulaItemResponse implements IDeleteFormulaItemResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IDeleteFormulaItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteFormulaItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormulaItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteFormulaItemResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class DeleteFormulaResponse implements IDeleteFormulaResponse {
    ok?: boolean;

    constructor(data?: IDeleteFormulaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteFormulaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFormulaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteFormulaResponse {
    ok?: boolean;
}

export class DeleteImportDSSettingResponse implements IDeleteImportDSSettingResponse {
    ok?: boolean;

    constructor(data?: IDeleteImportDSSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteImportDSSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteImportDSSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteImportDSSettingResponse {
    ok?: boolean;
}

export class DeleteMeasuringUnitResponse implements IDeleteMeasuringUnitResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IDeleteMeasuringUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteMeasuringUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMeasuringUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteMeasuringUnitResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class DeleteMicrostationPairingResponse implements IDeleteMicrostationPairingResponse {
    ok?: boolean;

    constructor(data?: IDeleteMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMicrostationPairingResponse {
    ok?: boolean;
}

export class DeleteMicrostationPairingsRequest implements IDeleteMicrostationPairingsRequest {
    pairingIds?: number[] | undefined;

    constructor(data?: IDeleteMicrostationPairingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairingIds"])) {
                this.pairingIds = [] as any;
                for (let item of _data["pairingIds"])
                    this.pairingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMicrostationPairingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMicrostationPairingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairingIds)) {
            data["pairingIds"] = [];
            for (let item of this.pairingIds)
                data["pairingIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteMicrostationPairingsRequest {
    pairingIds?: number[] | undefined;
}

export class DeleteMicrostationPairingsResponse implements IDeleteMicrostationPairingsResponse {
    ok?: boolean;

    constructor(data?: IDeleteMicrostationPairingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMicrostationPairingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMicrostationPairingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMicrostationPairingsResponse {
    ok?: boolean;
}

export class DeleteModelFromTreeResponse implements IDeleteModelFromTreeResponse {
    success?: boolean;

    constructor(data?: IDeleteModelFromTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteModelFromTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModelFromTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteModelFromTreeResponse {
    success?: boolean;
}

export class DeleteMStnFeederCurveRequest implements IDeleteMStnFeederCurveRequest {
    id?: number;

    constructor(data?: IDeleteMStnFeederCurveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteMStnFeederCurveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederCurveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteMStnFeederCurveRequest {
    id?: number;
}

export class DeleteMStnFeederCurveResponse implements IDeleteMStnFeederCurveResponse {
    ok?: boolean;

    constructor(data?: IDeleteMStnFeederCurveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMStnFeederCurveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederCurveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMStnFeederCurveResponse {
    ok?: boolean;
}

export class DeleteMStnFeederElementStationingRequest implements IDeleteMStnFeederElementStationingRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeleteMStnFeederElementStationingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMStnFeederElementStationingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederElementStationingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteMStnFeederElementStationingRequest {
    ids?: number[] | undefined;
}

export class DeleteMStnFeederElementStationingResponse implements IDeleteMStnFeederElementStationingResponse {
    ok?: boolean;

    constructor(data?: IDeleteMStnFeederElementStationingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMStnFeederElementStationingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederElementStationingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMStnFeederElementStationingResponse {
    ok?: boolean;
}

export class DeleteMStnFeederItemsRequest implements IDeleteMStnFeederItemsRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeleteMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteMStnFeederItemsRequest {
    ids?: number[] | undefined;
}

export class DeleteMStnFeederItemsResponse implements IDeleteMStnFeederItemsResponse {
    ok?: boolean;

    constructor(data?: IDeleteMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteMStnFeederItemsResponse {
    ok?: boolean;
}

export class DeleteOrGroupRuleSetRequest implements IDeleteOrGroupRuleSetRequest {
    groupId?: number;
    groupIndex?: number;

    constructor(data?: IDeleteOrGroupRuleSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupIndex = _data["groupIndex"];
        }
    }

    static fromJS(data: any): DeleteOrGroupRuleSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrGroupRuleSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupIndex"] = this.groupIndex;
        return data;
    }
}

export interface IDeleteOrGroupRuleSetRequest {
    groupId?: number;
    groupIndex?: number;
}

export class DeleteOrGroupRuleSetResponse implements IDeleteOrGroupRuleSetResponse {
    deleted?: boolean;

    constructor(data?: IDeleteOrGroupRuleSetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): DeleteOrGroupRuleSetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrGroupRuleSetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IDeleteOrGroupRuleSetResponse {
    deleted?: boolean;
}

export class DeletePairersRequest implements IDeletePairersRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeletePairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeletePairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeletePairersRequest {
    ids?: number[] | undefined;
}

export class DeleteProjectRequest implements IDeleteProjectRequest {
    id?: number;

    constructor(data?: IDeleteProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteProjectRequest {
    id?: number;
}

export class DeleteProjectResponse implements IDeleteProjectResponse {
    ok?: boolean;

    constructor(data?: IDeleteProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProjectResponse {
    ok?: boolean;
}

export class DeleteRouteRequest implements IDeleteRouteRequest {
    id?: number;

    constructor(data?: IDeleteRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteRouteRequest {
    id?: number;
}

export class DeleteRouteResponse implements IDeleteRouteResponse {
    ok?: boolean;

    constructor(data?: IDeleteRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteRouteResponse {
    ok?: boolean;
}

export class DeleteSelectorItemRequest implements IDeleteSelectorItemRequest {
    id?: number;

    constructor(data?: IDeleteSelectorItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSelectorItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSelectorItemRequest {
    id?: number;
}

export class DeleteSelectorItemResponse implements IDeleteSelectorItemResponse {
    ok?: boolean;

    constructor(data?: IDeleteSelectorItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSelectorItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSelectorItemResponse {
    ok?: boolean;
}

export class DeleteSelectorRequest implements IDeleteSelectorRequest {
    id?: number;

    constructor(data?: IDeleteSelectorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSelectorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSelectorRequest {
    id?: number;
}

export class DeleteSelectorResponse implements IDeleteSelectorResponse {
    ok?: boolean;

    constructor(data?: IDeleteSelectorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteSelectorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSelectorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteSelectorResponse {
    ok?: boolean;
}

export class DeleteTenantResponse implements IDeleteTenantResponse {
    ok?: boolean;

    constructor(data?: IDeleteTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteTenantResponse {
    ok?: boolean;
}

export class DeleteValidationsRuleRequest implements IDeleteValidationsRuleRequest {
    ids?: number[] | undefined;

    constructor(data?: IDeleteValidationsRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteValidationsRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteValidationsRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteValidationsRuleRequest {
    ids?: number[] | undefined;
}

export class DetectedIntentResponse implements IDetectedIntentResponse {
    intent?: string | undefined;
    keywords?: string[] | undefined;
    aggregateProperty?: string | undefined;
    groupByProperty?: string | undefined;
    distinctProperty?: string | undefined;
    confidence?: number;
    explanation?: string | undefined;
    useExistingContext?: boolean;

    constructor(data?: IDetectedIntentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intent = _data["intent"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            this.aggregateProperty = _data["aggregateProperty"];
            this.groupByProperty = _data["groupByProperty"];
            this.distinctProperty = _data["distinctProperty"];
            this.confidence = _data["confidence"];
            this.explanation = _data["explanation"];
            this.useExistingContext = _data["useExistingContext"];
        }
    }

    static fromJS(data: any): DetectedIntentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DetectedIntentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intent"] = this.intent;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["aggregateProperty"] = this.aggregateProperty;
        data["groupByProperty"] = this.groupByProperty;
        data["distinctProperty"] = this.distinctProperty;
        data["confidence"] = this.confidence;
        data["explanation"] = this.explanation;
        data["useExistingContext"] = this.useExistingContext;
        return data;
    }
}

export interface IDetectedIntentResponse {
    intent?: string | undefined;
    keywords?: string[] | undefined;
    aggregateProperty?: string | undefined;
    groupByProperty?: string | undefined;
    distinctProperty?: string | undefined;
    confidence?: number;
    explanation?: string | undefined;
    useExistingContext?: boolean;
}

export enum DocumentationStage {
    DUR = "DUR",
    DSP = "DSP",
    PDPS = "PDPS",
    RDS = "RDS",
    DSPS = "DSPS",
    DUSP = "DUSP",
    DRS = "DRS",
    DPS = "DPS",
}

export class ElementBudgetMatch implements IElementBudgetMatch {
    elementId?: string | undefined;
    levelName?: string | undefined;
    modelId?: string | undefined;
    hasMultipleMatches?: boolean;
    isUnmatched?: boolean;
    properties?: ItemModelPropertiesData[] | undefined;
    pairerMatches?: PairerBudgetMatch[] | undefined;

    constructor(data?: IElementBudgetMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.levelName = _data["levelName"];
            this.modelId = _data["modelId"];
            this.hasMultipleMatches = _data["hasMultipleMatches"];
            this.isUnmatched = _data["isUnmatched"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(ItemModelPropertiesData.fromJS(item));
            }
            if (Array.isArray(_data["pairerMatches"])) {
                this.pairerMatches = [] as any;
                for (let item of _data["pairerMatches"])
                    this.pairerMatches!.push(PairerBudgetMatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementBudgetMatch {
        data = typeof data === 'object' ? data : {};
        let result = new ElementBudgetMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["levelName"] = this.levelName;
        data["modelId"] = this.modelId;
        data["hasMultipleMatches"] = this.hasMultipleMatches;
        data["isUnmatched"] = this.isUnmatched;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pairerMatches)) {
            data["pairerMatches"] = [];
            for (let item of this.pairerMatches)
                data["pairerMatches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementBudgetMatch {
    elementId?: string | undefined;
    levelName?: string | undefined;
    modelId?: string | undefined;
    hasMultipleMatches?: boolean;
    isUnmatched?: boolean;
    properties?: ItemModelPropertiesData[] | undefined;
    pairerMatches?: PairerBudgetMatch[] | undefined;
}

export class ElementListResult implements IElementListResult {
    elements?: BimElementSummary[] | undefined;
    totalCount?: number;
    pageSize?: number;
    page?: number;
    filterApplied?: string | undefined;

    constructor(data?: IElementListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(BimElementSummary.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.page = _data["page"];
            this.filterApplied = _data["filterApplied"];
        }
    }

    static fromJS(data: any): ElementListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ElementListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["page"] = this.page;
        data["filterApplied"] = this.filterApplied;
        return data;
    }
}

export interface IElementListResult {
    elements?: BimElementSummary[] | undefined;
    totalCount?: number;
    pageSize?: number;
    page?: number;
    filterApplied?: string | undefined;
}

export class ElementPropertyRow implements IElementPropertyRow {
    expressId?: number;
    name?: string | undefined;
    propertiesBySet?: { [key: string]: { [key: string]: string; }; } | undefined;

    constructor(data?: IElementPropertyRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.name = _data["name"];
            if (_data["propertiesBySet"]) {
                this.propertiesBySet = {} as any;
                for (let key in _data["propertiesBySet"]) {
                    if (_data["propertiesBySet"].hasOwnProperty(key))
                        (this.propertiesBySet as any)![key] = _data["propertiesBySet"][key] !== undefined ? _data["propertiesBySet"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ElementPropertyRow {
        data = typeof data === 'object' ? data : {};
        let result = new ElementPropertyRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["name"] = this.name;
        if (this.propertiesBySet) {
            data["propertiesBySet"] = {};
            for (let key in this.propertiesBySet) {
                if (this.propertiesBySet.hasOwnProperty(key))
                    (data["propertiesBySet"] as any)[key] = (this.propertiesBySet as any)[key];
            }
        }
        return data;
    }
}

export interface IElementPropertyRow {
    expressId?: number;
    name?: string | undefined;
    propertiesBySet?: { [key: string]: { [key: string]: string; }; } | undefined;
}

export class ElementStationingDTO implements IElementStationingDTO {
    id?: number;
    pairerId?: number;
    elementId?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;

    constructor(data?: IElementStationingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pairerId = _data["pairerId"];
            this.elementId = _data["elementId"];
            this.alignmentName2 = _data["alignmentName2"];
            this.alignmentName3 = _data["alignmentName3"];
        }
    }

    static fromJS(data: any): ElementStationingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ElementStationingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pairerId"] = this.pairerId;
        data["elementId"] = this.elementId;
        data["alignmentName2"] = this.alignmentName2;
        data["alignmentName3"] = this.alignmentName3;
        return data;
    }
}

export interface IElementStationingDTO {
    id?: number;
    pairerId?: number;
    elementId?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;
}

export class ElementTypeDTO implements IElementTypeDTO {
    expanded?: boolean;
    name?: string | undefined;
    elements?: MStnElementDTO[] | undefined;

    constructor(data?: IElementTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expanded = _data["expanded"];
            this.name = _data["name"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MStnElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expanded"] = this.expanded;
        data["name"] = this.name;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementTypeDTO {
    expanded?: boolean;
    name?: string | undefined;
    elements?: MStnElementDTO[] | undefined;
}

export class EmptyResponse implements IEmptyResponse {
    unit?: Unit;

    constructor(data?: IEmptyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmptyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmptyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        return data;
    }
}

export interface IEmptyResponse {
    unit?: Unit;
}

export class ExecuteActionRequest implements IExecuteActionRequest {
    insightId?: string | undefined;
    actionId?: string | undefined;
    projectId?: number;
    additionalParams?: { [key: string]: any; } | undefined;

    constructor(data?: IExecuteActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insightId = _data["insightId"];
            this.actionId = _data["actionId"];
            this.projectId = _data["projectId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (this.additionalParams as any)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecuteActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insightId"] = this.insightId;
        data["actionId"] = this.actionId;
        data["projectId"] = this.projectId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (data["additionalParams"] as any)[key] = (this.additionalParams as any)[key];
            }
        }
        return data;
    }
}

export interface IExecuteActionRequest {
    insightId?: string | undefined;
    actionId?: string | undefined;
    projectId?: number;
    additionalParams?: { [key: string]: any; } | undefined;
}

export class ExecuteActionResponse implements IExecuteActionResponse {
    actionType?: InsightActionType;
    elements?: ElementListResult;
    elementIdsToHighlight?: number[] | undefined;
    comparison?: ComparisonResult;
    drillDownInsights?: BimInsight[] | undefined;
    exportUrl?: string | undefined;
    additionalData?: { [key: string]: any; } | undefined;

    constructor(data?: IExecuteActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.elements = _data["elements"] ? ElementListResult.fromJS(_data["elements"]) : undefined as any;
            if (Array.isArray(_data["elementIdsToHighlight"])) {
                this.elementIdsToHighlight = [] as any;
                for (let item of _data["elementIdsToHighlight"])
                    this.elementIdsToHighlight!.push(item);
            }
            this.comparison = _data["comparison"] ? ComparisonResult.fromJS(_data["comparison"]) : undefined as any;
            if (Array.isArray(_data["drillDownInsights"])) {
                this.drillDownInsights = [] as any;
                for (let item of _data["drillDownInsights"])
                    this.drillDownInsights!.push(BimInsight.fromJS(item));
            }
            this.exportUrl = _data["exportUrl"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (this.additionalData as any)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecuteActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["elements"] = this.elements ? this.elements.toJSON() : undefined as any;
        if (Array.isArray(this.elementIdsToHighlight)) {
            data["elementIdsToHighlight"] = [];
            for (let item of this.elementIdsToHighlight)
                data["elementIdsToHighlight"].push(item);
        }
        data["comparison"] = this.comparison ? this.comparison.toJSON() : undefined as any;
        if (Array.isArray(this.drillDownInsights)) {
            data["drillDownInsights"] = [];
            for (let item of this.drillDownInsights)
                data["drillDownInsights"].push(item ? item.toJSON() : undefined as any);
        }
        data["exportUrl"] = this.exportUrl;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (data["additionalData"] as any)[key] = (this.additionalData as any)[key];
            }
        }
        return data;
    }
}

export interface IExecuteActionResponse {
    actionType?: InsightActionType;
    elements?: ElementListResult;
    elementIdsToHighlight?: number[] | undefined;
    comparison?: ComparisonResult;
    drillDownInsights?: BimInsight[] | undefined;
    exportUrl?: string | undefined;
    additionalData?: { [key: string]: any; } | undefined;
}

export class ExecutionStats implements IExecutionStats {
    totalTime?: TimeSpan;
    vectorSearchTime?: TimeSpan;
    sqlQueryTime?: TimeSpan;
    aiProcessingTime?: TimeSpan;
    elementsProcessed?: number;
    documentsSearched?: number;

    constructor(data?: IExecutionStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTime = _data["totalTime"] ? TimeSpan.fromJS(_data["totalTime"]) : undefined as any;
            this.vectorSearchTime = _data["vectorSearchTime"] ? TimeSpan.fromJS(_data["vectorSearchTime"]) : undefined as any;
            this.sqlQueryTime = _data["sqlQueryTime"] ? TimeSpan.fromJS(_data["sqlQueryTime"]) : undefined as any;
            this.aiProcessingTime = _data["aiProcessingTime"] ? TimeSpan.fromJS(_data["aiProcessingTime"]) : undefined as any;
            this.elementsProcessed = _data["elementsProcessed"];
            this.documentsSearched = _data["documentsSearched"];
        }
    }

    static fromJS(data: any): ExecutionStats {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTime"] = this.totalTime ? this.totalTime.toJSON() : undefined as any;
        data["vectorSearchTime"] = this.vectorSearchTime ? this.vectorSearchTime.toJSON() : undefined as any;
        data["sqlQueryTime"] = this.sqlQueryTime ? this.sqlQueryTime.toJSON() : undefined as any;
        data["aiProcessingTime"] = this.aiProcessingTime ? this.aiProcessingTime.toJSON() : undefined as any;
        data["elementsProcessed"] = this.elementsProcessed;
        data["documentsSearched"] = this.documentsSearched;
        return data;
    }
}

export interface IExecutionStats {
    totalTime?: TimeSpan;
    vectorSearchTime?: TimeSpan;
    sqlQueryTime?: TimeSpan;
    aiProcessingTime?: TimeSpan;
    elementsProcessed?: number;
    documentsSearched?: number;
}

export class ExplanationStep implements IExplanationStep {
    order?: number;
    description?: string | undefined;
    details?: string | undefined;
    resultSummary?: string | undefined;

    constructor(data?: IExplanationStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.description = _data["description"];
            this.details = _data["details"];
            this.resultSummary = _data["resultSummary"];
        }
    }

    static fromJS(data: any): ExplanationStep {
        data = typeof data === 'object' ? data : {};
        let result = new ExplanationStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["description"] = this.description;
        data["details"] = this.details;
        data["resultSummary"] = this.resultSummary;
        return data;
    }
}

export interface IExplanationStep {
    order?: number;
    description?: string | undefined;
    details?: string | undefined;
    resultSummary?: string | undefined;
}

export class ExportResult implements IExportResult {
    errors?: string[] | undefined;
    fileResult?: any | undefined;

    constructor(data?: IExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.fileResult = _data["fileResult"];
        }
    }

    static fromJS(data: any): ExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["fileResult"] = this.fileResult;
        return data;
    }
}

export interface IExportResult {
    errors?: string[] | undefined;
    fileResult?: any | undefined;
}

export enum FeederAutoValueState {
    OK = "OK",
    ElementNotFound = "ElementNotFound",
    AttributNotFound = "AttributNotFound",
    UnsupportedElement = "UnsupportedElement",
    StartDateNotFound = "StartDateNotFound",
    EndDateNotFound = "EndDateNotFound",
    StartAndEndDateNotFound = "StartAndEndDateNotFound",
    StartDateGreaterThanEndDate = "StartDateGreaterThanEndDate",
    AlignmentNotFound = "AlignmentNotFound",
}

export enum FeederAutoValueType {
    ManualValue = "ManualValue",
    Volume = "Volume",
    Length = "Length",
    Area2D = "Area2D",
    Area3DUp = "Area3DUp",
    StationingFrom = "StationingFrom",
    StationingTo = "StationingTo",
    Stationing = "Stationing",
    Thickness = "Thickness",
    Formula = "Formula",
    AreaTotal = "AreaTotal",
}

export class FeederCurveDTO implements IFeederCurveDTO {
    id?: number;
    elementId?: string | undefined;
    modelName?: string | undefined;
    modelFile?: string | undefined;
    name?: string | undefined;
    startStationing?: number | undefined;
    startStationingString?: string | undefined;
    isGeneralCurve?: boolean;
    isProjectCurve?: boolean;

    constructor(data?: IFeederCurveDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementId = _data["elementId"];
            this.modelName = _data["modelName"];
            this.modelFile = _data["modelFile"];
            this.name = _data["name"];
            this.startStationing = _data["startStationing"];
            this.startStationingString = _data["startStationingString"];
            this.isGeneralCurve = _data["isGeneralCurve"];
            this.isProjectCurve = _data["isProjectCurve"];
        }
    }

    static fromJS(data: any): FeederCurveDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeederCurveDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementId"] = this.elementId;
        data["modelName"] = this.modelName;
        data["modelFile"] = this.modelFile;
        data["name"] = this.name;
        data["startStationing"] = this.startStationing;
        data["startStationingString"] = this.startStationingString;
        data["isGeneralCurve"] = this.isGeneralCurve;
        data["isProjectCurve"] = this.isProjectCurve;
        return data;
    }
}

export interface IFeederCurveDTO {
    id?: number;
    elementId?: string | undefined;
    modelName?: string | undefined;
    modelFile?: string | undefined;
    name?: string | undefined;
    startStationing?: number | undefined;
    startStationingString?: string | undefined;
    isGeneralCurve?: boolean;
    isProjectCurve?: boolean;
}

export enum FeederDateValueType {
    ManualValue = "ManualValue",
    StartDate = "StartDate",
    EndDate = "EndDate",
}

export class FeederFormulaDTO implements IFeederFormulaDTO {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    formulaString?: string | undefined;
    formulaItems?: FeederFormulaItemDTO[] | undefined;

    constructor(data?: IFeederFormulaDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.level = _data["level"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            if (Array.isArray(_data["validationRuleIds"])) {
                this.validationRuleIds = [] as any;
                for (let item of _data["validationRuleIds"])
                    this.validationRuleIds!.push(item);
            }
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
            this.formulaString = _data["formulaString"];
            if (Array.isArray(_data["formulaItems"])) {
                this.formulaItems = [] as any;
                for (let item of _data["formulaItems"])
                    this.formulaItems!.push(FeederFormulaItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeederFormulaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeederFormulaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["level"] = this.level;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        if (Array.isArray(this.validationRuleIds)) {
            data["validationRuleIds"] = [];
            for (let item of this.validationRuleIds)
                data["validationRuleIds"].push(item);
        }
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        data["formulaString"] = this.formulaString;
        if (Array.isArray(this.formulaItems)) {
            data["formulaItems"] = [];
            for (let item of this.formulaItems)
                data["formulaItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFeederFormulaDTO {
    mStnPairingId?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleIds?: number[] | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    formulaString?: string | undefined;
    formulaItems?: FeederFormulaItemDTO[] | undefined;
}

export class FeederFormulaItemDTO implements IFeederFormulaItemDTO {
    pairerName?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    type?: FormulaItemType;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;

    constructor(data?: IFeederFormulaItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerName = _data["pairerName"];
            this.namePrefix = _data["namePrefix"];
            this.field = _data["field"];
            this.type = _data["type"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
        }
    }

    static fromJS(data: any): FeederFormulaItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeederFormulaItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerName"] = this.pairerName;
        data["namePrefix"] = this.namePrefix;
        data["field"] = this.field;
        data["type"] = this.type;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        return data;
    }
}

export interface IFeederFormulaItemDTO {
    pairerName?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    type?: FormulaItemType;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
}

export enum FeederStringValueType {
    ManualValue = "ManualValue",
    FromDS = "FromDS",
    TemplateDS = "TemplateDS",
    Color = "Color",
    Precision = "Precision",
    Duration = "Duration",
    Formula = "Formula",
    Generated = "Generated",
}

export class FillBudgetCustomFieldWithValueDto implements IFillBudgetCustomFieldWithValueDto {
    fieldName?: string | undefined;
    value?: string | undefined;
    budgetSessionId?: number;
    pairerBudgetRuleId?: number;
    elementId?: string | undefined;
    modelId?: string | undefined;

    constructor(data?: IFillBudgetCustomFieldWithValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.value = _data["value"];
            this.budgetSessionId = _data["budgetSessionId"];
            this.pairerBudgetRuleId = _data["pairerBudgetRuleId"];
            this.elementId = _data["elementId"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): FillBudgetCustomFieldWithValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FillBudgetCustomFieldWithValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["value"] = this.value;
        data["budgetSessionId"] = this.budgetSessionId;
        data["pairerBudgetRuleId"] = this.pairerBudgetRuleId;
        data["elementId"] = this.elementId;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IFillBudgetCustomFieldWithValueDto {
    fieldName?: string | undefined;
    value?: string | undefined;
    budgetSessionId?: number;
    pairerBudgetRuleId?: number;
    elementId?: string | undefined;
    modelId?: string | undefined;
}

export class FillBudgetCustomFieldWithValueRequest implements IFillBudgetCustomFieldWithValueRequest {
    fields?: FillBudgetCustomFieldWithValueDto[] | undefined;

    constructor(data?: IFillBudgetCustomFieldWithValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FillBudgetCustomFieldWithValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FillBudgetCustomFieldWithValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FillBudgetCustomFieldWithValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFillBudgetCustomFieldWithValueRequest {
    fields?: FillBudgetCustomFieldWithValueDto[] | undefined;
}

export class FillBudgetCustomFieldWithValueResponse implements IFillBudgetCustomFieldWithValueResponse {
    ok?: boolean;
    valueIds?: number[] | undefined;

    constructor(data?: IFillBudgetCustomFieldWithValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["valueIds"])) {
                this.valueIds = [] as any;
                for (let item of _data["valueIds"])
                    this.valueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FillBudgetCustomFieldWithValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FillBudgetCustomFieldWithValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.valueIds)) {
            data["valueIds"] = [];
            for (let item of this.valueIds)
                data["valueIds"].push(item);
        }
        return data;
    }
}

export interface IFillBudgetCustomFieldWithValueResponse {
    ok?: boolean;
    valueIds?: number[] | undefined;
}

export class FilterElementsForBudgetingPluginRequest implements IFilterElementsForBudgetingPluginRequest {
    budgetingSessionId?: number;
    modelData?: string | undefined;
    mStnPairingId?: number | undefined;

    constructor(data?: IFilterElementsForBudgetingPluginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetingSessionId = _data["budgetingSessionId"];
            this.modelData = _data["modelData"];
            this.mStnPairingId = _data["mStnPairingId"];
        }
    }

    static fromJS(data: any): FilterElementsForBudgetingPluginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterElementsForBudgetingPluginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetingSessionId"] = this.budgetingSessionId;
        data["modelData"] = this.modelData;
        data["mStnPairingId"] = this.mStnPairingId;
        return data;
    }
}

export interface IFilterElementsForBudgetingPluginRequest {
    budgetingSessionId?: number;
    modelData?: string | undefined;
    mStnPairingId?: number | undefined;
}

export class FilterElementsForBudgetingRequest implements IFilterElementsForBudgetingRequest {
    standardId?: number;
    modelData?: string | undefined;
    budgetingSessionId?: number | undefined;

    constructor(data?: IFilterElementsForBudgetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.modelData = _data["modelData"];
            this.budgetingSessionId = _data["budgetingSessionId"];
        }
    }

    static fromJS(data: any): FilterElementsForBudgetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterElementsForBudgetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["modelData"] = this.modelData;
        data["budgetingSessionId"] = this.budgetingSessionId;
        return data;
    }
}

export interface IFilterElementsForBudgetingRequest {
    standardId?: number;
    modelData?: string | undefined;
    budgetingSessionId?: number | undefined;
}

export class FilterElementsForBudgetingResponse implements IFilterElementsForBudgetingResponse {
    elementMatches?: ElementBudgetMatch[] | undefined;

    constructor(data?: IFilterElementsForBudgetingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elementMatches"])) {
                this.elementMatches = [] as any;
                for (let item of _data["elementMatches"])
                    this.elementMatches!.push(ElementBudgetMatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterElementsForBudgetingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterElementsForBudgetingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elementMatches)) {
            data["elementMatches"] = [];
            for (let item of this.elementMatches)
                data["elementMatches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterElementsForBudgetingResponse {
    elementMatches?: ElementBudgetMatch[] | undefined;
}

export class FilterElementsRequest implements IFilterElementsRequest {
    data?: string | undefined;
    filterModel?: string | undefined;

    constructor(data?: IFilterElementsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.filterModel = _data["filterModel"];
        }
    }

    static fromJS(data: any): FilterElementsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterElementsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["filterModel"] = this.filterModel;
        return data;
    }
}

export interface IFilterElementsRequest {
    data?: string | undefined;
    filterModel?: string | undefined;
}

export enum FilteringOperator {
    Equals = "Equals",
    Contains = "Contains",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    Empty = "Empty",
    NotEmpty = "NotEmpty",
}

export class FilterItem implements IFilterItem {
    field?: string | undefined;
    filterOperator?: FilteringOperator;
    value?: string | undefined;
    id?: number;

    constructor(data?: IFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterOperator = _data["filterOperator"];
            this.value = _data["value"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterOperator"] = this.filterOperator;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IFilterItem {
    field?: string | undefined;
    filterOperator?: FilteringOperator;
    value?: string | undefined;
    id?: number;
}

export enum FilterType {
    RowFilter = "RowFilter",
    ElementFilter = "ElementFilter",
    Aggregation = "Aggregation",
}

export class FindSimilarRequest implements IFindSimilarRequest {
    expressId?: number;
    tenantId?: number;
    projectId?: number;
    modelId?: number | undefined;
    topK?: number;

    constructor(data?: IFindSimilarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.topK = _data["topK"];
        }
    }

    static fromJS(data: any): FindSimilarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindSimilarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["topK"] = this.topK;
        return data;
    }
}

export interface IFindSimilarRequest {
    expressId?: number;
    tenantId?: number;
    projectId?: number;
    modelId?: number | undefined;
    topK?: number;
}

export class FinishModelProcessingResponse implements IFinishModelProcessingResponse {
    ok?: boolean;

    constructor(data?: IFinishModelProcessingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): FinishModelProcessingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinishModelProcessingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IFinishModelProcessingResponse {
    ok?: boolean;
}

export enum FlatExcelErrorType {
    OK = "OK",
    NoData = "NoData",
    InvalidColumnsStructure = "InvalidColumnsStructure",
    RowError = "RowError",
}

export class FlexibleSearchApiRequest implements IFlexibleSearchApiRequest {
    query?: string | undefined;
    tenantId?: number;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    propertyFilters?: PropertyFilterRequest[] | undefined;
    aggregation?: AggregationRequest;
    topK?: number;
    minScore?: number;

    constructor(data?: IFlexibleSearchApiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            if (Array.isArray(_data["propertyFilters"])) {
                this.propertyFilters = [] as any;
                for (let item of _data["propertyFilters"])
                    this.propertyFilters!.push(PropertyFilterRequest.fromJS(item));
            }
            this.aggregation = _data["aggregation"] ? AggregationRequest.fromJS(_data["aggregation"]) : undefined as any;
            this.topK = _data["topK"];
            this.minScore = _data["minScore"];
        }
    }

    static fromJS(data: any): FlexibleSearchApiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FlexibleSearchApiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        if (Array.isArray(this.propertyFilters)) {
            data["propertyFilters"] = [];
            for (let item of this.propertyFilters)
                data["propertyFilters"].push(item ? item.toJSON() : undefined as any);
        }
        data["aggregation"] = this.aggregation ? this.aggregation.toJSON() : undefined as any;
        data["topK"] = this.topK;
        data["minScore"] = this.minScore;
        return data;
    }
}

export interface IFlexibleSearchApiRequest {
    query?: string | undefined;
    tenantId?: number;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    propertyFilters?: PropertyFilterRequest[] | undefined;
    aggregation?: AggregationRequest;
    topK?: number;
    minScore?: number;
}

export class FlexibleSearchElementResponse implements IFlexibleSearchElementResponse {
    id?: string | undefined;
    expressId?: number;
    modelId?: number;
    ifcGuid?: string | undefined;
    ifcType?: string | undefined;
    name?: string | undefined;
    classifications?: string[] | undefined;
    propertySets?: string[] | undefined;
    properties?: PropertyResponse[] | undefined;

    constructor(data?: IFlexibleSearchElementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
            this.ifcGuid = _data["ifcGuid"];
            this.ifcType = _data["ifcType"];
            this.name = _data["name"];
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(item);
            }
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(item);
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlexibleSearchElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FlexibleSearchElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        data["ifcGuid"] = this.ifcGuid;
        data["ifcType"] = this.ifcType;
        data["name"] = this.name;
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item);
        }
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFlexibleSearchElementResponse {
    id?: string | undefined;
    expressId?: number;
    modelId?: number;
    ifcGuid?: string | undefined;
    ifcType?: string | undefined;
    name?: string | undefined;
    classifications?: string[] | undefined;
    propertySets?: string[] | undefined;
    properties?: PropertyResponse[] | undefined;
}

export class FlexibleSearchResponse implements IFlexibleSearchResponse {
    totalCount?: number;
    executionTimeMs?: number;
    distinctValues?: { [key: string]: string[]; } | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    aggregation?: AggregationResponse;

    constructor(data?: IFlexibleSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.executionTimeMs = _data["executionTimeMs"];
            if (_data["distinctValues"]) {
                this.distinctValues = {} as any;
                for (let key in _data["distinctValues"]) {
                    if (_data["distinctValues"].hasOwnProperty(key))
                        (this.distinctValues as any)![key] = _data["distinctValues"][key] !== undefined ? _data["distinctValues"][key] : [];
                }
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FlexibleSearchElementResponse.fromJS(item));
            }
            this.aggregation = _data["aggregation"] ? AggregationResponse.fromJS(_data["aggregation"]) : undefined as any;
        }
    }

    static fromJS(data: any): FlexibleSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FlexibleSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["executionTimeMs"] = this.executionTimeMs;
        if (this.distinctValues) {
            data["distinctValues"] = {};
            for (let key in this.distinctValues) {
                if (this.distinctValues.hasOwnProperty(key))
                    (data["distinctValues"] as any)[key] = (this.distinctValues as any)[key];
            }
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["aggregation"] = this.aggregation ? this.aggregation.toJSON() : undefined as any;
        return data;
    }
}

export interface IFlexibleSearchResponse {
    totalCount?: number;
    executionTimeMs?: number;
    distinctValues?: { [key: string]: string[]; } | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    aggregation?: AggregationResponse;
}

export class FormulaDto implements IFormulaDto {
    id?: number;
    name?: string | undefined;
    numeric?: boolean;
    formulaString?: string | undefined;

    constructor(data?: IFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numeric = _data["numeric"];
            this.formulaString = _data["formulaString"];
        }
    }

    static fromJS(data: any): FormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numeric"] = this.numeric;
        data["formulaString"] = this.formulaString;
        return data;
    }
}

export interface IFormulaDto {
    id?: number;
    name?: string | undefined;
    numeric?: boolean;
    formulaString?: string | undefined;
}

export class FormulaElementDTO implements IFormulaElementDTO {
    elementId?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    formula?: string | undefined;
    items?: FormulaItemDTO[] | undefined;

    constructor(data?: IFormulaElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.namePrefix = _data["namePrefix"];
            this.field = _data["field"];
            this.formula = _data["formula"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormulaItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormulaElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["namePrefix"] = this.namePrefix;
        data["field"] = this.field;
        data["formula"] = this.formula;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormulaElementDTO {
    elementId?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    formula?: string | undefined;
    items?: FormulaItemDTO[] | undefined;
}

export class FormulaItemDto implements IFormulaItemDto {
    id?: number;
    formulaId?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IFormulaItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formulaId = _data["formulaId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FormulaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formulaId"] = this.formulaId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IFormulaItemDto {
    id?: number;
    formulaId?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class FormulaItemDTO implements IFormulaItemDTO {
    pairerName?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    type?: FormulaItemType;
    autoValueType?: FeederAutoValueType;
    value?: string | undefined;
    state?: FeederAutoValueState;
    stringValueType?: FeederStringValueType;

    constructor(data?: IFormulaItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerName = _data["pairerName"];
            this.namePrefix = _data["namePrefix"];
            this.field = _data["field"];
            this.type = _data["type"];
            this.autoValueType = _data["autoValueType"];
            this.value = _data["value"];
            this.state = _data["state"];
            this.stringValueType = _data["stringValueType"];
        }
    }

    static fromJS(data: any): FormulaItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerName"] = this.pairerName;
        data["namePrefix"] = this.namePrefix;
        data["field"] = this.field;
        data["type"] = this.type;
        data["autoValueType"] = this.autoValueType;
        data["value"] = this.value;
        data["state"] = this.state;
        data["stringValueType"] = this.stringValueType;
        return data;
    }
}

export interface IFormulaItemDTO {
    pairerName?: string | undefined;
    namePrefix?: string | undefined;
    field?: string | undefined;
    type?: FormulaItemType;
    autoValueType?: FeederAutoValueType;
    value?: string | undefined;
    state?: FeederAutoValueState;
    stringValueType?: FeederStringValueType;
}

export enum FormulaItemType {
    Custom = "Custom",
    Native = "Native",
    Auto = "Auto",
    DataStandard = "DataStandard",
    CustomType = "CustomType",
    NativeType = "NativeType",
}

export class GetAllDataStandardsSharingResponse implements IGetAllDataStandardsSharingResponse {
    tenantDataStandardsSharing?: TenantDataStandardSharingDTO[] | undefined;

    constructor(data?: IGetAllDataStandardsSharingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantDataStandardsSharing"])) {
                this.tenantDataStandardsSharing = [] as any;
                for (let item of _data["tenantDataStandardsSharing"])
                    this.tenantDataStandardsSharing!.push(TenantDataStandardSharingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDataStandardsSharingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDataStandardsSharingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantDataStandardsSharing)) {
            data["tenantDataStandardsSharing"] = [];
            for (let item of this.tenantDataStandardsSharing)
                data["tenantDataStandardsSharing"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllDataStandardsSharingResponse {
    tenantDataStandardsSharing?: TenantDataStandardSharingDTO[] | undefined;
}

export class GetAllPairersForStandardResponse implements IGetAllPairersForStandardResponse {
    pairers?: PairerDTO[] | undefined;

    constructor(data?: IGetAllPairersForStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPairersForStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPairersForStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllPairersForStandardResponse {
    pairers?: PairerDTO[] | undefined;
}

export class GetAllPropertiesForDataStandardResponse implements IGetAllPropertiesForDataStandardResponse {
    properties?: string[] | undefined;

    constructor(data?: IGetAllPropertiesForDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllPropertiesForDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPropertiesForDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item);
        }
        return data;
    }
}

export interface IGetAllPropertiesForDataStandardResponse {
    properties?: string[] | undefined;
}

export class GetAllPropertiesForFormulasResponse implements IGetAllPropertiesForFormulasResponse {
    formulaProperties?: PropertyFormulaDto[] | undefined;

    constructor(data?: IGetAllPropertiesForFormulasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formulaProperties"])) {
                this.formulaProperties = [] as any;
                for (let item of _data["formulaProperties"])
                    this.formulaProperties!.push(PropertyFormulaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllPropertiesForFormulasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPropertiesForFormulasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formulaProperties)) {
            data["formulaProperties"] = [];
            for (let item of this.formulaProperties)
                data["formulaProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAllPropertiesForFormulasResponse {
    formulaProperties?: PropertyFormulaDto[] | undefined;
}

export class GetAppLogoResponse implements IGetAppLogoResponse {
    base64?: string | undefined;

    constructor(data?: IGetAppLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): GetAppLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IGetAppLogoResponse {
    base64?: string | undefined;
}

export class GetBudgetingSessionPairingResponse implements IGetBudgetingSessionPairingResponse {
    pairing?: BudgetingSessionPairingDto;

    constructor(data?: IGetBudgetingSessionPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairing = _data["pairing"] ? BudgetingSessionPairingDto.fromJS(_data["pairing"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetBudgetingSessionPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetingSessionPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairing"] = this.pairing ? this.pairing.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetBudgetingSessionPairingResponse {
    pairing?: BudgetingSessionPairingDto;
}

export class GetBudgetingSessionsResponse implements IGetBudgetingSessionsResponse {
    sessions?: BudgetingSessionDto[] | undefined;

    constructor(data?: IGetBudgetingSessionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(BudgetingSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetingSessionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetingSessionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBudgetingSessionsResponse {
    sessions?: BudgetingSessionDto[] | undefined;
}

export class GetBudgetingSessionsTilesResponse implements IGetBudgetingSessionsTilesResponse {
    sessions?: BudgetingSessionForTilesDto[] | undefined;
    projects?: ProjectDTO[] | undefined;

    constructor(data?: IGetBudgetingSessionsTilesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(BudgetingSessionForTilesDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetingSessionsTilesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetingSessionsTilesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBudgetingSessionsTilesResponse {
    sessions?: BudgetingSessionForTilesDto[] | undefined;
    projects?: ProjectDTO[] | undefined;
}

export class GetBudgetRuleByIdResponse implements IGetBudgetRuleByIdResponse {
    ok?: boolean;
    budgetRuleId?: number | undefined;
    pairerId?: number | undefined;
    name?: string | undefined;
    category?: string | undefined;
    error?: string | undefined;
    items?: BudgetRuleItemDto[] | undefined;

    constructor(data?: IGetBudgetRuleByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.budgetRuleId = _data["budgetRuleId"];
            this.pairerId = _data["pairerId"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.error = _data["error"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetRuleItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetRuleByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetRuleByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["budgetRuleId"] = this.budgetRuleId;
        data["pairerId"] = this.pairerId;
        data["name"] = this.name;
        data["category"] = this.category;
        data["error"] = this.error;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBudgetRuleByIdResponse {
    ok?: boolean;
    budgetRuleId?: number | undefined;
    pairerId?: number | undefined;
    name?: string | undefined;
    category?: string | undefined;
    error?: string | undefined;
    items?: BudgetRuleItemDto[] | undefined;
}

export class GetBudgetRuleItemByIdResponse implements IGetBudgetRuleItemByIdResponse {
    ok?: boolean;
    error?: string | undefined;
    itemId?: number;
    budgetRuleId?: number;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;

    constructor(data?: IGetBudgetRuleItemByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
            this.itemId = _data["itemId"];
            this.budgetRuleId = _data["budgetRuleId"];
            this.formulaId = _data["formulaId"];
            this.budgetItemSign = _data["budgetItemSign"];
            this.budgetItemName = _data["budgetItemName"];
            this.budgetItemDescription = _data["budgetItemDescription"];
            this.budgetItemSpecification = _data["budgetItemSpecification"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.measuringUnit = _data["measuringUnit"];
        }
    }

    static fromJS(data: any): GetBudgetRuleItemByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetRuleItemByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        data["itemId"] = this.itemId;
        data["budgetRuleId"] = this.budgetRuleId;
        data["formulaId"] = this.formulaId;
        data["budgetItemSign"] = this.budgetItemSign;
        data["budgetItemName"] = this.budgetItemName;
        data["budgetItemDescription"] = this.budgetItemDescription;
        data["budgetItemSpecification"] = this.budgetItemSpecification;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["measuringUnitId"] = this.measuringUnitId;
        data["measuringUnit"] = this.measuringUnit;
        return data;
    }
}

export interface IGetBudgetRuleItemByIdResponse {
    ok?: boolean;
    error?: string | undefined;
    itemId?: number;
    budgetRuleId?: number;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;
}

export class GetBudgetRulesForPairerResponse implements IGetBudgetRulesForPairerResponse {
    budgetRules?: BudgetRuleDto[] | undefined;

    constructor(data?: IGetBudgetRulesForPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetRules"])) {
                this.budgetRules = [] as any;
                for (let item of _data["budgetRules"])
                    this.budgetRules!.push(BudgetRuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetRulesForPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetRulesForPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetRules)) {
            data["budgetRules"] = [];
            for (let item of this.budgetRules)
                data["budgetRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBudgetRulesForPairerResponse {
    budgetRules?: BudgetRuleDto[] | undefined;
}

export class GetBudgetRulesItemsForRuleResponse implements IGetBudgetRulesItemsForRuleResponse {
    budgetRules?: BudgetRuleItemDto[] | undefined;

    constructor(data?: IGetBudgetRulesItemsForRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetRules"])) {
                this.budgetRules = [] as any;
                for (let item of _data["budgetRules"])
                    this.budgetRules!.push(BudgetRuleItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetRulesItemsForRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetRulesItemsForRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetRules)) {
            data["budgetRules"] = [];
            for (let item of this.budgetRules)
                data["budgetRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetBudgetRulesItemsForRuleResponse {
    budgetRules?: BudgetRuleItemDto[] | undefined;
}

export class GetConstructionObjectPrizesForProjectResponse implements IGetConstructionObjectPrizesForProjectResponse {
    prizes?: ConstructionObjectPrizeDto[] | undefined;

    constructor(data?: IGetConstructionObjectPrizesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prizes"])) {
                this.prizes = [] as any;
                for (let item of _data["prizes"])
                    this.prizes!.push(ConstructionObjectPrizeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConstructionObjectPrizesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionObjectPrizesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prizes)) {
            data["prizes"] = [];
            for (let item of this.prizes)
                data["prizes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetConstructionObjectPrizesForProjectResponse {
    prizes?: ConstructionObjectPrizeDto[] | undefined;
}

export class GetConstructionPartsPrizesForProjectResponse implements IGetConstructionPartsPrizesForProjectResponse {
    prizes?: ConstructionPartsPrizeDto[] | undefined;

    constructor(data?: IGetConstructionPartsPrizesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prizes"])) {
                this.prizes = [] as any;
                for (let item of _data["prizes"])
                    this.prizes!.push(ConstructionPartsPrizeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConstructionPartsPrizesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionPartsPrizesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prizes)) {
            data["prizes"] = [];
            for (let item of this.prizes)
                data["prizes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetConstructionPartsPrizesForProjectResponse {
    prizes?: ConstructionPartsPrizeDto[] | undefined;
}

export class GetConstructionStructureOutputForSessionResponse implements IGetConstructionStructureOutputForSessionResponse {
    objects?: ConstructionObjectDto[] | undefined;

    constructor(data?: IGetConstructionStructureOutputForSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["objects"])) {
                this.objects = [] as any;
                for (let item of _data["objects"])
                    this.objects!.push(ConstructionObjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConstructionStructureOutputForSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConstructionStructureOutputForSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.objects)) {
            data["objects"] = [];
            for (let item of this.objects)
                data["objects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetConstructionStructureOutputForSessionResponse {
    objects?: ConstructionObjectDto[] | undefined;
}

export class GetCurvesForRouteResponse implements IGetCurvesForRouteResponse {
    routeId?: number;
    routeName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    curves?: CurveDTO[] | undefined;

    constructor(data?: IGetCurvesForRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
            this.routeName = _data["routeName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurvesForRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurvesForRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        data["routeName"] = this.routeName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCurvesForRouteResponse {
    routeId?: number;
    routeName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    curves?: CurveDTO[] | undefined;
}

export class GetDataFromModelRequest implements IGetDataFromModelRequest {
    models?: Model[] | undefined;

    constructor(data?: IGetDataFromModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(Model.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataFromModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataFromModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataFromModelRequest {
    models?: Model[] | undefined;
}

export class GetDataStandardBCHPValRulesResponse implements IGetDataStandardBCHPValRulesResponse {
    isDataStandardSZ?: boolean;
    postPrefixGroup?: string | undefined;
    pairerValRules?: BCHPPairerValRulesDTO[] | undefined;

    constructor(data?: IGetDataStandardBCHPValRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixGroup = _data["postPrefixGroup"];
            if (Array.isArray(_data["pairerValRules"])) {
                this.pairerValRules = [] as any;
                for (let item of _data["pairerValRules"])
                    this.pairerValRules!.push(BCHPPairerValRulesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardBCHPValRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardBCHPValRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixGroup"] = this.postPrefixGroup;
        if (Array.isArray(this.pairerValRules)) {
            data["pairerValRules"] = [];
            for (let item of this.pairerValRules)
                data["pairerValRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardBCHPValRulesResponse {
    isDataStandardSZ?: boolean;
    postPrefixGroup?: string | undefined;
    pairerValRules?: BCHPPairerValRulesDTO[] | undefined;
}

export class GetDataStandardForTreeFeederRequest implements IGetDataStandardForTreeFeederRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreeFeederRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreeFeederRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeFeederRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardForTreeFeederRequest {
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetDataStandardForTreeFeederResponse implements IGetDataStandardForTreeFeederResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreeFeederResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandard"])) {
                this.dataStandard = [] as any;
                for (let item of _data["dataStandard"])
                    this.dataStandard!.push(PairerGroupFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreeFeederResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeFeederResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandard)) {
            data["dataStandard"] = [];
            for (let item of this.dataStandard)
                data["dataStandard"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardForTreeFeederResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;
}

export class GetDataStandardForTreePairingResponse implements IGetDataStandardForTreePairingResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;

    constructor(data?: IGetDataStandardForTreePairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandard"])) {
                this.dataStandard = [] as any;
                for (let item of _data["dataStandard"])
                    this.dataStandard!.push(PairerGroupFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardForTreePairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreePairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandard)) {
            data["dataStandard"] = [];
            for (let item of this.dataStandard)
                data["dataStandard"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardForTreePairingResponse {
    dataStandard?: PairerGroupFullDTO[] | undefined;
}

export class GetDataStandardForTreeValRuleRequest implements IGetDataStandardForTreeValRuleRequest {
    standardId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;

    constructor(data?: IGetDataStandardForTreeValRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.isRevit = _data["isRevit"];
            this.isMSTN = _data["isMSTN"];
        }
    }

    static fromJS(data: any): GetDataStandardForTreeValRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeValRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["isRevit"] = this.isRevit;
        data["isMSTN"] = this.isMSTN;
        return data;
    }
}

export interface IGetDataStandardForTreeValRuleRequest {
    standardId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
}

export class GetDataStandardForTreeValRuleResponse implements IGetDataStandardForTreeValRuleResponse {
    dataStandard?: DataStandardsFullTreeDTO;

    constructor(data?: IGetDataStandardForTreeValRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandard = _data["dataStandard"] ? DataStandardsFullTreeDTO.fromJS(_data["dataStandard"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetDataStandardForTreeValRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardForTreeValRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandard"] = this.dataStandard ? this.dataStandard.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetDataStandardForTreeValRuleResponse {
    dataStandard?: DataStandardsFullTreeDTO;
}

export class GetDataStandardsResponse implements IGetDataStandardsResponse {
    dataStandards?: DataStandardDTO[] | undefined;

    constructor(data?: IGetDataStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataStandards"])) {
                this.dataStandards = [] as any;
                for (let item of _data["dataStandards"])
                    this.dataStandards!.push(DataStandardDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataStandards)) {
            data["dataStandards"] = [];
            for (let item of this.dataStandards)
                data["dataStandards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardsResponse {
    dataStandards?: DataStandardDTO[] | undefined;
}

export class GetDataStandardValRuleFieldsRequest implements IGetDataStandardValRuleFieldsRequest {
    standardId?: number;
    onlyDecimal?: boolean;

    constructor(data?: IGetDataStandardValRuleFieldsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.onlyDecimal = _data["onlyDecimal"];
        }
    }

    static fromJS(data: any): GetDataStandardValRuleFieldsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardValRuleFieldsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["onlyDecimal"] = this.onlyDecimal;
        return data;
    }
}

export interface IGetDataStandardValRuleFieldsRequest {
    standardId?: number;
    onlyDecimal?: boolean;
}

export class GetDataStandardValRuleFieldsResponse implements IGetDataStandardValRuleFieldsResponse {
    valRules?: ValRuleDecimalPlacesDTO[] | undefined;

    constructor(data?: IGetDataStandardValRuleFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valRules"])) {
                this.valRules = [] as any;
                for (let item of _data["valRules"])
                    this.valRules!.push(ValRuleDecimalPlacesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDataStandardValRuleFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataStandardValRuleFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valRules)) {
            data["valRules"] = [];
            for (let item of this.valRules)
                data["valRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDataStandardValRuleFieldsResponse {
    valRules?: ValRuleDecimalPlacesDTO[] | undefined;
}

export class GetEnumCategoriesResponse implements IGetEnumCategoriesResponse {
    categories?: string[] | undefined;

    constructor(data?: IGetEnumCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): GetEnumCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnumCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface IGetEnumCategoriesResponse {
    categories?: string[] | undefined;
}

export class GetFilterItemFieldsRequest implements IGetFilterItemFieldsRequest {
    pairerIds?: number[] | undefined;

    constructor(data?: IGetFilterItemFieldsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairerIds"])) {
                this.pairerIds = [] as any;
                for (let item of _data["pairerIds"])
                    this.pairerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetFilterItemFieldsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilterItemFieldsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairerIds)) {
            data["pairerIds"] = [];
            for (let item of this.pairerIds)
                data["pairerIds"].push(item);
        }
        return data;
    }
}

export interface IGetFilterItemFieldsRequest {
    pairerIds?: number[] | undefined;
}

export class GetFilterItemFieldsResponse implements IGetFilterItemFieldsResponse {
    filterItemFields?: string[] | undefined;

    constructor(data?: IGetFilterItemFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filterItemFields"])) {
                this.filterItemFields = [] as any;
                for (let item of _data["filterItemFields"])
                    this.filterItemFields!.push(item);
            }
        }
    }

    static fromJS(data: any): GetFilterItemFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilterItemFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filterItemFields)) {
            data["filterItemFields"] = [];
            for (let item of this.filterItemFields)
                data["filterItemFields"].push(item);
        }
        return data;
    }
}

export interface IGetFilterItemFieldsResponse {
    filterItemFields?: string[] | undefined;
}

export class GetFormulaItemResponse implements IGetFormulaItemResponse {
    ok?: boolean;
    formulaItem?: FormulaItemDto;
    error?: string | undefined;

    constructor(data?: IGetFormulaItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.formulaItem = _data["formulaItem"] ? FormulaItemDto.fromJS(_data["formulaItem"]) : undefined as any;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetFormulaItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["formulaItem"] = this.formulaItem ? this.formulaItem.toJSON() : undefined as any;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetFormulaItemResponse {
    ok?: boolean;
    formulaItem?: FormulaItemDto;
    error?: string | undefined;
}

export class GetFormulaResponse implements IGetFormulaResponse {
    formula?: FormulaDto;

    constructor(data?: IGetFormulaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formula = _data["formula"] ? FormulaDto.fromJS(_data["formula"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetFormulaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formula"] = this.formula ? this.formula.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetFormulaResponse {
    formula?: FormulaDto;
}

export class GetFormulasResponse implements IGetFormulasResponse {
    formulas?: FormulaDto[] | undefined;

    constructor(data?: IGetFormulasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formulas"])) {
                this.formulas = [] as any;
                for (let item of _data["formulas"])
                    this.formulas!.push(FormulaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFormulasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formulas)) {
            data["formulas"] = [];
            for (let item of this.formulas)
                data["formulas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFormulasResponse {
    formulas?: FormulaDto[] | undefined;
}

export class GetGroupsForStandardResponse implements IGetGroupsForStandardResponse {
    pairersGroups?: PairerGroupDTO[] | undefined;

    constructor(data?: IGetGroupsForStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairersGroups"])) {
                this.pairersGroups = [] as any;
                for (let item of _data["pairersGroups"])
                    this.pairersGroups!.push(PairerGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGroupsForStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupsForStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairersGroups)) {
            data["pairersGroups"] = [];
            for (let item of this.pairersGroups)
                data["pairersGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetGroupsForStandardResponse {
    pairersGroups?: PairerGroupDTO[] | undefined;
}

export class GetGroupsWithPairerNamesResponse implements IGetGroupsWithPairerNamesResponse {
    pairersGroups?: PairerGroupWithPairerNamesDTO[] | undefined;

    constructor(data?: IGetGroupsWithPairerNamesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairersGroups"])) {
                this.pairersGroups = [] as any;
                for (let item of _data["pairersGroups"])
                    this.pairersGroups!.push(PairerGroupWithPairerNamesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGroupsWithPairerNamesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupsWithPairerNamesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairersGroups)) {
            data["pairersGroups"] = [];
            for (let item of this.pairersGroups)
                data["pairersGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetGroupsWithPairerNamesResponse {
    pairersGroups?: PairerGroupWithPairerNamesDTO[] | undefined;
}

export class GetImportDSSettingsResponse implements IGetImportDSSettingsResponse {
    importDSSettings?: ImportDSSettingDTO[] | undefined;

    constructor(data?: IGetImportDSSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["importDSSettings"])) {
                this.importDSSettings = [] as any;
                for (let item of _data["importDSSettings"])
                    this.importDSSettings!.push(ImportDSSettingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetImportDSSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportDSSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.importDSSettings)) {
            data["importDSSettings"] = [];
            for (let item of this.importDSSettings)
                data["importDSSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetImportDSSettingsResponse {
    importDSSettings?: ImportDSSettingDTO[] | undefined;
}

export class GetInitDataResponse implements IGetInitDataResponse {
    generatedData?: OutputRowDTO[] | undefined;

    constructor(data?: IGetInitDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["generatedData"])) {
                this.generatedData = [] as any;
                for (let item of _data["generatedData"])
                    this.generatedData!.push(OutputRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInitDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInitDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.generatedData)) {
            data["generatedData"] = [];
            for (let item of this.generatedData)
                data["generatedData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInitDataResponse {
    generatedData?: OutputRowDTO[] | undefined;
}

export class GetMeasuringUnitsListResponse implements IGetMeasuringUnitsListResponse {
    units?: MeasuringUnitDto[] | undefined;

    constructor(data?: IGetMeasuringUnitsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(MeasuringUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMeasuringUnitsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeasuringUnitsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMeasuringUnitsListResponse {
    units?: MeasuringUnitDto[] | undefined;
}

export class GetMicrostationPairingPairersRequest implements IGetMicrostationPairingPairersRequest {
    mStnPairingId?: number;
    pairerId?: number;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingPairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.pairerId = _data["pairerId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingPairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingPairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["pairerId"] = this.pairerId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMicrostationPairingPairersRequest {
    mStnPairingId?: number;
    pairerId?: number;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetMicrostationPairingPairersResponse implements IGetMicrostationPairingPairersResponse {
    pairing?: MicrostationPairingPairerDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairing"])) {
                this.pairing = [] as any;
                for (let item of _data["pairing"])
                    this.pairing!.push(MicrostationPairingPairerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairing)) {
            data["pairing"] = [];
            for (let item of this.pairing)
                data["pairing"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMicrostationPairingPairersResponse {
    pairing?: MicrostationPairingPairerDTO[] | undefined;
}

export class GetMicrostationPairingPairingsResponse implements IGetMicrostationPairingPairingsResponse {
    pairings?: MicrostationPairingPairerDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingPairingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairings"])) {
                this.pairings = [] as any;
                for (let item of _data["pairings"])
                    this.pairings!.push(MicrostationPairingPairerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingPairingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingPairingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairings)) {
            data["pairings"] = [];
            for (let item of this.pairings)
                data["pairings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMicrostationPairingPairingsResponse {
    pairings?: MicrostationPairingPairerDTO[] | undefined;
}

export class GetMicrostationPairingResponse implements IGetMicrostationPairingResponse {
    pairings?: MicrostationPairingDTO[] | undefined;

    constructor(data?: IGetMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairings"])) {
                this.pairings = [] as any;
                for (let item of _data["pairings"])
                    this.pairings!.push(MicrostationPairingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairings)) {
            data["pairings"] = [];
            for (let item of this.pairings)
                data["pairings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMicrostationPairingResponse {
    pairings?: MicrostationPairingDTO[] | undefined;
}

export class GetModelDataForProjectResponse implements IGetModelDataForProjectResponse {
    bimModels?: BimModelDto[] | undefined;

    constructor(data?: IGetModelDataForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bimModels"])) {
                this.bimModels = [] as any;
                for (let item of _data["bimModels"])
                    this.bimModels!.push(BimModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetModelDataForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelDataForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bimModels)) {
            data["bimModels"] = [];
            for (let item of this.bimModels)
                data["bimModels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetModelDataForProjectResponse {
    bimModels?: BimModelDto[] | undefined;
}

export class GetModelFragsResponse implements IGetModelFragsResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetModelFragsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetModelFragsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelFragsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetModelFragsResponse {
    modelUri?: string | undefined;
}

export class GetModelIfcResponse implements IGetModelIfcResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetModelIfcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetModelIfcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelIfcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetModelIfcResponse {
    modelUri?: string | undefined;
}

export class GetModelResponse implements IGetModelResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetModelResponse {
    modelUri?: string | undefined;
}

export class GetModelSasUrisFromProjectIdCabinetResponse implements IGetModelSasUrisFromProjectIdCabinetResponse {
    canAccess?: boolean;
    projectName?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    modelUris?: ModelUrisDto[] | undefined;

    constructor(data?: IGetModelSasUrisFromProjectIdCabinetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
            this.projectName = _data["projectName"];
            this.drawer = _data["drawer"];
            this.investor = _data["investor"];
            this.stage = _data["stage"];
            if (Array.isArray(_data["modelUris"])) {
                this.modelUris = [] as any;
                for (let item of _data["modelUris"])
                    this.modelUris!.push(ModelUrisDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetModelSasUrisFromProjectIdCabinetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelSasUrisFromProjectIdCabinetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        data["projectName"] = this.projectName;
        data["drawer"] = this.drawer;
        data["investor"] = this.investor;
        data["stage"] = this.stage;
        if (Array.isArray(this.modelUris)) {
            data["modelUris"] = [];
            for (let item of this.modelUris)
                data["modelUris"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetModelSasUrisFromProjectIdCabinetResponse {
    canAccess?: boolean;
    projectName?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    modelUris?: ModelUrisDto[] | undefined;
}

export class GetModelSasUrisFromProjectIdResponse implements IGetModelSasUrisFromProjectIdResponse {
    modelUris?: ModelUrisDto[] | undefined;

    constructor(data?: IGetModelSasUrisFromProjectIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modelUris"])) {
                this.modelUris = [] as any;
                for (let item of _data["modelUris"])
                    this.modelUris!.push(ModelUrisDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetModelSasUrisFromProjectIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelSasUrisFromProjectIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modelUris)) {
            data["modelUris"] = [];
            for (let item of this.modelUris)
                data["modelUris"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetModelSasUrisFromProjectIdResponse {
    modelUris?: ModelUrisDto[] | undefined;
}

export class GetMStnFeederAllValRulesRequest implements IGetMStnFeederAllValRulesRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    isOpenX?: boolean;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetMStnFeederAllValRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isRevit = _data["isRevit"];
            this.isMSTN = _data["isMSTN"];
            this.isOpenX = _data["isOpenX"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederAllValRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederAllValRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isRevit"] = this.isRevit;
        data["isMSTN"] = this.isMSTN;
        data["isOpenX"] = this.isOpenX;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederAllValRulesRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    isOpenX?: boolean;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetMStnFeederAllValRulesResponse implements IGetMStnFeederAllValRulesResponse {
    pairerValRules?: PairerValRulesDTO[] | undefined;

    constructor(data?: IGetMStnFeederAllValRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairerValRules"])) {
                this.pairerValRules = [] as any;
                for (let item of _data["pairerValRules"])
                    this.pairerValRules!.push(PairerValRulesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederAllValRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederAllValRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairerValRules)) {
            data["pairerValRules"] = [];
            for (let item of this.pairerValRules)
                data["pairerValRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederAllValRulesResponse {
    pairerValRules?: PairerValRulesDTO[] | undefined;
}

export class GetMStnFeederCurvesRequest implements IGetMStnFeederCurvesRequest {
    projectId?: number | undefined;
    mStnPairingId?: number | undefined;
    isFeeder?: boolean;

    constructor(data?: IGetMStnFeederCurvesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeeder = _data["isFeeder"];
        }
    }

    static fromJS(data: any): GetMStnFeederCurvesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederCurvesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeeder"] = this.isFeeder;
        return data;
    }
}

export interface IGetMStnFeederCurvesRequest {
    projectId?: number | undefined;
    mStnPairingId?: number | undefined;
    isFeeder?: boolean;
}

export class GetMStnFeederCurvesResponse implements IGetMStnFeederCurvesResponse {
    feederCurves?: FeederCurveDTO[] | undefined;

    constructor(data?: IGetMStnFeederCurvesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["feederCurves"])) {
                this.feederCurves = [] as any;
                for (let item of _data["feederCurves"])
                    this.feederCurves!.push(FeederCurveDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederCurvesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederCurvesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.feederCurves)) {
            data["feederCurves"] = [];
            for (let item of this.feederCurves)
                data["feederCurves"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederCurvesResponse {
    feederCurves?: FeederCurveDTO[] | undefined;
}

export class GetMStnFeederElementsStationingResponse implements IGetMStnFeederElementsStationingResponse {
    elementsStationing?: ElementStationingDTO[] | undefined;

    constructor(data?: IGetMStnFeederElementsStationingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elementsStationing"])) {
                this.elementsStationing = [] as any;
                for (let item of _data["elementsStationing"])
                    this.elementsStationing!.push(ElementStationingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederElementsStationingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederElementsStationingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elementsStationing)) {
            data["elementsStationing"] = [];
            for (let item of this.elementsStationing)
                data["elementsStationing"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederElementsStationingResponse {
    elementsStationing?: ElementStationingDTO[] | undefined;
}

export class GetMStnFeederFormulaItemsRequest implements IGetMStnFeederFormulaItemsRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    elementsWithFormula?: MStnFeederAutoValueDTO[] | undefined;

    constructor(data?: IGetMStnFeederFormulaItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            if (Array.isArray(_data["elementsWithFormula"])) {
                this.elementsWithFormula = [] as any;
                for (let item of _data["elementsWithFormula"])
                    this.elementsWithFormula!.push(MStnFeederAutoValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederFormulaItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederFormulaItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        if (Array.isArray(this.elementsWithFormula)) {
            data["elementsWithFormula"] = [];
            for (let item of this.elementsWithFormula)
                data["elementsWithFormula"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederFormulaItemsRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    elementsWithFormula?: MStnFeederAutoValueDTO[] | undefined;
}

export class GetMStnFeederFormulaItemsResponse implements IGetMStnFeederFormulaItemsResponse {
    formulaElements?: FormulaElementDTO[] | undefined;

    constructor(data?: IGetMStnFeederFormulaItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formulaElements"])) {
                this.formulaElements = [] as any;
                for (let item of _data["formulaElements"])
                    this.formulaElements!.push(FormulaElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederFormulaItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederFormulaItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formulaElements)) {
            data["formulaElements"] = [];
            for (let item of this.formulaElements)
                data["formulaElements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederFormulaItemsResponse {
    formulaElements?: FormulaElementDTO[] | undefined;
}

export class GetMStnFeederItemsCountRequest implements IGetMStnFeederItemsCountRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;

    constructor(data?: IGetMStnFeederItemsCountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
        }
    }

    static fromJS(data: any): GetMStnFeederItemsCountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederItemsCountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        return data;
    }
}

export interface IGetMStnFeederItemsCountRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
}

export class GetMStnFeederItemsCountResponse implements IGetMStnFeederItemsCountResponse {
    dataStandardId?: number;
    isDataStandardSZ?: boolean;
    documentationStage?: DocumentationStage;
    count?: number;

    constructor(data?: IGetMStnFeederItemsCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.documentationStage = _data["documentationStage"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMStnFeederItemsCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederItemsCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["documentationStage"] = this.documentationStage;
        data["count"] = this.count;
        return data;
    }
}

export interface IGetMStnFeederItemsCountResponse {
    dataStandardId?: number;
    isDataStandardSZ?: boolean;
    documentationStage?: DocumentationStage;
    count?: number;
}

export class GetMStnFeederItemsRequest implements IGetMStnFeederItemsRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    isFeatureDefinitions?: boolean;
    pageIndex?: number;
    pageSize?: number;
    elementIds?: string[] | undefined;

    constructor(data?: IGetMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isRevit = _data["isRevit"];
            this.isMSTN = _data["isMSTN"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["elementIds"])) {
                this.elementIds = [] as any;
                for (let item of _data["elementIds"])
                    this.elementIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isRevit"] = this.isRevit;
        data["isMSTN"] = this.isMSTN;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.elementIds)) {
            data["elementIds"] = [];
            for (let item of this.elementIds)
                data["elementIds"].push(item);
        }
        return data;
    }
}

export interface IGetMStnFeederItemsRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    isFeatureDefinitions?: boolean;
    pageIndex?: number;
    pageSize?: number;
    elementIds?: string[] | undefined;
}

export class GetMStnFeederItemsResponse implements IGetMStnFeederItemsResponse {
    mStnFeederItems?: MStnFeederItemDTO[] | undefined;

    constructor(data?: IGetMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnFeederItems"])) {
                this.mStnFeederItems = [] as any;
                for (let item of _data["mStnFeederItems"])
                    this.mStnFeederItems!.push(MStnFeederItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnFeederItems)) {
            data["mStnFeederItems"] = [];
            for (let item of this.mStnFeederItems)
                data["mStnFeederItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnFeederItemsResponse {
    mStnFeederItems?: MStnFeederItemDTO[] | undefined;
}

export class GetMStnPairingsByLevelsRequest implements IGetMStnPairingsByLevelsRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    levels?: LevelMStnDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByLevelsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isRevit = _data["isRevit"];
            this.isMSTN = _data["isMSTN"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByLevelsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByLevelsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isRevit"] = this.isRevit;
        data["isMSTN"] = this.isMSTN;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnPairingsByLevelsRequest {
    mStnPairingId?: number;
    isRevit?: boolean;
    isMSTN?: boolean;
    levels?: LevelMStnDTO[] | undefined;
}

export class GetMStnPairingsByLevelsResponse implements IGetMStnPairingsByLevelsResponse {
    mStnPairings?: MStnPairingDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByLevelsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairings"])) {
                this.mStnPairings = [] as any;
                for (let item of _data["mStnPairings"])
                    this.mStnPairings!.push(MStnPairingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByLevelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByLevelsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairings)) {
            data["mStnPairings"] = [];
            for (let item of this.mStnPairings)
                data["mStnPairings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnPairingsByLevelsResponse {
    mStnPairings?: MStnPairingDTO[] | undefined;
}

export class GetMStnPairingsByRelevance2Request implements IGetMStnPairingsByRelevance2Request {
    dataStandardId?: number;
    levels?: LevelMStnDTO[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
    filteredPairerGroupIds?: number[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevance2Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
            this.isCaseSensitive = _data["isCaseSensitive"];
            this.isDiacritics = _data["isDiacritics"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
            if (Array.isArray(_data["filteredPairerGroupIds"])) {
                this.filteredPairerGroupIds = [] as any;
                for (let item of _data["filteredPairerGroupIds"])
                    this.filteredPairerGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevance2Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevance2Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCaseSensitive"] = this.isCaseSensitive;
        data["isDiacritics"] = this.isDiacritics;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        if (Array.isArray(this.filteredPairerGroupIds)) {
            data["filteredPairerGroupIds"] = [];
            for (let item of this.filteredPairerGroupIds)
                data["filteredPairerGroupIds"].push(item);
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevance2Request {
    dataStandardId?: number;
    levels?: LevelMStnDTO[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
    filteredPairerGroupIds?: number[] | undefined;
}

export class GetMStnPairingsByRelevance2Response implements IGetMStnPairingsByRelevance2Response {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevance2Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairingRelevance"])) {
                this.mStnPairingRelevance = [] as any;
                for (let item of _data["mStnPairingRelevance"])
                    this.mStnPairingRelevance!.push(MStnPairingRelevanceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevance2Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevance2Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairingRelevance)) {
            data["mStnPairingRelevance"] = [];
            for (let item of this.mStnPairingRelevance)
                data["mStnPairingRelevance"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevance2Response {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;
}

export class GetMStnPairingsByRelevanceRequest implements IGetMStnPairingsByRelevanceRequest {
    dataStandardId?: number;
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
    filteredPairerGroupIds?: number[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.mStnPairingId = _data["mStnPairingId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(LevelMStnDTO.fromJS(item));
            }
            this.isCaseSensitive = _data["isCaseSensitive"];
            this.isDiacritics = _data["isDiacritics"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
            if (Array.isArray(_data["filteredPairerGroupIds"])) {
                this.filteredPairerGroupIds = [] as any;
                for (let item of _data["filteredPairerGroupIds"])
                    this.filteredPairerGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["mStnPairingId"] = this.mStnPairingId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCaseSensitive"] = this.isCaseSensitive;
        data["isDiacritics"] = this.isDiacritics;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        if (Array.isArray(this.filteredPairerGroupIds)) {
            data["filteredPairerGroupIds"] = [];
            for (let item of this.filteredPairerGroupIds)
                data["filteredPairerGroupIds"].push(item);
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevanceRequest {
    dataStandardId?: number;
    mStnPairingId?: number;
    levels?: LevelMStnDTO[] | undefined;
    isCaseSensitive?: boolean;
    isDiacritics?: boolean;
    prefix?: number;
    suffix?: number;
    filteredPairerGroupIds?: number[] | undefined;
}

export class GetMStnPairingsByRelevanceResponse implements IGetMStnPairingsByRelevanceResponse {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;

    constructor(data?: IGetMStnPairingsByRelevanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mStnPairingRelevance"])) {
                this.mStnPairingRelevance = [] as any;
                for (let item of _data["mStnPairingRelevance"])
                    this.mStnPairingRelevance!.push(MStnPairingRelevanceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsByRelevanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsByRelevanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mStnPairingRelevance)) {
            data["mStnPairingRelevance"] = [];
            for (let item of this.mStnPairingRelevance)
                data["mStnPairingRelevance"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMStnPairingsByRelevanceResponse {
    mStnPairingRelevance?: MStnPairingRelevanceDTO[] | undefined;
}

export class GetMStnPairingsLevelsNameResponse implements IGetMStnPairingsLevelsNameResponse {
    levelNames?: string[] | undefined;
    pairersIds?: number[] | undefined;

    constructor(data?: IGetMStnPairingsLevelsNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["levelNames"])) {
                this.levelNames = [] as any;
                for (let item of _data["levelNames"])
                    this.levelNames!.push(item);
            }
            if (Array.isArray(_data["pairersIds"])) {
                this.pairersIds = [] as any;
                for (let item of _data["pairersIds"])
                    this.pairersIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMStnPairingsLevelsNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMStnPairingsLevelsNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.levelNames)) {
            data["levelNames"] = [];
            for (let item of this.levelNames)
                data["levelNames"].push(item);
        }
        if (Array.isArray(this.pairersIds)) {
            data["pairersIds"] = [];
            for (let item of this.pairersIds)
                data["pairersIds"].push(item);
        }
        return data;
    }
}

export interface IGetMStnPairingsLevelsNameResponse {
    levelNames?: string[] | undefined;
    pairersIds?: number[] | undefined;
}

export class GetMultiPairerByGroupIdResponse implements IGetMultiPairerByGroupIdResponse {
    rows?: MultiPairerRowDTO[] | undefined;

    constructor(data?: IGetMultiPairerByGroupIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MultiPairerRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByGroupIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByGroupIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMultiPairerByGroupIdResponse {
    rows?: MultiPairerRowDTO[] | undefined;
}

export class GetMultiPairerByIdsRequest implements IGetMultiPairerByIdsRequest {
    ids?: number[] | undefined;

    constructor(data?: IGetMultiPairerByIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IGetMultiPairerByIdsRequest {
    ids?: number[] | undefined;
}

export class GetMultiPairerByIdsResponse implements IGetMultiPairerByIdsResponse {
    rows?: MultiPairerRowDTO[] | undefined;

    constructor(data?: IGetMultiPairerByIdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MultiPairerRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMultiPairerByIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMultiPairerByIdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMultiPairerByIdsResponse {
    rows?: MultiPairerRowDTO[] | undefined;
}

export class GetNewVersionResponse implements IGetNewVersionResponse {
    downloadLink?: string | undefined;

    constructor(data?: IGetNewVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadLink = _data["downloadLink"];
        }
    }

    static fromJS(data: any): GetNewVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadLink"] = this.downloadLink;
        return data;
    }
}

export interface IGetNewVersionResponse {
    downloadLink?: string | undefined;
}

export class GetPairerDetailResponse implements IGetPairerDetailResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filter?: string | undefined;
    standardId?: number;
    groupId?: number;
    rowVersion?: string | undefined;
    isParsable?: boolean;
    filterItems?: FilterItem[] | undefined;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    validationOrGroups?: ValidationOrGroupDTO[] | undefined;
    documentationStage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    isDefaultStandard?: boolean;
    postPrefixGroup?: string | undefined;

    constructor(data?: IGetPairerDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.colorR = _data["colorR"];
            this.colorG = _data["colorG"];
            this.colorB = _data["colorB"];
            this.precisionDUR = _data["precisionDUR"];
            this.precisionDSP = _data["precisionDSP"];
            this.precisionPDPS = _data["precisionPDPS"];
            this.precisionRDS = _data["precisionRDS"];
            this.precisionDSPS = _data["precisionDSPS"];
            this.precisionDUSP = _data["precisionDUSP"];
            this.precisionDRS = _data["precisionDRS"];
            this.precisionDPS = _data["precisionDPS"];
            this.filter = _data["filter"];
            this.standardId = _data["standardId"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
            this.isParsable = _data["isParsable"];
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            if (Array.isArray(_data["validationOrGroups"])) {
                this.validationOrGroups = [] as any;
                for (let item of _data["validationOrGroups"])
                    this.validationOrGroups!.push(ValidationOrGroupDTO.fromJS(item));
            }
            this.documentationStage = _data["documentationStage"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.isDefaultStandard = _data["isDefaultStandard"];
            this.postPrefixGroup = _data["postPrefixGroup"];
        }
    }

    static fromJS(data: any): GetPairerDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPairerDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["colorR"] = this.colorR;
        data["colorG"] = this.colorG;
        data["colorB"] = this.colorB;
        data["precisionDUR"] = this.precisionDUR;
        data["precisionDSP"] = this.precisionDSP;
        data["precisionPDPS"] = this.precisionPDPS;
        data["precisionRDS"] = this.precisionRDS;
        data["precisionDSPS"] = this.precisionDSPS;
        data["precisionDUSP"] = this.precisionDUSP;
        data["precisionDRS"] = this.precisionDRS;
        data["precisionDPS"] = this.precisionDPS;
        data["filter"] = this.filter;
        data["standardId"] = this.standardId;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        data["isParsable"] = this.isParsable;
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.validationOrGroups)) {
            data["validationOrGroups"] = [];
            for (let item of this.validationOrGroups)
                data["validationOrGroups"].push(item ? item.toJSON() : undefined as any);
        }
        data["documentationStage"] = this.documentationStage;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["isDefaultStandard"] = this.isDefaultStandard;
        data["postPrefixGroup"] = this.postPrefixGroup;
        return data;
    }
}

export interface IGetPairerDetailResponse {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filter?: string | undefined;
    standardId?: number;
    groupId?: number;
    rowVersion?: string | undefined;
    isParsable?: boolean;
    filterItems?: FilterItem[] | undefined;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    validationOrGroups?: ValidationOrGroupDTO[] | undefined;
    documentationStage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    isDefaultStandard?: boolean;
    postPrefixGroup?: string | undefined;
}

export class GetPairerListForGroupIdResponse implements IGetPairerListForGroupIdResponse {
    pairers?: PairerDTO[] | undefined;
    elapsedTimeMilliseconds?: number;

    constructor(data?: IGetPairerListForGroupIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
        }
    }

    static fromJS(data: any): GetPairerListForGroupIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPairerListForGroupIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        return data;
    }
}

export interface IGetPairerListForGroupIdResponse {
    pairers?: PairerDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
}

export class GetPricingDatabaseListResponse implements IGetPricingDatabaseListResponse {
    pricingDatabases?: PricingDatabaseDto[] | undefined;

    constructor(data?: IGetPricingDatabaseListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pricingDatabases"])) {
                this.pricingDatabases = [] as any;
                for (let item of _data["pricingDatabases"])
                    this.pricingDatabases!.push(PricingDatabaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPricingDatabaseListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingDatabaseListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pricingDatabases)) {
            data["pricingDatabases"] = [];
            for (let item of this.pricingDatabases)
                data["pricingDatabases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPricingDatabaseListResponse {
    pricingDatabases?: PricingDatabaseDto[] | undefined;
}

export class GetPricingDatabaseStructureTreeResponse implements IGetPricingDatabaseStructureTreeResponse {
    success?: boolean;
    message?: string | undefined;
    treeData?: PricingDatabaseStructureTreeNode[] | undefined;

    constructor(data?: IGetPricingDatabaseStructureTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            if (Array.isArray(_data["treeData"])) {
                this.treeData = [] as any;
                for (let item of _data["treeData"])
                    this.treeData!.push(PricingDatabaseStructureTreeNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPricingDatabaseStructureTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingDatabaseStructureTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        if (Array.isArray(this.treeData)) {
            data["treeData"] = [];
            for (let item of this.treeData)
                data["treeData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPricingDatabaseStructureTreeResponse {
    success?: boolean;
    message?: string | undefined;
    treeData?: PricingDatabaseStructureTreeNode[] | undefined;
}

export class GetProjectByIdResponse implements IGetProjectByIdResponse {
    id?: number;
    name?: string | undefined;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    blobFileId?: string | undefined;
    tenantName?: string | undefined;
    description?: string | undefined;
    dateTime?: Date;
    type?: ProjectType;

    constructor(data?: IGetProjectByIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInBimCabinet = _data["showInBimCabinet"];
            this.customImageUri = _data["customImageUri"];
            this.drawer = _data["drawer"];
            this.investor = _data["investor"];
            this.stage = _data["stage"];
            this.drawingSoftware = _data["drawingSoftware"];
            this.cde = _data["cde"];
            this.blobFileId = _data["blobFileId"];
            this.tenantName = _data["tenantName"];
            this.description = _data["description"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GetProjectByIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectByIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInBimCabinet"] = this.showInBimCabinet;
        data["customImageUri"] = this.customImageUri;
        data["drawer"] = this.drawer;
        data["investor"] = this.investor;
        data["stage"] = this.stage;
        data["drawingSoftware"] = this.drawingSoftware;
        data["cde"] = this.cde;
        data["blobFileId"] = this.blobFileId;
        data["tenantName"] = this.tenantName;
        data["description"] = this.description;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetProjectByIdResponse {
    id?: number;
    name?: string | undefined;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    blobFileId?: string | undefined;
    tenantName?: string | undefined;
    description?: string | undefined;
    dateTime?: Date;
    type?: ProjectType;
}

export class GetProjectsForTenantAndCabinetResponse implements IGetProjectsForTenantAndCabinetResponse {
    projects?: ProjectForCabinetDto[] | undefined;

    constructor(data?: IGetProjectsForTenantAndCabinetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectForCabinetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsForTenantAndCabinetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForTenantAndCabinetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectsForTenantAndCabinetResponse {
    projects?: ProjectForCabinetDto[] | undefined;
}

export class GetProjectsForTenantResponse implements IGetProjectsForTenantResponse {
    tenantId?: number;
    tenantName?: string | undefined;
    projects?: ProjectDTO[] | undefined;

    constructor(data?: IGetProjectsForTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsForTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsForTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectsForTenantResponse {
    tenantId?: number;
    tenantName?: string | undefined;
    projects?: ProjectDTO[] | undefined;
}

export class GetPropertiesForFormulaIdResponse implements IGetPropertiesForFormulaIdResponse {
    formulaProperties?: PropertyFormulaDto[] | undefined;

    constructor(data?: IGetPropertiesForFormulaIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["formulaProperties"])) {
                this.formulaProperties = [] as any;
                for (let item of _data["formulaProperties"])
                    this.formulaProperties!.push(PropertyFormulaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPropertiesForFormulaIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForFormulaIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formulaProperties)) {
            data["formulaProperties"] = [];
            for (let item of this.formulaProperties)
                data["formulaProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPropertiesForFormulaIdResponse {
    formulaProperties?: PropertyFormulaDto[] | undefined;
}

export class GetPropertiesForModelResponse implements IGetPropertiesForModelResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;

    constructor(data?: IGetPropertiesForModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPropertiesForModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface IGetPropertiesForModelResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
}

export class GetPropertiesForProjectCabinetResponse implements IGetPropertiesForProjectCabinetResponse {
    canAccess?: boolean;
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;

    constructor(data?: IGetPropertiesForProjectCabinetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPropertiesForProjectCabinetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForProjectCabinetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface IGetPropertiesForProjectCabinetResponse {
    canAccess?: boolean;
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
}

export class GetPropertiesForProjectResponse implements IGetPropertiesForProjectResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IGetPropertiesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): GetPropertiesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IGetPropertiesForProjectResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GetResetPasswordUserDataResponse implements IGetResetPasswordUserDataResponse {
    userId?: number;

    constructor(data?: IGetResetPasswordUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetResetPasswordUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResetPasswordUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IGetResetPasswordUserDataResponse {
    userId?: number;
}

export class GetRolePermissionsResponse implements IGetRolePermissionsResponse {
    role?: RoleDTO;

    constructor(data?: IGetRolePermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRolePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetRolePermissionsResponse {
    role?: RoleDTO;
}

export class GetRoutesForProjectResponse implements IGetRoutesForProjectResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    routes?: RouteDTO[] | undefined;

    constructor(data?: IGetRoutesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectData = _data["projectData"] ? ProjectDataDTO.fromJS(_data["projectData"]) : undefined as any;
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(RouteDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRoutesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoutesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : undefined as any;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRoutesForProjectResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    routes?: RouteDTO[] | undefined;
}

export class GetSasUrlForDownloadFragmentsResponse implements IGetSasUrlForDownloadFragmentsResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForDownloadFragmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForDownloadFragmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForDownloadFragmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForDownloadFragmentsResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForDownloadIfcResponse implements IGetSasUrlForDownloadIfcResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForDownloadIfcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForDownloadIfcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForDownloadIfcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForDownloadIfcResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForUploadFragmentRequest implements IGetSasUrlForUploadFragmentRequest {
    id?: number;

    constructor(data?: IGetSasUrlForUploadFragmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadFragmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadFragmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSasUrlForUploadFragmentRequest {
    id?: number;
}

export class GetSasUrlForUploadFragmentResponse implements IGetSasUrlForUploadFragmentResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForUploadFragmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadFragmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadFragmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForUploadFragmentResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForUploadIfcRequest implements IGetSasUrlForUploadIfcRequest {
    name?: string | undefined;
    projectId?: number;
    bulkUploadId?: string | undefined;

    constructor(data?: IGetSasUrlForUploadIfcRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.bulkUploadId = _data["bulkUploadId"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadIfcRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadIfcRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["bulkUploadId"] = this.bulkUploadId;
        return data;
    }
}

export interface IGetSasUrlForUploadIfcRequest {
    name?: string | undefined;
    projectId?: number;
    bulkUploadId?: string | undefined;
}

export class GetSasUrlForUploadIfcResponse implements IGetSasUrlForUploadIfcResponse {
    id?: number;
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForUploadIfcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadIfcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadIfcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForUploadIfcResponse {
    id?: number;
    modelUri?: string | undefined;
}

export class GetSelectorHierarchyRequest implements IGetSelectorHierarchyRequest {
    dataType?: DataTypeValidation;

    constructor(data?: IGetSelectorHierarchyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): GetSelectorHierarchyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorHierarchyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IGetSelectorHierarchyRequest {
    dataType?: DataTypeValidation;
}

export class GetSelectorHierarchyResponse implements IGetSelectorHierarchyResponse {
    selectorList?: SelectorHierarchyDto[] | undefined;

    constructor(data?: IGetSelectorHierarchyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectorList"])) {
                this.selectorList = [] as any;
                for (let item of _data["selectorList"])
                    this.selectorList!.push(SelectorHierarchyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectorHierarchyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorHierarchyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectorList)) {
            data["selectorList"] = [];
            for (let item of this.selectorList)
                data["selectorList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSelectorHierarchyResponse {
    selectorList?: SelectorHierarchyDto[] | undefined;
}

export class GetSelectorItemsRequest implements IGetSelectorItemsRequest {
    id?: number;

    constructor(data?: IGetSelectorItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSelectorItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSelectorItemsRequest {
    id?: number;
}

export class GetSelectorItemsResponse implements IGetSelectorItemsResponse {
    name?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    dataType?: DataTypeValidation;
    selectorItems?: SelectorItemDTO[] | undefined;

    constructor(data?: IGetSelectorItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.projectId = _data["projectId"];
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["selectorItems"])) {
                this.selectorItems = [] as any;
                for (let item of _data["selectorItems"])
                    this.selectorItems!.push(SelectorItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectorItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["projectId"] = this.projectId;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.selectorItems)) {
            data["selectorItems"] = [];
            for (let item of this.selectorItems)
                data["selectorItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSelectorItemsResponse {
    name?: string | undefined;
    category?: string | undefined;
    projectId?: number | undefined;
    dataType?: DataTypeValidation;
    selectorItems?: SelectorItemDTO[] | undefined;
}

export class GetSelectorListRequest implements IGetSelectorListRequest {
    dataType?: DataTypeValidation;
    category?: string | undefined;

    constructor(data?: IGetSelectorListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataType = _data["dataType"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): GetSelectorListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataType"] = this.dataType;
        data["category"] = this.category;
        return data;
    }
}

export interface IGetSelectorListRequest {
    dataType?: DataTypeValidation;
    category?: string | undefined;
}

export class GetSelectorListResponse implements IGetSelectorListResponse {
    selectorList?: SelectorListDTO[] | undefined;

    constructor(data?: IGetSelectorListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectorList"])) {
                this.selectorList = [] as any;
                for (let item of _data["selectorList"])
                    this.selectorList!.push(SelectorListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSelectorListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSelectorListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectorList)) {
            data["selectorList"] = [];
            for (let item of this.selectorList)
                data["selectorList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSelectorListResponse {
    selectorList?: SelectorListDTO[] | undefined;
}

export class GetSharedDataStandardsResponse implements IGetSharedDataStandardsResponse {
    sharedDataStandards?: DataStandardDTO[] | undefined;

    constructor(data?: IGetSharedDataStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sharedDataStandards"])) {
                this.sharedDataStandards = [] as any;
                for (let item of _data["sharedDataStandards"])
                    this.sharedDataStandards!.push(DataStandardDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSharedDataStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharedDataStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sharedDataStandards)) {
            data["sharedDataStandards"] = [];
            for (let item of this.sharedDataStandards)
                data["sharedDataStandards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetSharedDataStandardsResponse {
    sharedDataStandards?: DataStandardDTO[] | undefined;
}

export class GetSignupUserDataResponse implements IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;

    constructor(data?: IGetSignupUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
        }
    }

    static fromJS(data: any): GetSignupUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignupUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        return data;
    }
}

export interface IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;
}

export class GetStandardIsDefaultResponse implements IGetStandardIsDefaultResponse {
    isDefaultStandard?: boolean;

    constructor(data?: IGetStandardIsDefaultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDefaultStandard = _data["isDefaultStandard"];
        }
    }

    static fromJS(data: any): GetStandardIsDefaultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardIsDefaultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefaultStandard"] = this.isDefaultStandard;
        return data;
    }
}

export interface IGetStandardIsDefaultResponse {
    isDefaultStandard?: boolean;
}

export class GetStandardIsEmptyResponse implements IGetStandardIsEmptyResponse {
    isEmptyStandard?: boolean;

    constructor(data?: IGetStandardIsEmptyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmptyStandard = _data["isEmptyStandard"];
        }
    }

    static fromJS(data: any): GetStandardIsEmptyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardIsEmptyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmptyStandard"] = this.isEmptyStandard;
        return data;
    }
}

export interface IGetStandardIsEmptyResponse {
    isEmptyStandard?: boolean;
}

export class GetTenantsAdminResponse implements IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetTenantsRequest implements IGetTenantsRequest {

    constructor(data?: IGetTenantsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetTenantsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetTenantsRequest {
}

export class GetTenantsResponse implements IGetTenantsResponse {
    tenants?: TenantListDTO[] | undefined;

    constructor(data?: IGetTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantsResponse {
    tenants?: TenantListDTO[] | undefined;
}

export class GetTenantsUserResponse implements IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetToolsResponse implements IGetToolsResponse {
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;

    constructor(data?: IGetToolsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBimValidator = _data["hasBimValidator"];
            this.hasBudgeting = _data["hasBudgeting"];
            this.hasCurveSolver = _data["hasCurveSolver"];
            this.hasIsoAnalyzer = _data["hasIsoAnalyzer"];
            this.hasSlopeGuard = _data["hasSlopeGuard"];
            this.hasEnumerationsAdministration = _data["hasEnumerationsAdministration"];
            this.hasOvCe = _data["hasOvCe"];
            this.hasBimVitrina = _data["hasBimVitrina"];
            this.hasAiAsker = _data["hasAiAsker"];
        }
    }

    static fromJS(data: any): GetToolsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBimValidator"] = this.hasBimValidator;
        data["hasBudgeting"] = this.hasBudgeting;
        data["hasCurveSolver"] = this.hasCurveSolver;
        data["hasIsoAnalyzer"] = this.hasIsoAnalyzer;
        data["hasSlopeGuard"] = this.hasSlopeGuard;
        data["hasEnumerationsAdministration"] = this.hasEnumerationsAdministration;
        data["hasOvCe"] = this.hasOvCe;
        data["hasBimVitrina"] = this.hasBimVitrina;
        data["hasAiAsker"] = this.hasAiAsker;
        return data;
    }
}

export interface IGetToolsResponse {
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
}

export class GetTreeDataFromModelResponse implements IGetTreeDataFromModelResponse {
    ifcTree?: string | undefined;

    constructor(data?: IGetTreeDataFromModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ifcTree = _data["ifcTree"];
        }
    }

    static fromJS(data: any): GetTreeDataFromModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeDataFromModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifcTree"] = this.ifcTree;
        return data;
    }
}

export interface IGetTreeDataFromModelResponse {
    ifcTree?: string | undefined;
}

export class GetTreeDataFromProjectCabinetResponse implements IGetTreeDataFromProjectCabinetResponse {
    canAccess?: boolean;
    modelTrees?: ModelTreeDto[] | undefined;

    constructor(data?: IGetTreeDataFromProjectCabinetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccess = _data["canAccess"];
            if (Array.isArray(_data["modelTrees"])) {
                this.modelTrees = [] as any;
                for (let item of _data["modelTrees"])
                    this.modelTrees!.push(ModelTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTreeDataFromProjectCabinetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeDataFromProjectCabinetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccess"] = this.canAccess;
        if (Array.isArray(this.modelTrees)) {
            data["modelTrees"] = [];
            for (let item of this.modelTrees)
                data["modelTrees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTreeDataFromProjectCabinetResponse {
    canAccess?: boolean;
    modelTrees?: ModelTreeDto[] | undefined;
}

export class GetTreeDataFromProjectResponse implements IGetTreeDataFromProjectResponse {
    modelTrees?: ModelTreeDto[] | undefined;

    constructor(data?: IGetTreeDataFromProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modelTrees"])) {
                this.modelTrees = [] as any;
                for (let item of _data["modelTrees"])
                    this.modelTrees!.push(ModelTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTreeDataFromProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeDataFromProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modelTrees)) {
            data["modelTrees"] = [];
            for (let item of this.modelTrees)
                data["modelTrees"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTreeDataFromProjectResponse {
    modelTrees?: ModelTreeDto[] | undefined;
}

export class GetUploaderUriResponse implements IGetUploaderUriResponse {
    uri?: string | undefined;
    updateId?: number;

    constructor(data?: IGetUploaderUriResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.updateId = _data["updateId"];
        }
    }

    static fromJS(data: any): GetUploaderUriResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUploaderUriResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["updateId"] = this.updateId;
        return data;
    }
}

export interface IGetUploaderUriResponse {
    uri?: string | undefined;
    updateId?: number;
}

export class GetUserInfoResponse implements IGetUserInfoResponse {
    userId?: number;
    tenantId?: number;
    username?: string | undefined;
    userSurname?: string | undefined;
    userEmail?: string | undefined;
    tenantName?: string | undefined;
    canCreateTenant?: boolean;
    canCreateUsers?: boolean;
    initials?: string | undefined;
    isAdmin?: boolean;
    validatingTreeProps?: boolean;
    permissions?: GetToolsResponse;

    constructor(data?: IGetUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.username = _data["username"];
            this.userSurname = _data["userSurname"];
            this.userEmail = _data["userEmail"];
            this.tenantName = _data["tenantName"];
            this.canCreateTenant = _data["canCreateTenant"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.initials = _data["initials"];
            this.isAdmin = _data["isAdmin"];
            this.validatingTreeProps = _data["validatingTreeProps"];
            this.permissions = _data["permissions"] ? GetToolsResponse.fromJS(_data["permissions"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["username"] = this.username;
        data["userSurname"] = this.userSurname;
        data["userEmail"] = this.userEmail;
        data["tenantName"] = this.tenantName;
        data["canCreateTenant"] = this.canCreateTenant;
        data["canCreateUsers"] = this.canCreateUsers;
        data["initials"] = this.initials;
        data["isAdmin"] = this.isAdmin;
        data["validatingTreeProps"] = this.validatingTreeProps;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUserInfoResponse {
    userId?: number;
    tenantId?: number;
    username?: string | undefined;
    userSurname?: string | undefined;
    userEmail?: string | undefined;
    tenantName?: string | undefined;
    canCreateTenant?: boolean;
    canCreateUsers?: boolean;
    initials?: string | undefined;
    isAdmin?: boolean;
    validatingTreeProps?: boolean;
    permissions?: GetToolsResponse;
}

export class GetUsersTenantResponse implements IGetUsersTenantResponse {
    tenant?: TenantDTO;

    constructor(data?: IGetUsersTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDTO.fromJS(_data["tenant"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUsersTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUsersTenantResponse {
    tenant?: TenantDTO;
}

export class GetUserTenantsResponse implements IGetUserTenantsResponse {
    tenants?: TenantListDTO[] | undefined;

    constructor(data?: IGetUserTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserTenantsResponse {
    tenants?: TenantListDTO[] | undefined;
}

export class GridFilterModel implements IGridFilterModel {
    items?: GridFilterModelItem[] | undefined;
    logicOperator?: GridLogicOperator;

    constructor(data?: IGridFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GridFilterModelItem.fromJS(item));
            }
            this.logicOperator = _data["logicOperator"];
        }
    }

    static fromJS(data: any): GridFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["logicOperator"] = this.logicOperator;
        return data;
    }
}

export interface IGridFilterModel {
    items?: GridFilterModelItem[] | undefined;
    logicOperator?: GridLogicOperator;
}

export class GridFilterModelItem implements IGridFilterModelItem {
    id?: number;
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;

    constructor(data?: IGridFilterModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GridFilterModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new GridFilterModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface IGridFilterModelItem {
    id?: number;
    field?: string | undefined;
    operator?: string | undefined;
    value?: string | undefined;
}

export enum GridLogicOperator {
    And = "And",
    Or = "Or",
}

export class ChangeUserPasswordRequest implements IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangeUserPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangeUserPasswordResponse implements IChangeUserPasswordResponse {
    ok?: boolean;

    constructor(data?: IChangeUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeUserPasswordResponse {
    ok?: boolean;
}

export class ChangeUserTenantRequest implements IChangeUserTenantRequest {
    tenantId?: number;

    constructor(data?: IChangeUserTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantRequest {
    tenantId?: number;
}

export class ChangeUserTenantResponse implements IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;

    constructor(data?: IChangeUserTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;
}

export class CheckDataStandardRequest implements ICheckDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;
    deleteEntities?: boolean;

    constructor(data?: ICheckDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
            this.elementNameColumn = _data["elementNameColumn"];
            this.importCciValues = _data["importCciValues"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.cciPrefix = _data["cciPrefix"];
            this.cciName = _data["cciName"];
            this.dsPrefix = _data["dsPrefix"];
            this.dsName = _data["dsName"];
            this.deleteEntities = _data["deleteEntities"];
        }
    }

    static fromJS(data: any): CheckDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        data["elementNameColumn"] = this.elementNameColumn;
        data["importCciValues"] = this.importCciValues;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["cciPrefix"] = this.cciPrefix;
        data["cciName"] = this.cciName;
        data["dsPrefix"] = this.dsPrefix;
        data["dsName"] = this.dsName;
        data["deleteEntities"] = this.deleteEntities;
        return data;
    }
}

export interface ICheckDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;
    deleteEntities?: boolean;
}

export class CheckDataStandardResponse implements ICheckDataStandardResponse {
    ok?: boolean;
    addedPairersGroups?: string[] | undefined;
    deletedPairersGroups?: string[] | undefined;
    addedPairers?: string[] | undefined;
    updatedPairers?: ImportChangesDTO[] | undefined;
    deletedPairers?: string[] | undefined;
    addedValidationRules?: string[] | undefined;
    updatedValidationRules?: ImportChangesDTO[] | undefined;
    deletedValidationRules?: string[] | undefined;

    constructor(data?: ICheckDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["addedPairersGroups"])) {
                this.addedPairersGroups = [] as any;
                for (let item of _data["addedPairersGroups"])
                    this.addedPairersGroups!.push(item);
            }
            if (Array.isArray(_data["deletedPairersGroups"])) {
                this.deletedPairersGroups = [] as any;
                for (let item of _data["deletedPairersGroups"])
                    this.deletedPairersGroups!.push(item);
            }
            if (Array.isArray(_data["addedPairers"])) {
                this.addedPairers = [] as any;
                for (let item of _data["addedPairers"])
                    this.addedPairers!.push(item);
            }
            if (Array.isArray(_data["updatedPairers"])) {
                this.updatedPairers = [] as any;
                for (let item of _data["updatedPairers"])
                    this.updatedPairers!.push(ImportChangesDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedPairers"])) {
                this.deletedPairers = [] as any;
                for (let item of _data["deletedPairers"])
                    this.deletedPairers!.push(item);
            }
            if (Array.isArray(_data["addedValidationRules"])) {
                this.addedValidationRules = [] as any;
                for (let item of _data["addedValidationRules"])
                    this.addedValidationRules!.push(item);
            }
            if (Array.isArray(_data["updatedValidationRules"])) {
                this.updatedValidationRules = [] as any;
                for (let item of _data["updatedValidationRules"])
                    this.updatedValidationRules!.push(ImportChangesDTO.fromJS(item));
            }
            if (Array.isArray(_data["deletedValidationRules"])) {
                this.deletedValidationRules = [] as any;
                for (let item of _data["deletedValidationRules"])
                    this.deletedValidationRules!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.addedPairersGroups)) {
            data["addedPairersGroups"] = [];
            for (let item of this.addedPairersGroups)
                data["addedPairersGroups"].push(item);
        }
        if (Array.isArray(this.deletedPairersGroups)) {
            data["deletedPairersGroups"] = [];
            for (let item of this.deletedPairersGroups)
                data["deletedPairersGroups"].push(item);
        }
        if (Array.isArray(this.addedPairers)) {
            data["addedPairers"] = [];
            for (let item of this.addedPairers)
                data["addedPairers"].push(item);
        }
        if (Array.isArray(this.updatedPairers)) {
            data["updatedPairers"] = [];
            for (let item of this.updatedPairers)
                data["updatedPairers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedPairers)) {
            data["deletedPairers"] = [];
            for (let item of this.deletedPairers)
                data["deletedPairers"].push(item);
        }
        if (Array.isArray(this.addedValidationRules)) {
            data["addedValidationRules"] = [];
            for (let item of this.addedValidationRules)
                data["addedValidationRules"].push(item);
        }
        if (Array.isArray(this.updatedValidationRules)) {
            data["updatedValidationRules"] = [];
            for (let item of this.updatedValidationRules)
                data["updatedValidationRules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deletedValidationRules)) {
            data["deletedValidationRules"] = [];
            for (let item of this.deletedValidationRules)
                data["deletedValidationRules"].push(item);
        }
        return data;
    }
}

export interface ICheckDataStandardResponse {
    ok?: boolean;
    addedPairersGroups?: string[] | undefined;
    deletedPairersGroups?: string[] | undefined;
    addedPairers?: string[] | undefined;
    updatedPairers?: ImportChangesDTO[] | undefined;
    deletedPairers?: string[] | undefined;
    addedValidationRules?: string[] | undefined;
    updatedValidationRules?: ImportChangesDTO[] | undefined;
    deletedValidationRules?: string[] | undefined;
}

export class IdsExportRequest implements IIdsExportRequest {
    dataStandardId?: number;
    exportOrsAsAnds?: boolean;
    propertySetName?: string | undefined;

    constructor(data?: IIdsExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStandardId = _data["dataStandardId"];
            this.exportOrsAsAnds = _data["exportOrsAsAnds"];
            this.propertySetName = _data["propertySetName"];
        }
    }

    static fromJS(data: any): IdsExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdsExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStandardId"] = this.dataStandardId;
        data["exportOrsAsAnds"] = this.exportOrsAsAnds;
        data["propertySetName"] = this.propertySetName;
        return data;
    }
}

export interface IIdsExportRequest {
    dataStandardId?: number;
    exportOrsAsAnds?: boolean;
    propertySetName?: string | undefined;
}

export class ImportDataStandardFlatExcelRequest implements IImportDataStandardFlatExcelRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    rows?: { [key: string]: any; }[] | undefined;

    constructor(data?: IImportDataStandardFlatExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportDataStandardFlatExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardFlatExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IImportDataStandardFlatExcelRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    rows?: { [key: string]: any; }[] | undefined;
}

export class ImportDataStandardFlatExcelResponse implements IImportDataStandardFlatExcelResponse {
    errorType?: FlatExcelErrorType;
    rowErrorIndex?: number | undefined;

    constructor(data?: IImportDataStandardFlatExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorType = _data["errorType"];
            this.rowErrorIndex = _data["rowErrorIndex"];
        }
    }

    static fromJS(data: any): ImportDataStandardFlatExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardFlatExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorType"] = this.errorType;
        data["rowErrorIndex"] = this.rowErrorIndex;
        return data;
    }
}

export interface IImportDataStandardFlatExcelResponse {
    errorType?: FlatExcelErrorType;
    rowErrorIndex?: number | undefined;
}

export class ImportDataStandardLocallyRequest implements IImportDataStandardLocallyRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;

    constructor(data?: IImportDataStandardLocallyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ImportDataStandardLocallyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardLocallyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        return data;
    }
}

export interface IImportDataStandardLocallyRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
}

export class ImportDataStandardRequest implements IImportDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;
    deleteEntities?: boolean;

    constructor(data?: IImportDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
            this.elementNameColumn = _data["elementNameColumn"];
            this.importCciValues = _data["importCciValues"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.cciPrefix = _data["cciPrefix"];
            this.cciName = _data["cciName"];
            this.dsPrefix = _data["dsPrefix"];
            this.dsName = _data["dsName"];
            this.deleteEntities = _data["deleteEntities"];
        }
    }

    static fromJS(data: any): ImportDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        data["elementNameColumn"] = this.elementNameColumn;
        data["importCciValues"] = this.importCciValues;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["cciPrefix"] = this.cciPrefix;
        data["cciName"] = this.cciName;
        data["dsPrefix"] = this.dsPrefix;
        data["dsName"] = this.dsName;
        data["deleteEntities"] = this.deleteEntities;
        return data;
    }
}

export interface IImportDataStandardRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;
    deleteEntities?: boolean;
}

export class ImportDataStandardResponse implements IImportDataStandardResponse {
    ok?: boolean;

    constructor(data?: IImportDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportDataStandardResponse {
    ok?: boolean;
}

export class ImportDataStandardRSDRequest implements IImportDataStandardRSDRequest {
    standardId?: number;

    constructor(data?: IImportDataStandardRSDRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
        }
    }

    static fromJS(data: any): ImportDataStandardRSDRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardRSDRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        return data;
    }
}

export interface IImportDataStandardRSDRequest {
    standardId?: number;
}

export class ImportDataStandardRSDResponse implements IImportDataStandardRSDResponse {
    ok?: boolean;

    constructor(data?: IImportDataStandardRSDResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportDataStandardRSDResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataStandardRSDResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportDataStandardRSDResponse {
    ok?: boolean;
}

export class ImportDSSettingDTO implements IImportDSSettingDTO {
    id?: number;
    name?: string | undefined;
    propertiesNameOfSheet?: string | undefined;
    propertiesStartRow?: number | undefined;
    propertiesPropertyGroupName?: string | undefined;
    propertiesPropertyDesignation?: string | undefined;
    propertiesDataType?: string | undefined;
    propertiesUnitOfMeasure?: string | undefined;
    propertiesExampleOfValues?: string | undefined;
    propertiesPropertyDesignationIFC?: string | undefined;
    propertiesDefinedTypeIFC?: string | undefined;
    propertiesDUR?: string | undefined;
    propertiesDUSP?: string | undefined;
    propertiesDSP?: string | undefined;
    propertiesPDPS?: string | undefined;
    propertiesRDS?: string | undefined;
    propertiesDSPS?: string | undefined;
    propertiesDRS?: string | undefined;
    propertiesDPS?: string | undefined;
    isColor?: boolean;
    colorNameOfSheet?: string | undefined;
    colorStartRow?: number | undefined;
    colorR?: string | undefined;
    colorG?: string | undefined;
    colorB?: string | undefined;
    colorIndex?: string | undefined;
    colorElementIndex?: string | undefined;
    elementsStartRow?: number | undefined;
    elementsGroupsOfElements?: string | undefined;
    elementsTypeOfElement?: string | undefined;
    elementsDUR?: string | undefined;
    elementsDUSP?: string | undefined;
    elementsDSP?: string | undefined;
    elementsPDPS?: string | undefined;
    elementsRDS?: string | undefined;
    elementsDSPS?: string | undefined;
    elementsDRS?: string | undefined;
    elementsDPS?: string | undefined;
    elementsI?: string | undefined;
    elementsS?: string | undefined;
    elementsE?: string | undefined;
    elementsZ?: string | undefined;
    elementsM?: string | undefined;
    elementsU?: string | undefined;
    elementsF?: string | undefined;
    elementsGeometricAccuracyDUR?: string | undefined;
    elementsGeometricAccuracyDUSP?: string | undefined;
    elementsGeometricAccuracyDSP?: string | undefined;
    elementsGeometricAccuracyPDPS?: string | undefined;
    elementsGeometricAccuracyRDS?: string | undefined;
    elementsGeometricAccuracyDSPS?: string | undefined;
    elementsGeometricAccuracyDRS?: string | undefined;
    elementsGeometricAccuracyDPS?: string | undefined;
    isSZ?: boolean;
    szPostPrefixGroup?: string | undefined;
    szdsPrefix?: string | undefined;
    szdsName?: string | undefined;
    isCCI?: boolean;
    cciUseForClassification?: boolean;
    cciRowWithName?: number | undefined;
    cciStartRow?: number | undefined;
    cciBuildingComplex?: string | undefined;
    cciConstructionEntities?: string | undefined;
    cciBuiltUpSpaces?: string | undefined;
    cciFunctionalSystem?: string | undefined;
    cciTechnicalSystem?: string | undefined;
    cciComponents?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    importValuesToCCIRules?: boolean;
    isOperatorOR?: boolean;
    importDSSettingQualifyItems?: ImportDSSettingQualifyItemDTO[] | undefined;
    prefix?: string | undefined;
    replaceSpacesInTitleWith?: string | undefined;
    importByPhase?: boolean;
    levelOfProjectDocumentation?: DocumentationStage;
    isFlatExcelSettings?: boolean;

    constructor(data?: IImportDSSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.propertiesNameOfSheet = _data["propertiesNameOfSheet"];
            this.propertiesStartRow = _data["propertiesStartRow"];
            this.propertiesPropertyGroupName = _data["propertiesPropertyGroupName"];
            this.propertiesPropertyDesignation = _data["propertiesPropertyDesignation"];
            this.propertiesDataType = _data["propertiesDataType"];
            this.propertiesUnitOfMeasure = _data["propertiesUnitOfMeasure"];
            this.propertiesExampleOfValues = _data["propertiesExampleOfValues"];
            this.propertiesPropertyDesignationIFC = _data["propertiesPropertyDesignationIFC"];
            this.propertiesDefinedTypeIFC = _data["propertiesDefinedTypeIFC"];
            this.propertiesDUR = _data["propertiesDUR"];
            this.propertiesDUSP = _data["propertiesDUSP"];
            this.propertiesDSP = _data["propertiesDSP"];
            this.propertiesPDPS = _data["propertiesPDPS"];
            this.propertiesRDS = _data["propertiesRDS"];
            this.propertiesDSPS = _data["propertiesDSPS"];
            this.propertiesDRS = _data["propertiesDRS"];
            this.propertiesDPS = _data["propertiesDPS"];
            this.isColor = _data["isColor"];
            this.colorNameOfSheet = _data["colorNameOfSheet"];
            this.colorStartRow = _data["colorStartRow"];
            this.colorR = _data["colorR"];
            this.colorG = _data["colorG"];
            this.colorB = _data["colorB"];
            this.colorIndex = _data["colorIndex"];
            this.colorElementIndex = _data["colorElementIndex"];
            this.elementsStartRow = _data["elementsStartRow"];
            this.elementsGroupsOfElements = _data["elementsGroupsOfElements"];
            this.elementsTypeOfElement = _data["elementsTypeOfElement"];
            this.elementsDUR = _data["elementsDUR"];
            this.elementsDUSP = _data["elementsDUSP"];
            this.elementsDSP = _data["elementsDSP"];
            this.elementsPDPS = _data["elementsPDPS"];
            this.elementsRDS = _data["elementsRDS"];
            this.elementsDSPS = _data["elementsDSPS"];
            this.elementsDRS = _data["elementsDRS"];
            this.elementsDPS = _data["elementsDPS"];
            this.elementsI = _data["elementsI"];
            this.elementsS = _data["elementsS"];
            this.elementsE = _data["elementsE"];
            this.elementsZ = _data["elementsZ"];
            this.elementsM = _data["elementsM"];
            this.elementsU = _data["elementsU"];
            this.elementsF = _data["elementsF"];
            this.elementsGeometricAccuracyDUR = _data["elementsGeometricAccuracyDUR"];
            this.elementsGeometricAccuracyDUSP = _data["elementsGeometricAccuracyDUSP"];
            this.elementsGeometricAccuracyDSP = _data["elementsGeometricAccuracyDSP"];
            this.elementsGeometricAccuracyPDPS = _data["elementsGeometricAccuracyPDPS"];
            this.elementsGeometricAccuracyRDS = _data["elementsGeometricAccuracyRDS"];
            this.elementsGeometricAccuracyDSPS = _data["elementsGeometricAccuracyDSPS"];
            this.elementsGeometricAccuracyDRS = _data["elementsGeometricAccuracyDRS"];
            this.elementsGeometricAccuracyDPS = _data["elementsGeometricAccuracyDPS"];
            this.isSZ = _data["isSZ"];
            this.szPostPrefixGroup = _data["szPostPrefixGroup"];
            this.szdsPrefix = _data["szdsPrefix"];
            this.szdsName = _data["szdsName"];
            this.isCCI = _data["isCCI"];
            this.cciUseForClassification = _data["cciUseForClassification"];
            this.cciRowWithName = _data["cciRowWithName"];
            this.cciStartRow = _data["cciStartRow"];
            this.cciBuildingComplex = _data["cciBuildingComplex"];
            this.cciConstructionEntities = _data["cciConstructionEntities"];
            this.cciBuiltUpSpaces = _data["cciBuiltUpSpaces"];
            this.cciFunctionalSystem = _data["cciFunctionalSystem"];
            this.cciTechnicalSystem = _data["cciTechnicalSystem"];
            this.cciComponents = _data["cciComponents"];
            this.cciPrefix = _data["cciPrefix"];
            this.cciName = _data["cciName"];
            this.importValuesToCCIRules = _data["importValuesToCCIRules"];
            this.isOperatorOR = _data["isOperatorOR"];
            if (Array.isArray(_data["importDSSettingQualifyItems"])) {
                this.importDSSettingQualifyItems = [] as any;
                for (let item of _data["importDSSettingQualifyItems"])
                    this.importDSSettingQualifyItems!.push(ImportDSSettingQualifyItemDTO.fromJS(item));
            }
            this.prefix = _data["prefix"];
            this.replaceSpacesInTitleWith = _data["replaceSpacesInTitleWith"];
            this.importByPhase = _data["importByPhase"];
            this.levelOfProjectDocumentation = _data["levelOfProjectDocumentation"];
            this.isFlatExcelSettings = _data["isFlatExcelSettings"];
        }
    }

    static fromJS(data: any): ImportDSSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDSSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["propertiesNameOfSheet"] = this.propertiesNameOfSheet;
        data["propertiesStartRow"] = this.propertiesStartRow;
        data["propertiesPropertyGroupName"] = this.propertiesPropertyGroupName;
        data["propertiesPropertyDesignation"] = this.propertiesPropertyDesignation;
        data["propertiesDataType"] = this.propertiesDataType;
        data["propertiesUnitOfMeasure"] = this.propertiesUnitOfMeasure;
        data["propertiesExampleOfValues"] = this.propertiesExampleOfValues;
        data["propertiesPropertyDesignationIFC"] = this.propertiesPropertyDesignationIFC;
        data["propertiesDefinedTypeIFC"] = this.propertiesDefinedTypeIFC;
        data["propertiesDUR"] = this.propertiesDUR;
        data["propertiesDUSP"] = this.propertiesDUSP;
        data["propertiesDSP"] = this.propertiesDSP;
        data["propertiesPDPS"] = this.propertiesPDPS;
        data["propertiesRDS"] = this.propertiesRDS;
        data["propertiesDSPS"] = this.propertiesDSPS;
        data["propertiesDRS"] = this.propertiesDRS;
        data["propertiesDPS"] = this.propertiesDPS;
        data["isColor"] = this.isColor;
        data["colorNameOfSheet"] = this.colorNameOfSheet;
        data["colorStartRow"] = this.colorStartRow;
        data["colorR"] = this.colorR;
        data["colorG"] = this.colorG;
        data["colorB"] = this.colorB;
        data["colorIndex"] = this.colorIndex;
        data["colorElementIndex"] = this.colorElementIndex;
        data["elementsStartRow"] = this.elementsStartRow;
        data["elementsGroupsOfElements"] = this.elementsGroupsOfElements;
        data["elementsTypeOfElement"] = this.elementsTypeOfElement;
        data["elementsDUR"] = this.elementsDUR;
        data["elementsDUSP"] = this.elementsDUSP;
        data["elementsDSP"] = this.elementsDSP;
        data["elementsPDPS"] = this.elementsPDPS;
        data["elementsRDS"] = this.elementsRDS;
        data["elementsDSPS"] = this.elementsDSPS;
        data["elementsDRS"] = this.elementsDRS;
        data["elementsDPS"] = this.elementsDPS;
        data["elementsI"] = this.elementsI;
        data["elementsS"] = this.elementsS;
        data["elementsE"] = this.elementsE;
        data["elementsZ"] = this.elementsZ;
        data["elementsM"] = this.elementsM;
        data["elementsU"] = this.elementsU;
        data["elementsF"] = this.elementsF;
        data["elementsGeometricAccuracyDUR"] = this.elementsGeometricAccuracyDUR;
        data["elementsGeometricAccuracyDUSP"] = this.elementsGeometricAccuracyDUSP;
        data["elementsGeometricAccuracyDSP"] = this.elementsGeometricAccuracyDSP;
        data["elementsGeometricAccuracyPDPS"] = this.elementsGeometricAccuracyPDPS;
        data["elementsGeometricAccuracyRDS"] = this.elementsGeometricAccuracyRDS;
        data["elementsGeometricAccuracyDSPS"] = this.elementsGeometricAccuracyDSPS;
        data["elementsGeometricAccuracyDRS"] = this.elementsGeometricAccuracyDRS;
        data["elementsGeometricAccuracyDPS"] = this.elementsGeometricAccuracyDPS;
        data["isSZ"] = this.isSZ;
        data["szPostPrefixGroup"] = this.szPostPrefixGroup;
        data["szdsPrefix"] = this.szdsPrefix;
        data["szdsName"] = this.szdsName;
        data["isCCI"] = this.isCCI;
        data["cciUseForClassification"] = this.cciUseForClassification;
        data["cciRowWithName"] = this.cciRowWithName;
        data["cciStartRow"] = this.cciStartRow;
        data["cciBuildingComplex"] = this.cciBuildingComplex;
        data["cciConstructionEntities"] = this.cciConstructionEntities;
        data["cciBuiltUpSpaces"] = this.cciBuiltUpSpaces;
        data["cciFunctionalSystem"] = this.cciFunctionalSystem;
        data["cciTechnicalSystem"] = this.cciTechnicalSystem;
        data["cciComponents"] = this.cciComponents;
        data["cciPrefix"] = this.cciPrefix;
        data["cciName"] = this.cciName;
        data["importValuesToCCIRules"] = this.importValuesToCCIRules;
        data["isOperatorOR"] = this.isOperatorOR;
        if (Array.isArray(this.importDSSettingQualifyItems)) {
            data["importDSSettingQualifyItems"] = [];
            for (let item of this.importDSSettingQualifyItems)
                data["importDSSettingQualifyItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["prefix"] = this.prefix;
        data["replaceSpacesInTitleWith"] = this.replaceSpacesInTitleWith;
        data["importByPhase"] = this.importByPhase;
        data["levelOfProjectDocumentation"] = this.levelOfProjectDocumentation;
        data["isFlatExcelSettings"] = this.isFlatExcelSettings;
        return data;
    }
}

export interface IImportDSSettingDTO {
    id?: number;
    name?: string | undefined;
    propertiesNameOfSheet?: string | undefined;
    propertiesStartRow?: number | undefined;
    propertiesPropertyGroupName?: string | undefined;
    propertiesPropertyDesignation?: string | undefined;
    propertiesDataType?: string | undefined;
    propertiesUnitOfMeasure?: string | undefined;
    propertiesExampleOfValues?: string | undefined;
    propertiesPropertyDesignationIFC?: string | undefined;
    propertiesDefinedTypeIFC?: string | undefined;
    propertiesDUR?: string | undefined;
    propertiesDUSP?: string | undefined;
    propertiesDSP?: string | undefined;
    propertiesPDPS?: string | undefined;
    propertiesRDS?: string | undefined;
    propertiesDSPS?: string | undefined;
    propertiesDRS?: string | undefined;
    propertiesDPS?: string | undefined;
    isColor?: boolean;
    colorNameOfSheet?: string | undefined;
    colorStartRow?: number | undefined;
    colorR?: string | undefined;
    colorG?: string | undefined;
    colorB?: string | undefined;
    colorIndex?: string | undefined;
    colorElementIndex?: string | undefined;
    elementsStartRow?: number | undefined;
    elementsGroupsOfElements?: string | undefined;
    elementsTypeOfElement?: string | undefined;
    elementsDUR?: string | undefined;
    elementsDUSP?: string | undefined;
    elementsDSP?: string | undefined;
    elementsPDPS?: string | undefined;
    elementsRDS?: string | undefined;
    elementsDSPS?: string | undefined;
    elementsDRS?: string | undefined;
    elementsDPS?: string | undefined;
    elementsI?: string | undefined;
    elementsS?: string | undefined;
    elementsE?: string | undefined;
    elementsZ?: string | undefined;
    elementsM?: string | undefined;
    elementsU?: string | undefined;
    elementsF?: string | undefined;
    elementsGeometricAccuracyDUR?: string | undefined;
    elementsGeometricAccuracyDUSP?: string | undefined;
    elementsGeometricAccuracyDSP?: string | undefined;
    elementsGeometricAccuracyPDPS?: string | undefined;
    elementsGeometricAccuracyRDS?: string | undefined;
    elementsGeometricAccuracyDSPS?: string | undefined;
    elementsGeometricAccuracyDRS?: string | undefined;
    elementsGeometricAccuracyDPS?: string | undefined;
    isSZ?: boolean;
    szPostPrefixGroup?: string | undefined;
    szdsPrefix?: string | undefined;
    szdsName?: string | undefined;
    isCCI?: boolean;
    cciUseForClassification?: boolean;
    cciRowWithName?: number | undefined;
    cciStartRow?: number | undefined;
    cciBuildingComplex?: string | undefined;
    cciConstructionEntities?: string | undefined;
    cciBuiltUpSpaces?: string | undefined;
    cciFunctionalSystem?: string | undefined;
    cciTechnicalSystem?: string | undefined;
    cciComponents?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    importValuesToCCIRules?: boolean;
    isOperatorOR?: boolean;
    importDSSettingQualifyItems?: ImportDSSettingQualifyItemDTO[] | undefined;
    prefix?: string | undefined;
    replaceSpacesInTitleWith?: string | undefined;
    importByPhase?: boolean;
    levelOfProjectDocumentation?: DocumentationStage;
    isFlatExcelSettings?: boolean;
}

export class ImportDSSettingQualifyItemDTO implements IImportDSSettingQualifyItemDTO {
    id?: number;
    importDSSettingId?: number;
    value?: string | undefined;
    index?: number | undefined;
    column?: number | undefined;
    column2?: number | undefined;

    constructor(data?: IImportDSSettingQualifyItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.importDSSettingId = _data["importDSSettingId"];
            this.value = _data["value"];
            this.index = _data["index"];
            this.column = _data["column"];
            this.column2 = _data["column2"];
        }
    }

    static fromJS(data: any): ImportDSSettingQualifyItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDSSettingQualifyItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["importDSSettingId"] = this.importDSSettingId;
        data["value"] = this.value;
        data["index"] = this.index;
        data["column"] = this.column;
        data["column2"] = this.column2;
        return data;
    }
}

export interface IImportDSSettingQualifyItemDTO {
    id?: number;
    importDSSettingId?: number;
    value?: string | undefined;
    index?: number | undefined;
    column?: number | undefined;
    column2?: number | undefined;
}

export class ImportEnumDto implements IImportEnumDto {
    enum?: string | undefined;
    dataType?: string | undefined;
    category?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;

    constructor(data?: IImportEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enum = _data["enum"];
            this.dataType = _data["dataType"];
            this.category = _data["category"];
            this.value = _data["value"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ImportEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enum"] = this.enum;
        data["dataType"] = this.dataType;
        data["category"] = this.category;
        data["value"] = this.value;
        data["note"] = this.note;
        return data;
    }
}

export interface IImportEnumDto {
    enum?: string | undefined;
    dataType?: string | undefined;
    category?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;
}

export class ImportEnumsFromExcelRequest implements IImportEnumsFromExcelRequest {
    enums?: ImportEnumDto[] | undefined;

    constructor(data?: IImportEnumsFromExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enums"])) {
                this.enums = [] as any;
                for (let item of _data["enums"])
                    this.enums!.push(ImportEnumDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportEnumsFromExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnumsFromExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enums)) {
            data["enums"] = [];
            for (let item of this.enums)
                data["enums"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportEnumsFromExcelRequest {
    enums?: ImportEnumDto[] | undefined;
}

export class ImportEnumsFromExcelResponse implements IImportEnumsFromExcelResponse {

    constructor(data?: IImportEnumsFromExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportEnumsFromExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEnumsFromExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportEnumsFromExcelResponse {
}

export class ImportHospitalExcelRequest implements IImportHospitalExcelRequest {
    rows?: { [key: string]: any; }[] | undefined;

    constructor(data?: IImportHospitalExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportHospitalExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHospitalExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IImportHospitalExcelRequest {
    rows?: { [key: string]: any; }[] | undefined;
}

export class ImportHospitalExcelResponse implements IImportHospitalExcelResponse {
    standardId?: number;

    constructor(data?: IImportHospitalExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
        }
    }

    static fromJS(data: any): ImportHospitalExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHospitalExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        return data;
    }
}

export interface IImportHospitalExcelResponse {
    standardId?: number;
}

export class ImportChangeDTO implements IImportChangeDTO {
    type?: ImportChangeType;
    newValue?: string | undefined;
    oldValue?: string | undefined;

    constructor(data?: IImportChangeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.newValue = _data["newValue"];
            this.oldValue = _data["oldValue"];
        }
    }

    static fromJS(data: any): ImportChangeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportChangeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["newValue"] = this.newValue;
        data["oldValue"] = this.oldValue;
        return data;
    }
}

export interface IImportChangeDTO {
    type?: ImportChangeType;
    newValue?: string | undefined;
    oldValue?: string | undefined;
}

export class ImportChangesDTO implements IImportChangesDTO {
    name?: string | undefined;
    changes?: ImportChangeDTO[] | undefined;

    constructor(data?: IImportChangesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(ImportChangeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportChangesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ImportChangesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportChangesDTO {
    name?: string | undefined;
    changes?: ImportChangeDTO[] | undefined;
}

export enum ImportChangeType {
    Color = "Color",
    PrecisionDUR = "PrecisionDUR",
    PrecisionDSP = "PrecisionDSP",
    PrecisionPDPS = "PrecisionPDPS",
    PrecisionRDS = "PrecisionRDS",
    PrecisionDSPS = "PrecisionDSPS",
    PrecisionDUSP = "PrecisionDUSP",
    PrecisionDRS = "PrecisionDRS",
    PrecisionDPS = "PrecisionDPS",
    Filter = "Filter",
    UnitOfMeasure = "UnitOfMeasure",
    ExamplesOfValues = "ExamplesOfValues",
    PropertyIFC = "PropertyIFC",
    DefinedTypeIFC = "DefinedTypeIFC",
    IsCCI = "isCCI",
    DUR = "DUR",
    DSP = "DSP",
    PDPS = "PDPS",
    RDS = "RDS",
    DSPS = "DSPS",
    DUSP = "DUSP",
    DRS = "DRS",
    DPS = "DPS",
    Condition = "Condition",
}

export class ImportMStnFeederValuesRequest implements IImportMStnFeederValuesRequest {
    sourceMStnPairingId?: number;
    targetMStnPairingId?: number;
    targetPairerIds?: number[] | undefined;
    isImportValues?: boolean;
    isImportAutoValues?: boolean;
    autoValueTypes?: FeederAutoValueType[] | undefined;
    stringValueTypes?: FeederStringValueType[] | undefined;
    dateValueTypes?: FeederDateValueType[] | undefined;
    isImportOverwrite?: boolean;
    overwrite?: boolean;
    isFeatureDefinitions?: boolean;

    constructor(data?: IImportMStnFeederValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceMStnPairingId = _data["sourceMStnPairingId"];
            this.targetMStnPairingId = _data["targetMStnPairingId"];
            if (Array.isArray(_data["targetPairerIds"])) {
                this.targetPairerIds = [] as any;
                for (let item of _data["targetPairerIds"])
                    this.targetPairerIds!.push(item);
            }
            this.isImportValues = _data["isImportValues"];
            this.isImportAutoValues = _data["isImportAutoValues"];
            if (Array.isArray(_data["autoValueTypes"])) {
                this.autoValueTypes = [] as any;
                for (let item of _data["autoValueTypes"])
                    this.autoValueTypes!.push(item);
            }
            if (Array.isArray(_data["stringValueTypes"])) {
                this.stringValueTypes = [] as any;
                for (let item of _data["stringValueTypes"])
                    this.stringValueTypes!.push(item);
            }
            if (Array.isArray(_data["dateValueTypes"])) {
                this.dateValueTypes = [] as any;
                for (let item of _data["dateValueTypes"])
                    this.dateValueTypes!.push(item);
            }
            this.isImportOverwrite = _data["isImportOverwrite"];
            this.overwrite = _data["overwrite"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
        }
    }

    static fromJS(data: any): ImportMStnFeederValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMStnFeederValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceMStnPairingId"] = this.sourceMStnPairingId;
        data["targetMStnPairingId"] = this.targetMStnPairingId;
        if (Array.isArray(this.targetPairerIds)) {
            data["targetPairerIds"] = [];
            for (let item of this.targetPairerIds)
                data["targetPairerIds"].push(item);
        }
        data["isImportValues"] = this.isImportValues;
        data["isImportAutoValues"] = this.isImportAutoValues;
        if (Array.isArray(this.autoValueTypes)) {
            data["autoValueTypes"] = [];
            for (let item of this.autoValueTypes)
                data["autoValueTypes"].push(item);
        }
        if (Array.isArray(this.stringValueTypes)) {
            data["stringValueTypes"] = [];
            for (let item of this.stringValueTypes)
                data["stringValueTypes"].push(item);
        }
        if (Array.isArray(this.dateValueTypes)) {
            data["dateValueTypes"] = [];
            for (let item of this.dateValueTypes)
                data["dateValueTypes"].push(item);
        }
        data["isImportOverwrite"] = this.isImportOverwrite;
        data["overwrite"] = this.overwrite;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        return data;
    }
}

export interface IImportMStnFeederValuesRequest {
    sourceMStnPairingId?: number;
    targetMStnPairingId?: number;
    targetPairerIds?: number[] | undefined;
    isImportValues?: boolean;
    isImportAutoValues?: boolean;
    autoValueTypes?: FeederAutoValueType[] | undefined;
    stringValueTypes?: FeederStringValueType[] | undefined;
    dateValueTypes?: FeederDateValueType[] | undefined;
    isImportOverwrite?: boolean;
    overwrite?: boolean;
    isFeatureDefinitions?: boolean;
}

export class ImportMStnFeederValuesResponse implements IImportMStnFeederValuesResponse {
    ok?: boolean;

    constructor(data?: IImportMStnFeederValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportMStnFeederValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMStnFeederValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportMStnFeederValuesResponse {
    ok?: boolean;
}

export class ImportMultiCurvesNewRequest implements IImportMultiCurvesNewRequest {
    curves?: CurveDTO[] | undefined;
    projectId?: number;
    routeId?: number | undefined;
    toExisting?: boolean;
    replace?: boolean;
    routeName?: string | undefined;

    constructor(data?: IImportMultiCurvesNewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["curves"])) {
                this.curves = [] as any;
                for (let item of _data["curves"])
                    this.curves!.push(CurveDTO.fromJS(item));
            }
            this.projectId = _data["projectId"];
            this.routeId = _data["routeId"];
            this.toExisting = _data["toExisting"];
            this.replace = _data["replace"];
            this.routeName = _data["routeName"];
        }
    }

    static fromJS(data: any): ImportMultiCurvesNewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMultiCurvesNewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.curves)) {
            data["curves"] = [];
            for (let item of this.curves)
                data["curves"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectId"] = this.projectId;
        data["routeId"] = this.routeId;
        data["toExisting"] = this.toExisting;
        data["replace"] = this.replace;
        data["routeName"] = this.routeName;
        return data;
    }
}

export interface IImportMultiCurvesNewRequest {
    curves?: CurveDTO[] | undefined;
    projectId?: number;
    routeId?: number | undefined;
    toExisting?: boolean;
    replace?: boolean;
    routeName?: string | undefined;
}

export class ImportMultiCurvesNewResponse implements IImportMultiCurvesNewResponse {
    routeId?: number;

    constructor(data?: IImportMultiCurvesNewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeId = _data["routeId"];
        }
    }

    static fromJS(data: any): ImportMultiCurvesNewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMultiCurvesNewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeId"] = this.routeId;
        return data;
    }
}

export interface IImportMultiCurvesNewResponse {
    routeId?: number;
}

export class ImportOtskpResponse implements IImportOtskpResponse {
    pricingDatabaseId?: number;

    constructor(data?: IImportOtskpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricingDatabaseId = _data["pricingDatabaseId"];
        }
    }

    static fromJS(data: any): ImportOtskpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOtskpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricingDatabaseId"] = this.pricingDatabaseId;
        return data;
    }
}

export interface IImportOtskpResponse {
    pricingDatabaseId?: number;
}

export class ImportPairingRequest implements IImportPairingRequest {
    sourceMStnPairingId?: number;
    targetMStnPairingId?: number;
    overwrite?: boolean;
    targetLevels?: LevelMStnDTO[] | undefined;

    constructor(data?: IImportPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceMStnPairingId = _data["sourceMStnPairingId"];
            this.targetMStnPairingId = _data["targetMStnPairingId"];
            this.overwrite = _data["overwrite"];
            if (Array.isArray(_data["targetLevels"])) {
                this.targetLevels = [] as any;
                for (let item of _data["targetLevels"])
                    this.targetLevels!.push(LevelMStnDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceMStnPairingId"] = this.sourceMStnPairingId;
        data["targetMStnPairingId"] = this.targetMStnPairingId;
        data["overwrite"] = this.overwrite;
        if (Array.isArray(this.targetLevels)) {
            data["targetLevels"] = [];
            for (let item of this.targetLevels)
                data["targetLevels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportPairingRequest {
    sourceMStnPairingId?: number;
    targetMStnPairingId?: number;
    overwrite?: boolean;
    targetLevels?: LevelMStnDTO[] | undefined;
}

export class ImportPairingResponse implements IImportPairingResponse {
    ok?: boolean;

    constructor(data?: IImportPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportPairingResponse {
    ok?: boolean;
}

export class ImportPricingDatabaseStructureResponse implements IImportPricingDatabaseStructureResponse {
    success?: boolean;
    message?: string | undefined;
    cenovaSoustavaId?: number | undefined;

    constructor(data?: IImportPricingDatabaseStructureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.cenovaSoustavaId = _data["cenovaSoustavaId"];
        }
    }

    static fromJS(data: any): ImportPricingDatabaseStructureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportPricingDatabaseStructureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["cenovaSoustavaId"] = this.cenovaSoustavaId;
        return data;
    }
}

export interface IImportPricingDatabaseStructureResponse {
    success?: boolean;
    message?: string | undefined;
    cenovaSoustavaId?: number | undefined;
}

export class IndexStats implements IIndexStats {
    totalDocuments?: number;
    documentsForTenant?: number;
    lastIndexed?: Date | undefined;

    constructor(data?: IIndexStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDocuments = _data["totalDocuments"];
            this.documentsForTenant = _data["documentsForTenant"];
            this.lastIndexed = _data["lastIndexed"] ? new Date(_data["lastIndexed"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IndexStats {
        data = typeof data === 'object' ? data : {};
        let result = new IndexStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDocuments"] = this.totalDocuments;
        data["documentsForTenant"] = this.documentsForTenant;
        data["lastIndexed"] = this.lastIndexed ? this.lastIndexed.toISOString() : undefined as any;
        return data;
    }
}

export interface IIndexStats {
    totalDocuments?: number;
    documentsForTenant?: number;
    lastIndexed?: Date | undefined;
}

export class IndexSyncRequest implements IIndexSyncRequest {
    projectId?: number;
    modelId?: number | undefined;
    fullResync?: boolean;

    constructor(data?: IIndexSyncRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.fullResync = _data["fullResync"];
        }
    }

    static fromJS(data: any): IndexSyncRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IndexSyncRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["fullResync"] = this.fullResync;
        return data;
    }
}

export interface IIndexSyncRequest {
    projectId?: number;
    modelId?: number | undefined;
    fullResync?: boolean;
}

export enum IndexSyncState {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
    PartiallyCompleted = "PartiallyCompleted",
}

export class IndexSyncStatus implements IIndexSyncStatus {
    projectId?: number;
    modelId?: number | undefined;
    state?: IndexSyncState;
    totalElements?: number;
    processedElements?: number;
    failedElements?: number;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IIndexSyncStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.state = _data["state"];
            this.totalElements = _data["totalElements"];
            this.processedElements = _data["processedElements"];
            this.failedElements = _data["failedElements"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): IndexSyncStatus {
        data = typeof data === 'object' ? data : {};
        let result = new IndexSyncStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["state"] = this.state;
        data["totalElements"] = this.totalElements;
        data["processedElements"] = this.processedElements;
        data["failedElements"] = this.failedElements;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IIndexSyncStatus {
    projectId?: number;
    modelId?: number | undefined;
    state?: IndexSyncState;
    totalElements?: number;
    processedElements?: number;
    failedElements?: number;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    errorMessage?: string | undefined;
}

export class InsightAction implements IInsightAction {
    id?: string | undefined;
    type?: InsightActionType;
    label?: string | undefined;
    description?: string | undefined;
    parameters?: { [key: string]: any; } | undefined;

    constructor(data?: IInsightAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.label = _data["label"];
            this.description = _data["description"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (this.parameters as any)![key] = _data["parameters"][key];
                }
            }
        }
    }

    static fromJS(data: any): InsightAction {
        data = typeof data === 'object' ? data : {};
        let result = new InsightAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["label"] = this.label;
        data["description"] = this.description;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (data["parameters"] as any)[key] = (this.parameters as any)[key];
            }
        }
        return data;
    }
}

export interface IInsightAction {
    id?: string | undefined;
    type?: InsightActionType;
    label?: string | undefined;
    description?: string | undefined;
    parameters?: { [key: string]: any; } | undefined;
}

export enum InsightActionType {
    ViewElements = "ViewElements",
    Highlight3D = "Highlight3D",
    Compare = "Compare",
    DrillDown = "DrillDown",
    Export = "Export",
    Filter = "Filter",
    Calculate = "Calculate",
    CreateReport = "CreateReport",
    Share = "Share",
}

export enum InsightCategory {
    General = "General",
    MissingData = "MissingData",
    Classification = "Classification",
    Quantity = "Quantity",
    Quality = "Quality",
    Comparison = "Comparison",
    Cost = "Cost",
    Schedule = "Schedule",
    Compliance = "Compliance",
    Anomaly = "Anomaly",
}

export class InsightExplanation implements IInsightExplanation {
    summary?: string | undefined;
    steps?: ExplanationStep[] | undefined;
    dataSources?: string[] | undefined;
    executedPlan?: QueryPlan;
    statistics?: AnalysisStatistics;

    constructor(data?: IInsightExplanation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(ExplanationStep.fromJS(item));
            }
            if (Array.isArray(_data["dataSources"])) {
                this.dataSources = [] as any;
                for (let item of _data["dataSources"])
                    this.dataSources!.push(item);
            }
            this.executedPlan = _data["executedPlan"] ? QueryPlan.fromJS(_data["executedPlan"]) : undefined as any;
            this.statistics = _data["statistics"] ? AnalysisStatistics.fromJS(_data["statistics"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsightExplanation {
        data = typeof data === 'object' ? data : {};
        let result = new InsightExplanation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataSources)) {
            data["dataSources"] = [];
            for (let item of this.dataSources)
                data["dataSources"].push(item);
        }
        data["executedPlan"] = this.executedPlan ? this.executedPlan.toJSON() : undefined as any;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsightExplanation {
    summary?: string | undefined;
    steps?: ExplanationStep[] | undefined;
    dataSources?: string[] | undefined;
    executedPlan?: QueryPlan;
    statistics?: AnalysisStatistics;
}

export class InsightHistoryItem implements IInsightHistoryItem {
    insightId?: string | undefined;
    originalQuestion?: string | undefined;
    title?: string | undefined;
    category?: InsightCategory;
    severity?: InsightSeverity;
    createdAt?: Date;
    isBookmarked?: boolean;
    notes?: string | undefined;

    constructor(data?: IInsightHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insightId = _data["insightId"];
            this.originalQuestion = _data["originalQuestion"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.severity = _data["severity"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isBookmarked = _data["isBookmarked"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): InsightHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsightHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insightId"] = this.insightId;
        data["originalQuestion"] = this.originalQuestion;
        data["title"] = this.title;
        data["category"] = this.category;
        data["severity"] = this.severity;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isBookmarked"] = this.isBookmarked;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IInsightHistoryItem {
    insightId?: string | undefined;
    originalQuestion?: string | undefined;
    title?: string | undefined;
    category?: InsightCategory;
    severity?: InsightSeverity;
    createdAt?: Date;
    isBookmarked?: boolean;
    notes?: string | undefined;
}

export class InsightHistoryRequest implements IInsightHistoryRequest {
    projectId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    category?: InsightCategory;
    bookmarkedOnly?: boolean;
    page?: number;
    pageSize?: number;

    constructor(data?: IInsightHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.category = _data["category"];
            this.bookmarkedOnly = _data["bookmarkedOnly"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InsightHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsightHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["category"] = this.category;
        data["bookmarkedOnly"] = this.bookmarkedOnly;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IInsightHistoryRequest {
    projectId?: number;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    category?: InsightCategory;
    bookmarkedOnly?: boolean;
    page?: number;
    pageSize?: number;
}

export class InsightHistoryResponse implements IInsightHistoryResponse {
    items?: InsightHistoryItem[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IInsightHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InsightHistoryItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): InsightHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InsightHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IInsightHistoryResponse {
    items?: InsightHistoryItem[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export class InsightMetric implements IInsightMetric {
    label?: string | undefined;
    value?: number;
    unit?: string | undefined;
    trend?: string | undefined;
    previousValue?: number | undefined;

    constructor(data?: IInsightMetric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.trend = _data["trend"];
            this.previousValue = _data["previousValue"];
        }
    }

    static fromJS(data: any): InsightMetric {
        data = typeof data === 'object' ? data : {};
        let result = new InsightMetric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["trend"] = this.trend;
        data["previousValue"] = this.previousValue;
        return data;
    }
}

export interface IInsightMetric {
    label?: string | undefined;
    value?: number;
    unit?: string | undefined;
    trend?: string | undefined;
    previousValue?: number | undefined;
}

export enum InsightSeverity {
    Info = "Info",
    Warning = "Warning",
    Critical = "Critical",
}

export class InsightStatistics implements IInsightStatistics {
    totalCount?: number;
    uniqueTypesCount?: number;
    totalVolume?: number | undefined;
    totalArea?: number | undefined;
    mostCommonMaterial?: string | undefined;
    mostCommonElementType?: string | undefined;

    constructor(data?: IInsightStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.uniqueTypesCount = _data["uniqueTypesCount"];
            this.totalVolume = _data["totalVolume"];
            this.totalArea = _data["totalArea"];
            this.mostCommonMaterial = _data["mostCommonMaterial"];
            this.mostCommonElementType = _data["mostCommonElementType"];
        }
    }

    static fromJS(data: any): InsightStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new InsightStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["uniqueTypesCount"] = this.uniqueTypesCount;
        data["totalVolume"] = this.totalVolume;
        data["totalArea"] = this.totalArea;
        data["mostCommonMaterial"] = this.mostCommonMaterial;
        data["mostCommonElementType"] = this.mostCommonElementType;
        return data;
    }
}

export interface IInsightStatistics {
    totalCount?: number;
    uniqueTypesCount?: number;
    totalVolume?: number | undefined;
    totalArea?: number | undefined;
    mostCommonMaterial?: string | undefined;
    mostCommonElementType?: string | undefined;
}

export enum InvalidFieldReasons {
    InvalidFieldName = "InvalidFieldName",
    InvalidDataType = "InvalidDataType",
    InvalidNull = "InvalidNull",
    InvalidCondition = "InvalidCondition",
    InvalidField = "InvalidField",
}

export class ItemModelPropertiesData implements IItemModelPropertiesData {
    setName?: string | undefined;
    propertyName?: string | undefined;
    value?: string | undefined;

    constructor(data?: IItemModelPropertiesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setName = _data["setName"];
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ItemModelPropertiesData {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModelPropertiesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setName"] = this.setName;
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        return data;
    }
}

export interface IItemModelPropertiesData {
    setName?: string | undefined;
    propertyName?: string | undefined;
    value?: string | undefined;
}

export class LevelMStnDTO implements ILevelMStnDTO {
    levelName?: string | undefined;
    type?: number;

    constructor(data?: ILevelMStnDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LevelMStnDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LevelMStnDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface ILevelMStnDTO {
    levelName?: string | undefined;
    type?: number;
}

export class MeasuringUnitDto implements IMeasuringUnitDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IMeasuringUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MeasuringUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasuringUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface IMeasuringUnitDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    rowVersion?: Date;
}

export class MicrostationPairingDTO implements IMicrostationPairingDTO {
    id?: number;
    projectId?: number;
    dataStandardId?: number;
    name?: string | undefined;
    pairingName?: string | undefined;
    dataStandardName?: string | undefined;
    projectName?: string | undefined;
    isMultipleRoutes?: boolean;
    curveName?: string | undefined;
    startStationing?: number | undefined;
    filteredPairerGroupIds?: number[] | undefined;

    constructor(data?: IMicrostationPairingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.dataStandardId = _data["dataStandardId"];
            this.name = _data["name"];
            this.pairingName = _data["pairingName"];
            this.dataStandardName = _data["dataStandardName"];
            this.projectName = _data["projectName"];
            this.isMultipleRoutes = _data["isMultipleRoutes"];
            this.curveName = _data["curveName"];
            this.startStationing = _data["startStationing"];
            if (Array.isArray(_data["filteredPairerGroupIds"])) {
                this.filteredPairerGroupIds = [] as any;
                for (let item of _data["filteredPairerGroupIds"])
                    this.filteredPairerGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MicrostationPairingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MicrostationPairingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["dataStandardId"] = this.dataStandardId;
        data["name"] = this.name;
        data["pairingName"] = this.pairingName;
        data["dataStandardName"] = this.dataStandardName;
        data["projectName"] = this.projectName;
        data["isMultipleRoutes"] = this.isMultipleRoutes;
        data["curveName"] = this.curveName;
        data["startStationing"] = this.startStationing;
        if (Array.isArray(this.filteredPairerGroupIds)) {
            data["filteredPairerGroupIds"] = [];
            for (let item of this.filteredPairerGroupIds)
                data["filteredPairerGroupIds"].push(item);
        }
        return data;
    }
}

export interface IMicrostationPairingDTO {
    id?: number;
    projectId?: number;
    dataStandardId?: number;
    name?: string | undefined;
    pairingName?: string | undefined;
    dataStandardName?: string | undefined;
    projectName?: string | undefined;
    isMultipleRoutes?: boolean;
    curveName?: string | undefined;
    startStationing?: number | undefined;
    filteredPairerGroupIds?: number[] | undefined;
}

export class MicrostationPairingPairerDTO implements IMicrostationPairingPairerDTO {
    id?: number;
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;

    constructor(data?: IMicrostationPairingPairerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pairerId = _data["pairerId"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
            this.pairerName = _data["pairerName"];
            this.pairerGroupName = _data["pairerGroupName"];
        }
    }

    static fromJS(data: any): MicrostationPairingPairerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MicrostationPairingPairerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pairerId"] = this.pairerId;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        data["pairerName"] = this.pairerName;
        data["pairerGroupName"] = this.pairerGroupName;
        return data;
    }
}

export interface IMicrostationPairingPairerDTO {
    id?: number;
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
}

export class Model implements IModel {
    elements?: ModelData[] | undefined;
    modelId?: number;

    constructor(data?: IModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ModelData.fromJS(item));
            }
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): Model {
        data = typeof data === 'object' ? data : {};
        let result = new Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IModel {
    elements?: ModelData[] | undefined;
    modelId?: number;
}

export class ModelData implements IModelData {
    expressId?: number;
    ifcId?: string | undefined;
    propertySets?: PropertySet[] | undefined;

    constructor(data?: IModelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcId = _data["ifcId"];
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(PropertySet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcId"] = this.ifcId;
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModelData {
    expressId?: number;
    ifcId?: string | undefined;
    propertySets?: PropertySet[] | undefined;
}

export class ModelTreeDto implements IModelTreeDto {
    ifcTree?: string | undefined;
    modelName?: string | undefined;
    modelId?: number;

    constructor(data?: IModelTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ifcTree = _data["ifcTree"];
            this.modelName = _data["modelName"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): ModelTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifcTree"] = this.ifcTree;
        data["modelName"] = this.modelName;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IModelTreeDto {
    ifcTree?: string | undefined;
    modelName?: string | undefined;
    modelId?: number;
}

export class ModelUrisDto implements IModelUrisDto {
    modelId?: number;
    modelName?: string | undefined;
    modelUri?: string | undefined;

    constructor(data?: IModelUrisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): ModelUrisDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelUrisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IModelUrisDto {
    modelId?: number;
    modelName?: string | undefined;
    modelUri?: string | undefined;
}

export enum ModuleType {
    DataStandards = "DataStandards",
    BimValidator = "BimValidator",
    GpkValidator = "GpkValidator",
    SlopeGuard = "SlopeGuard",
    Enumerations = "Enumerations",
    Standalyzer = "Standalyzer",
    BimVitrina = "BimVitrina",
    Sumec = "Sumec",
    BimComplete = "BimComplete",
    ModelsAdministration = "ModelsAdministration",
    AiAsker = "AiAsker",
}

export class MStnElementDTO implements IMStnElementDTO {
    id?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;
    pairerLevel?: PairerLevelDTO;

    constructor(data?: IMStnElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alignmentName2 = _data["alignmentName2"];
            this.alignmentName3 = _data["alignmentName3"];
            this.pairerLevel = _data["pairerLevel"] ? PairerLevelDTO.fromJS(_data["pairerLevel"]) : undefined as any;
        }
    }

    static fromJS(data: any): MStnElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alignmentName2"] = this.alignmentName2;
        data["alignmentName3"] = this.alignmentName3;
        data["pairerLevel"] = this.pairerLevel ? this.pairerLevel.toJSON() : undefined as any;
        return data;
    }
}

export interface IMStnElementDTO {
    id?: string | undefined;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;
    pairerLevel?: PairerLevelDTO;
}

export class MStnFeederAddedElementStationingDTO implements IMStnFeederAddedElementStationingDTO {
    id?: number;
    pairerId?: number;
    elementId?: string | undefined;

    constructor(data?: IMStnFeederAddedElementStationingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pairerId = _data["pairerId"];
            this.elementId = _data["elementId"];
        }
    }

    static fromJS(data: any): MStnFeederAddedElementStationingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederAddedElementStationingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pairerId"] = this.pairerId;
        data["elementId"] = this.elementId;
        return data;
    }
}

export interface IMStnFeederAddedElementStationingDTO {
    id?: number;
    pairerId?: number;
    elementId?: string | undefined;
}

export class MStnFeederAddedItemsDTO implements IMStnFeederAddedItemsDTO {
    id?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleId?: number;

    constructor(data?: IMStnFeederAddedItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            this.validationRuleId = _data["validationRuleId"];
        }
    }

    static fromJS(data: any): MStnFeederAddedItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederAddedItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        data["validationRuleId"] = this.validationRuleId;
        return data;
    }
}

export interface IMStnFeederAddedItemsDTO {
    id?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    validationRuleId?: number;
}

export class MStnFeederAutoValueDTO implements IMStnFeederAutoValueDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    filterField?: string | undefined;
    dataType?: DataTypeValidation;
    autoValue?: string | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    curveElementId?: string | undefined;
    curveModelName?: string | undefined;
    curveModelFile?: string | undefined;
    validationRuleGUID?: string | undefined;

    constructor(data?: IMStnFeederAutoValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.validationRuleId = _data["validationRuleId"];
            this.filterField = _data["filterField"];
            this.dataType = _data["dataType"];
            this.autoValue = _data["autoValue"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.dateValueType = _data["dateValueType"];
            this.autoValueState = _data["autoValueState"];
            this.curveElementId = _data["curveElementId"];
            this.curveModelName = _data["curveModelName"];
            this.curveModelFile = _data["curveModelFile"];
            this.validationRuleGUID = _data["validationRuleGUID"];
        }
    }

    static fromJS(data: any): MStnFeederAutoValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederAutoValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["validationRuleId"] = this.validationRuleId;
        data["filterField"] = this.filterField;
        data["dataType"] = this.dataType;
        data["autoValue"] = this.autoValue;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["dateValueType"] = this.dateValueType;
        data["autoValueState"] = this.autoValueState;
        data["curveElementId"] = this.curveElementId;
        data["curveModelName"] = this.curveModelName;
        data["curveModelFile"] = this.curveModelFile;
        data["validationRuleGUID"] = this.validationRuleGUID;
        return data;
    }
}

export interface IMStnFeederAutoValueDTO {
    elementId?: string | undefined;
    validationRuleId?: number;
    filterField?: string | undefined;
    dataType?: DataTypeValidation;
    autoValue?: string | undefined;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    curveElementId?: string | undefined;
    curveModelName?: string | undefined;
    curveModelFile?: string | undefined;
    validationRuleGUID?: string | undefined;
}

export class MStnFeederFromDGNDTO implements IMStnFeederFromDGNDTO {
    isProjectValue?: boolean;
    elementId?: string | undefined;
    validationRuleId?: number;
    value?: string | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: IMStnFeederFromDGNDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isProjectValue = _data["isProjectValue"];
            this.elementId = _data["elementId"];
            this.validationRuleId = _data["validationRuleId"];
            this.value = _data["value"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): MStnFeederFromDGNDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederFromDGNDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isProjectValue"] = this.isProjectValue;
        data["elementId"] = this.elementId;
        data["validationRuleId"] = this.validationRuleId;
        data["value"] = this.value;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IMStnFeederFromDGNDTO {
    isProjectValue?: boolean;
    elementId?: string | undefined;
    validationRuleId?: number;
    value?: string | undefined;
    dataType?: DataTypeValidation;
}

export class MStnFeederItemDTO implements IMStnFeederItemDTO {
    id?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    curveName?: string | undefined;
    formulaString?: string | undefined;
    validationRule?: ValidationRuleFullTreeDTO;

    constructor(data?: IMStnFeederItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level = _data["level"];
            this.itemId = _data["itemId"];
            this.elementId = _data["elementId"];
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.dateValueType = _data["dateValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
            this.curveName = _data["curveName"];
            this.formulaString = _data["formulaString"];
            this.validationRule = _data["validationRule"] ? ValidationRuleFullTreeDTO.fromJS(_data["validationRule"]) : undefined as any;
        }
    }

    static fromJS(data: any): MStnFeederItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnFeederItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["itemId"] = this.itemId;
        data["elementId"] = this.elementId;
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["dateValueType"] = this.dateValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        data["curveName"] = this.curveName;
        data["formulaString"] = this.formulaString;
        data["validationRule"] = this.validationRule ? this.validationRule.toJSON() : undefined as any;
        return data;
    }
}

export interface IMStnFeederItemDTO {
    id?: number;
    level?: number;
    itemId?: number | undefined;
    elementId?: string | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    curveName?: string | undefined;
    formulaString?: string | undefined;
    validationRule?: ValidationRuleFullTreeDTO;
}

export class MStnPairingAssignDTO implements IMStnPairingAssignDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;

    constructor(data?: IMStnPairingAssignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MStnPairingAssignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingAssignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface IMStnPairingAssignDTO {
    pairerId?: number;
    levelName?: string | undefined;
    type?: number;
}

export class MStnPairingDTO implements IMStnPairingDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairer?: PairerFullTreeDTO;

    constructor(data?: IMStnPairingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
            this.pairer = _data["pairer"] ? PairerFullTreeDTO.fromJS(_data["pairer"]) : undefined as any;
        }
    }

    static fromJS(data: any): MStnPairingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        data["pairer"] = this.pairer ? this.pairer.toJSON() : undefined as any;
        return data;
    }
}

export interface IMStnPairingDTO {
    id?: number;
    levelName?: string | undefined;
    type?: number;
    pairer?: PairerFullTreeDTO;
}

export class MStnPairingRelevanceDTO implements IMStnPairingRelevanceDTO {
    levelNamePuv?: string | undefined;
    type?: number;
    items?: MStnPairingRelevanceItemsDTO[] | undefined;

    constructor(data?: IMStnPairingRelevanceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelNamePuv = _data["levelNamePuv"];
            this.type = _data["type"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MStnPairingRelevanceItemsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MStnPairingRelevanceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingRelevanceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelNamePuv"] = this.levelNamePuv;
        data["type"] = this.type;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMStnPairingRelevanceDTO {
    levelNamePuv?: string | undefined;
    type?: number;
    items?: MStnPairingRelevanceItemsDTO[] | undefined;
}

export class MStnPairingRelevanceItemsDTO implements IMStnPairingRelevanceItemsDTO {
    levelName?: string | undefined;
    pairerId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    relevance?: number;

    constructor(data?: IMStnPairingRelevanceItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelName = _data["levelName"];
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.pairerGroupName = _data["pairerGroupName"];
            this.relevance = _data["relevance"];
        }
    }

    static fromJS(data: any): MStnPairingRelevanceItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MStnPairingRelevanceItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelName"] = this.levelName;
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["pairerGroupName"] = this.pairerGroupName;
        data["relevance"] = this.relevance;
        return data;
    }
}

export interface IMStnPairingRelevanceItemsDTO {
    levelName?: string | undefined;
    pairerId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    relevance?: number;
}

export class MultiPairerRowDTO implements IMultiPairerRowDTO {
    code?: string | undefined;
    name?: string | undefined;
    state?: CollectionState;
    gridFilter?: GridFilterModel;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    id?: number;
    rowVersion?: string | undefined;
    ruleStringChanged?: boolean;

    constructor(data?: IMultiPairerRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.gridFilter = _data["gridFilter"] ? GridFilterModel.fromJS(_data["gridFilter"]) : undefined as any;
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.rowVersion = _data["rowVersion"];
            this.ruleStringChanged = _data["ruleStringChanged"];
        }
    }

    static fromJS(data: any): MultiPairerRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MultiPairerRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["state"] = this.state;
        data["gridFilter"] = this.gridFilter ? this.gridFilter.toJSON() : undefined as any;
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["rowVersion"] = this.rowVersion;
        data["ruleStringChanged"] = this.ruleStringChanged;
        return data;
    }
}

export interface IMultiPairerRowDTO {
    code?: string | undefined;
    name?: string | undefined;
    state?: CollectionState;
    gridFilter?: GridFilterModel;
    validationRules?: PairerDetailValidationRuleDTO[] | undefined;
    id?: number;
    rowVersion?: string | undefined;
    ruleStringChanged?: boolean;
}

export class NaturalLanguageSearchRequest implements INaturalLanguageSearchRequest {
    query?: string | undefined;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    topK?: number;
    sessionId?: string | undefined;
    contextElements?: ContextElement[] | undefined;
    previousResultSummary?: string | undefined;
    useExistingContext?: boolean | undefined;

    constructor(data?: INaturalLanguageSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.topK = _data["topK"];
            this.sessionId = _data["sessionId"];
            if (Array.isArray(_data["contextElements"])) {
                this.contextElements = [] as any;
                for (let item of _data["contextElements"])
                    this.contextElements!.push(ContextElement.fromJS(item));
            }
            this.previousResultSummary = _data["previousResultSummary"];
            this.useExistingContext = _data["useExistingContext"];
        }
    }

    static fromJS(data: any): NaturalLanguageSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalLanguageSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["topK"] = this.topK;
        data["sessionId"] = this.sessionId;
        if (Array.isArray(this.contextElements)) {
            data["contextElements"] = [];
            for (let item of this.contextElements)
                data["contextElements"].push(item ? item.toJSON() : undefined as any);
        }
        data["previousResultSummary"] = this.previousResultSummary;
        data["useExistingContext"] = this.useExistingContext;
        return data;
    }
}

export interface INaturalLanguageSearchRequest {
    query?: string | undefined;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    topK?: number;
    sessionId?: string | undefined;
    contextElements?: ContextElement[] | undefined;
    previousResultSummary?: string | undefined;
    useExistingContext?: boolean | undefined;
}

export class NaturalLanguageSearchResponse implements INaturalLanguageSearchResponse {
    query?: string | undefined;
    sessionId?: string | undefined;
    parsedQuery?: ParsedQueryResponse;
    detectedIntent?: DetectedIntentResponse;
    totalCount?: number;
    summary?: string | undefined;
    suggestions?: AISuggestion[] | undefined;
    suggestedQueries?: string[] | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    aggregation?: AggregationResponse;
    tableData?: TableDataResponse;
    insights?: DataInsightResponse;
    debugInfo?: string[] | undefined;

    constructor(data?: INaturalLanguageSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.sessionId = _data["sessionId"];
            this.parsedQuery = _data["parsedQuery"] ? ParsedQueryResponse.fromJS(_data["parsedQuery"]) : undefined as any;
            this.detectedIntent = _data["detectedIntent"] ? DetectedIntentResponse.fromJS(_data["detectedIntent"]) : undefined as any;
            this.totalCount = _data["totalCount"];
            this.summary = _data["summary"];
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(AISuggestion.fromJS(item));
            }
            if (Array.isArray(_data["suggestedQueries"])) {
                this.suggestedQueries = [] as any;
                for (let item of _data["suggestedQueries"])
                    this.suggestedQueries!.push(item);
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FlexibleSearchElementResponse.fromJS(item));
            }
            this.aggregation = _data["aggregation"] ? AggregationResponse.fromJS(_data["aggregation"]) : undefined as any;
            this.tableData = _data["tableData"] ? TableDataResponse.fromJS(_data["tableData"]) : undefined as any;
            this.insights = _data["insights"] ? DataInsightResponse.fromJS(_data["insights"]) : undefined as any;
            if (Array.isArray(_data["debugInfo"])) {
                this.debugInfo = [] as any;
                for (let item of _data["debugInfo"])
                    this.debugInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): NaturalLanguageSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalLanguageSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["sessionId"] = this.sessionId;
        data["parsedQuery"] = this.parsedQuery ? this.parsedQuery.toJSON() : undefined as any;
        data["detectedIntent"] = this.detectedIntent ? this.detectedIntent.toJSON() : undefined as any;
        data["totalCount"] = this.totalCount;
        data["summary"] = this.summary;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.suggestedQueries)) {
            data["suggestedQueries"] = [];
            for (let item of this.suggestedQueries)
                data["suggestedQueries"].push(item);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        data["aggregation"] = this.aggregation ? this.aggregation.toJSON() : undefined as any;
        data["tableData"] = this.tableData ? this.tableData.toJSON() : undefined as any;
        data["insights"] = this.insights ? this.insights.toJSON() : undefined as any;
        if (Array.isArray(this.debugInfo)) {
            data["debugInfo"] = [];
            for (let item of this.debugInfo)
                data["debugInfo"].push(item);
        }
        return data;
    }
}

export interface INaturalLanguageSearchResponse {
    query?: string | undefined;
    sessionId?: string | undefined;
    parsedQuery?: ParsedQueryResponse;
    detectedIntent?: DetectedIntentResponse;
    totalCount?: number;
    summary?: string | undefined;
    suggestions?: AISuggestion[] | undefined;
    suggestedQueries?: string[] | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    aggregation?: AggregationResponse;
    tableData?: TableDataResponse;
    insights?: DataInsightResponse;
    debugInfo?: string[] | undefined;
}

export class NumericComparisonRequest implements INumericComparisonRequest {
    operator?: string | undefined;
    value?: number;

    constructor(data?: INumericComparisonRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NumericComparisonRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumericComparisonRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["value"] = this.value;
        return data;
    }
}

export interface INumericComparisonRequest {
    operator?: string | undefined;
    value?: number;
}

export class OutputRowDTO implements IOutputRowDTO {
    order?: number | undefined;
    zp?: number | undefined;
    zo?: number | undefined;
    ko?: number | undefined;
    kp?: number | undefined;
    zO_ZP?: number | undefined;
    kO_KP?: number | undefined;
    r?: number | undefined;
    li?: number | undefined;
    d?: number | undefined;
    lvz1?: number | undefined;
    lvzm?: number | undefined;
    lvz2?: number | undefined;
    rowType?: RowType;
    v100?: number | undefined;
    v100max?: number | undefined;
    l100?: number | undefined;
    v100n1?: number | undefined;
    v100n2?: number | undefined;
    v130?: number | undefined;
    v130max?: number | undefined;
    l130?: number | undefined;
    v130n1?: number | undefined;
    v130n2?: number | undefined;
    vk?: number | undefined;
    vkmax?: number | undefined;
    lk?: number | undefined;
    vkn1?: number | undefined;
    vkn2?: number | undefined;
    v150?: number | undefined;
    v150max?: number | undefined;
    l150?: number | undefined;
    v150n1?: number | undefined;
    v150n2?: number | undefined;
    v150ni?: number | undefined;
    v150i?: number | undefined;
    v150deltai?: number | undefined;

    constructor(data?: IOutputRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.zp = _data["zp"];
            this.zo = _data["zo"];
            this.ko = _data["ko"];
            this.kp = _data["kp"];
            this.zO_ZP = _data["zO_ZP"];
            this.kO_KP = _data["kO_KP"];
            this.r = _data["r"];
            this.li = _data["li"];
            this.d = _data["d"];
            this.lvz1 = _data["lvz1"];
            this.lvzm = _data["lvzm"];
            this.lvz2 = _data["lvz2"];
            this.rowType = _data["rowType"];
            this.v100 = _data["v100"];
            this.v100max = _data["v100max"];
            this.l100 = _data["l100"];
            this.v100n1 = _data["v100n1"];
            this.v100n2 = _data["v100n2"];
            this.v130 = _data["v130"];
            this.v130max = _data["v130max"];
            this.l130 = _data["l130"];
            this.v130n1 = _data["v130n1"];
            this.v130n2 = _data["v130n2"];
            this.vk = _data["vk"];
            this.vkmax = _data["vkmax"];
            this.lk = _data["lk"];
            this.vkn1 = _data["vkn1"];
            this.vkn2 = _data["vkn2"];
            this.v150 = _data["v150"];
            this.v150max = _data["v150max"];
            this.l150 = _data["l150"];
            this.v150n1 = _data["v150n1"];
            this.v150n2 = _data["v150n2"];
            this.v150ni = _data["v150ni"];
            this.v150i = _data["v150i"];
            this.v150deltai = _data["v150deltai"];
        }
    }

    static fromJS(data: any): OutputRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutputRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["zp"] = this.zp;
        data["zo"] = this.zo;
        data["ko"] = this.ko;
        data["kp"] = this.kp;
        data["zO_ZP"] = this.zO_ZP;
        data["kO_KP"] = this.kO_KP;
        data["r"] = this.r;
        data["li"] = this.li;
        data["d"] = this.d;
        data["lvz1"] = this.lvz1;
        data["lvzm"] = this.lvzm;
        data["lvz2"] = this.lvz2;
        data["rowType"] = this.rowType;
        data["v100"] = this.v100;
        data["v100max"] = this.v100max;
        data["l100"] = this.l100;
        data["v100n1"] = this.v100n1;
        data["v100n2"] = this.v100n2;
        data["v130"] = this.v130;
        data["v130max"] = this.v130max;
        data["l130"] = this.l130;
        data["v130n1"] = this.v130n1;
        data["v130n2"] = this.v130n2;
        data["vk"] = this.vk;
        data["vkmax"] = this.vkmax;
        data["lk"] = this.lk;
        data["vkn1"] = this.vkn1;
        data["vkn2"] = this.vkn2;
        data["v150"] = this.v150;
        data["v150max"] = this.v150max;
        data["l150"] = this.l150;
        data["v150n1"] = this.v150n1;
        data["v150n2"] = this.v150n2;
        data["v150ni"] = this.v150ni;
        data["v150i"] = this.v150i;
        data["v150deltai"] = this.v150deltai;
        return data;
    }
}

export interface IOutputRowDTO {
    order?: number | undefined;
    zp?: number | undefined;
    zo?: number | undefined;
    ko?: number | undefined;
    kp?: number | undefined;
    zO_ZP?: number | undefined;
    kO_KP?: number | undefined;
    r?: number | undefined;
    li?: number | undefined;
    d?: number | undefined;
    lvz1?: number | undefined;
    lvzm?: number | undefined;
    lvz2?: number | undefined;
    rowType?: RowType;
    v100?: number | undefined;
    v100max?: number | undefined;
    l100?: number | undefined;
    v100n1?: number | undefined;
    v100n2?: number | undefined;
    v130?: number | undefined;
    v130max?: number | undefined;
    l130?: number | undefined;
    v130n1?: number | undefined;
    v130n2?: number | undefined;
    vk?: number | undefined;
    vkmax?: number | undefined;
    lk?: number | undefined;
    vkn1?: number | undefined;
    vkn2?: number | undefined;
    v150?: number | undefined;
    v150max?: number | undefined;
    l150?: number | undefined;
    v150n1?: number | undefined;
    v150n2?: number | undefined;
    v150ni?: number | undefined;
    v150i?: number | undefined;
    v150deltai?: number | undefined;
}

export class PairerBudgetMatch implements IPairerBudgetMatch {
    pairerId?: number;
    pairerName?: string | undefined;
    groupName?: string | undefined;
    filter?: string | undefined;
    budgetRules?: BudgetRuleMatch[] | undefined;
    isSelected?: boolean;
    color?: string | undefined;

    constructor(data?: IPairerBudgetMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.groupName = _data["groupName"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["budgetRules"])) {
                this.budgetRules = [] as any;
                for (let item of _data["budgetRules"])
                    this.budgetRules!.push(BudgetRuleMatch.fromJS(item));
            }
            this.isSelected = _data["isSelected"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): PairerBudgetMatch {
        data = typeof data === 'object' ? data : {};
        let result = new PairerBudgetMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["groupName"] = this.groupName;
        data["filter"] = this.filter;
        if (Array.isArray(this.budgetRules)) {
            data["budgetRules"] = [];
            for (let item of this.budgetRules)
                data["budgetRules"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSelected"] = this.isSelected;
        data["color"] = this.color;
        return data;
    }
}

export interface IPairerBudgetMatch {
    pairerId?: number;
    pairerName?: string | undefined;
    groupName?: string | undefined;
    filter?: string | undefined;
    budgetRules?: BudgetRuleMatch[] | undefined;
    isSelected?: boolean;
    color?: string | undefined;
}

export class PairerDetailValidationRuleDTO implements IPairerDetailValidationRuleDTO {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    rowVersion?: string | undefined;
    isNullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupIndex?: number | undefined;
    serializedString?: string | undefined;
    hasCondition?: boolean;
    condition?: string | undefined;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    attributeNumber?: number | undefined;
    attributeName?: string | undefined;
    postPrefixGroup?: string | undefined;
    isDsStandard?: boolean;
    expression?: string | undefined;
    expressionOpenX?: string | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;

    constructor(data?: IPairerDetailValidationRuleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.examplesOfValues = _data["examplesOfValues"];
            this.propertyIFC = _data["propertyIFC"];
            this.definedTypeIFC = _data["definedTypeIFC"];
            this.classIFC = _data["classIFC"];
            this.predefinedTypeIFC = _data["predefinedTypeIFC"];
            this.attributeIFC = _data["attributeIFC"];
            this.rowVersion = _data["rowVersion"];
            this.isNullable = _data["isNullable"];
            this.dataType = _data["dataType"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.groupIndex = _data["groupIndex"];
            this.serializedString = _data["serializedString"];
            this.hasCondition = _data["hasCondition"];
            this.condition = _data["condition"];
            this.isCCI = _data["isCCI"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.attributeNumber = _data["attributeNumber"];
            this.attributeName = _data["attributeName"];
            this.postPrefixGroup = _data["postPrefixGroup"];
            this.isDsStandard = _data["isDsStandard"];
            this.expression = _data["expression"];
            this.expressionOpenX = _data["expressionOpenX"];
            this.validateDecimalPlaces = _data["validateDecimalPlaces"];
            this.description = _data["description"];
            this.dur = _data["dur"];
            this.dsp = _data["dsp"];
            this.pdps = _data["pdps"];
            this.rds = _data["rds"];
            this.dsps = _data["dsps"];
            this.dusp = _data["dusp"];
            this.drs = _data["drs"];
            this.dps = _data["dps"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : undefined as any;
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerDetailValidationRuleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerDetailValidationRuleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["examplesOfValues"] = this.examplesOfValues;
        data["propertyIFC"] = this.propertyIFC;
        data["definedTypeIFC"] = this.definedTypeIFC;
        data["classIFC"] = this.classIFC;
        data["predefinedTypeIFC"] = this.predefinedTypeIFC;
        data["attributeIFC"] = this.attributeIFC;
        data["rowVersion"] = this.rowVersion;
        data["isNullable"] = this.isNullable;
        data["dataType"] = this.dataType;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["groupIndex"] = this.groupIndex;
        data["serializedString"] = this.serializedString;
        data["hasCondition"] = this.hasCondition;
        data["condition"] = this.condition;
        data["isCCI"] = this.isCCI;
        data["decimalPlaces"] = this.decimalPlaces;
        data["attributeNumber"] = this.attributeNumber;
        data["attributeName"] = this.attributeName;
        data["postPrefixGroup"] = this.postPrefixGroup;
        data["isDsStandard"] = this.isDsStandard;
        data["expression"] = this.expression;
        data["expressionOpenX"] = this.expressionOpenX;
        data["validateDecimalPlaces"] = this.validateDecimalPlaces;
        data["description"] = this.description;
        data["dur"] = this.dur;
        data["dsp"] = this.dsp;
        data["pdps"] = this.pdps;
        data["rds"] = this.rds;
        data["dsps"] = this.dsps;
        data["dusp"] = this.dusp;
        data["drs"] = this.drs;
        data["dps"] = this.dps;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : undefined as any;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerDetailValidationRuleDTO {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    rowVersion?: string | undefined;
    isNullable?: boolean;
    dataType?: DataTypeValidation;
    groupId?: number | undefined;
    groupName?: string | undefined;
    groupIndex?: number | undefined;
    serializedString?: string | undefined;
    hasCondition?: boolean;
    condition?: string | undefined;
    isCCI?: boolean;
    decimalPlaces?: number | undefined;
    attributeNumber?: number | undefined;
    attributeName?: string | undefined;
    postPrefixGroup?: string | undefined;
    isDsStandard?: boolean;
    expression?: string | undefined;
    expressionOpenX?: string | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
}

export class PairerDTO implements IPairerDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;

    constructor(data?: IPairerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PairerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IPairerDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;
}

export class PairerFullDTO implements IPairerFullDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    levels?: PairerLevelDTO[] | undefined;
    elementTypes?: ElementTypeDTO[] | undefined;
    elements?: MStnElementDTO[] | undefined;

    constructor(data?: IPairerFullDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            if (Array.isArray(_data["levels"])) {
                this.levels = [] as any;
                for (let item of _data["levels"])
                    this.levels!.push(PairerLevelDTO.fromJS(item));
            }
            if (Array.isArray(_data["elementTypes"])) {
                this.elementTypes = [] as any;
                for (let item of _data["elementTypes"])
                    this.elementTypes!.push(ElementTypeDTO.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MStnElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerFullDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerFullDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elementTypes)) {
            data["elementTypes"] = [];
            for (let item of this.elementTypes)
                data["elementTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerFullDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    levels?: PairerLevelDTO[] | undefined;
    elementTypes?: ElementTypeDTO[] | undefined;
    elements?: MStnElementDTO[] | undefined;
}

export class PairerFullTreeDTO implements IPairerFullTreeDTO {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;

    constructor(data?: IPairerFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(ValidationRuleFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerFullTreeDTO {
    id?: number;
    name?: string | undefined;
    groupName?: string | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;
}

export class PairerGroupDTO implements IPairerGroupDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;
    color?: string | undefined;
    profession?: string | undefined;

    constructor(data?: IPairerGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            this.rowVersion = _data["rowVersion"];
            this.standardId = _data["standardId"];
            this.color = _data["color"];
            this.profession = _data["profession"];
        }
    }

    static fromJS(data: any): PairerGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        data["rowVersion"] = this.rowVersion;
        data["standardId"] = this.standardId;
        data["color"] = this.color;
        data["profession"] = this.profession;
        return data;
    }
}

export interface IPairerGroupDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;
    color?: string | undefined;
    profession?: string | undefined;
}

export class PairerGroupFullDTO implements IPairerGroupFullDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    standardId?: number;
    pairers?: PairerFullDTO[] | undefined;

    constructor(data?: IPairerGroupFullDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            this.standardId = _data["standardId"];
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerFullDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerGroupFullDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupFullDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        data["standardId"] = this.standardId;
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerGroupFullDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    standardId?: number;
    pairers?: PairerFullDTO[] | undefined;
}

export class PairerGroupFullTreeDTO implements IPairerGroupFullTreeDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    pairers?: PairerFullTreeDTO[] | undefined;

    constructor(data?: IPairerGroupFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerGroupFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerGroupFullTreeDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    pairers?: PairerFullTreeDTO[] | undefined;
}

export class PairerGroupWithPairerNamesDTO implements IPairerGroupWithPairerNamesDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;
    color?: string | undefined;
    profession?: string | undefined;
    pairerNames?: string[] | undefined;

    constructor(data?: IPairerGroupWithPairerNamesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameGroup = _data["nameGroup"];
            this.rowVersion = _data["rowVersion"];
            this.standardId = _data["standardId"];
            this.color = _data["color"];
            this.profession = _data["profession"];
            if (Array.isArray(_data["pairerNames"])) {
                this.pairerNames = [] as any;
                for (let item of _data["pairerNames"])
                    this.pairerNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PairerGroupWithPairerNamesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerGroupWithPairerNamesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameGroup"] = this.nameGroup;
        data["rowVersion"] = this.rowVersion;
        data["standardId"] = this.standardId;
        data["color"] = this.color;
        data["profession"] = this.profession;
        if (Array.isArray(this.pairerNames)) {
            data["pairerNames"] = [];
            for (let item of this.pairerNames)
                data["pairerNames"].push(item);
        }
        return data;
    }
}

export interface IPairerGroupWithPairerNamesDTO {
    id?: number;
    name?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    standardId?: number;
    color?: string | undefined;
    profession?: string | undefined;
    pairerNames?: string[] | undefined;
}

export class PairerLevelDTO implements IPairerLevelDTO {
    pairerId?: number;
    pairerGroupName?: string | undefined;
    pairerGroupNameGroup?: string | undefined;
    pairerName?: string | undefined;
    levelName?: string | undefined;
    type?: number;

    constructor(data?: IPairerLevelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerGroupName = _data["pairerGroupName"];
            this.pairerGroupNameGroup = _data["pairerGroupNameGroup"];
            this.pairerName = _data["pairerName"];
            this.levelName = _data["levelName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PairerLevelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerLevelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerGroupName"] = this.pairerGroupName;
        data["pairerGroupNameGroup"] = this.pairerGroupNameGroup;
        data["pairerName"] = this.pairerName;
        data["levelName"] = this.levelName;
        data["type"] = this.type;
        return data;
    }
}

export interface IPairerLevelDTO {
    pairerId?: number;
    pairerGroupName?: string | undefined;
    pairerGroupNameGroup?: string | undefined;
    pairerName?: string | undefined;
    levelName?: string | undefined;
    type?: number;
}

export class PairerValRulesDTO implements IPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filterItems?: FilterItem[] | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;

    constructor(data?: IPairerValRulesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerGroupId = _data["pairerGroupId"];
            this.pairerName = _data["pairerName"];
            this.pairerGroupName = _data["pairerGroupName"];
            this.colorR = _data["colorR"];
            this.colorG = _data["colorG"];
            this.colorB = _data["colorB"];
            this.precisionDUR = _data["precisionDUR"];
            this.precisionDSP = _data["precisionDSP"];
            this.precisionPDPS = _data["precisionPDPS"];
            this.precisionRDS = _data["precisionRDS"];
            this.precisionDSPS = _data["precisionDSPS"];
            this.precisionDUSP = _data["precisionDUSP"];
            this.precisionDRS = _data["precisionDRS"];
            this.precisionDPS = _data["precisionDPS"];
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["validationRules"])) {
                this.validationRules = [] as any;
                for (let item of _data["validationRules"])
                    this.validationRules!.push(ValidationRuleFullTreeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PairerValRulesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PairerValRulesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerGroupId"] = this.pairerGroupId;
        data["pairerName"] = this.pairerName;
        data["pairerGroupName"] = this.pairerGroupName;
        data["colorR"] = this.colorR;
        data["colorG"] = this.colorG;
        data["colorB"] = this.colorB;
        data["precisionDUR"] = this.precisionDUR;
        data["precisionDSP"] = this.precisionDSP;
        data["precisionPDPS"] = this.precisionPDPS;
        data["precisionRDS"] = this.precisionRDS;
        data["precisionDSPS"] = this.precisionDSPS;
        data["precisionDUSP"] = this.precisionDUSP;
        data["precisionDRS"] = this.precisionDRS;
        data["precisionDPS"] = this.precisionDPS;
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.validationRules)) {
            data["validationRules"] = [];
            for (let item of this.validationRules)
                data["validationRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPairerValRulesDTO {
    pairerId?: number;
    pairerGroupId?: number;
    pairerName?: string | undefined;
    pairerGroupName?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filterItems?: FilterItem[] | undefined;
    validationRules?: ValidationRuleFullTreeDTO[] | undefined;
}

export class ParsedQueryResponse implements IParsedQueryResponse {
    intent?: string | undefined;
    searchTerms?: string[] | undefined;
    explanation?: string | undefined;
    confidence?: number;

    constructor(data?: IParsedQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.intent = _data["intent"];
            if (Array.isArray(_data["searchTerms"])) {
                this.searchTerms = [] as any;
                for (let item of _data["searchTerms"])
                    this.searchTerms!.push(item);
            }
            this.explanation = _data["explanation"];
            this.confidence = _data["confidence"];
        }
    }

    static fromJS(data: any): ParsedQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParsedQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intent"] = this.intent;
        if (Array.isArray(this.searchTerms)) {
            data["searchTerms"] = [];
            for (let item of this.searchTerms)
                data["searchTerms"].push(item);
        }
        data["explanation"] = this.explanation;
        data["confidence"] = this.confidence;
        return data;
    }
}

export interface IParsedQueryResponse {
    intent?: string | undefined;
    searchTerms?: string[] | undefined;
    explanation?: string | undefined;
    confidence?: number;
}

export class PermissionDTO implements IPermissionDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    granted?: boolean;

    constructor(data?: IPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.permissionType = _data["permissionType"];
            this.moduleType = _data["moduleType"];
            this.granted = _data["granted"];
        }
    }

    static fromJS(data: any): PermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["permissionType"] = this.permissionType;
        data["moduleType"] = this.moduleType;
        data["granted"] = this.granted;
        return data;
    }
}

export interface IPermissionDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    granted?: boolean;
}

export enum PermissionType {
    CreateDataStandard = "CreateDataStandard",
    DeleteForeignDataStandard = "DeleteForeignDataStandard",
    EditForeignDataStandard = "EditForeignDataStandard",
    AddIsoStandard = "AddIsoStandard",
    RunStandardUpdate = "RunStandardUpdate",
    ImportIsoStandardsExcel = "ImportIsoStandardsExcel",
    EditIsoStandard = "EditIsoStandard",
    DeleteIsoStandard = "DeleteIsoStandard",
    CreateMappingBimComplete = "CreateMappingBimComplete",
    EditMappingBimComplete = "EditMappingBimComplete",
    DeleteMappingBimComplete = "DeleteMappingBimComplete",
    ImportStandardBimComplete = "ImportStandardBimComplete",
    AddPropertiesBimComplete = "AddPropertiesBimComplete",
    CreateRouteBimComplete = "CreateRouteBimComplete",
    EditRouteBimComplete = "EditRouteBimComplete",
    DeleteRouteBimComplete = "DeleteRouteBimComplete",
    UpdateElementFromProjectBimComplete = "UpdateElementFromProjectBimComplete",
    DeleteElementPropertiesBimComplete = "DeleteElementPropertiesBimComplete",
    ImportExcelBimComplete = "ImportExcelBimComplete",
    CreateEnumaration = "CreateEnumaration",
    UpdateEnumaration = "UpdateEnumaration",
    DeleteEnumaration = "DeleteEnumaration",
    ImportExcelEnumaration = "ImportExcelEnumaration",
    ExportStandardsExcel = "ExportStandardsExcel",
    DeleteModelsAdministration = "DeleteModelsAdministration",
    DownloadModelsAdministration = "DownloadModelsAdministration",
    ShareDataStandards = "ShareDataStandards",
    CopySharedDataStandards = "CopySharedDataStandards",
}

export class Point3dServer implements IPoint3dServer {
    x?: number;
    y?: number;
    z?: number;

    constructor(data?: IPoint3dServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
            this.z = _data["z"];
        }
    }

    static fromJS(data: any): Point3dServer {
        data = typeof data === 'object' ? data : {};
        let result = new Point3dServer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        data["z"] = this.z;
        return data;
    }
}

export interface IPoint3dServer {
    x?: number;
    y?: number;
    z?: number;
}

export class PricingDatabaseDto implements IPricingDatabaseDto {
    id?: number;
    name?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IPricingDatabaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PricingDatabaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDatabaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface IPricingDatabaseDto {
    id?: number;
    name?: string | undefined;
    rowVersion?: Date;
}

export class PricingDatabaseItemDto implements IPricingDatabaseItemDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    price?: number;
    technicalSpecification?: string | undefined;
    measuringUnit?: string | undefined;
    measuringUnitId?: number | undefined;

    constructor(data?: IPricingDatabaseItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.technicalSpecification = _data["technicalSpecification"];
            this.measuringUnit = _data["measuringUnit"];
            this.measuringUnitId = _data["measuringUnitId"];
        }
    }

    static fromJS(data: any): PricingDatabaseItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDatabaseItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["price"] = this.price;
        data["technicalSpecification"] = this.technicalSpecification;
        data["measuringUnit"] = this.measuringUnit;
        data["measuringUnitId"] = this.measuringUnitId;
        return data;
    }
}

export interface IPricingDatabaseItemDto {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    price?: number;
    technicalSpecification?: string | undefined;
    measuringUnit?: string | undefined;
    measuringUnitId?: number | undefined;
}

export class PricingDatabaseItemDtoPaginableResult implements IPricingDatabaseItemDtoPaginableResult {
    items?: PricingDatabaseItemDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPricingDatabaseItemDtoPaginableResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricingDatabaseItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PricingDatabaseItemDtoPaginableResult {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDatabaseItemDtoPaginableResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPricingDatabaseItemDtoPaginableResult {
    items?: PricingDatabaseItemDto[] | undefined;
    totalCount?: number;
}

export class PricingDatabaseStructureTreeNode implements IPricingDatabaseStructureTreeNode {
    id?: number;
    znacka?: string | undefined;
    nazev?: string | undefined;
    children?: PricingDatabaseStructureTreeNode[] | undefined;
    hasChildren?: boolean;

    constructor(data?: IPricingDatabaseStructureTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.znacka = _data["znacka"];
            this.nazev = _data["nazev"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(PricingDatabaseStructureTreeNode.fromJS(item));
            }
            this.hasChildren = _data["hasChildren"];
        }
    }

    static fromJS(data: any): PricingDatabaseStructureTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDatabaseStructureTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["znacka"] = this.znacka;
        data["nazev"] = this.nazev;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasChildren"] = this.hasChildren;
        return data;
    }
}

export interface IPricingDatabaseStructureTreeNode {
    id?: number;
    znacka?: string | undefined;
    nazev?: string | undefined;
    children?: PricingDatabaseStructureTreeNode[] | undefined;
    hasChildren?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProjectDataDTO implements IProjectDataDTO {
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
    projectType?: ProjectType;

    constructor(data?: IProjectDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.projectManager = _data["projectManager"];
            this.authorizedPersons = _data["authorizedPersons"];
            this.otherFeatures = _data["otherFeatures"];
            this.projectType = _data["projectType"];
        }
    }

    static fromJS(data: any): ProjectDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["projectManager"] = this.projectManager;
        data["authorizedPersons"] = this.authorizedPersons;
        data["otherFeatures"] = this.otherFeatures;
        data["projectType"] = this.projectType;
        return data;
    }
}

export interface IProjectDataDTO {
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
    projectType?: ProjectType;
}

export class ProjectDTO implements IProjectDTO {
    id?: number;
    name?: string | undefined;
    type?: ProjectType;
    customImageUri?: string | undefined;
    showInBimCabinet?: boolean;

    constructor(data?: IProjectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.customImageUri = _data["customImageUri"];
            this.showInBimCabinet = _data["showInBimCabinet"];
        }
    }

    static fromJS(data: any): ProjectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["customImageUri"] = this.customImageUri;
        data["showInBimCabinet"] = this.showInBimCabinet;
        return data;
    }
}

export interface IProjectDTO {
    id?: number;
    name?: string | undefined;
    type?: ProjectType;
    customImageUri?: string | undefined;
    showInBimCabinet?: boolean;
}

export class ProjectForCabinetDto implements IProjectForCabinetDto {
    id?: number;
    name?: string | undefined;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    blobFileId?: string | undefined;
    tenantName?: string | undefined;
    description?: string | undefined;
    dateTime?: Date;
    type?: ProjectType;

    constructor(data?: IProjectForCabinetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customImageUri = _data["customImageUri"];
            this.drawer = _data["drawer"];
            this.investor = _data["investor"];
            this.stage = _data["stage"];
            this.drawingSoftware = _data["drawingSoftware"];
            this.cde = _data["cde"];
            this.blobFileId = _data["blobFileId"];
            this.tenantName = _data["tenantName"];
            this.description = _data["description"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : undefined as any;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ProjectForCabinetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectForCabinetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customImageUri"] = this.customImageUri;
        data["drawer"] = this.drawer;
        data["investor"] = this.investor;
        data["stage"] = this.stage;
        data["drawingSoftware"] = this.drawingSoftware;
        data["cde"] = this.cde;
        data["blobFileId"] = this.blobFileId;
        data["tenantName"] = this.tenantName;
        data["description"] = this.description;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["type"] = this.type;
        return data;
    }
}

export interface IProjectForCabinetDto {
    id?: number;
    name?: string | undefined;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    blobFileId?: string | undefined;
    tenantName?: string | undefined;
    description?: string | undefined;
    dateTime?: Date;
    type?: ProjectType;
}

export enum ProjectType {
    None = "None",
    Road = "Road",
    Railway = "Railway",
    RoadBridge = "RoadBridge",
    RailwayBridge = "RailwayBridge",
}

export class Property implements IProperty {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IProperty {
    name?: string | undefined;
    value?: string | undefined;
}

export class PropertyAggregationResultResponse implements IPropertyAggregationResultResponse {
    propertySet?: string | undefined;
    propertyName?: string | undefined;
    value?: number;
    unit?: string | undefined;
    count?: number;

    constructor(data?: IPropertyAggregationResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySet = _data["propertySet"];
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PropertyAggregationResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAggregationResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySet"] = this.propertySet;
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["count"] = this.count;
        return data;
    }
}

export interface IPropertyAggregationResultResponse {
    propertySet?: string | undefined;
    propertyName?: string | undefined;
    value?: number;
    unit?: string | undefined;
    count?: number;
}

export class PropertyDiff implements IPropertyDiff {
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IPropertyDiff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PropertyDiff {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDiff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPropertyDiff {
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class PropertyDto implements IPropertyDto {
    id?: number;
    data?: DataPropertyDto;

    constructor(data?: IPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"] ? DataPropertyDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IPropertyDto {
    id?: number;
    data?: DataPropertyDto;
}

export class PropertyFilterRequest implements IPropertyFilterRequest {
    propertySet?: string | undefined;
    propertyName?: string | undefined;
    value?: string | undefined;
    values?: string[] | undefined;
    matchType?: string | undefined;
    numericComparison?: NumericComparisonRequest;

    constructor(data?: IPropertyFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySet = _data["propertySet"];
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.matchType = _data["matchType"];
            this.numericComparison = _data["numericComparison"] ? NumericComparisonRequest.fromJS(_data["numericComparison"]) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySet"] = this.propertySet;
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["matchType"] = this.matchType;
        data["numericComparison"] = this.numericComparison ? this.numericComparison.toJSON() : undefined as any;
        return data;
    }
}

export interface IPropertyFilterRequest {
    propertySet?: string | undefined;
    propertyName?: string | undefined;
    value?: string | undefined;
    values?: string[] | undefined;
    matchType?: string | undefined;
    numericComparison?: NumericComparisonRequest;
}

export class PropertyFormulaDto implements IPropertyFormulaDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPropertyFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PropertyFormulaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPropertyFormulaDto {
    id?: number;
    name?: string | undefined;
}

export class PropertyResponse implements IPropertyResponse {
    propertySet?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    unit?: string | undefined;

    constructor(data?: IPropertyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySet = _data["propertySet"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.numericValue = _data["numericValue"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): PropertyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySet"] = this.propertySet;
        data["name"] = this.name;
        data["value"] = this.value;
        data["numericValue"] = this.numericValue;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IPropertyResponse {
    propertySet?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numericValue?: number | undefined;
    unit?: string | undefined;
}

export class PropertySet implements IPropertySet {
    name?: string | undefined;
    properties?: Property[] | undefined;

    constructor(data?: IPropertySet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPropertySet {
    name?: string | undefined;
    properties?: Property[] | undefined;
}

export class PropertyTableData implements IPropertyTableData {
    elements?: ElementPropertyRow[] | undefined;
    propertySets?: string[] | undefined;
    propertyNamesBySet?: { [key: string]: string[]; } | undefined;
    totalCount?: number;

    constructor(data?: IPropertyTableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ElementPropertyRow.fromJS(item));
            }
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(item);
            }
            if (_data["propertyNamesBySet"]) {
                this.propertyNamesBySet = {} as any;
                for (let key in _data["propertyNamesBySet"]) {
                    if (_data["propertyNamesBySet"].hasOwnProperty(key))
                        (this.propertyNamesBySet as any)![key] = _data["propertyNamesBySet"][key] !== undefined ? _data["propertyNamesBySet"][key] : [];
                }
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PropertyTableData {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item);
        }
        if (this.propertyNamesBySet) {
            data["propertyNamesBySet"] = {};
            for (let key in this.propertyNamesBySet) {
                if (this.propertyNamesBySet.hasOwnProperty(key))
                    (data["propertyNamesBySet"] as any)[key] = (this.propertyNamesBySet as any)[key];
            }
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPropertyTableData {
    elements?: ElementPropertyRow[] | undefined;
    propertySets?: string[] | undefined;
    propertyNamesBySet?: { [key: string]: string[]; } | undefined;
    totalCount?: number;
}

export class PropertyValue implements IPropertyValue {
    stringValue?: string | undefined;
    numericValue?: number | undefined;
    unit?: string | undefined;

    constructor(data?: IPropertyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stringValue = _data["stringValue"];
            this.numericValue = _data["numericValue"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): PropertyValue {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stringValue"] = this.stringValue;
        data["numericValue"] = this.numericValue;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IPropertyValue {
    stringValue?: string | undefined;
    numericValue?: number | undefined;
    unit?: string | undefined;
}

export class PushPropertiesForModelRequest implements IPushPropertiesForModelRequest {
    modelId?: number;
    properties?: PropertyDto[] | undefined;
    chunkIndex?: number;
    totalChunks?: number;

    constructor(data?: IPushPropertiesForModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyDto.fromJS(item));
            }
            this.chunkIndex = _data["chunkIndex"];
            this.totalChunks = _data["totalChunks"];
        }
    }

    static fromJS(data: any): PushPropertiesForModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PushPropertiesForModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["chunkIndex"] = this.chunkIndex;
        data["totalChunks"] = this.totalChunks;
        return data;
    }
}

export interface IPushPropertiesForModelRequest {
    modelId?: number;
    properties?: PropertyDto[] | undefined;
    chunkIndex?: number;
    totalChunks?: number;
}

export class PushPropertiesForModelResponse implements IPushPropertiesForModelResponse {
    ok?: boolean;

    constructor(data?: IPushPropertiesForModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PushPropertiesForModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushPropertiesForModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPushPropertiesForModelResponse {
    ok?: boolean;
}

export class PushTreeDataToModelRequest implements IPushTreeDataToModelRequest {
    modelId?: number;
    ifcTree?: string | undefined;
    ifcGuidLocalIdMap?: string | undefined;

    constructor(data?: IPushTreeDataToModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.ifcTree = _data["ifcTree"];
            this.ifcGuidLocalIdMap = _data["ifcGuidLocalIdMap"];
        }
    }

    static fromJS(data: any): PushTreeDataToModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PushTreeDataToModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["ifcTree"] = this.ifcTree;
        data["ifcGuidLocalIdMap"] = this.ifcGuidLocalIdMap;
        return data;
    }
}

export interface IPushTreeDataToModelRequest {
    modelId?: number;
    ifcTree?: string | undefined;
    ifcGuidLocalIdMap?: string | undefined;
}

export class PushTreeDataToModelResponse implements IPushTreeDataToModelResponse {
    ok?: boolean;

    constructor(data?: IPushTreeDataToModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PushTreeDataToModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushTreeDataToModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPushTreeDataToModelResponse {
    ok?: boolean;
}

export enum QueryApproach {
    Direct = "Direct",
    Chunked = "Chunked",
    AggregatedOnly = "AggregatedOnly",
    FilteredByClassification = "FilteredByClassification",
}

export enum QueryComplexity {
    Simple = "Simple",
    Medium = "Medium",
    Complex = "Complex",
    Heavy = "Heavy",
}

export enum QueryOutputFormat {
    Insights = "Insights",
    Table = "Table",
    Chart = "Chart",
    Summary = "Summary",
    Elements = "Elements",
}

export class QueryPlan implements IQueryPlan {
    id?: string | undefined;
    originalQuestion?: string | undefined;
    interpretedIntent?: string | undefined;
    steps?: QueryPlanStep[] | undefined;
    outputFormat?: QueryOutputFormat;
    complexity?: QueryComplexity;

    constructor(data?: IQueryPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.originalQuestion = _data["originalQuestion"];
            this.interpretedIntent = _data["interpretedIntent"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(QueryPlanStep.fromJS(item));
            }
            this.outputFormat = _data["outputFormat"];
            this.complexity = _data["complexity"];
        }
    }

    static fromJS(data: any): QueryPlan {
        data = typeof data === 'object' ? data : {};
        let result = new QueryPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalQuestion"] = this.originalQuestion;
        data["interpretedIntent"] = this.interpretedIntent;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item ? item.toJSON() : undefined as any);
        }
        data["outputFormat"] = this.outputFormat;
        data["complexity"] = this.complexity;
        return data;
    }
}

export interface IQueryPlan {
    id?: string | undefined;
    originalQuestion?: string | undefined;
    interpretedIntent?: string | undefined;
    steps?: QueryPlanStep[] | undefined;
    outputFormat?: QueryOutputFormat;
    complexity?: QueryComplexity;
}

export class QueryPlanStep implements IQueryPlanStep {
    order?: number;
    type?: QueryStepType;
    description?: string | undefined;
    vectorSearch?: VectorSearchParams;
    sqlQuery?: SqlQueryParams;
    compute?: ComputeParams;
    compare?: CompareParams;

    constructor(data?: IQueryPlanStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.vectorSearch = _data["vectorSearch"] ? VectorSearchParams.fromJS(_data["vectorSearch"]) : undefined as any;
            this.sqlQuery = _data["sqlQuery"] ? SqlQueryParams.fromJS(_data["sqlQuery"]) : undefined as any;
            this.compute = _data["compute"] ? ComputeParams.fromJS(_data["compute"]) : undefined as any;
            this.compare = _data["compare"] ? CompareParams.fromJS(_data["compare"]) : undefined as any;
        }
    }

    static fromJS(data: any): QueryPlanStep {
        data = typeof data === 'object' ? data : {};
        let result = new QueryPlanStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["type"] = this.type;
        data["description"] = this.description;
        data["vectorSearch"] = this.vectorSearch ? this.vectorSearch.toJSON() : undefined as any;
        data["sqlQuery"] = this.sqlQuery ? this.sqlQuery.toJSON() : undefined as any;
        data["compute"] = this.compute ? this.compute.toJSON() : undefined as any;
        data["compare"] = this.compare ? this.compare.toJSON() : undefined as any;
        return data;
    }
}

export interface IQueryPlanStep {
    order?: number;
    type?: QueryStepType;
    description?: string | undefined;
    vectorSearch?: VectorSearchParams;
    sqlQuery?: SqlQueryParams;
    compute?: ComputeParams;
    compare?: CompareParams;
}

export enum QueryStepType {
    VectorSearch = "VectorSearch",
    SqlFilter = "SqlFilter",
    SqlAggregate = "SqlAggregate",
    HybridSearch = "HybridSearch",
    Compute = "Compute",
    Compare = "Compare",
    Summarize = "Summarize",
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RelationshipInfo implements IRelationshipInfo {
    relatedTable?: string | undefined;
    foreignKeyColumn?: string | undefined;
    relationshipType?: string | undefined;

    constructor(data?: IRelationshipInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedTable = _data["relatedTable"];
            this.foreignKeyColumn = _data["foreignKeyColumn"];
            this.relationshipType = _data["relationshipType"];
        }
    }

    static fromJS(data: any): RelationshipInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RelationshipInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedTable"] = this.relatedTable;
        data["foreignKeyColumn"] = this.foreignKeyColumn;
        data["relationshipType"] = this.relationshipType;
        return data;
    }
}

export interface IRelationshipInfo {
    relatedTable?: string | undefined;
    foreignKeyColumn?: string | undefined;
    relationshipType?: string | undefined;
}

export class RemoveUserFromTenantRequest implements IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;

    constructor(data?: IRemoveUserFromTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;
}

export class RemoveUserFromTenantResponse implements IRemoveUserFromTenantResponse {
    ok?: boolean;

    constructor(data?: IRemoveUserFromTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRemoveUserFromTenantResponse {
    ok?: boolean;
}

export class RenamePricingDatabaseRequest implements IRenamePricingDatabaseRequest {
    id?: number;
    newName?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IRenamePricingDatabaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newName = _data["newName"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RenamePricingDatabaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePricingDatabaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newName"] = this.newName;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface IRenamePricingDatabaseRequest {
    id?: number;
    newName?: string | undefined;
    rowVersion?: Date;
}

export class RenamePricingDatabaseResponse implements IRenamePricingDatabaseResponse {
    id?: number;
    name?: string | undefined;
    rowVersion?: Date;

    constructor(data?: IRenamePricingDatabaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rowVersion = _data["rowVersion"] ? new Date(_data["rowVersion"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RenamePricingDatabaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePricingDatabaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rowVersion"] = this.rowVersion ? this.rowVersion.toISOString() : undefined as any;
        return data;
    }
}

export interface IRenamePricingDatabaseResponse {
    id?: number;
    name?: string | undefined;
    rowVersion?: Date;
}

export class RenameTenantRequest implements IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;

    constructor(data?: IRenameTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
        }
    }

    static fromJS(data: any): RenameTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        return data;
    }
}

export interface IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
}

export class RenameTenantResponse implements IRenameTenantResponse {
    ok?: boolean;

    constructor(data?: IRenameTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameTenantResponse {
    ok?: boolean;
}

export class ResetPasswordUserRequest implements IResetPasswordUserRequest {
    id?: number;

    constructor(data?: IResetPasswordUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResetPasswordUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IResetPasswordUserRequest {
    id?: number;
}

export class ResetPasswordUserResponse implements IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;
}

export class ResetUserPasswordSendMailResponse implements IResetUserPasswordSendMailResponse {
    ok?: boolean;
    msLogin?: boolean;

    constructor(data?: IResetUserPasswordSendMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.msLogin = _data["msLogin"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["msLogin"] = this.msLogin;
        return data;
    }
}

export interface IResetUserPasswordSendMailResponse {
    ok?: boolean;
    msLogin?: boolean;
}

export class ResultStatsDTO implements IResultStatsDTO {
    expressId?: number;
    modelId?: string | undefined;
    ok?: boolean;
    error?: boolean;
    warning?: boolean;

    constructor(data?: IResultStatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
            this.ok = _data["ok"];
            this.error = _data["error"];
            this.warning = _data["warning"];
        }
    }

    static fromJS(data: any): ResultStatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResultStatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        data["ok"] = this.ok;
        data["error"] = this.error;
        data["warning"] = this.warning;
        return data;
    }
}

export interface IResultStatsDTO {
    expressId?: number;
    modelId?: string | undefined;
    ok?: boolean;
    error?: boolean;
    warning?: boolean;
}

export class RoleDTO implements IRoleDTO {
    id?: number;
    name?: string | undefined;
    permissions?: PermissionDTO[] | undefined;

    constructor(data?: IRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoleDTO {
    id?: number;
    name?: string | undefined;
    permissions?: PermissionDTO[] | undefined;
}

export class RouteDTO implements IRouteDTO {
    id?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: IRouteDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): RouteDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface IRouteDTO {
    id?: number;
    name?: string | undefined;
    state?: number;
}

export enum RowType {
    Curve = "Curve",
    Inflexion = "Inflexion",
    Intermediate = "Intermediate",
}

export class SaveBlobToUpdateRequest implements ISaveBlobToUpdateRequest {
    updateId?: number;
    password?: string | undefined;

    constructor(data?: ISaveBlobToUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateId = _data["updateId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SaveBlobToUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBlobToUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateId"] = this.updateId;
        data["password"] = this.password;
        return data;
    }
}

export interface ISaveBlobToUpdateRequest {
    updateId?: number;
    password?: string | undefined;
}

export class SaveBudgetingSessionsPairingRequest implements ISaveBudgetingSessionsPairingRequest {
    budgetSessionId?: number;
    pairings?: BudgetingSessionPairingDto[] | undefined;

    constructor(data?: ISaveBudgetingSessionsPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetSessionId = _data["budgetSessionId"];
            if (Array.isArray(_data["pairings"])) {
                this.pairings = [] as any;
                for (let item of _data["pairings"])
                    this.pairings!.push(BudgetingSessionPairingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveBudgetingSessionsPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBudgetingSessionsPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetSessionId"] = this.budgetSessionId;
        if (Array.isArray(this.pairings)) {
            data["pairings"] = [];
            for (let item of this.pairings)
                data["pairings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveBudgetingSessionsPairingRequest {
    budgetSessionId?: number;
    pairings?: BudgetingSessionPairingDto[] | undefined;
}

export class SaveBudgetingSessionsPairingResponse implements ISaveBudgetingSessionsPairingResponse {
    ok?: boolean;

    constructor(data?: ISaveBudgetingSessionsPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveBudgetingSessionsPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBudgetingSessionsPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveBudgetingSessionsPairingResponse {
    ok?: boolean;
}

export class SavedQueryDto implements ISavedQueryDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    originalQuestion?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isShared?: boolean;
    type?: SavedQueryType;

    constructor(data?: ISavedQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.sqlQuery = _data["sqlQuery"];
            this.originalQuestion = _data["originalQuestion"];
            this.creatorId = _data["creatorId"];
            this.creatorName = _data["creatorName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.isShared = _data["isShared"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SavedQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SavedQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["sqlQuery"] = this.sqlQuery;
        data["originalQuestion"] = this.originalQuestion;
        data["creatorId"] = this.creatorId;
        data["creatorName"] = this.creatorName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["isShared"] = this.isShared;
        data["type"] = this.type;
        return data;
    }
}

export interface ISavedQueryDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    originalQuestion?: string | undefined;
    creatorId?: number | undefined;
    creatorName?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date | undefined;
    isShared?: boolean;
    type?: SavedQueryType;
}

export enum SavedQueryType {
    Sql = "Sql",
    Natural = "Natural",
}

export class SaveFormulaRequest implements ISaveFormulaRequest {
    id?: number | undefined;
    name?: string | undefined;
    numeric?: boolean;
    formulaString?: string | undefined;
    userFields?: PropertyFormulaDto[] | undefined;

    constructor(data?: ISaveFormulaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numeric = _data["numeric"];
            this.formulaString = _data["formulaString"];
            if (Array.isArray(_data["userFields"])) {
                this.userFields = [] as any;
                for (let item of _data["userFields"])
                    this.userFields!.push(PropertyFormulaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveFormulaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFormulaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numeric"] = this.numeric;
        data["formulaString"] = this.formulaString;
        if (Array.isArray(this.userFields)) {
            data["userFields"] = [];
            for (let item of this.userFields)
                data["userFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveFormulaRequest {
    id?: number | undefined;
    name?: string | undefined;
    numeric?: boolean;
    formulaString?: string | undefined;
    userFields?: PropertyFormulaDto[] | undefined;
}

export class SaveFormulaResponse implements ISaveFormulaResponse {
    id?: number;

    constructor(data?: ISaveFormulaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveFormulaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFormulaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveFormulaResponse {
    id?: number;
}

export class SaveMStnFeederElementStationingRequest implements ISaveMStnFeederElementStationingRequest {
    addElementStationing?: AddMStnFeederElementStationingDTO[] | undefined;
    updateElementStationing?: UpdateMStnFeederElementStationingDTO[] | undefined;

    constructor(data?: ISaveMStnFeederElementStationingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addElementStationing"])) {
                this.addElementStationing = [] as any;
                for (let item of _data["addElementStationing"])
                    this.addElementStationing!.push(AddMStnFeederElementStationingDTO.fromJS(item));
            }
            if (Array.isArray(_data["updateElementStationing"])) {
                this.updateElementStationing = [] as any;
                for (let item of _data["updateElementStationing"])
                    this.updateElementStationing!.push(UpdateMStnFeederElementStationingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMStnFeederElementStationingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederElementStationingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addElementStationing)) {
            data["addElementStationing"] = [];
            for (let item of this.addElementStationing)
                data["addElementStationing"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updateElementStationing)) {
            data["updateElementStationing"] = [];
            for (let item of this.updateElementStationing)
                data["updateElementStationing"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveMStnFeederElementStationingRequest {
    addElementStationing?: AddMStnFeederElementStationingDTO[] | undefined;
    updateElementStationing?: UpdateMStnFeederElementStationingDTO[] | undefined;
}

export class SaveMStnFeederElementStationingResponse implements ISaveMStnFeederElementStationingResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedElementStationingDTO[] | undefined;

    constructor(data?: ISaveMStnFeederElementStationingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["addedItems"])) {
                this.addedItems = [] as any;
                for (let item of _data["addedItems"])
                    this.addedItems!.push(MStnFeederAddedElementStationingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMStnFeederElementStationingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederElementStationingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.addedItems)) {
            data["addedItems"] = [];
            for (let item of this.addedItems)
                data["addedItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveMStnFeederElementStationingResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedElementStationingDTO[] | undefined;
}

export class SaveMStnFeederFormulasRequest implements ISaveMStnFeederFormulasRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    isRevit?: boolean;
    items?: FeederFormulaDTO[] | undefined;

    constructor(data?: ISaveMStnFeederFormulasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            this.isRevit = _data["isRevit"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeederFormulaDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMStnFeederFormulasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederFormulasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        data["isRevit"] = this.isRevit;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveMStnFeederFormulasRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    isRevit?: boolean;
    items?: FeederFormulaDTO[] | undefined;
}

export class SaveMStnFeederFormulasResponse implements ISaveMStnFeederFormulasResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    innerExceptionMessage?: string | undefined;

    constructor(data?: ISaveMStnFeederFormulasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.errorMessage = _data["errorMessage"];
            this.innerExceptionMessage = _data["innerExceptionMessage"];
        }
    }

    static fromJS(data: any): SaveMStnFeederFormulasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederFormulasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["errorMessage"] = this.errorMessage;
        data["innerExceptionMessage"] = this.innerExceptionMessage;
        return data;
    }
}

export interface ISaveMStnFeederFormulasResponse {
    ok?: boolean;
    errorMessage?: string | undefined;
    innerExceptionMessage?: string | undefined;
}

export class SaveMStnFeederItemsRequest implements ISaveMStnFeederItemsRequest {
    isOverwriteOrLockChanged?: boolean;
    addItems?: AddMStnFeederItemDTO[] | undefined;
    updateItems?: UpdateMStnFeederItemDTO[] | undefined;
    deleteIds?: number[] | undefined;
    isFeatureDefinitions?: boolean;

    constructor(data?: ISaveMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOverwriteOrLockChanged = _data["isOverwriteOrLockChanged"];
            if (Array.isArray(_data["addItems"])) {
                this.addItems = [] as any;
                for (let item of _data["addItems"])
                    this.addItems!.push(AddMStnFeederItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["updateItems"])) {
                this.updateItems = [] as any;
                for (let item of _data["updateItems"])
                    this.updateItems!.push(UpdateMStnFeederItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["deleteIds"])) {
                this.deleteIds = [] as any;
                for (let item of _data["deleteIds"])
                    this.deleteIds!.push(item);
            }
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
        }
    }

    static fromJS(data: any): SaveMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOverwriteOrLockChanged"] = this.isOverwriteOrLockChanged;
        if (Array.isArray(this.addItems)) {
            data["addItems"] = [];
            for (let item of this.addItems)
                data["addItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updateItems)) {
            data["updateItems"] = [];
            for (let item of this.updateItems)
                data["updateItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.deleteIds)) {
            data["deleteIds"] = [];
            for (let item of this.deleteIds)
                data["deleteIds"].push(item);
        }
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        return data;
    }
}

export interface ISaveMStnFeederItemsRequest {
    isOverwriteOrLockChanged?: boolean;
    addItems?: AddMStnFeederItemDTO[] | undefined;
    updateItems?: UpdateMStnFeederItemDTO[] | undefined;
    deleteIds?: number[] | undefined;
    isFeatureDefinitions?: boolean;
}

export class SaveMStnFeederItemsResponse implements ISaveMStnFeederItemsResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedItemsDTO[] | undefined;
    removedItems?: number[] | undefined;

    constructor(data?: ISaveMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["addedItems"])) {
                this.addedItems = [] as any;
                for (let item of _data["addedItems"])
                    this.addedItems!.push(MStnFeederAddedItemsDTO.fromJS(item));
            }
            if (Array.isArray(_data["removedItems"])) {
                this.removedItems = [] as any;
                for (let item of _data["removedItems"])
                    this.removedItems!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.addedItems)) {
            data["addedItems"] = [];
            for (let item of this.addedItems)
                data["addedItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.removedItems)) {
            data["removedItems"] = [];
            for (let item of this.removedItems)
                data["removedItems"].push(item);
        }
        return data;
    }
}

export interface ISaveMStnFeederItemsResponse {
    ok?: boolean;
    addedItems?: MStnFeederAddedItemsDTO[] | undefined;
    removedItems?: number[] | undefined;
}

export class SaveMultiPairerRequest implements ISaveMultiPairerRequest {
    deletedIds?: number[] | undefined;
    pairers?: MultiPairerRowDTO[] | undefined;
    groupId?: number;

    constructor(data?: ISaveMultiPairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(MultiPairerRowDTO.fromJS(item));
            }
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): SaveMultiPairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMultiPairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ISaveMultiPairerRequest {
    deletedIds?: number[] | undefined;
    pairers?: MultiPairerRowDTO[] | undefined;
    groupId?: number;
}

export class SaveMultiPairerResponse implements ISaveMultiPairerResponse {
    pairers?: PairerDTO[] | undefined;
    ok?: boolean;

    constructor(data?: ISaveMultiPairerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairers"])) {
                this.pairers = [] as any;
                for (let item of _data["pairers"])
                    this.pairers!.push(PairerDTO.fromJS(item));
            }
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveMultiPairerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMultiPairerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairers)) {
            data["pairers"] = [];
            for (let item of this.pairers)
                data["pairers"].push(item ? item.toJSON() : undefined as any);
        }
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveMultiPairerResponse {
    pairers?: PairerDTO[] | undefined;
    ok?: boolean;
}

export class SaveQueryRequest implements ISaveQueryRequest {
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    originalQuestion?: string | undefined;
    type?: SavedQueryType;
    isShared?: boolean;

    constructor(data?: ISaveQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sqlQuery = _data["sqlQuery"];
            this.originalQuestion = _data["originalQuestion"];
            this.type = _data["type"];
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): SaveQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sqlQuery"] = this.sqlQuery;
        data["originalQuestion"] = this.originalQuestion;
        data["type"] = this.type;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface ISaveQueryRequest {
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    originalQuestion?: string | undefined;
    type?: SavedQueryType;
    isShared?: boolean;
}

export class SaveUserDataRequest implements ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenant?: boolean;

    constructor(data?: ISaveUserDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.isAdmin = _data["isAdmin"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.canCreateTenant = _data["canCreateTenant"];
        }
    }

    static fromJS(data: any): SaveUserDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["isAdmin"] = this.isAdmin;
        data["canCreateUsers"] = this.canCreateUsers;
        data["canCreateTenant"] = this.canCreateTenant;
        return data;
    }
}

export interface ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenant?: boolean;
}

export class SaveUserDataResponse implements ISaveUserDataResponse {
    ok?: boolean;

    constructor(data?: ISaveUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveUserDataResponse {
    ok?: boolean;
}

export class SeedGenerationRequest implements ISeedGenerationRequest {
    samples?: string[] | undefined;

    constructor(data?: ISeedGenerationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["samples"])) {
                this.samples = [] as any;
                for (let item of _data["samples"])
                    this.samples!.push(item);
            }
        }
    }

    static fromJS(data: any): SeedGenerationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SeedGenerationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.samples)) {
            data["samples"] = [];
            for (let item of this.samples)
                data["samples"].push(item);
        }
        return data;
    }
}

export interface ISeedGenerationRequest {
    samples?: string[] | undefined;
}

export class SeedGenerationResponse implements ISeedGenerationResponse {
    query?: string | undefined;

    constructor(data?: ISeedGenerationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): SeedGenerationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SeedGenerationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        return data;
    }
}

export interface ISeedGenerationResponse {
    query?: string | undefined;
}

export class SelectorHierarchyDto implements ISelectorHierarchyDto {
    id?: number;
    label?: string | undefined;
    dataType?: DataTypeValidation;
    children?: SelectorHierarchyDto[] | undefined;

    constructor(data?: ISelectorHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(SelectorHierarchyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectorHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISelectorHierarchyDto {
    id?: number;
    label?: string | undefined;
    dataType?: DataTypeValidation;
    children?: SelectorHierarchyDto[] | undefined;
}

export class SelectorItemDTO implements ISelectorItemDTO {
    id?: number;
    label?: string | undefined;
    note?: string | undefined;

    constructor(data?: ISelectorItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SelectorItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["note"] = this.note;
        return data;
    }
}

export interface ISelectorItemDTO {
    id?: number;
    label?: string | undefined;
    note?: string | undefined;
}

export class SelectorListDTO implements ISelectorListDTO {
    id?: number;
    label?: string | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: ISelectorListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): SelectorListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SelectorListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface ISelectorListDTO {
    id?: number;
    label?: string | undefined;
    dataType?: DataTypeValidation;
}

export class SemanticDebugRequest implements ISemanticDebugRequest {
    query?: string | undefined;
    tenantId?: number;
    topK?: number;

    constructor(data?: ISemanticDebugRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.tenantId = _data["tenantId"];
            this.topK = _data["topK"];
        }
    }

    static fromJS(data: any): SemanticDebugRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SemanticDebugRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["tenantId"] = this.tenantId;
        data["topK"] = this.topK;
        return data;
    }
}

export interface ISemanticDebugRequest {
    query?: string | undefined;
    tenantId?: number;
    topK?: number;
}

export class SemanticDebugResult implements ISemanticDebugResult {
    id?: string | undefined;
    score?: number;
    snippet?: string | undefined;

    constructor(data?: ISemanticDebugResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.score = _data["score"];
            this.snippet = _data["snippet"];
        }
    }

    static fromJS(data: any): SemanticDebugResult {
        data = typeof data === 'object' ? data : {};
        let result = new SemanticDebugResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["score"] = this.score;
        data["snippet"] = this.snippet;
        return data;
    }
}

export interface ISemanticDebugResult {
    id?: string | undefined;
    score?: number;
    snippet?: string | undefined;
}

export class SemanticSearchRequest implements ISemanticSearchRequest {
    query?: string | undefined;
    tenantId?: number;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    filter?: string | undefined;
    topK?: number;
    minScore?: number;
    asTable?: boolean;

    constructor(data?: ISemanticSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.filter = _data["filter"];
            this.topK = _data["topK"];
            this.minScore = _data["minScore"];
            this.asTable = _data["asTable"];
        }
    }

    static fromJS(data: any): SemanticSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SemanticSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["filter"] = this.filter;
        data["topK"] = this.topK;
        data["minScore"] = this.minScore;
        data["asTable"] = this.asTable;
        return data;
    }
}

export interface ISemanticSearchRequest {
    query?: string | undefined;
    tenantId?: number;
    projectId?: number | undefined;
    modelIds?: number[] | undefined;
    filter?: string | undefined;
    topK?: number;
    minScore?: number;
    asTable?: boolean;
}

export class SemanticSearchResponse implements ISemanticSearchResponse {
    query?: string | undefined;
    totalResults?: number;
    results?: SemanticSearchResult[] | undefined;
    tableData?: TableData;

    constructor(data?: ISemanticSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.totalResults = _data["totalResults"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SemanticSearchResult.fromJS(item));
            }
            this.tableData = _data["tableData"] ? TableData.fromJS(_data["tableData"]) : undefined as any;
        }
    }

    static fromJS(data: any): SemanticSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SemanticSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["totalResults"] = this.totalResults;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["tableData"] = this.tableData ? this.tableData.toJSON() : undefined as any;
        return data;
    }
}

export interface ISemanticSearchResponse {
    query?: string | undefined;
    totalResults?: number;
    results?: SemanticSearchResult[] | undefined;
    tableData?: TableData;
}

export class SemanticSearchResult implements ISemanticSearchResult {
    expressId?: number;
    ifcGuid?: string | undefined;
    ifcType?: string | undefined;
    name?: string | undefined;
    semanticText?: string | undefined;
    score?: number;
    properties?: { [key: string]: string; } | undefined;
    propertySets?: string[] | undefined;
    classifications?: string[] | undefined;

    constructor(data?: ISemanticSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.ifcGuid = _data["ifcGuid"];
            this.ifcType = _data["ifcType"];
            this.name = _data["name"];
            this.semanticText = _data["semanticText"];
            this.score = _data["score"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
            if (Array.isArray(_data["propertySets"])) {
                this.propertySets = [] as any;
                for (let item of _data["propertySets"])
                    this.propertySets!.push(item);
            }
            if (Array.isArray(_data["classifications"])) {
                this.classifications = [] as any;
                for (let item of _data["classifications"])
                    this.classifications!.push(item);
            }
        }
    }

    static fromJS(data: any): SemanticSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new SemanticSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["ifcGuid"] = this.ifcGuid;
        data["ifcType"] = this.ifcType;
        data["name"] = this.name;
        data["semanticText"] = this.semanticText;
        data["score"] = this.score;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        if (Array.isArray(this.propertySets)) {
            data["propertySets"] = [];
            for (let item of this.propertySets)
                data["propertySets"].push(item);
        }
        if (Array.isArray(this.classifications)) {
            data["classifications"] = [];
            for (let item of this.classifications)
                data["classifications"].push(item);
        }
        return data;
    }
}

export interface ISemanticSearchResult {
    expressId?: number;
    ifcGuid?: string | undefined;
    ifcType?: string | undefined;
    name?: string | undefined;
    semanticText?: string | undefined;
    score?: number;
    properties?: { [key: string]: string; } | undefined;
    propertySets?: string[] | undefined;
    classifications?: string[] | undefined;
}

export class SetUserPasswordResponse implements ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;

    constructor(data?: ISetUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SetUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["email"] = this.email;
        return data;
    }
}

export interface ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;
}

export enum SGProductType {
    Updater = "Updater",
    PowerTools = "PowerTools",
    OpenTools = "OpenTools",
    Bimloader = "Bimloader",
}

export class SchemaMetadataResponse implements ISchemaMetadataResponse {
    tables?: TableInfo[] | undefined;

    constructor(data?: ISchemaMetadataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(TableInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaMetadataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaMetadataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchemaMetadataResponse {
    tables?: TableInfo[] | undefined;
}

export class SignupMicrosoftRequest implements ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignupMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignupMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;
}

export class SignupResponse implements ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;

    constructor(data?: ISignupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDTO[] | undefined;
}

export class SignupUserMicrosoftRequest implements ISignupUserMicrosoftRequest {
    userId?: number;
    msToken?: string | undefined;
    signupToken?: string | undefined;

    constructor(data?: ISignupUserMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.msToken = _data["msToken"];
            this.signupToken = _data["signupToken"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["msToken"] = this.msToken;
        data["signupToken"] = this.signupToken;
        return data;
    }
}

export interface ISignupUserMicrosoftRequest {
    userId?: number;
    msToken?: string | undefined;
    signupToken?: string | undefined;
}

export class SignupUserMicrosoftResponse implements ISignupUserMicrosoftResponse {
    ok?: boolean;

    constructor(data?: ISignupUserMicrosoftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISignupUserMicrosoftResponse {
    ok?: boolean;
}

export class SmartAggregationValue implements ISmartAggregationValue {
    value?: number;
    unit?: string | undefined;
    count?: number;

    constructor(data?: ISmartAggregationValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): SmartAggregationValue {
        data = typeof data === 'object' ? data : {};
        let result = new SmartAggregationValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["count"] = this.count;
        return data;
    }
}

export interface ISmartAggregationValue {
    value?: number;
    unit?: string | undefined;
    count?: number;
}

export class SmartSearchResponse implements ISmartSearchResponse {
    query?: string | undefined;
    sessionId?: string | undefined;
    answer?: string | undefined;
    category?: string | undefined;
    interpretation?: string | undefined;
    totalCount?: number;
    structuredData?: SmartStructuredData;
    suggestions?: SmartSuggestion[] | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    debugInfo?: string[] | undefined;

    constructor(data?: ISmartSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.sessionId = _data["sessionId"];
            this.answer = _data["answer"];
            this.category = _data["category"];
            this.interpretation = _data["interpretation"];
            this.totalCount = _data["totalCount"];
            this.structuredData = _data["structuredData"] ? SmartStructuredData.fromJS(_data["structuredData"]) : undefined as any;
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(SmartSuggestion.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FlexibleSearchElementResponse.fromJS(item));
            }
            if (Array.isArray(_data["debugInfo"])) {
                this.debugInfo = [] as any;
                for (let item of _data["debugInfo"])
                    this.debugInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): SmartSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["sessionId"] = this.sessionId;
        data["answer"] = this.answer;
        data["category"] = this.category;
        data["interpretation"] = this.interpretation;
        data["totalCount"] = this.totalCount;
        data["structuredData"] = this.structuredData ? this.structuredData.toJSON() : undefined as any;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.debugInfo)) {
            data["debugInfo"] = [];
            for (let item of this.debugInfo)
                data["debugInfo"].push(item);
        }
        return data;
    }
}

export interface ISmartSearchResponse {
    query?: string | undefined;
    sessionId?: string | undefined;
    answer?: string | undefined;
    category?: string | undefined;
    interpretation?: string | undefined;
    totalCount?: number;
    structuredData?: SmartStructuredData;
    suggestions?: SmartSuggestion[] | undefined;
    elements?: FlexibleSearchElementResponse[] | undefined;
    debugInfo?: string[] | undefined;
}

export class SmartStructuredData implements ISmartStructuredData {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
    aggregations?: { [key: string]: SmartAggregationValue; } | undefined;
    distribution?: { [key: string]: number; } | undefined;
    keyFindings?: { [key: string]: string; } | undefined;
    statistics?: { [key: string]: any; } | undefined;

    constructor(data?: ISmartStructuredData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            if (_data["aggregations"]) {
                this.aggregations = {} as any;
                for (let key in _data["aggregations"]) {
                    if (_data["aggregations"].hasOwnProperty(key))
                        (this.aggregations as any)![key] = _data["aggregations"][key] ? SmartAggregationValue.fromJS(_data["aggregations"][key]) : new SmartAggregationValue();
                }
            }
            if (_data["distribution"]) {
                this.distribution = {} as any;
                for (let key in _data["distribution"]) {
                    if (_data["distribution"].hasOwnProperty(key))
                        (this.distribution as any)![key] = _data["distribution"][key];
                }
            }
            if (_data["keyFindings"]) {
                this.keyFindings = {} as any;
                for (let key in _data["keyFindings"]) {
                    if (_data["keyFindings"].hasOwnProperty(key))
                        (this.keyFindings as any)![key] = _data["keyFindings"][key];
                }
            }
            if (_data["statistics"]) {
                this.statistics = {} as any;
                for (let key in _data["statistics"]) {
                    if (_data["statistics"].hasOwnProperty(key))
                        (this.statistics as any)![key] = _data["statistics"][key];
                }
            }
        }
    }

    static fromJS(data: any): SmartStructuredData {
        data = typeof data === 'object' ? data : {};
        let result = new SmartStructuredData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        if (this.aggregations) {
            data["aggregations"] = {};
            for (let key in this.aggregations) {
                if (this.aggregations.hasOwnProperty(key))
                    (data["aggregations"] as any)[key] = this.aggregations[key] ? this.aggregations[key].toJSON() : undefined as any;
            }
        }
        if (this.distribution) {
            data["distribution"] = {};
            for (let key in this.distribution) {
                if (this.distribution.hasOwnProperty(key))
                    (data["distribution"] as any)[key] = (this.distribution as any)[key];
            }
        }
        if (this.keyFindings) {
            data["keyFindings"] = {};
            for (let key in this.keyFindings) {
                if (this.keyFindings.hasOwnProperty(key))
                    (data["keyFindings"] as any)[key] = (this.keyFindings as any)[key];
            }
        }
        if (this.statistics) {
            data["statistics"] = {};
            for (let key in this.statistics) {
                if (this.statistics.hasOwnProperty(key))
                    (data["statistics"] as any)[key] = (this.statistics as any)[key];
            }
        }
        return data;
    }
}

export interface ISmartStructuredData {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
    aggregations?: { [key: string]: SmartAggregationValue; } | undefined;
    distribution?: { [key: string]: number; } | undefined;
    keyFindings?: { [key: string]: string; } | undefined;
    statistics?: { [key: string]: any; } | undefined;
}

export class SmartSuggestion implements ISmartSuggestion {
    query?: string | undefined;
    reason?: string | undefined;
    icon?: string | undefined;

    constructor(data?: ISmartSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.reason = _data["reason"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): SmartSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["reason"] = this.reason;
        data["icon"] = this.icon;
        return data;
    }
}

export interface ISmartSuggestion {
    query?: string | undefined;
    reason?: string | undefined;
    icon?: string | undefined;
}

export class SqlGenerateRequest implements ISqlGenerateRequest {
    question?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: ISqlGenerateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): SqlGenerateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SqlGenerateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ISqlGenerateRequest {
    question?: string | undefined;
    sessionId?: string | undefined;
}

export class SqlGenerateResponse implements ISqlGenerateResponse {
    sqlQuery?: string | undefined;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    usage?: TokenUsage;

    constructor(data?: ISqlGenerateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sqlQuery = _data["sqlQuery"];
            this.explanation = _data["explanation"];
            this.sessionId = _data["sessionId"];
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
            this.usage = _data["usage"] ? TokenUsage.fromJS(_data["usage"]) : undefined as any;
        }
    }

    static fromJS(data: any): SqlGenerateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SqlGenerateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery;
        data["explanation"] = this.explanation;
        data["sessionId"] = this.sessionId;
        data["isValid"] = this.isValid;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["usage"] = this.usage ? this.usage.toJSON() : undefined as any;
        return data;
    }
}

export interface ISqlGenerateResponse {
    sqlQuery?: string | undefined;
    explanation?: string | undefined;
    sessionId?: string | undefined;
    isValid?: boolean;
    validationErrors?: string[] | undefined;
    usage?: TokenUsage;
}

export class SqlChatRequest implements ISqlChatRequest {
    message?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: ISqlChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): SqlChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SqlChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface ISqlChatRequest {
    message?: string | undefined;
    sessionId?: string | undefined;
}

export class SqlChatResponse implements ISqlChatResponse {
    message?: string | undefined;
    sqlQuery?: string | undefined;
    sessionId?: string | undefined;
    usage?: TokenUsage;

    constructor(data?: ISqlChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.sqlQuery = _data["sqlQuery"];
            this.sessionId = _data["sessionId"];
            this.usage = _data["usage"] ? TokenUsage.fromJS(_data["usage"]) : undefined as any;
        }
    }

    static fromJS(data: any): SqlChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SqlChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["sqlQuery"] = this.sqlQuery;
        data["sessionId"] = this.sessionId;
        data["usage"] = this.usage ? this.usage.toJSON() : undefined as any;
        return data;
    }
}

export interface ISqlChatResponse {
    message?: string | undefined;
    sqlQuery?: string | undefined;
    sessionId?: string | undefined;
    usage?: TokenUsage;
}

export class SqlPreviewRequest implements ISqlPreviewRequest {
    sqlQuery?: string | undefined;
    maxRows?: number;

    constructor(data?: ISqlPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sqlQuery = _data["sqlQuery"];
            this.maxRows = _data["maxRows"];
        }
    }

    static fromJS(data: any): SqlPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SqlPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sqlQuery"] = this.sqlQuery;
        data["maxRows"] = this.maxRows;
        return data;
    }
}

export interface ISqlPreviewRequest {
    sqlQuery?: string | undefined;
    maxRows?: number;
}

export class SqlPreviewResponse implements ISqlPreviewResponse {
    columns?: string[] | undefined;
    rows?: { [key: string]: any; }[] | undefined;
    rowCount?: number;
    hasMoreRows?: boolean;
    executionTimeMs?: number;

    constructor(data?: ISqlPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.rowCount = _data["rowCount"];
            this.hasMoreRows = _data["hasMoreRows"];
            this.executionTimeMs = _data["executionTimeMs"];
        }
    }

    static fromJS(data: any): SqlPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SqlPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["rowCount"] = this.rowCount;
        data["hasMoreRows"] = this.hasMoreRows;
        data["executionTimeMs"] = this.executionTimeMs;
        return data;
    }
}

export interface ISqlPreviewResponse {
    columns?: string[] | undefined;
    rows?: { [key: string]: any; }[] | undefined;
    rowCount?: number;
    hasMoreRows?: boolean;
    executionTimeMs?: number;
}

export class SqlQueryParams implements ISqlQueryParams {
    table?: string | undefined;
    whereClause?: string | undefined;
    selectClause?: string | undefined;
    groupByClause?: string | undefined;
    orderByClause?: string | undefined;
    limit?: number | undefined;

    constructor(data?: ISqlQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.table = _data["table"];
            this.whereClause = _data["whereClause"];
            this.selectClause = _data["selectClause"];
            this.groupByClause = _data["groupByClause"];
            this.orderByClause = _data["orderByClause"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): SqlQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["table"] = this.table;
        data["whereClause"] = this.whereClause;
        data["selectClause"] = this.selectClause;
        data["groupByClause"] = this.groupByClause;
        data["orderByClause"] = this.orderByClause;
        data["limit"] = this.limit;
        return data;
    }
}

export interface ISqlQueryParams {
    table?: string | undefined;
    whereClause?: string | undefined;
    selectClause?: string | undefined;
    groupByClause?: string | undefined;
    orderByClause?: string | undefined;
    limit?: number | undefined;
}

export class StartUploadDatabaseStructureResponse implements IStartUploadDatabaseStructureResponse {
    blobId?: string | undefined;
    sasUri?: string | undefined;

    constructor(data?: IStartUploadDatabaseStructureResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobId = _data["blobId"];
            this.sasUri = _data["sasUri"];
        }
    }

    static fromJS(data: any): StartUploadDatabaseStructureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartUploadDatabaseStructureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobId"] = this.blobId;
        data["sasUri"] = this.sasUri;
        return data;
    }
}

export interface IStartUploadDatabaseStructureResponse {
    blobId?: string | undefined;
    sasUri?: string | undefined;
}

export class SuggestionCategory implements ISuggestionCategory {
    name?: string | undefined;
    icon?: string | undefined;
    questions?: string[] | undefined;

    constructor(data?: ISuggestionCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionCategory {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["icon"] = this.icon;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item);
        }
        return data;
    }
}

export interface ISuggestionCategory {
    name?: string | undefined;
    icon?: string | undefined;
    questions?: string[] | undefined;
}

export class SuggestionsResponse implements ISuggestionsResponse {
    projectId?: number;
    modelId?: number | undefined;
    suggestedQuestions?: string[] | undefined;
    categories?: SuggestionCategory[] | undefined;

    constructor(data?: ISuggestionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["suggestedQuestions"])) {
                this.suggestedQuestions = [] as any;
                for (let item of _data["suggestedQuestions"])
                    this.suggestedQuestions!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(SuggestionCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuggestionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        if (Array.isArray(this.suggestedQuestions)) {
            data["suggestedQuestions"] = [];
            for (let item of this.suggestedQuestions)
                data["suggestedQuestions"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISuggestionsResponse {
    projectId?: number;
    modelId?: number | undefined;
    suggestedQuestions?: string[] | undefined;
    categories?: SuggestionCategory[] | undefined;
}

export class TableData implements ITableData {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;

    constructor(data?: ITableData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): TableData {
        data = typeof data === 'object' ? data : {};
        let result = new TableData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface ITableData {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
}

export class TableDataResponse implements ITableDataResponse {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
    totalRows?: number;

    constructor(data?: ITableDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.totalRows = _data["totalRows"];
        }
    }

    static fromJS(data: any): TableDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TableDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["totalRows"] = this.totalRows;
        return data;
    }
}

export interface ITableDataResponse {
    headers?: string[] | undefined;
    rows?: string[][] | undefined;
    totalRows?: number;
}

export class TableInfo implements ITableInfo {
    tableName?: string | undefined;
    entityName?: string | undefined;
    columns?: ColumnInfo[] | undefined;
    relationships?: RelationshipInfo[] | undefined;
    hasTenantId?: boolean;
    hasIsDeleted?: boolean;

    constructor(data?: ITableInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"];
            this.entityName = _data["entityName"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(ColumnInfo.fromJS(item));
            }
            if (Array.isArray(_data["relationships"])) {
                this.relationships = [] as any;
                for (let item of _data["relationships"])
                    this.relationships!.push(RelationshipInfo.fromJS(item));
            }
            this.hasTenantId = _data["hasTenantId"];
            this.hasIsDeleted = _data["hasIsDeleted"];
        }
    }

    static fromJS(data: any): TableInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TableInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["entityName"] = this.entityName;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relationships)) {
            data["relationships"] = [];
            for (let item of this.relationships)
                data["relationships"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasTenantId"] = this.hasTenantId;
        data["hasIsDeleted"] = this.hasIsDeleted;
        return data;
    }
}

export interface ITableInfo {
    tableName?: string | undefined;
    entityName?: string | undefined;
    columns?: ColumnInfo[] | undefined;
    relationships?: RelationshipInfo[] | undefined;
    hasTenantId?: boolean;
    hasIsDeleted?: boolean;
}

export class TenantDataStandardSharingDTO implements ITenantDataStandardSharingDTO {
    id?: number;
    name?: string | undefined;
    dataStandards?: DataStandardDTO[] | undefined;

    constructor(data?: ITenantDataStandardSharingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["dataStandards"])) {
                this.dataStandards = [] as any;
                for (let item of _data["dataStandards"])
                    this.dataStandards!.push(DataStandardDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDataStandardSharingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDataStandardSharingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.dataStandards)) {
            data["dataStandards"] = [];
            for (let item of this.dataStandards)
                data["dataStandards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantDataStandardSharingDTO {
    id?: number;
    name?: string | undefined;
    dataStandards?: DataStandardDTO[] | undefined;
}

export class TenantDTO implements ITenantDTO {
    id?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
    users?: TenantUserDTO[] | undefined;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(TenantUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantDTO {
    id?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
    users?: TenantUserDTO[] | undefined;
}

export class TenantListDTO implements ITenantListDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantListDTO {
    id?: number;
    name?: string | undefined;
}

export class TenantLoginDTO implements ITenantLoginDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginDTO {
    id?: number;
    name?: string | undefined;
}

export class TenantUserDTO implements ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;

    constructor(data?: ITenantUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.isAdmin = _data["isAdmin"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.canCreateTenants = _data["canCreateTenants"];
            this.identityProvider = _data["identityProvider"];
        }
    }

    static fromJS(data: any): TenantUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        data["canCreateUsers"] = this.canCreateUsers;
        data["canCreateTenants"] = this.canCreateTenants;
        data["identityProvider"] = this.identityProvider;
        return data;
    }
}

export interface ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    canCreateUsers?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;
}

export class TestVideoValidationSlopeRequest implements ITestVideoValidationSlopeRequest {

    constructor(data?: ITestVideoValidationSlopeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TestVideoValidationSlopeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestVideoValidationSlopeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITestVideoValidationSlopeRequest {
}

export class TiltValidationLine implements ITiltValidationLine {
    tiltValidationLineParts?: TiltValidationLinePart[] | undefined;
    perpendiculars?: TiltValidationLinePart[] | undefined;

    constructor(data?: ITiltValidationLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tiltValidationLineParts"])) {
                this.tiltValidationLineParts = [] as any;
                for (let item of _data["tiltValidationLineParts"])
                    this.tiltValidationLineParts!.push(TiltValidationLinePart.fromJS(item));
            }
            if (Array.isArray(_data["perpendiculars"])) {
                this.perpendiculars = [] as any;
                for (let item of _data["perpendiculars"])
                    this.perpendiculars!.push(TiltValidationLinePart.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationLine {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tiltValidationLineParts)) {
            data["tiltValidationLineParts"] = [];
            for (let item of this.tiltValidationLineParts)
                data["tiltValidationLineParts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.perpendiculars)) {
            data["perpendiculars"] = [];
            for (let item of this.perpendiculars)
                data["perpendiculars"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITiltValidationLine {
    tiltValidationLineParts?: TiltValidationLinePart[] | undefined;
    perpendiculars?: TiltValidationLinePart[] | undefined;
}

export class TiltValidationLinePart implements ITiltValidationLinePart {
    entityType?: ValidationDesignEntityType;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
    perpendicularPointLeft?: Point3dServer;
    perpendicularPointRight?: Point3dServer;
    perpendicularCrossId?: string | undefined;

    constructor(data?: ITiltValidationLinePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.startPoint = _data["startPoint"] ? Point3dServer.fromJS(_data["startPoint"]) : undefined as any;
            this.endPoint = _data["endPoint"] ? Point3dServer.fromJS(_data["endPoint"]) : undefined as any;
            this.perpendicularPointLeft = _data["perpendicularPointLeft"] ? Point3dServer.fromJS(_data["perpendicularPointLeft"]) : undefined as any;
            this.perpendicularPointRight = _data["perpendicularPointRight"] ? Point3dServer.fromJS(_data["perpendicularPointRight"]) : undefined as any;
            this.perpendicularCrossId = _data["perpendicularCrossId"];
        }
    }

    static fromJS(data: any): TiltValidationLinePart {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationLinePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : undefined as any;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : undefined as any;
        data["perpendicularPointLeft"] = this.perpendicularPointLeft ? this.perpendicularPointLeft.toJSON() : undefined as any;
        data["perpendicularPointRight"] = this.perpendicularPointRight ? this.perpendicularPointRight.toJSON() : undefined as any;
        data["perpendicularCrossId"] = this.perpendicularCrossId;
        return data;
    }
}

export interface ITiltValidationLinePart {
    entityType?: ValidationDesignEntityType;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
    perpendicularPointLeft?: Point3dServer;
    perpendicularPointRight?: Point3dServer;
    perpendicularCrossId?: string | undefined;
}

export class TiltValidationPluginResponse implements ITiltValidationPluginResponse {
    data?: ValidationDesignSlopeResponse;

    constructor(data?: ITiltValidationPluginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ValidationDesignSlopeResponse.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): TiltValidationPluginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationPluginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface ITiltValidationPluginResponse {
    data?: ValidationDesignSlopeResponse;
}

export class TiltValidationResponse implements ITiltValidationResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;

    constructor(data?: ITiltValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tiltId = _data["tiltId"];
            this.tiltName = _data["tiltName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.polyLine = _data["polyLine"] ? TiltValidationLine.fromJS(_data["polyLine"]) : undefined as any;
            this.polyLine2 = _data["polyLine2"] ? TiltValidationLine.fromJS(_data["polyLine2"]) : undefined as any;
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
            if (Array.isArray(_data["gridLines"])) {
                this.gridLines = [] as any;
                for (let item of _data["gridLines"])
                    this.gridLines!.push(ValidationDesignDataGridSectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tiltId"] = this.tiltId;
        data["tiltName"] = this.tiltName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["polyLine"] = this.polyLine ? this.polyLine.toJSON() : undefined as any;
        data["polyLine2"] = this.polyLine2 ? this.polyLine2.toJSON() : undefined as any;
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridLines)) {
            data["gridLines"] = [];
            for (let item of this.gridLines)
                data["gridLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITiltValidationResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;
}

export class TiltValidationVersionResponse implements ITiltValidationVersionResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;

    constructor(data?: ITiltValidationVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tiltId = _data["tiltId"];
            this.tiltName = _data["tiltName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.polyLine = _data["polyLine"] ? TiltValidationLine.fromJS(_data["polyLine"]) : undefined as any;
            this.polyLine2 = _data["polyLine2"] ? TiltValidationLine.fromJS(_data["polyLine2"]) : undefined as any;
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
            if (Array.isArray(_data["gridLines"])) {
                this.gridLines = [] as any;
                for (let item of _data["gridLines"])
                    this.gridLines!.push(ValidationDesignDataGridSectionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TiltValidationVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TiltValidationVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tiltId"] = this.tiltId;
        data["tiltName"] = this.tiltName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["polyLine"] = this.polyLine ? this.polyLine.toJSON() : undefined as any;
        data["polyLine2"] = this.polyLine2 ? this.polyLine2.toJSON() : undefined as any;
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.gridLines)) {
            data["gridLines"] = [];
            for (let item of this.gridLines)
                data["gridLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITiltValidationVersionResponse {
    tiltId?: number;
    tiltName?: string | undefined;
    projectId?: number;
    projectName?: string | undefined;
    polyLine?: TiltValidationLine;
    polyLine2?: TiltValidationLine;
    hectos?: ValidationDesignHectoServer[] | undefined;
    gridLines?: ValidationDesignDataGridSectionDTO[] | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            (this as any).totalDays = _data["totalDays"];
            (this as any).totalHours = _data["totalHours"];
            (this as any).totalMilliseconds = _data["totalMilliseconds"];
            (this as any).totalMinutes = _data["totalMinutes"];
            (this as any).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class TokenUsage implements ITokenUsage {
    promptTokens?: number | undefined;
    completionTokens?: number | undefined;
    totalTokens?: number | undefined;

    constructor(data?: ITokenUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
        }
    }

    static fromJS(data: any): TokenUsage {
        data = typeof data === 'object' ? data : {};
        let result = new TokenUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        return data;
    }
}

export interface ITokenUsage {
    promptTokens?: number | undefined;
    completionTokens?: number | undefined;
    totalTokens?: number | undefined;
}

export class TokenUsageInfo implements ITokenUsageInfo {
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;
    estimatedCost?: number;

    constructor(data?: ITokenUsageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptTokens = _data["promptTokens"];
            this.completionTokens = _data["completionTokens"];
            this.totalTokens = _data["totalTokens"];
            this.estimatedCost = _data["estimatedCost"];
        }
    }

    static fromJS(data: any): TokenUsageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TokenUsageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptTokens"] = this.promptTokens;
        data["completionTokens"] = this.completionTokens;
        data["totalTokens"] = this.totalTokens;
        data["estimatedCost"] = this.estimatedCost;
        return data;
    }
}

export interface ITokenUsageInfo {
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;
    estimatedCost?: number;
}

export class UncheckedElementDTO implements IUncheckedElementDTO {
    expressId?: number;
    typeId?: string | undefined;
    modelId?: string | undefined;

    constructor(data?: IUncheckedElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.typeId = _data["typeId"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): UncheckedElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UncheckedElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["typeId"] = this.typeId;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IUncheckedElementDTO {
    expressId?: number;
    typeId?: string | undefined;
    modelId?: string | undefined;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export class UpdateBudgetRuleItemRequest implements IUpdateBudgetRuleItemRequest {
    itemId?: number;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;

    constructor(data?: IUpdateBudgetRuleItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.formulaId = _data["formulaId"];
            this.budgetItemSign = _data["budgetItemSign"];
            this.budgetItemName = _data["budgetItemName"];
            this.budgetItemDescription = _data["budgetItemDescription"];
            this.budgetItemSpecification = _data["budgetItemSpecification"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.measuringUnit = _data["measuringUnit"];
        }
    }

    static fromJS(data: any): UpdateBudgetRuleItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetRuleItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["formulaId"] = this.formulaId;
        data["budgetItemSign"] = this.budgetItemSign;
        data["budgetItemName"] = this.budgetItemName;
        data["budgetItemDescription"] = this.budgetItemDescription;
        data["budgetItemSpecification"] = this.budgetItemSpecification;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["measuringUnitId"] = this.measuringUnitId;
        data["measuringUnit"] = this.measuringUnit;
        return data;
    }
}

export interface IUpdateBudgetRuleItemRequest {
    itemId?: number;
    formulaId?: number | undefined;
    budgetItemSign?: string | undefined;
    budgetItemName?: string | undefined;
    budgetItemDescription?: string | undefined;
    budgetItemSpecification?: string | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    measuringUnitId?: number | undefined;
    measuringUnit?: string | undefined;
}

export class UpdateBudgetRuleItemResponse implements IUpdateBudgetRuleItemResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IUpdateBudgetRuleItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): UpdateBudgetRuleItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetRuleItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IUpdateBudgetRuleItemResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class UpdateBudgetRuleRequest implements IUpdateBudgetRuleRequest {
    budgetRuleId?: number;
    name?: string | undefined;
    category?: string | undefined;
    deletedItemIds?: number[] | undefined;
    updatedItems?: BudgetRuleItemDto[] | undefined;
    newItems?: CreateBudgetRuleItemRequest[] | undefined;

    constructor(data?: IUpdateBudgetRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetRuleId = _data["budgetRuleId"];
            this.name = _data["name"];
            this.category = _data["category"];
            if (Array.isArray(_data["deletedItemIds"])) {
                this.deletedItemIds = [] as any;
                for (let item of _data["deletedItemIds"])
                    this.deletedItemIds!.push(item);
            }
            if (Array.isArray(_data["updatedItems"])) {
                this.updatedItems = [] as any;
                for (let item of _data["updatedItems"])
                    this.updatedItems!.push(BudgetRuleItemDto.fromJS(item));
            }
            if (Array.isArray(_data["newItems"])) {
                this.newItems = [] as any;
                for (let item of _data["newItems"])
                    this.newItems!.push(CreateBudgetRuleItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateBudgetRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetRuleId"] = this.budgetRuleId;
        data["name"] = this.name;
        data["category"] = this.category;
        if (Array.isArray(this.deletedItemIds)) {
            data["deletedItemIds"] = [];
            for (let item of this.deletedItemIds)
                data["deletedItemIds"].push(item);
        }
        if (Array.isArray(this.updatedItems)) {
            data["updatedItems"] = [];
            for (let item of this.updatedItems)
                data["updatedItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newItems)) {
            data["newItems"] = [];
            for (let item of this.newItems)
                data["newItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateBudgetRuleRequest {
    budgetRuleId?: number;
    name?: string | undefined;
    category?: string | undefined;
    deletedItemIds?: number[] | undefined;
    updatedItems?: BudgetRuleItemDto[] | undefined;
    newItems?: CreateBudgetRuleItemRequest[] | undefined;
}

export class UpdateBudgetRuleResponse implements IUpdateBudgetRuleResponse {
    ok?: boolean;
    error?: string | undefined;

    constructor(data?: IUpdateBudgetRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): UpdateBudgetRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface IUpdateBudgetRuleResponse {
    ok?: boolean;
    error?: string | undefined;
}

export class UpdateConstructionItemRequest implements IUpdateConstructionItemRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IUpdateConstructionItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.specification = _data["specification"];
            this.billOfQuantities = _data["billOfQuantities"];
            this.measuringUnitId = _data["measuringUnitId"];
            this.unitPrice = _data["unitPrice"];
            this.pricingDatabase = _data["pricingDatabase"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): UpdateConstructionItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        data["description"] = this.description;
        data["specification"] = this.specification;
        data["billOfQuantities"] = this.billOfQuantities;
        data["measuringUnitId"] = this.measuringUnitId;
        data["unitPrice"] = this.unitPrice;
        data["pricingDatabase"] = this.pricingDatabase;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IUpdateConstructionItemRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    specification?: string | undefined;
    billOfQuantities?: string | undefined;
    measuringUnitId?: number | undefined;
    unitPrice?: number | undefined;
    pricingDatabase?: string | undefined;
    quantity?: number | undefined;
}

export class UpdateConstructionItemResponse implements IUpdateConstructionItemResponse {
    ok?: boolean;

    constructor(data?: IUpdateConstructionItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateConstructionItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateConstructionItemResponse {
    ok?: boolean;
}

export class UpdateConstructionObjectRequest implements IUpdateConstructionObjectRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUpdateConstructionObjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateConstructionObjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionObjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateConstructionObjectRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
}

export class UpdateConstructionObjectResponse implements IUpdateConstructionObjectResponse {
    ok?: boolean;

    constructor(data?: IUpdateConstructionObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateConstructionObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateConstructionObjectResponse {
    ok?: boolean;
}

export class UpdateConstructionPartRequest implements IUpdateConstructionPartRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUpdateConstructionPartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sign = _data["sign"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateConstructionPartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionPartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sign"] = this.sign;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateConstructionPartRequest {
    id?: number;
    sign?: string | undefined;
    name?: string | undefined;
}

export class UpdateConstructionPartResponse implements IUpdateConstructionPartResponse {
    ok?: boolean;

    constructor(data?: IUpdateConstructionPartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateConstructionPartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConstructionPartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateConstructionPartResponse {
    ok?: boolean;
}

export class UpdateDataStandardDecimalPlacesRequest implements IUpdateDataStandardDecimalPlacesRequest {
    standardId?: number;
    valRules?: ValRuleDecimalPlacesDTO[] | undefined;

    constructor(data?: IUpdateDataStandardDecimalPlacesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            if (Array.isArray(_data["valRules"])) {
                this.valRules = [] as any;
                for (let item of _data["valRules"])
                    this.valRules!.push(ValRuleDecimalPlacesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDataStandardDecimalPlacesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardDecimalPlacesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        if (Array.isArray(this.valRules)) {
            data["valRules"] = [];
            for (let item of this.valRules)
                data["valRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateDataStandardDecimalPlacesRequest {
    standardId?: number;
    valRules?: ValRuleDecimalPlacesDTO[] | undefined;
}

export class UpdateDataStandardDecimalPlacesResponse implements IUpdateDataStandardDecimalPlacesResponse {
    ok?: boolean;

    constructor(data?: IUpdateDataStandardDecimalPlacesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateDataStandardDecimalPlacesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardDecimalPlacesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateDataStandardDecimalPlacesResponse {
    ok?: boolean;
}

export class UpdateDataStandardElementFiltersRequest implements IUpdateDataStandardElementFiltersRequest {
    pairerIds?: number[] | undefined;
    filterItems?: FilterItem[] | undefined;

    constructor(data?: IUpdateDataStandardElementFiltersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pairerIds"])) {
                this.pairerIds = [] as any;
                for (let item of _data["pairerIds"])
                    this.pairerIds!.push(item);
            }
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(FilterItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDataStandardElementFiltersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardElementFiltersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pairerIds)) {
            data["pairerIds"] = [];
            for (let item of this.pairerIds)
                data["pairerIds"].push(item);
        }
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateDataStandardElementFiltersRequest {
    pairerIds?: number[] | undefined;
    filterItems?: FilterItem[] | undefined;
}

export class UpdateDataStandardElementFiltersResponse implements IUpdateDataStandardElementFiltersResponse {
    ok?: boolean;

    constructor(data?: IUpdateDataStandardElementFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateDataStandardElementFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardElementFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateDataStandardElementFiltersResponse {
    ok?: boolean;
}

export class UpdateDataStandardFromExcelRequest implements IUpdateDataStandardFromExcelRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;

    constructor(data?: IUpdateDataStandardFromExcelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.filterField = _data["filterField"];
            this.documentationStage = _data["documentationStage"];
            this.filterStage = _data["filterStage"];
            this.prefix = _data["prefix"];
            this.whiteSubstition = _data["whiteSubstition"];
            this.file = _data["file"];
            this.elementNameColumn = _data["elementNameColumn"];
            this.importCciValues = _data["importCciValues"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.cciPrefix = _data["cciPrefix"];
            this.cciName = _data["cciName"];
            this.dsPrefix = _data["dsPrefix"];
            this.dsName = _data["dsName"];
        }
    }

    static fromJS(data: any): UpdateDataStandardFromExcelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardFromExcelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["filterField"] = this.filterField;
        data["documentationStage"] = this.documentationStage;
        data["filterStage"] = this.filterStage;
        data["prefix"] = this.prefix;
        data["whiteSubstition"] = this.whiteSubstition;
        data["file"] = this.file;
        data["elementNameColumn"] = this.elementNameColumn;
        data["importCciValues"] = this.importCciValues;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["cciPrefix"] = this.cciPrefix;
        data["cciName"] = this.cciName;
        data["dsPrefix"] = this.dsPrefix;
        data["dsName"] = this.dsName;
        return data;
    }
}

export interface IUpdateDataStandardFromExcelRequest {
    standardId?: number;
    filterField?: string | undefined;
    documentationStage?: DocumentationStage;
    filterStage?: boolean;
    prefix?: string | undefined;
    whiteSubstition?: string | undefined;
    file?: string | undefined;
    elementNameColumn?: number;
    importCciValues?: boolean;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    cciPrefix?: string | undefined;
    cciName?: string | undefined;
    dsPrefix?: string | undefined;
    dsName?: string | undefined;
}

export class UpdateDataStandardFromExcelResponse implements IUpdateDataStandardFromExcelResponse {
    ok?: boolean;

    constructor(data?: IUpdateDataStandardFromExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateDataStandardFromExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardFromExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateDataStandardFromExcelResponse {
    ok?: boolean;
}

export class UpdateDataStandardRequest implements IUpdateDataStandardRequest {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    timestamp?: string | undefined;
    stage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    isDefaultStandard?: boolean;

    constructor(data?: IUpdateDataStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.classifierName = _data["classifierName"];
            this.timestamp = _data["timestamp"];
            this.stage = _data["stage"];
            this.isDataStandardSZ = _data["isDataStandardSZ"];
            this.postPrefixSkupiny = _data["postPrefixSkupiny"];
            this.ds_ds = _data["ds_ds"];
            this.isDefaultStandard = _data["isDefaultStandard"];
        }
    }

    static fromJS(data: any): UpdateDataStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["classifierName"] = this.classifierName;
        data["timestamp"] = this.timestamp;
        data["stage"] = this.stage;
        data["isDataStandardSZ"] = this.isDataStandardSZ;
        data["postPrefixSkupiny"] = this.postPrefixSkupiny;
        data["ds_ds"] = this.ds_ds;
        data["isDefaultStandard"] = this.isDefaultStandard;
        return data;
    }
}

export interface IUpdateDataStandardRequest {
    id?: number;
    name?: string | undefined;
    classifierName?: string | undefined;
    timestamp?: string | undefined;
    stage?: DocumentationStage;
    isDataStandardSZ?: boolean;
    postPrefixSkupiny?: string | undefined;
    ds_ds?: string | undefined;
    isDefaultStandard?: boolean;
}

export class UpdateDataStandardResponse implements IUpdateDataStandardResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
    dataStandard?: DataStandardDTO;

    constructor(data?: IUpdateDataStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.newTimestamp = _data["newTimestamp"];
            this.dataStandard = _data["dataStandard"] ? DataStandardDTO.fromJS(_data["dataStandard"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateDataStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["newTimestamp"] = this.newTimestamp;
        data["dataStandard"] = this.dataStandard ? this.dataStandard.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateDataStandardResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
    dataStandard?: DataStandardDTO;
}

export class UpdateDataStandardValRulesRequest implements IUpdateDataStandardValRulesRequest {
    valRuleIds?: number[] | undefined;
    validationRuleData?: PairerDetailValidationRuleDTO;
    namePrefixChecked?: boolean;
    fieldChecked?: boolean;
    attributeNameChecked?: boolean;
    attributeNumberChecked?: boolean;
    dataTypeChecked?: boolean;
    numberDecimalsChecked?: boolean;
    stagesPDChecked?: boolean;
    enumerationsChecked?: boolean;
    isNullableChecked?: boolean;
    hasConditionChecked?: boolean;
    examplesOfValuesChecked?: boolean;
    unitOfMeasureChecked?: boolean;
    isDsStandardChecked?: boolean;
    isCCIChecked?: boolean;
    expressionChecked?: boolean;
    expressionOpenXChecked?: boolean;
    validateDecimalPlacesChecked?: boolean;
    propertyIFCChecked?: boolean;
    definedTypeIFCChecked?: boolean;
    classIFCChecked?: boolean;
    predefinedTypeIFCChecked?: boolean;
    attributeIFCChecked?: boolean;
    descriptionChecked?: boolean;

    constructor(data?: IUpdateDataStandardValRulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valRuleIds"])) {
                this.valRuleIds = [] as any;
                for (let item of _data["valRuleIds"])
                    this.valRuleIds!.push(item);
            }
            this.validationRuleData = _data["validationRuleData"] ? PairerDetailValidationRuleDTO.fromJS(_data["validationRuleData"]) : undefined as any;
            this.namePrefixChecked = _data["namePrefixChecked"];
            this.fieldChecked = _data["fieldChecked"];
            this.attributeNameChecked = _data["attributeNameChecked"];
            this.attributeNumberChecked = _data["attributeNumberChecked"];
            this.dataTypeChecked = _data["dataTypeChecked"];
            this.numberDecimalsChecked = _data["numberDecimalsChecked"];
            this.stagesPDChecked = _data["stagesPDChecked"];
            this.enumerationsChecked = _data["enumerationsChecked"];
            this.isNullableChecked = _data["isNullableChecked"];
            this.hasConditionChecked = _data["hasConditionChecked"];
            this.examplesOfValuesChecked = _data["examplesOfValuesChecked"];
            this.unitOfMeasureChecked = _data["unitOfMeasureChecked"];
            this.isDsStandardChecked = _data["isDsStandardChecked"];
            this.isCCIChecked = _data["isCCIChecked"];
            this.expressionChecked = _data["expressionChecked"];
            this.expressionOpenXChecked = _data["expressionOpenXChecked"];
            this.validateDecimalPlacesChecked = _data["validateDecimalPlacesChecked"];
            this.propertyIFCChecked = _data["propertyIFCChecked"];
            this.definedTypeIFCChecked = _data["definedTypeIFCChecked"];
            this.classIFCChecked = _data["classIFCChecked"];
            this.predefinedTypeIFCChecked = _data["predefinedTypeIFCChecked"];
            this.attributeIFCChecked = _data["attributeIFCChecked"];
            this.descriptionChecked = _data["descriptionChecked"];
        }
    }

    static fromJS(data: any): UpdateDataStandardValRulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardValRulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valRuleIds)) {
            data["valRuleIds"] = [];
            for (let item of this.valRuleIds)
                data["valRuleIds"].push(item);
        }
        data["validationRuleData"] = this.validationRuleData ? this.validationRuleData.toJSON() : undefined as any;
        data["namePrefixChecked"] = this.namePrefixChecked;
        data["fieldChecked"] = this.fieldChecked;
        data["attributeNameChecked"] = this.attributeNameChecked;
        data["attributeNumberChecked"] = this.attributeNumberChecked;
        data["dataTypeChecked"] = this.dataTypeChecked;
        data["numberDecimalsChecked"] = this.numberDecimalsChecked;
        data["stagesPDChecked"] = this.stagesPDChecked;
        data["enumerationsChecked"] = this.enumerationsChecked;
        data["isNullableChecked"] = this.isNullableChecked;
        data["hasConditionChecked"] = this.hasConditionChecked;
        data["examplesOfValuesChecked"] = this.examplesOfValuesChecked;
        data["unitOfMeasureChecked"] = this.unitOfMeasureChecked;
        data["isDsStandardChecked"] = this.isDsStandardChecked;
        data["isCCIChecked"] = this.isCCIChecked;
        data["expressionChecked"] = this.expressionChecked;
        data["expressionOpenXChecked"] = this.expressionOpenXChecked;
        data["validateDecimalPlacesChecked"] = this.validateDecimalPlacesChecked;
        data["propertyIFCChecked"] = this.propertyIFCChecked;
        data["definedTypeIFCChecked"] = this.definedTypeIFCChecked;
        data["classIFCChecked"] = this.classIFCChecked;
        data["predefinedTypeIFCChecked"] = this.predefinedTypeIFCChecked;
        data["attributeIFCChecked"] = this.attributeIFCChecked;
        data["descriptionChecked"] = this.descriptionChecked;
        return data;
    }
}

export interface IUpdateDataStandardValRulesRequest {
    valRuleIds?: number[] | undefined;
    validationRuleData?: PairerDetailValidationRuleDTO;
    namePrefixChecked?: boolean;
    fieldChecked?: boolean;
    attributeNameChecked?: boolean;
    attributeNumberChecked?: boolean;
    dataTypeChecked?: boolean;
    numberDecimalsChecked?: boolean;
    stagesPDChecked?: boolean;
    enumerationsChecked?: boolean;
    isNullableChecked?: boolean;
    hasConditionChecked?: boolean;
    examplesOfValuesChecked?: boolean;
    unitOfMeasureChecked?: boolean;
    isDsStandardChecked?: boolean;
    isCCIChecked?: boolean;
    expressionChecked?: boolean;
    expressionOpenXChecked?: boolean;
    validateDecimalPlacesChecked?: boolean;
    propertyIFCChecked?: boolean;
    definedTypeIFCChecked?: boolean;
    classIFCChecked?: boolean;
    predefinedTypeIFCChecked?: boolean;
    attributeIFCChecked?: boolean;
    descriptionChecked?: boolean;
}

export class UpdateDataStandardValRulesResponse implements IUpdateDataStandardValRulesResponse {
    ok?: boolean;

    constructor(data?: IUpdateDataStandardValRulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateDataStandardValRulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataStandardValRulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateDataStandardValRulesResponse {
    ok?: boolean;
}

export class UpdateEnumCategoryRequest implements IUpdateEnumCategoryRequest {
    oldName?: string | undefined;
    newName?: string | undefined;

    constructor(data?: IUpdateEnumCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldName = _data["oldName"];
            this.newName = _data["newName"];
        }
    }

    static fromJS(data: any): UpdateEnumCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnumCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldName"] = this.oldName;
        data["newName"] = this.newName;
        return data;
    }
}

export interface IUpdateEnumCategoryRequest {
    oldName?: string | undefined;
    newName?: string | undefined;
}

export class UpdateEnumCategoryResponse implements IUpdateEnumCategoryResponse {
    ok?: boolean;

    constructor(data?: IUpdateEnumCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateEnumCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnumCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateEnumCategoryResponse {
    ok?: boolean;
}

export class UpdateGroupForStandardRequest implements IUpdateGroupForStandardRequest {
    groupId?: number;
    name?: string | undefined;
    color?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    updateColorAll?: boolean;

    constructor(data?: IUpdateGroupForStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.nameGroup = _data["nameGroup"];
            this.rowVersion = _data["rowVersion"];
            this.updateColorAll = _data["updateColorAll"];
        }
    }

    static fromJS(data: any): UpdateGroupForStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupForStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["color"] = this.color;
        data["nameGroup"] = this.nameGroup;
        data["rowVersion"] = this.rowVersion;
        data["updateColorAll"] = this.updateColorAll;
        return data;
    }
}

export interface IUpdateGroupForStandardRequest {
    groupId?: number;
    name?: string | undefined;
    color?: string | undefined;
    nameGroup?: string | undefined;
    rowVersion?: string | undefined;
    updateColorAll?: boolean;
}

export class UpdateImportDSSettingRequest implements IUpdateImportDSSettingRequest {
    isUpdateFromOptions?: boolean;
    importDSSetting?: ImportDSSettingDTO;

    constructor(data?: IUpdateImportDSSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUpdateFromOptions = _data["isUpdateFromOptions"];
            this.importDSSetting = _data["importDSSetting"] ? ImportDSSettingDTO.fromJS(_data["importDSSetting"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateImportDSSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImportDSSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpdateFromOptions"] = this.isUpdateFromOptions;
        data["importDSSetting"] = this.importDSSetting ? this.importDSSetting.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateImportDSSettingRequest {
    isUpdateFromOptions?: boolean;
    importDSSetting?: ImportDSSettingDTO;
}

export class UpdateImportDSSettingResponse implements IUpdateImportDSSettingResponse {
    ok?: boolean;

    constructor(data?: IUpdateImportDSSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateImportDSSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImportDSSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateImportDSSettingResponse {
    ok?: boolean;
}

export class UpdateInfoResponse implements IUpdateInfoResponse {
    version?: string | undefined;
    updateUri?: string | undefined;
    updateId?: number;

    constructor(data?: IUpdateInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.updateUri = _data["updateUri"];
            this.updateId = _data["updateId"];
        }
    }

    static fromJS(data: any): UpdateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["updateUri"] = this.updateUri;
        data["updateId"] = this.updateId;
        return data;
    }
}

export interface IUpdateInfoResponse {
    version?: string | undefined;
    updateUri?: string | undefined;
    updateId?: number;
}

export class UpdateMicrostationPairingRequest implements IUpdateMicrostationPairingRequest {
    id?: number;
    projectId?: number;
    name?: string | undefined;

    constructor(data?: IUpdateMicrostationPairingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateMicrostationPairingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMicrostationPairingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateMicrostationPairingRequest {
    id?: number;
    projectId?: number;
    name?: string | undefined;
}

export class UpdateMicrostationPairingResponse implements IUpdateMicrostationPairingResponse {
    ok?: boolean;

    constructor(data?: IUpdateMicrostationPairingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMicrostationPairingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMicrostationPairingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMicrostationPairingResponse {
    ok?: boolean;
}

export class UpdateMStnFeederAutoValuesRequest implements IUpdateMStnFeederAutoValuesRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    ignoreLocked?: boolean;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederAutoValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            this.ignoreLocked = _data["ignoreLocked"];
            if (Array.isArray(_data["feederAutoValues"])) {
                this.feederAutoValues = [] as any;
                for (let item of _data["feederAutoValues"])
                    this.feederAutoValues!.push(MStnFeederAutoValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        data["ignoreLocked"] = this.ignoreLocked;
        if (Array.isArray(this.feederAutoValues)) {
            data["feederAutoValues"] = [];
            for (let item of this.feederAutoValues)
                data["feederAutoValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    ignoreLocked?: boolean;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;
}

export class UpdateMStnFeederAutoValuesResponse implements IUpdateMStnFeederAutoValuesResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederAutoValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesResponse {
    ok?: boolean;
}

export class UpdateMStnFeederAutoValuesToManualRequest implements IUpdateMStnFeederAutoValuesToManualRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    ignoreLocked?: boolean;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederAutoValuesToManualRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            this.ignoreLocked = _data["ignoreLocked"];
            if (Array.isArray(_data["feederAutoValues"])) {
                this.feederAutoValues = [] as any;
                for (let item of _data["feederAutoValues"])
                    this.feederAutoValues!.push(MStnFeederAutoValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesToManualRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesToManualRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        data["ignoreLocked"] = this.ignoreLocked;
        if (Array.isArray(this.feederAutoValues)) {
            data["feederAutoValues"] = [];
            for (let item of this.feederAutoValues)
                data["feederAutoValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesToManualRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    ignoreLocked?: boolean;
    feederAutoValues?: MStnFeederAutoValueDTO[] | undefined;
}

export class UpdateMStnFeederAutoValuesToManualResponse implements IUpdateMStnFeederAutoValuesToManualResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederAutoValuesToManualResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederAutoValuesToManualResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederAutoValuesToManualResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederAutoValuesToManualResponse {
    ok?: boolean;
}

export class UpdateMStnFeederCurveNameRequest implements IUpdateMStnFeederCurveNameRequest {
    id?: number;
    curveName?: string | undefined;

    constructor(data?: IUpdateMStnFeederCurveNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.curveName = _data["curveName"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederCurveNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederCurveNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["curveName"] = this.curveName;
        return data;
    }
}

export interface IUpdateMStnFeederCurveNameRequest {
    id?: number;
    curveName?: string | undefined;
}

export class UpdateMStnFeederCurveNameResponse implements IUpdateMStnFeederCurveNameResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederCurveNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederCurveNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederCurveNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederCurveNameResponse {
    ok?: boolean;
}

export class UpdateMStnFeederCurveRequest implements IUpdateMStnFeederCurveRequest {
    id?: number;
    name?: string | undefined;
    startStationing?: number | undefined;

    constructor(data?: IUpdateMStnFeederCurveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startStationing = _data["startStationing"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederCurveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederCurveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startStationing"] = this.startStationing;
        return data;
    }
}

export interface IUpdateMStnFeederCurveRequest {
    id?: number;
    name?: string | undefined;
    startStationing?: number | undefined;
}

export class UpdateMStnFeederCurveResponse implements IUpdateMStnFeederCurveResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederCurveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederCurveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederCurveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederCurveResponse {
    ok?: boolean;
}

export class UpdateMStnFeederElementStationingDTO implements IUpdateMStnFeederElementStationingDTO {
    id?: number;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;

    constructor(data?: IUpdateMStnFeederElementStationingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alignmentName2 = _data["alignmentName2"];
            this.alignmentName3 = _data["alignmentName3"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederElementStationingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederElementStationingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alignmentName2"] = this.alignmentName2;
        data["alignmentName3"] = this.alignmentName3;
        return data;
    }
}

export interface IUpdateMStnFeederElementStationingDTO {
    id?: number;
    alignmentName2?: string | undefined;
    alignmentName3?: string | undefined;
}

export class UpdateMStnFeederFromDGNRequest implements IUpdateMStnFeederFromDGNRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    feederItems?: MStnFeederFromDGNDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederFromDGNRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mStnPairingId = _data["mStnPairingId"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            if (Array.isArray(_data["feederItems"])) {
                this.feederItems = [] as any;
                for (let item of _data["feederItems"])
                    this.feederItems!.push(MStnFeederFromDGNDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederFromDGNRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederFromDGNRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mStnPairingId"] = this.mStnPairingId;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        if (Array.isArray(this.feederItems)) {
            data["feederItems"] = [];
            for (let item of this.feederItems)
                data["feederItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateMStnFeederFromDGNRequest {
    mStnPairingId?: number;
    isFeatureDefinitions?: boolean;
    feederItems?: MStnFeederFromDGNDTO[] | undefined;
}

export class UpdateMStnFeederFromDGNResponse implements IUpdateMStnFeederFromDGNResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederFromDGNResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederFromDGNResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederFromDGNResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederFromDGNResponse {
    ok?: boolean;
}

export class UpdateMStnFeederIsMultipleRoutesRequest implements IUpdateMStnFeederIsMultipleRoutesRequest {
    id?: number;
    isMultipleRoutes?: boolean;

    constructor(data?: IUpdateMStnFeederIsMultipleRoutesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isMultipleRoutes = _data["isMultipleRoutes"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederIsMultipleRoutesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederIsMultipleRoutesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isMultipleRoutes"] = this.isMultipleRoutes;
        return data;
    }
}

export interface IUpdateMStnFeederIsMultipleRoutesRequest {
    id?: number;
    isMultipleRoutes?: boolean;
}

export class UpdateMStnFeederIsMultipleRoutesResponse implements IUpdateMStnFeederIsMultipleRoutesResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederIsMultipleRoutesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederIsMultipleRoutesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederIsMultipleRoutesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederIsMultipleRoutesResponse {
    ok?: boolean;
}

export class UpdateMStnFeederItemDTO implements IUpdateMStnFeederItemDTO {
    ids?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    childElementIds?: string[] | undefined;

    constructor(data?: IUpdateMStnFeederItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.value = _data["value"];
            this.overwrite = _data["overwrite"];
            this.isLocked = _data["isLocked"];
            this.autoValueType = _data["autoValueType"];
            this.stringValueType = _data["stringValueType"];
            this.dateValueType = _data["dateValueType"];
            this.autoValueState = _data["autoValueState"];
            this.autoValue = _data["autoValue"];
            if (Array.isArray(_data["childElementIds"])) {
                this.childElementIds = [] as any;
                for (let item of _data["childElementIds"])
                    this.childElementIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["value"] = this.value;
        data["overwrite"] = this.overwrite;
        data["isLocked"] = this.isLocked;
        data["autoValueType"] = this.autoValueType;
        data["stringValueType"] = this.stringValueType;
        data["dateValueType"] = this.dateValueType;
        data["autoValueState"] = this.autoValueState;
        data["autoValue"] = this.autoValue;
        if (Array.isArray(this.childElementIds)) {
            data["childElementIds"] = [];
            for (let item of this.childElementIds)
                data["childElementIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateMStnFeederItemDTO {
    ids?: number[] | undefined;
    value?: string | undefined;
    overwrite?: boolean;
    isLocked?: boolean;
    autoValueType?: FeederAutoValueType;
    stringValueType?: FeederStringValueType;
    dateValueType?: FeederDateValueType;
    autoValueState?: FeederAutoValueState;
    autoValue?: string | undefined;
    childElementIds?: string[] | undefined;
}

export class UpdateMStnFeederItemsRequest implements IUpdateMStnFeederItemsRequest {
    isImportExcel?: boolean;
    isOverwriteOrLockChanged?: boolean;
    isFeatureDefinitions?: boolean;
    items?: UpdateMStnFeederItemDTO[] | undefined;

    constructor(data?: IUpdateMStnFeederItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isImportExcel = _data["isImportExcel"];
            this.isOverwriteOrLockChanged = _data["isOverwriteOrLockChanged"];
            this.isFeatureDefinitions = _data["isFeatureDefinitions"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UpdateMStnFeederItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isImportExcel"] = this.isImportExcel;
        data["isOverwriteOrLockChanged"] = this.isOverwriteOrLockChanged;
        data["isFeatureDefinitions"] = this.isFeatureDefinitions;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateMStnFeederItemsRequest {
    isImportExcel?: boolean;
    isOverwriteOrLockChanged?: boolean;
    isFeatureDefinitions?: boolean;
    items?: UpdateMStnFeederItemDTO[] | undefined;
}

export class UpdateMStnFeederItemsResponse implements IUpdateMStnFeederItemsResponse {
    ok?: boolean;
    removedItems?: number[] | undefined;

    constructor(data?: IUpdateMStnFeederItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["removedItems"])) {
                this.removedItems = [] as any;
                for (let item of _data["removedItems"])
                    this.removedItems!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMStnFeederItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.removedItems)) {
            data["removedItems"] = [];
            for (let item of this.removedItems)
                data["removedItems"].push(item);
        }
        return data;
    }
}

export interface IUpdateMStnFeederItemsResponse {
    ok?: boolean;
    removedItems?: number[] | undefined;
}

export class UpdateMStnFeederStartStationingRequest implements IUpdateMStnFeederStartStationingRequest {
    id?: number;
    startStationing?: number;

    constructor(data?: IUpdateMStnFeederStartStationingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startStationing = _data["startStationing"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederStartStationingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederStartStationingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startStationing"] = this.startStationing;
        return data;
    }
}

export interface IUpdateMStnFeederStartStationingRequest {
    id?: number;
    startStationing?: number;
}

export class UpdateMStnFeederStartStationingResponse implements IUpdateMStnFeederStartStationingResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnFeederStartStationingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnFeederStartStationingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnFeederStartStationingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnFeederStartStationingResponse {
    ok?: boolean;
}

export class UpdateMStnPairingFilteredPairerGroupsRequest implements IUpdateMStnPairingFilteredPairerGroupsRequest {
    id?: number;
    filteredPairerGroupIds?: number[] | undefined;

    constructor(data?: IUpdateMStnPairingFilteredPairerGroupsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["filteredPairerGroupIds"])) {
                this.filteredPairerGroupIds = [] as any;
                for (let item of _data["filteredPairerGroupIds"])
                    this.filteredPairerGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMStnPairingFilteredPairerGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnPairingFilteredPairerGroupsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.filteredPairerGroupIds)) {
            data["filteredPairerGroupIds"] = [];
            for (let item of this.filteredPairerGroupIds)
                data["filteredPairerGroupIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateMStnPairingFilteredPairerGroupsRequest {
    id?: number;
    filteredPairerGroupIds?: number[] | undefined;
}

export class UpdateMStnPairingFilteredPairerGroupsResponse implements IUpdateMStnPairingFilteredPairerGroupsResponse {
    ok?: boolean;

    constructor(data?: IUpdateMStnPairingFilteredPairerGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateMStnPairingFilteredPairerGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMStnPairingFilteredPairerGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateMStnPairingFilteredPairerGroupsResponse {
    ok?: boolean;
}

export class UpdateOrGroupRequest implements IUpdateOrGroupRequest {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateOrGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateOrGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateOrGroupRequest {
    id?: number;
    name?: string | undefined;
}

export class UpdateOrGroupResponse implements IUpdateOrGroupResponse {
    ok?: boolean;

    constructor(data?: IUpdateOrGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateOrGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateOrGroupResponse {
    ok?: boolean;
}

export class UpdatePairerRequest implements IUpdatePairerRequest {
    id?: number;
    simplifiedSave?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;

    constructor(data?: IUpdatePairerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.simplifiedSave = _data["simplifiedSave"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.colorR = _data["colorR"];
            this.colorG = _data["colorG"];
            this.colorB = _data["colorB"];
            this.precisionDUR = _data["precisionDUR"];
            this.precisionDSP = _data["precisionDSP"];
            this.precisionPDPS = _data["precisionPDPS"];
            this.precisionRDS = _data["precisionRDS"];
            this.precisionDSPS = _data["precisionDSPS"];
            this.precisionDUSP = _data["precisionDUSP"];
            this.precisionDRS = _data["precisionDRS"];
            this.precisionDPS = _data["precisionDPS"];
            this.filter = _data["filter"];
            this.groupId = _data["groupId"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): UpdatePairerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePairerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["simplifiedSave"] = this.simplifiedSave;
        data["code"] = this.code;
        data["name"] = this.name;
        data["colorR"] = this.colorR;
        data["colorG"] = this.colorG;
        data["colorB"] = this.colorB;
        data["precisionDUR"] = this.precisionDUR;
        data["precisionDSP"] = this.precisionDSP;
        data["precisionPDPS"] = this.precisionPDPS;
        data["precisionRDS"] = this.precisionRDS;
        data["precisionDSPS"] = this.precisionDSPS;
        data["precisionDUSP"] = this.precisionDUSP;
        data["precisionDRS"] = this.precisionDRS;
        data["precisionDPS"] = this.precisionDPS;
        data["filter"] = this.filter;
        data["groupId"] = this.groupId;
        data["rowVersion"] = this.rowVersion;
        return data;
    }
}

export interface IUpdatePairerRequest {
    id?: number;
    simplifiedSave?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    colorR?: number;
    colorG?: number;
    colorB?: number;
    precisionDUR?: string | undefined;
    precisionDSP?: string | undefined;
    precisionPDPS?: string | undefined;
    precisionRDS?: string | undefined;
    precisionDSPS?: string | undefined;
    precisionDUSP?: string | undefined;
    precisionDRS?: string | undefined;
    precisionDPS?: string | undefined;
    filter?: string | undefined;
    groupId?: number;
    rowVersion?: string | undefined;
}

export class UpdateProjectDataRequest implements IUpdateProjectDataRequest {
    projectId?: number;
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;

    constructor(data?: IUpdateProjectDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.description = _data["description"];
            this.projectManager = _data["projectManager"];
            this.authorizedPersons = _data["authorizedPersons"];
            this.otherFeatures = _data["otherFeatures"];
        }
    }

    static fromJS(data: any): UpdateProjectDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["description"] = this.description;
        data["projectManager"] = this.projectManager;
        data["authorizedPersons"] = this.authorizedPersons;
        data["otherFeatures"] = this.otherFeatures;
        return data;
    }
}

export interface IUpdateProjectDataRequest {
    projectId?: number;
    projectName?: string | undefined;
    description?: string | undefined;
    projectManager?: string | undefined;
    authorizedPersons?: string | undefined;
    otherFeatures?: string | undefined;
}

export class UpdateProjectDataResponse implements IUpdateProjectDataResponse {
    ok?: boolean;

    constructor(data?: IUpdateProjectDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateProjectDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateProjectDataResponse {
    ok?: boolean;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    description?: string | undefined;
    type?: ProjectType;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInBimCabinet = _data["showInBimCabinet"];
            this.customImageUri = _data["customImageUri"];
            this.drawer = _data["drawer"];
            this.investor = _data["investor"];
            this.stage = _data["stage"];
            this.drawingSoftware = _data["drawingSoftware"];
            this.cde = _data["cde"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInBimCabinet"] = this.showInBimCabinet;
        data["customImageUri"] = this.customImageUri;
        data["drawer"] = this.drawer;
        data["investor"] = this.investor;
        data["stage"] = this.stage;
        data["drawingSoftware"] = this.drawingSoftware;
        data["cde"] = this.cde;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    showInBimCabinet?: boolean;
    customImageUri?: string | undefined;
    drawer?: string | undefined;
    investor?: string | undefined;
    stage?: string | undefined;
    drawingSoftware?: string | undefined;
    cde?: string | undefined;
    description?: string | undefined;
    type?: ProjectType;
}

export class UpdateProjectResponse implements IUpdateProjectResponse {
    ok?: boolean;

    constructor(data?: IUpdateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateProjectResponse {
    ok?: boolean;
}

export class UpdateQueryRequest implements IUpdateQueryRequest {
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    isShared?: boolean | undefined;
    type?: SavedQueryType;

    constructor(data?: IUpdateQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sqlQuery = _data["sqlQuery"];
            this.isShared = _data["isShared"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UpdateQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sqlQuery"] = this.sqlQuery;
        data["isShared"] = this.isShared;
        data["type"] = this.type;
        return data;
    }
}

export interface IUpdateQueryRequest {
    name?: string | undefined;
    description?: string | undefined;
    sqlQuery?: string | undefined;
    isShared?: boolean | undefined;
    type?: SavedQueryType;
}

export class UpdateResponse implements IUpdateResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;

    constructor(data?: IUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.isConcurrency = _data["isConcurrency"];
            this.newTimestamp = _data["newTimestamp"];
        }
    }

    static fromJS(data: any): UpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["isConcurrency"] = this.isConcurrency;
        data["newTimestamp"] = this.newTimestamp;
        return data;
    }
}

export interface IUpdateResponse {
    ok?: boolean;
    isConcurrency?: boolean;
    newTimestamp?: string | undefined;
}

export class UpdateRouteRequest implements IUpdateRouteRequest {
    id?: number;
    name?: string | undefined;
    state?: number;

    constructor(data?: IUpdateRouteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateRouteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRouteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateRouteRequest {
    id?: number;
    name?: string | undefined;
    state?: number;
}

export class UpdateRouteResponse implements IUpdateRouteResponse {
    ok?: boolean;

    constructor(data?: IUpdateRouteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateRouteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRouteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateRouteResponse {
    ok?: boolean;
}

export class UpdateShareDataStandardsRequest implements IUpdateShareDataStandardsRequest {
    tenantDataStandardsSharing?: TenantDataStandardSharingDTO[] | undefined;

    constructor(data?: IUpdateShareDataStandardsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantDataStandardsSharing"])) {
                this.tenantDataStandardsSharing = [] as any;
                for (let item of _data["tenantDataStandardsSharing"])
                    this.tenantDataStandardsSharing!.push(TenantDataStandardSharingDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateShareDataStandardsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShareDataStandardsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantDataStandardsSharing)) {
            data["tenantDataStandardsSharing"] = [];
            for (let item of this.tenantDataStandardsSharing)
                data["tenantDataStandardsSharing"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateShareDataStandardsRequest {
    tenantDataStandardsSharing?: TenantDataStandardSharingDTO[] | undefined;
}

export class UpdateShareDataStandardsResponse implements IUpdateShareDataStandardsResponse {
    success?: boolean;

    constructor(data?: IUpdateShareDataStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateShareDataStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateShareDataStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateShareDataStandardsResponse {
    success?: boolean;
}

export class UpdateValidationsRuleRequest implements IUpdateValidationsRuleRequest {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    condition?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    dataType?: DataTypeValidation;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    timestamp?: string | undefined;

    constructor(data?: IUpdateValidationsRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.namePrefix = _data["namePrefix"];
            this.name = _data["name"];
            this.field = _data["field"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.examplesOfValues = _data["examplesOfValues"];
            this.propertyIFC = _data["propertyIFC"];
            this.definedTypeIFC = _data["definedTypeIFC"];
            this.classIFC = _data["classIFC"];
            this.predefinedTypeIFC = _data["predefinedTypeIFC"];
            this.attributeIFC = _data["attributeIFC"];
            this.nullable = _data["nullable"];
            this.isCCI = _data["isCCI"];
            this.isDsStandard = _data["isDsStandard"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.condition = _data["condition"];
            this.attributeName = _data["attributeName"];
            this.attributeNumber = _data["attributeNumber"];
            this.validateDecimalPlaces = _data["validateDecimalPlaces"];
            this.description = _data["description"];
            this.dur = _data["dur"];
            this.dsp = _data["dsp"];
            this.pdps = _data["pdps"];
            this.rds = _data["rds"];
            this.dsps = _data["dsps"];
            this.dusp = _data["dusp"];
            this.drs = _data["drs"];
            this.dps = _data["dps"];
            this.valueCondition = _data["valueCondition"] ? ValueConditionModelDTO.fromJS(_data["valueCondition"]) : undefined as any;
            this.dataType = _data["dataType"];
            if (Array.isArray(_data["enumConditions"])) {
                this.enumConditions = [] as any;
                for (let item of _data["enumConditions"])
                    this.enumConditions!.push(ValueConditionEnumerationDTO.fromJS(item));
            }
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): UpdateValidationsRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateValidationsRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["namePrefix"] = this.namePrefix;
        data["name"] = this.name;
        data["field"] = this.field;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["examplesOfValues"] = this.examplesOfValues;
        data["propertyIFC"] = this.propertyIFC;
        data["definedTypeIFC"] = this.definedTypeIFC;
        data["classIFC"] = this.classIFC;
        data["predefinedTypeIFC"] = this.predefinedTypeIFC;
        data["attributeIFC"] = this.attributeIFC;
        data["nullable"] = this.nullable;
        data["isCCI"] = this.isCCI;
        data["isDsStandard"] = this.isDsStandard;
        data["decimalPlaces"] = this.decimalPlaces;
        data["condition"] = this.condition;
        data["attributeName"] = this.attributeName;
        data["attributeNumber"] = this.attributeNumber;
        data["validateDecimalPlaces"] = this.validateDecimalPlaces;
        data["description"] = this.description;
        data["dur"] = this.dur;
        data["dsp"] = this.dsp;
        data["pdps"] = this.pdps;
        data["rds"] = this.rds;
        data["dsps"] = this.dsps;
        data["dusp"] = this.dusp;
        data["drs"] = this.drs;
        data["dps"] = this.dps;
        data["valueCondition"] = this.valueCondition ? this.valueCondition.toJSON() : undefined as any;
        data["dataType"] = this.dataType;
        if (Array.isArray(this.enumConditions)) {
            data["enumConditions"] = [];
            for (let item of this.enumConditions)
                data["enumConditions"].push(item ? item.toJSON() : undefined as any);
        }
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IUpdateValidationsRuleRequest {
    id?: number;
    namePrefix?: string | undefined;
    name?: string | undefined;
    field?: string | undefined;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    propertyIFC?: string | undefined;
    definedTypeIFC?: string | undefined;
    classIFC?: string | undefined;
    predefinedTypeIFC?: string | undefined;
    attributeIFC?: string | undefined;
    nullable?: boolean;
    isCCI?: boolean;
    isDsStandard?: boolean;
    decimalPlaces?: number | undefined;
    condition?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    validateDecimalPlaces?: boolean;
    description?: string | undefined;
    dur?: number;
    dsp?: number;
    pdps?: number;
    rds?: number;
    dsps?: number;
    dusp?: number;
    drs?: number;
    dps?: number;
    valueCondition?: ValueConditionModelDTO;
    dataType?: DataTypeValidation;
    enumConditions?: ValueConditionEnumerationDTO[] | undefined;
    timestamp?: string | undefined;
}

export class UploadBlockResponse implements IUploadBlockResponse {
    ok?: boolean;

    constructor(data?: IUploadBlockResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UploadBlockResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBlockResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUploadBlockResponse {
    ok?: boolean;
}

export class UploadCustomImageForProjectResponse implements IUploadCustomImageForProjectResponse {
    uri?: string | undefined;

    constructor(data?: IUploadCustomImageForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): UploadCustomImageForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCustomImageForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        return data;
    }
}

export interface IUploadCustomImageForProjectResponse {
    uri?: string | undefined;
}

export class UploadDocumentationForProjectResponse implements IUploadDocumentationForProjectResponse {
    uri?: string | undefined;

    constructor(data?: IUploadDocumentationForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): UploadDocumentationForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentationForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        return data;
    }
}

export interface IUploadDocumentationForProjectResponse {
    uri?: string | undefined;
}

export class UploadIdsImportFileResponse implements IUploadIdsImportFileResponse {
    ok?: boolean;
    done?: boolean;

    constructor(data?: IUploadIdsImportFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UploadIdsImportFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadIdsImportFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["done"] = this.done;
        return data;
    }
}

export interface IUploadIdsImportFileResponse {
    ok?: boolean;
    done?: boolean;
}

export enum UserIntent {
    DisplayTable = "DisplayTable",
    Count = "Count",
    Sum = "Sum",
    Average = "Average",
    GroupBy = "GroupBy",
    Compare = "Compare",
    DataInsight = "DataInsight",
    FindExtremes = "FindExtremes",
    Filter = "Filter",
    ListDistinct = "ListDistinct",
    Search = "Search",
    ContinueOnContext = "ContinueOnContext",
    ListOverview = "ListOverview",
    FilterByRange = "FilterByRange",
}

export class ValidateModelAndReturnByPairersDatabaseRequest implements IValidateModelAndReturnByPairersDatabaseRequest {
    standardId?: number;
    projectId?: number;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;
    documentationStage?: DocumentationStage;

    constructor(data?: IValidateModelAndReturnByPairersDatabaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.projectId = _data["projectId"];
            this.onlySomeGroups = _data["onlySomeGroups"];
            this.validateConditions = _data["validateConditions"];
            this.validateNonStandard = _data["validateNonStandard"];
            if (Array.isArray(_data["selectedGroupIds"])) {
                this.selectedGroupIds = [] as any;
                for (let item of _data["selectedGroupIds"])
                    this.selectedGroupIds!.push(item);
            }
            this.documentationStage = _data["documentationStage"];
        }
    }

    static fromJS(data: any): ValidateModelAndReturnByPairersDatabaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelAndReturnByPairersDatabaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["projectId"] = this.projectId;
        data["onlySomeGroups"] = this.onlySomeGroups;
        data["validateConditions"] = this.validateConditions;
        data["validateNonStandard"] = this.validateNonStandard;
        if (Array.isArray(this.selectedGroupIds)) {
            data["selectedGroupIds"] = [];
            for (let item of this.selectedGroupIds)
                data["selectedGroupIds"].push(item);
        }
        data["documentationStage"] = this.documentationStage;
        return data;
    }
}

export interface IValidateModelAndReturnByPairersDatabaseRequest {
    standardId?: number;
    projectId?: number;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;
    documentationStage?: DocumentationStage;
}

export class ValidateModelAndReturnByPairersRequest implements IValidateModelAndReturnByPairersRequest {
    standardId?: number;
    modelData?: string | undefined;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;
    documentationStage?: DocumentationStage;

    constructor(data?: IValidateModelAndReturnByPairersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.modelData = _data["modelData"];
            this.onlySomeGroups = _data["onlySomeGroups"];
            this.validateConditions = _data["validateConditions"];
            this.validateNonStandard = _data["validateNonStandard"];
            if (Array.isArray(_data["selectedGroupIds"])) {
                this.selectedGroupIds = [] as any;
                for (let item of _data["selectedGroupIds"])
                    this.selectedGroupIds!.push(item);
            }
            this.documentationStage = _data["documentationStage"];
        }
    }

    static fromJS(data: any): ValidateModelAndReturnByPairersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelAndReturnByPairersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["modelData"] = this.modelData;
        data["onlySomeGroups"] = this.onlySomeGroups;
        data["validateConditions"] = this.validateConditions;
        data["validateNonStandard"] = this.validateNonStandard;
        if (Array.isArray(this.selectedGroupIds)) {
            data["selectedGroupIds"] = [];
            for (let item of this.selectedGroupIds)
                data["selectedGroupIds"].push(item);
        }
        data["documentationStage"] = this.documentationStage;
        return data;
    }
}

export interface IValidateModelAndReturnByPairersRequest {
    standardId?: number;
    modelData?: string | undefined;
    onlySomeGroups?: boolean;
    validateConditions?: boolean;
    validateNonStandard?: boolean;
    selectedGroupIds?: number[] | undefined;
    documentationStage?: DocumentationStage;
}

export class ValidateModelAndReturnByPairersResponse implements IValidateModelAndReturnByPairersResponse {
    validationsResult?: ValidationTreeResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
    elementsCount?: number;
    okPercentage?: number;
    okCount?: number;
    warningPercentage?: number;
    warningCount?: number;
    errorPercentage?: number;
    errorCount?: number;
    missingFieldErrorsCount?: number;
    nullableErrorsCount?: number;
    dataTypeErrorsCount?: number;
    conditionErrorsCount?: number;
    elementsCheckedCount?: number;
    invalidFieldErrorsCount?: number;
    stats?: ResultStatsDTO[] | undefined;
    uncheckedElements?: UncheckedElementDTO[] | undefined;
    unusedPairers?: PairerDTO[] | undefined;
    validationServerTime?: Date;

    constructor(data?: IValidateModelAndReturnByPairersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationsResult"])) {
                this.validationsResult = [] as any;
                for (let item of _data["validationsResult"])
                    this.validationsResult!.push(ValidationTreeResultDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
            this.elementsCount = _data["elementsCount"];
            this.okPercentage = _data["okPercentage"];
            this.okCount = _data["okCount"];
            this.warningPercentage = _data["warningPercentage"];
            this.warningCount = _data["warningCount"];
            this.errorPercentage = _data["errorPercentage"];
            this.errorCount = _data["errorCount"];
            this.missingFieldErrorsCount = _data["missingFieldErrorsCount"];
            this.nullableErrorsCount = _data["nullableErrorsCount"];
            this.dataTypeErrorsCount = _data["dataTypeErrorsCount"];
            this.conditionErrorsCount = _data["conditionErrorsCount"];
            this.elementsCheckedCount = _data["elementsCheckedCount"];
            this.invalidFieldErrorsCount = _data["invalidFieldErrorsCount"];
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(ResultStatsDTO.fromJS(item));
            }
            if (Array.isArray(_data["uncheckedElements"])) {
                this.uncheckedElements = [] as any;
                for (let item of _data["uncheckedElements"])
                    this.uncheckedElements!.push(UncheckedElementDTO.fromJS(item));
            }
            if (Array.isArray(_data["unusedPairers"])) {
                this.unusedPairers = [] as any;
                for (let item of _data["unusedPairers"])
                    this.unusedPairers!.push(PairerDTO.fromJS(item));
            }
            this.validationServerTime = _data["validationServerTime"] ? new Date(_data["validationServerTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ValidateModelAndReturnByPairersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelAndReturnByPairersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationsResult)) {
            data["validationsResult"] = [];
            for (let item of this.validationsResult)
                data["validationsResult"].push(item ? item.toJSON() : undefined as any);
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        data["elementsCount"] = this.elementsCount;
        data["okPercentage"] = this.okPercentage;
        data["okCount"] = this.okCount;
        data["warningPercentage"] = this.warningPercentage;
        data["warningCount"] = this.warningCount;
        data["errorPercentage"] = this.errorPercentage;
        data["errorCount"] = this.errorCount;
        data["missingFieldErrorsCount"] = this.missingFieldErrorsCount;
        data["nullableErrorsCount"] = this.nullableErrorsCount;
        data["dataTypeErrorsCount"] = this.dataTypeErrorsCount;
        data["conditionErrorsCount"] = this.conditionErrorsCount;
        data["elementsCheckedCount"] = this.elementsCheckedCount;
        data["invalidFieldErrorsCount"] = this.invalidFieldErrorsCount;
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.uncheckedElements)) {
            data["uncheckedElements"] = [];
            for (let item of this.uncheckedElements)
                data["uncheckedElements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.unusedPairers)) {
            data["unusedPairers"] = [];
            for (let item of this.unusedPairers)
                data["unusedPairers"].push(item ? item.toJSON() : undefined as any);
        }
        data["validationServerTime"] = this.validationServerTime ? this.validationServerTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IValidateModelAndReturnByPairersResponse {
    validationsResult?: ValidationTreeResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
    elementsCount?: number;
    okPercentage?: number;
    okCount?: number;
    warningPercentage?: number;
    warningCount?: number;
    errorPercentage?: number;
    errorCount?: number;
    missingFieldErrorsCount?: number;
    nullableErrorsCount?: number;
    dataTypeErrorsCount?: number;
    conditionErrorsCount?: number;
    elementsCheckedCount?: number;
    invalidFieldErrorsCount?: number;
    stats?: ResultStatsDTO[] | undefined;
    uncheckedElements?: UncheckedElementDTO[] | undefined;
    unusedPairers?: PairerDTO[] | undefined;
    validationServerTime?: Date;
}

export class ValidateModelRequest implements IValidateModelRequest {
    standardId?: number;
    modelData?: string | undefined;
    validateConditions?: boolean;

    constructor(data?: IValidateModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardId = _data["standardId"];
            this.modelData = _data["modelData"];
            this.validateConditions = _data["validateConditions"];
        }
    }

    static fromJS(data: any): ValidateModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardId"] = this.standardId;
        data["modelData"] = this.modelData;
        data["validateConditions"] = this.validateConditions;
        return data;
    }
}

export interface IValidateModelRequest {
    standardId?: number;
    modelData?: string | undefined;
    validateConditions?: boolean;
}

export class ValidateModelResponse implements IValidateModelResponse {
    validationsResult?: ValidationRowResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;

    constructor(data?: IValidateModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationsResult"])) {
                this.validationsResult = [] as any;
                for (let item of _data["validationsResult"])
                    this.validationsResult!.push(ValidationRowResultDTO.fromJS(item));
            }
            this.elapsedTimeMilliseconds = _data["elapsedTimeMilliseconds"];
        }
    }

    static fromJS(data: any): ValidateModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationsResult)) {
            data["validationsResult"] = [];
            for (let item of this.validationsResult)
                data["validationsResult"].push(item ? item.toJSON() : undefined as any);
        }
        data["elapsedTimeMilliseconds"] = this.elapsedTimeMilliseconds;
        return data;
    }
}

export interface IValidateModelResponse {
    validationsResult?: ValidationRowResultDTO[] | undefined;
    elapsedTimeMilliseconds?: number;
}

export class ValidateTiltTreeDataRequest implements IValidateTiltTreeDataRequest {
    projectId?: number;

    constructor(data?: IValidateTiltTreeDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ValidateTiltTreeDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTiltTreeDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IValidateTiltTreeDataRequest {
    projectId?: number;
}

export class ValidateTiltTreeDataResponse implements IValidateTiltTreeDataResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    corridors?: CorridorDTO[] | undefined;

    constructor(data?: IValidateTiltTreeDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectData = _data["projectData"] ? ProjectDataDTO.fromJS(_data["projectData"]) : undefined as any;
            if (Array.isArray(_data["corridors"])) {
                this.corridors = [] as any;
                for (let item of _data["corridors"])
                    this.corridors!.push(CorridorDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateTiltTreeDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateTiltTreeDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectData"] = this.projectData ? this.projectData.toJSON() : undefined as any;
        if (Array.isArray(this.corridors)) {
            data["corridors"] = [];
            for (let item of this.corridors)
                data["corridors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidateTiltTreeDataResponse {
    projectId?: number;
    projectData?: ProjectDataDTO;
    corridors?: CorridorDTO[] | undefined;
}

export class ValidationDesignCrossSectionRequestDTO implements IValidationDesignCrossSectionRequestDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    isEndStation?: boolean;
    station?: number;
    vn?: number;
    basePoint?: Point3dServer;
    crossSlopeLeftPoint?: Point3dServer;
    crossSlopeRightPoint?: Point3dServer;
    longitudinalSlopeLeftPoint?: Point3dServer;
    longitudinalSlopeLeftPointTo?: Point3dServer;
    longitudinalSlopeRightPoint?: Point3dServer;
    longitudinalSlopeRightPointTo?: Point3dServer;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeftPointFrom?: Point3dServer;
    deltaSLeftPointTo?: Point3dServer;
    deltaSRightPointFrom?: Point3dServer;
    deltaSRightPointTo?: Point3dServer;
    aLeftPointFrom?: Point3dServer;
    aRightPointFrom?: Point3dServer;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;

    constructor(data?: IValidationDesignCrossSectionRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vertexName = _data["vertexName"];
            this.isEndStation = _data["isEndStation"];
            this.station = _data["station"];
            this.vn = _data["vn"];
            this.basePoint = _data["basePoint"] ? Point3dServer.fromJS(_data["basePoint"]) : undefined as any;
            this.crossSlopeLeftPoint = _data["crossSlopeLeftPoint"] ? Point3dServer.fromJS(_data["crossSlopeLeftPoint"]) : undefined as any;
            this.crossSlopeRightPoint = _data["crossSlopeRightPoint"] ? Point3dServer.fromJS(_data["crossSlopeRightPoint"]) : undefined as any;
            this.longitudinalSlopeLeftPoint = _data["longitudinalSlopeLeftPoint"] ? Point3dServer.fromJS(_data["longitudinalSlopeLeftPoint"]) : undefined as any;
            this.longitudinalSlopeLeftPointTo = _data["longitudinalSlopeLeftPointTo"] ? Point3dServer.fromJS(_data["longitudinalSlopeLeftPointTo"]) : undefined as any;
            this.longitudinalSlopeRightPoint = _data["longitudinalSlopeRightPoint"] ? Point3dServer.fromJS(_data["longitudinalSlopeRightPoint"]) : undefined as any;
            this.longitudinalSlopeRightPointTo = _data["longitudinalSlopeRightPointTo"] ? Point3dServer.fromJS(_data["longitudinalSlopeRightPointTo"]) : undefined as any;
            this.crossSlopeLeft = _data["crossSlopeLeft"];
            this.crossSlopeRight = _data["crossSlopeRight"];
            this.longitudinalSlopeLeft = _data["longitudinalSlopeLeft"];
            this.longitudinalSlopeRight = _data["longitudinalSlopeRight"];
            this.finalSlopeLeft = _data["finalSlopeLeft"];
            this.finalSlopeRight = _data["finalSlopeRight"];
            this.crossSlopeLeftInCurve = _data["crossSlopeLeftInCurve"];
            this.crossSlopeRightInCurve = _data["crossSlopeRightInCurve"];
            this.paveWidthLeft = _data["paveWidthLeft"];
            this.paveWidthRight = _data["paveWidthRight"];
            this.deltaSLeftPointFrom = _data["deltaSLeftPointFrom"] ? Point3dServer.fromJS(_data["deltaSLeftPointFrom"]) : undefined as any;
            this.deltaSLeftPointTo = _data["deltaSLeftPointTo"] ? Point3dServer.fromJS(_data["deltaSLeftPointTo"]) : undefined as any;
            this.deltaSRightPointFrom = _data["deltaSRightPointFrom"] ? Point3dServer.fromJS(_data["deltaSRightPointFrom"]) : undefined as any;
            this.deltaSRightPointTo = _data["deltaSRightPointTo"] ? Point3dServer.fromJS(_data["deltaSRightPointTo"]) : undefined as any;
            this.aLeftPointFrom = _data["aLeftPointFrom"] ? Point3dServer.fromJS(_data["aLeftPointFrom"]) : undefined as any;
            this.aRightPointFrom = _data["aRightPointFrom"] ? Point3dServer.fromJS(_data["aRightPointFrom"]) : undefined as any;
            this.deltaSLeft = _data["deltaSLeft"];
            this.deltaSRight = _data["deltaSRight"];
            this.aLeft = _data["aLeft"];
            this.aRight = _data["aRight"];
            this.spMinLeft = _data["spMinLeft"];
            this.spMinRight = _data["spMinRight"];
        }
    }

    static fromJS(data: any): ValidationDesignCrossSectionRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignCrossSectionRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vertexName"] = this.vertexName;
        data["isEndStation"] = this.isEndStation;
        data["station"] = this.station;
        data["vn"] = this.vn;
        data["basePoint"] = this.basePoint ? this.basePoint.toJSON() : undefined as any;
        data["crossSlopeLeftPoint"] = this.crossSlopeLeftPoint ? this.crossSlopeLeftPoint.toJSON() : undefined as any;
        data["crossSlopeRightPoint"] = this.crossSlopeRightPoint ? this.crossSlopeRightPoint.toJSON() : undefined as any;
        data["longitudinalSlopeLeftPoint"] = this.longitudinalSlopeLeftPoint ? this.longitudinalSlopeLeftPoint.toJSON() : undefined as any;
        data["longitudinalSlopeLeftPointTo"] = this.longitudinalSlopeLeftPointTo ? this.longitudinalSlopeLeftPointTo.toJSON() : undefined as any;
        data["longitudinalSlopeRightPoint"] = this.longitudinalSlopeRightPoint ? this.longitudinalSlopeRightPoint.toJSON() : undefined as any;
        data["longitudinalSlopeRightPointTo"] = this.longitudinalSlopeRightPointTo ? this.longitudinalSlopeRightPointTo.toJSON() : undefined as any;
        data["crossSlopeLeft"] = this.crossSlopeLeft;
        data["crossSlopeRight"] = this.crossSlopeRight;
        data["longitudinalSlopeLeft"] = this.longitudinalSlopeLeft;
        data["longitudinalSlopeRight"] = this.longitudinalSlopeRight;
        data["finalSlopeLeft"] = this.finalSlopeLeft;
        data["finalSlopeRight"] = this.finalSlopeRight;
        data["crossSlopeLeftInCurve"] = this.crossSlopeLeftInCurve;
        data["crossSlopeRightInCurve"] = this.crossSlopeRightInCurve;
        data["paveWidthLeft"] = this.paveWidthLeft;
        data["paveWidthRight"] = this.paveWidthRight;
        data["deltaSLeftPointFrom"] = this.deltaSLeftPointFrom ? this.deltaSLeftPointFrom.toJSON() : undefined as any;
        data["deltaSLeftPointTo"] = this.deltaSLeftPointTo ? this.deltaSLeftPointTo.toJSON() : undefined as any;
        data["deltaSRightPointFrom"] = this.deltaSRightPointFrom ? this.deltaSRightPointFrom.toJSON() : undefined as any;
        data["deltaSRightPointTo"] = this.deltaSRightPointTo ? this.deltaSRightPointTo.toJSON() : undefined as any;
        data["aLeftPointFrom"] = this.aLeftPointFrom ? this.aLeftPointFrom.toJSON() : undefined as any;
        data["aRightPointFrom"] = this.aRightPointFrom ? this.aRightPointFrom.toJSON() : undefined as any;
        data["deltaSLeft"] = this.deltaSLeft;
        data["deltaSRight"] = this.deltaSRight;
        data["aLeft"] = this.aLeft;
        data["aRight"] = this.aRight;
        data["spMinLeft"] = this.spMinLeft;
        data["spMinRight"] = this.spMinRight;
        return data;
    }
}

export interface IValidationDesignCrossSectionRequestDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    isEndStation?: boolean;
    station?: number;
    vn?: number;
    basePoint?: Point3dServer;
    crossSlopeLeftPoint?: Point3dServer;
    crossSlopeRightPoint?: Point3dServer;
    longitudinalSlopeLeftPoint?: Point3dServer;
    longitudinalSlopeLeftPointTo?: Point3dServer;
    longitudinalSlopeRightPoint?: Point3dServer;
    longitudinalSlopeRightPointTo?: Point3dServer;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeftPointFrom?: Point3dServer;
    deltaSLeftPointTo?: Point3dServer;
    deltaSRightPointFrom?: Point3dServer;
    deltaSRightPointTo?: Point3dServer;
    aLeftPointFrom?: Point3dServer;
    aRightPointFrom?: Point3dServer;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
}

export class ValidationDesignCrossSectionResponseDTO implements IValidationDesignCrossSectionResponseDTO {
    id?: string | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;

    constructor(data?: IValidationDesignCrossSectionResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.finalSlopeLeftCorrectState = _data["finalSlopeLeftCorrectState"];
            this.finalSlopeRightCorrectState = _data["finalSlopeRightCorrectState"];
            this.tooltipFinalSlopeLeft = _data["tooltipFinalSlopeLeft"];
            this.tooltipFinalSlopeRight = _data["tooltipFinalSlopeRight"];
            this.isCrossSlopeLeftInCurveCorrect = _data["isCrossSlopeLeftInCurveCorrect"];
            this.isCrossSlopeRightInCurveCorrect = _data["isCrossSlopeRightInCurveCorrect"];
            this.tooltipCrossSlopeLeftInCurve = _data["tooltipCrossSlopeLeftInCurve"];
            this.tooltipCrossSlopeRightInCurve = _data["tooltipCrossSlopeRightInCurve"];
            this.spminLeftCorrectState = _data["spminLeftCorrectState"];
            this.spminLeftTooltip = _data["spminLeftTooltip"];
            this.spminRightCorrectState = _data["spminRightCorrectState"];
            this.spminRightTooltip = _data["spminRightTooltip"];
            this.deltaSLeftCorrectState = _data["deltaSLeftCorrectState"];
            this.deltaSLeftTooltip = _data["deltaSLeftTooltip"];
            this.deltaSRightCorrectState = _data["deltaSRightCorrectState"];
            this.deltaSRightTooltip = _data["deltaSRightTooltip"];
        }
    }

    static fromJS(data: any): ValidationDesignCrossSectionResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignCrossSectionResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["finalSlopeLeftCorrectState"] = this.finalSlopeLeftCorrectState;
        data["finalSlopeRightCorrectState"] = this.finalSlopeRightCorrectState;
        data["tooltipFinalSlopeLeft"] = this.tooltipFinalSlopeLeft;
        data["tooltipFinalSlopeRight"] = this.tooltipFinalSlopeRight;
        data["isCrossSlopeLeftInCurveCorrect"] = this.isCrossSlopeLeftInCurveCorrect;
        data["isCrossSlopeRightInCurveCorrect"] = this.isCrossSlopeRightInCurveCorrect;
        data["tooltipCrossSlopeLeftInCurve"] = this.tooltipCrossSlopeLeftInCurve;
        data["tooltipCrossSlopeRightInCurve"] = this.tooltipCrossSlopeRightInCurve;
        data["spminLeftCorrectState"] = this.spminLeftCorrectState;
        data["spminLeftTooltip"] = this.spminLeftTooltip;
        data["spminRightCorrectState"] = this.spminRightCorrectState;
        data["spminRightTooltip"] = this.spminRightTooltip;
        data["deltaSLeftCorrectState"] = this.deltaSLeftCorrectState;
        data["deltaSLeftTooltip"] = this.deltaSLeftTooltip;
        data["deltaSRightCorrectState"] = this.deltaSRightCorrectState;
        data["deltaSRightTooltip"] = this.deltaSRightTooltip;
        return data;
    }
}

export interface IValidationDesignCrossSectionResponseDTO {
    id?: string | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;
}

export class ValidationDesignDataGridSectionDTO implements IValidationDesignDataGridSectionDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    station?: number;
    station_km?: number;
    vn?: number;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    limitFinalSlope?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;

    constructor(data?: IValidationDesignDataGridSectionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vertexName = _data["vertexName"];
            this.station = _data["station"];
            this.station_km = _data["station_km"];
            this.vn = _data["vn"];
            this.crossSlopeLeft = _data["crossSlopeLeft"];
            this.crossSlopeRight = _data["crossSlopeRight"];
            this.longitudinalSlopeLeft = _data["longitudinalSlopeLeft"];
            this.longitudinalSlopeRight = _data["longitudinalSlopeRight"];
            this.finalSlopeLeft = _data["finalSlopeLeft"];
            this.finalSlopeRight = _data["finalSlopeRight"];
            this.limitFinalSlope = _data["limitFinalSlope"];
            this.crossSlopeLeftInCurve = _data["crossSlopeLeftInCurve"];
            this.crossSlopeRightInCurve = _data["crossSlopeRightInCurve"];
            this.paveWidthLeft = _data["paveWidthLeft"];
            this.paveWidthRight = _data["paveWidthRight"];
            this.deltaSLeft = _data["deltaSLeft"];
            this.deltaSRight = _data["deltaSRight"];
            this.aLeft = _data["aLeft"];
            this.aRight = _data["aRight"];
            this.spMinLeft = _data["spMinLeft"];
            this.spMinRight = _data["spMinRight"];
            this.finalSlopeLeftCorrectState = _data["finalSlopeLeftCorrectState"];
            this.finalSlopeRightCorrectState = _data["finalSlopeRightCorrectState"];
            this.tooltipFinalSlopeLeft = _data["tooltipFinalSlopeLeft"];
            this.tooltipFinalSlopeRight = _data["tooltipFinalSlopeRight"];
            this.isCrossSlopeLeftInCurveCorrect = _data["isCrossSlopeLeftInCurveCorrect"];
            this.isCrossSlopeRightInCurveCorrect = _data["isCrossSlopeRightInCurveCorrect"];
            this.tooltipCrossSlopeLeftInCurve = _data["tooltipCrossSlopeLeftInCurve"];
            this.tooltipCrossSlopeRightInCurve = _data["tooltipCrossSlopeRightInCurve"];
            this.spminLeftCorrectState = _data["spminLeftCorrectState"];
            this.spminLeftTooltip = _data["spminLeftTooltip"];
            this.spminRightCorrectState = _data["spminRightCorrectState"];
            this.spminRightTooltip = _data["spminRightTooltip"];
            this.deltaSLeftCorrectState = _data["deltaSLeftCorrectState"];
            this.deltaSLeftTooltip = _data["deltaSLeftTooltip"];
            this.deltaSRightCorrectState = _data["deltaSRightCorrectState"];
            this.deltaSRightTooltip = _data["deltaSRightTooltip"];
        }
    }

    static fromJS(data: any): ValidationDesignDataGridSectionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignDataGridSectionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vertexName"] = this.vertexName;
        data["station"] = this.station;
        data["station_km"] = this.station_km;
        data["vn"] = this.vn;
        data["crossSlopeLeft"] = this.crossSlopeLeft;
        data["crossSlopeRight"] = this.crossSlopeRight;
        data["longitudinalSlopeLeft"] = this.longitudinalSlopeLeft;
        data["longitudinalSlopeRight"] = this.longitudinalSlopeRight;
        data["finalSlopeLeft"] = this.finalSlopeLeft;
        data["finalSlopeRight"] = this.finalSlopeRight;
        data["limitFinalSlope"] = this.limitFinalSlope;
        data["crossSlopeLeftInCurve"] = this.crossSlopeLeftInCurve;
        data["crossSlopeRightInCurve"] = this.crossSlopeRightInCurve;
        data["paveWidthLeft"] = this.paveWidthLeft;
        data["paveWidthRight"] = this.paveWidthRight;
        data["deltaSLeft"] = this.deltaSLeft;
        data["deltaSRight"] = this.deltaSRight;
        data["aLeft"] = this.aLeft;
        data["aRight"] = this.aRight;
        data["spMinLeft"] = this.spMinLeft;
        data["spMinRight"] = this.spMinRight;
        data["finalSlopeLeftCorrectState"] = this.finalSlopeLeftCorrectState;
        data["finalSlopeRightCorrectState"] = this.finalSlopeRightCorrectState;
        data["tooltipFinalSlopeLeft"] = this.tooltipFinalSlopeLeft;
        data["tooltipFinalSlopeRight"] = this.tooltipFinalSlopeRight;
        data["isCrossSlopeLeftInCurveCorrect"] = this.isCrossSlopeLeftInCurveCorrect;
        data["isCrossSlopeRightInCurveCorrect"] = this.isCrossSlopeRightInCurveCorrect;
        data["tooltipCrossSlopeLeftInCurve"] = this.tooltipCrossSlopeLeftInCurve;
        data["tooltipCrossSlopeRightInCurve"] = this.tooltipCrossSlopeRightInCurve;
        data["spminLeftCorrectState"] = this.spminLeftCorrectState;
        data["spminLeftTooltip"] = this.spminLeftTooltip;
        data["spminRightCorrectState"] = this.spminRightCorrectState;
        data["spminRightTooltip"] = this.spminRightTooltip;
        data["deltaSLeftCorrectState"] = this.deltaSLeftCorrectState;
        data["deltaSLeftTooltip"] = this.deltaSLeftTooltip;
        data["deltaSRightCorrectState"] = this.deltaSRightCorrectState;
        data["deltaSRightTooltip"] = this.deltaSRightTooltip;
        return data;
    }
}

export interface IValidationDesignDataGridSectionDTO {
    id?: string | undefined;
    vertexName?: string | undefined;
    station?: number;
    station_km?: number;
    vn?: number;
    crossSlopeLeft?: number | undefined;
    crossSlopeRight?: number | undefined;
    longitudinalSlopeLeft?: number | undefined;
    longitudinalSlopeRight?: number | undefined;
    finalSlopeLeft?: number | undefined;
    finalSlopeRight?: number | undefined;
    limitFinalSlope?: number | undefined;
    crossSlopeLeftInCurve?: number | undefined;
    crossSlopeRightInCurve?: number | undefined;
    paveWidthLeft?: number | undefined;
    paveWidthRight?: number | undefined;
    deltaSLeft?: number | undefined;
    deltaSRight?: number | undefined;
    aLeft?: number | undefined;
    aRight?: number | undefined;
    spMinLeft?: number | undefined;
    spMinRight?: number | undefined;
    finalSlopeLeftCorrectState?: ValidationSlopeState;
    finalSlopeRightCorrectState?: ValidationSlopeState;
    tooltipFinalSlopeLeft?: string | undefined;
    tooltipFinalSlopeRight?: string | undefined;
    isCrossSlopeLeftInCurveCorrect?: boolean;
    isCrossSlopeRightInCurveCorrect?: boolean;
    tooltipCrossSlopeLeftInCurve?: string | undefined;
    tooltipCrossSlopeRightInCurve?: string | undefined;
    spminLeftCorrectState?: ValidationSlopeState;
    spminLeftTooltip?: string | undefined;
    spminRightCorrectState?: ValidationSlopeState;
    spminRightTooltip?: string | undefined;
    deltaSLeftCorrectState?: ValidationSlopeState;
    deltaSLeftTooltip?: string | undefined;
    deltaSRightCorrectState?: ValidationSlopeState;
    deltaSRightTooltip?: string | undefined;
}

export class ValidationDesignEntityRequestDTO implements IValidationDesignEntityRequestDTO {
    entityType?: ValidationDesignEntityType;
    crossSections?: ValidationDesignCrossSectionRequestDTO[] | undefined;
    startStation?: number;
    endStation?: number;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;

    constructor(data?: IValidationDesignEntityRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["crossSections"])) {
                this.crossSections = [] as any;
                for (let item of _data["crossSections"])
                    this.crossSections!.push(ValidationDesignCrossSectionRequestDTO.fromJS(item));
            }
            this.startStation = _data["startStation"];
            this.endStation = _data["endStation"];
            this.startPoint = _data["startPoint"] ? Point3dServer.fromJS(_data["startPoint"]) : undefined as any;
            this.endPoint = _data["endPoint"] ? Point3dServer.fromJS(_data["endPoint"]) : undefined as any;
        }
    }

    static fromJS(data: any): ValidationDesignEntityRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignEntityRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        if (Array.isArray(this.crossSections)) {
            data["crossSections"] = [];
            for (let item of this.crossSections)
                data["crossSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["startStation"] = this.startStation;
        data["endStation"] = this.endStation;
        data["startPoint"] = this.startPoint ? this.startPoint.toJSON() : undefined as any;
        data["endPoint"] = this.endPoint ? this.endPoint.toJSON() : undefined as any;
        return data;
    }
}

export interface IValidationDesignEntityRequestDTO {
    entityType?: ValidationDesignEntityType;
    crossSections?: ValidationDesignCrossSectionRequestDTO[] | undefined;
    startStation?: number;
    endStation?: number;
    startPoint?: Point3dServer;
    endPoint?: Point3dServer;
}

export enum ValidationDesignEntityType {
    None = "None",
    Tangent = "Tangent",
    Spiral = "Spiral",
    Curve = "Curve",
    Perpendicular = "Perpendicular",
}

export class ValidationDesignHectoServer implements IValidationDesignHectoServer {
    station?: number;
    basePoint?: Point3dServer;
    crossPoint?: Point3dServer;

    constructor(data?: IValidationDesignHectoServer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.station = _data["station"];
            this.basePoint = _data["basePoint"] ? Point3dServer.fromJS(_data["basePoint"]) : undefined as any;
            this.crossPoint = _data["crossPoint"] ? Point3dServer.fromJS(_data["crossPoint"]) : undefined as any;
        }
    }

    static fromJS(data: any): ValidationDesignHectoServer {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignHectoServer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["station"] = this.station;
        data["basePoint"] = this.basePoint ? this.basePoint.toJSON() : undefined as any;
        data["crossPoint"] = this.crossPoint ? this.crossPoint.toJSON() : undefined as any;
        return data;
    }
}

export interface IValidationDesignHectoServer {
    station?: number;
    basePoint?: Point3dServer;
    crossPoint?: Point3dServer;
}

export class ValidationDesignSlopePluginRequest implements IValidationDesignSlopePluginRequest {
    projectId?: number;
    data?: ValidationDesignSlopeRequest;

    constructor(data?: IValidationDesignSlopePluginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.data = _data["data"] ? ValidationDesignSlopeRequest.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ValidationDesignSlopePluginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopePluginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IValidationDesignSlopePluginRequest {
    projectId?: number;
    data?: ValidationDesignSlopeRequest;
}

export class ValidationDesignSlopeRequest implements IValidationDesignSlopeRequest {
    isHighway?: boolean;
    projectId?: number;
    corridorName?: string | undefined;
    baseLineName?: string | undefined;
    startStation?: number;
    endStation?: number;
    entities?: ValidationDesignEntityRequestDTO[] | undefined;
    hectos?: ValidationDesignHectoServer[] | undefined;

    constructor(data?: IValidationDesignSlopeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHighway = _data["isHighway"];
            this.projectId = _data["projectId"];
            this.corridorName = _data["corridorName"];
            this.baseLineName = _data["baseLineName"];
            this.startStation = _data["startStation"];
            this.endStation = _data["endStation"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ValidationDesignEntityRequestDTO.fromJS(item));
            }
            if (Array.isArray(_data["hectos"])) {
                this.hectos = [] as any;
                for (let item of _data["hectos"])
                    this.hectos!.push(ValidationDesignHectoServer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationDesignSlopeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHighway"] = this.isHighway;
        data["projectId"] = this.projectId;
        data["corridorName"] = this.corridorName;
        data["baseLineName"] = this.baseLineName;
        data["startStation"] = this.startStation;
        data["endStation"] = this.endStation;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.hectos)) {
            data["hectos"] = [];
            for (let item of this.hectos)
                data["hectos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationDesignSlopeRequest {
    isHighway?: boolean;
    projectId?: number;
    corridorName?: string | undefined;
    baseLineName?: string | undefined;
    startStation?: number;
    endStation?: number;
    entities?: ValidationDesignEntityRequestDTO[] | undefined;
    hectos?: ValidationDesignHectoServer[] | undefined;
}

export class ValidationDesignSlopeResponse implements IValidationDesignSlopeResponse {
    serverURL?: string | undefined;
    crossSections?: ValidationDesignCrossSectionResponseDTO[] | undefined;

    constructor(data?: IValidationDesignSlopeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverURL = _data["serverURL"];
            if (Array.isArray(_data["crossSections"])) {
                this.crossSections = [] as any;
                for (let item of _data["crossSections"])
                    this.crossSections!.push(ValidationDesignCrossSectionResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationDesignSlopeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationDesignSlopeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverURL"] = this.serverURL;
        if (Array.isArray(this.crossSections)) {
            data["crossSections"] = [];
            for (let item of this.crossSections)
                data["crossSections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationDesignSlopeResponse {
    serverURL?: string | undefined;
    crossSections?: ValidationDesignCrossSectionResponseDTO[] | undefined;
}

export class ValidationElementDTO implements IValidationElementDTO {
    expressId?: number;
    modelId?: number;

    constructor(data?: IValidationElementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): ValidationElementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationElementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IValidationElementDTO {
    expressId?: number;
    modelId?: number;
}

export class ValidationOrGroupDTO implements IValidationOrGroupDTO {
    groupId?: number;
    groupName?: string | undefined;
    orGroupItems?: PairerDetailValidationRuleDTO[] | undefined;

    constructor(data?: IValidationOrGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["orGroupItems"])) {
                this.orGroupItems = [] as any;
                for (let item of _data["orGroupItems"])
                    this.orGroupItems!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationOrGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationOrGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.orGroupItems)) {
            data["orGroupItems"] = [];
            for (let item of this.orGroupItems)
                data["orGroupItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationOrGroupDTO {
    groupId?: number;
    groupName?: string | undefined;
    orGroupItems?: PairerDetailValidationRuleDTO[] | undefined;
}

export class ValidationResponse implements IValidationResponse {
    elements?: ValidationElementDTO[] | undefined;

    constructor(data?: IValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ValidationElementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationResponse {
    elements?: ValidationElementDTO[] | undefined;
}

export class ValidationResultDTO implements IValidationResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    expressId?: number;
    resultItems?: ValidationResultItemDTO[] | undefined;
    resultGroups?: ValidationResultGroupDTO[] | undefined;

    constructor(data?: IValidationResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.expressId = _data["expressId"];
            if (Array.isArray(_data["resultItems"])) {
                this.resultItems = [] as any;
                for (let item of _data["resultItems"])
                    this.resultItems!.push(ValidationResultItemDTO.fromJS(item));
            }
            if (Array.isArray(_data["resultGroups"])) {
                this.resultGroups = [] as any;
                for (let item of _data["resultGroups"])
                    this.resultGroups!.push(ValidationResultGroupDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["expressId"] = this.expressId;
        if (Array.isArray(this.resultItems)) {
            data["resultItems"] = [];
            for (let item of this.resultItems)
                data["resultItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resultGroups)) {
            data["resultGroups"] = [];
            for (let item of this.resultGroups)
                data["resultGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    expressId?: number;
    resultItems?: ValidationResultItemDTO[] | undefined;
    resultGroups?: ValidationResultGroupDTO[] | undefined;
}

export class ValidationResultGroupDTO implements IValidationResultGroupDTO {
    ok?: boolean;
    groupId?: number;
    groupName?: string | undefined;
    resultGroupsItems?: ValidationResultItemDTO[] | undefined;

    constructor(data?: IValidationResultGroupDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["resultGroupsItems"])) {
                this.resultGroupsItems = [] as any;
                for (let item of _data["resultGroupsItems"])
                    this.resultGroupsItems!.push(ValidationResultItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResultGroupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultGroupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.resultGroupsItems)) {
            data["resultGroupsItems"] = [];
            for (let item of this.resultGroupsItems)
                data["resultGroupsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationResultGroupDTO {
    ok?: boolean;
    groupId?: number;
    groupName?: string | undefined;
    resultGroupsItems?: ValidationResultItemDTO[] | undefined;
}

export class ValidationResultItemDTO implements IValidationResultItemDTO {
    ok?: boolean;
    message?: string | undefined;
    propertyName?: string | undefined;
    expressId?: number;
    modelId?: string | undefined;
    invalidityReason?: InvalidFieldReasons;
    dataTypeValidation?: DataTypeValidation;
    isNullable?: boolean;
    pairerId?: number;
    groupIndex?: number | undefined;
    orGroupId?: number | undefined;
    orGroupName?: string | undefined;
    isOrGroupOk?: boolean | undefined;

    constructor(data?: IValidationResultItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.message = _data["message"];
            this.propertyName = _data["propertyName"];
            this.expressId = _data["expressId"];
            this.modelId = _data["modelId"];
            this.invalidityReason = _data["invalidityReason"];
            this.dataTypeValidation = _data["dataTypeValidation"];
            this.isNullable = _data["isNullable"];
            this.pairerId = _data["pairerId"];
            this.groupIndex = _data["groupIndex"];
            this.orGroupId = _data["orGroupId"];
            this.orGroupName = _data["orGroupName"];
            this.isOrGroupOk = _data["isOrGroupOk"];
        }
    }

    static fromJS(data: any): ValidationResultItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["expressId"] = this.expressId;
        data["modelId"] = this.modelId;
        data["invalidityReason"] = this.invalidityReason;
        data["dataTypeValidation"] = this.dataTypeValidation;
        data["isNullable"] = this.isNullable;
        data["pairerId"] = this.pairerId;
        data["groupIndex"] = this.groupIndex;
        data["orGroupId"] = this.orGroupId;
        data["orGroupName"] = this.orGroupName;
        data["isOrGroupOk"] = this.isOrGroupOk;
        return data;
    }
}

export interface IValidationResultItemDTO {
    ok?: boolean;
    message?: string | undefined;
    propertyName?: string | undefined;
    expressId?: number;
    modelId?: string | undefined;
    invalidityReason?: InvalidFieldReasons;
    dataTypeValidation?: DataTypeValidation;
    isNullable?: boolean;
    pairerId?: number;
    groupIndex?: number | undefined;
    orGroupId?: number | undefined;
    orGroupName?: string | undefined;
    isOrGroupOk?: boolean | undefined;
}

export class ValidationRowResultDTO implements IValidationRowResultDTO {
    expressId?: number;
    isCompletelyValid?: boolean;
    validationsResults?: ValidationResultDTO[] | undefined;

    constructor(data?: IValidationRowResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["validationsResults"])) {
                this.validationsResults = [] as any;
                for (let item of _data["validationsResults"])
                    this.validationsResults!.push(ValidationResultDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationRowResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRowResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.validationsResults)) {
            data["validationsResults"] = [];
            for (let item of this.validationsResults)
                data["validationsResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationRowResultDTO {
    expressId?: number;
    isCompletelyValid?: boolean;
    validationsResults?: ValidationResultDTO[] | undefined;
}

export class ValidationRuleEnumDTO implements IValidationRuleEnumDTO {
    category?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;

    constructor(data?: IValidationRuleEnumDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ValidationRuleEnumDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRuleEnumDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["name"] = this.name;
        data["value"] = this.value;
        data["note"] = this.note;
        return data;
    }
}

export interface IValidationRuleEnumDTO {
    category?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;
}

export class ValidationRuleFullTreeDTO implements IValidationRuleFullTreeDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    dataType?: DataTypeValidation;
    decimalPlaces?: number | undefined;
    isCCI?: boolean;
    isDSStandard?: boolean;
    dur?: boolean;
    dsp?: boolean;
    pdps?: boolean;
    rds?: boolean;
    dsps?: boolean;
    dusp?: boolean;
    drs?: boolean;
    dps?: boolean;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    expression?: string | undefined;
    guid?: string | undefined;
    validationRuleEnums?: ValidationRuleEnumDTO[] | undefined;

    constructor(data?: IValidationRuleFullTreeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.namePrefix = _data["namePrefix"];
            this.attributeName = _data["attributeName"];
            this.attributeNumber = _data["attributeNumber"];
            this.dataType = _data["dataType"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.isCCI = _data["isCCI"];
            this.isDSStandard = _data["isDSStandard"];
            this.dur = _data["dur"];
            this.dsp = _data["dsp"];
            this.pdps = _data["pdps"];
            this.rds = _data["rds"];
            this.dsps = _data["dsps"];
            this.dusp = _data["dusp"];
            this.drs = _data["drs"];
            this.dps = _data["dps"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.examplesOfValues = _data["examplesOfValues"];
            this.expression = _data["expression"];
            this.guid = _data["guid"];
            if (Array.isArray(_data["validationRuleEnums"])) {
                this.validationRuleEnums = [] as any;
                for (let item of _data["validationRuleEnums"])
                    this.validationRuleEnums!.push(ValidationRuleEnumDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationRuleFullTreeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRuleFullTreeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["namePrefix"] = this.namePrefix;
        data["attributeName"] = this.attributeName;
        data["attributeNumber"] = this.attributeNumber;
        data["dataType"] = this.dataType;
        data["decimalPlaces"] = this.decimalPlaces;
        data["isCCI"] = this.isCCI;
        data["isDSStandard"] = this.isDSStandard;
        data["dur"] = this.dur;
        data["dsp"] = this.dsp;
        data["pdps"] = this.pdps;
        data["rds"] = this.rds;
        data["dsps"] = this.dsps;
        data["dusp"] = this.dusp;
        data["drs"] = this.drs;
        data["dps"] = this.dps;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["examplesOfValues"] = this.examplesOfValues;
        data["expression"] = this.expression;
        data["guid"] = this.guid;
        if (Array.isArray(this.validationRuleEnums)) {
            data["validationRuleEnums"] = [];
            for (let item of this.validationRuleEnums)
                data["validationRuleEnums"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationRuleFullTreeDTO {
    id?: number;
    field?: string | undefined;
    namePrefix?: string | undefined;
    attributeName?: string | undefined;
    attributeNumber?: number | undefined;
    dataType?: DataTypeValidation;
    decimalPlaces?: number | undefined;
    isCCI?: boolean;
    isDSStandard?: boolean;
    dur?: boolean;
    dsp?: boolean;
    pdps?: boolean;
    rds?: boolean;
    dsps?: boolean;
    dusp?: boolean;
    drs?: boolean;
    dps?: boolean;
    unitOfMeasure?: string | undefined;
    examplesOfValues?: string | undefined;
    expression?: string | undefined;
    guid?: string | undefined;
    validationRuleEnums?: ValidationRuleEnumDTO[] | undefined;
}

export enum ValidationSlopeState {
    None = "None",
    Correct = "Correct",
    Error = "Error",
    Warning = "Warning",
}

export class ValidationTreeResultDTO implements IValidationTreeResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    countElementsValidated?: number;
    isCompletelyValid?: boolean;
    validationsResultElements?: ValidationTreeResultElementsDTO[] | undefined;
    rules?: PairerDetailValidationRuleDTO[] | undefined;
    isExpanded?: boolean;

    constructor(data?: IValidationTreeResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pairerId = _data["pairerId"];
            this.pairerName = _data["pairerName"];
            this.countElementsValidated = _data["countElementsValidated"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["validationsResultElements"])) {
                this.validationsResultElements = [] as any;
                for (let item of _data["validationsResultElements"])
                    this.validationsResultElements!.push(ValidationTreeResultElementsDTO.fromJS(item));
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(PairerDetailValidationRuleDTO.fromJS(item));
            }
            this.isExpanded = _data["isExpanded"];
        }
    }

    static fromJS(data: any): ValidationTreeResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationTreeResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pairerId"] = this.pairerId;
        data["pairerName"] = this.pairerName;
        data["countElementsValidated"] = this.countElementsValidated;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.validationsResultElements)) {
            data["validationsResultElements"] = [];
            for (let item of this.validationsResultElements)
                data["validationsResultElements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        data["isExpanded"] = this.isExpanded;
        return data;
    }
}

export interface IValidationTreeResultDTO {
    pairerId?: number;
    pairerName?: string | undefined;
    countElementsValidated?: number;
    isCompletelyValid?: boolean;
    validationsResultElements?: ValidationTreeResultElementsDTO[] | undefined;
    rules?: PairerDetailValidationRuleDTO[] | undefined;
    isExpanded?: boolean;
}

export class ValidationTreeResultElementsDTO implements IValidationTreeResultElementsDTO {
    expressId?: number;
    pairerId?: number;
    modelId?: string | undefined;
    isCompletelyValid?: boolean;
    resultItems?: ValidationResultItemDTO[] | undefined;

    constructor(data?: IValidationTreeResultElementsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expressId = _data["expressId"];
            this.pairerId = _data["pairerId"];
            this.modelId = _data["modelId"];
            this.isCompletelyValid = _data["isCompletelyValid"];
            if (Array.isArray(_data["resultItems"])) {
                this.resultItems = [] as any;
                for (let item of _data["resultItems"])
                    this.resultItems!.push(ValidationResultItemDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationTreeResultElementsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationTreeResultElementsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expressId"] = this.expressId;
        data["pairerId"] = this.pairerId;
        data["modelId"] = this.modelId;
        data["isCompletelyValid"] = this.isCompletelyValid;
        if (Array.isArray(this.resultItems)) {
            data["resultItems"] = [];
            for (let item of this.resultItems)
                data["resultItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationTreeResultElementsDTO {
    expressId?: number;
    pairerId?: number;
    modelId?: string | undefined;
    isCompletelyValid?: boolean;
    resultItems?: ValidationResultItemDTO[] | undefined;
}

export class ValRuleDecimalPlacesDTO implements IValRuleDecimalPlacesDTO {
    id?: number;
    field?: string | undefined;
    decimalPlaces?: number | undefined;
    isDifferentDecimalPlaces?: boolean;

    constructor(data?: IValRuleDecimalPlacesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"];
            this.decimalPlaces = _data["decimalPlaces"];
            this.isDifferentDecimalPlaces = _data["isDifferentDecimalPlaces"];
        }
    }

    static fromJS(data: any): ValRuleDecimalPlacesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValRuleDecimalPlacesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field;
        data["decimalPlaces"] = this.decimalPlaces;
        data["isDifferentDecimalPlaces"] = this.isDifferentDecimalPlaces;
        return data;
    }
}

export interface IValRuleDecimalPlacesDTO {
    id?: number;
    field?: string | undefined;
    decimalPlaces?: number | undefined;
    isDifferentDecimalPlaces?: boolean;
}

export class ValueConditionEnumerationDTO implements IValueConditionEnumerationDTO {
    id?: number;
    category?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;
    dataType?: DataTypeValidation;

    constructor(data?: IValueConditionEnumerationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.note = _data["note"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any): ValueConditionEnumerationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConditionEnumerationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["name"] = this.name;
        data["value"] = this.value;
        data["note"] = this.note;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IValueConditionEnumerationDTO {
    id?: number;
    category?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;
    dataType?: DataTypeValidation;
}

export class ValueConditionModelDTO implements IValueConditionModelDTO {
    conditionType?: ValueConditionType;
    value1?: string | undefined;
    value2?: string | undefined;
    numberOfDecimalPlaces?: number | undefined;

    constructor(data?: IValueConditionModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionType = _data["conditionType"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.numberOfDecimalPlaces = _data["numberOfDecimalPlaces"];
        }
    }

    static fromJS(data: any): ValueConditionModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConditionModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionType"] = this.conditionType;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["numberOfDecimalPlaces"] = this.numberOfDecimalPlaces;
        return data;
    }
}

export interface IValueConditionModelDTO {
    conditionType?: ValueConditionType;
    value1?: string | undefined;
    value2?: string | undefined;
    numberOfDecimalPlaces?: number | undefined;
}

export enum ValueConditionType {
    EqualsValue = "EqualsValue",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Between = "Between",
    Enumeration = "Enumeration",
}

export class VectorSearchParams implements IVectorSearchParams {
    query?: string | undefined;
    topK?: number;
    minScore?: number;
    filters?: string[] | undefined;
    selectFields?: string[] | undefined;

    constructor(data?: IVectorSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.topK = _data["topK"];
            this.minScore = _data["minScore"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
            if (Array.isArray(_data["selectFields"])) {
                this.selectFields = [] as any;
                for (let item of _data["selectFields"])
                    this.selectFields!.push(item);
            }
        }
    }

    static fromJS(data: any): VectorSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new VectorSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["topK"] = this.topK;
        data["minScore"] = this.minScore;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        if (Array.isArray(this.selectFields)) {
            data["selectFields"] = [];
            for (let item of this.selectFields)
                data["selectFields"].push(item);
        }
        return data;
    }
}

export interface IVectorSearchParams {
    query?: string | undefined;
    topK?: number;
    minScore?: number;
    filters?: string[] | undefined;
    selectFields?: string[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}